(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("knockout"), require("ko-bindinghandler"), require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["knockout", "ko-bindinghandler", "jquery"], factory);
	else if(typeof exports === 'object')
		exports["ycloud"] = factory(require("knockout"), require("ko-bindinghandler"), require("jquery"));
	else
		root["ycloud"] = factory(root["ko"], root[undefined], root["$"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_65__, __WEBPACK_EXTERNAL_MODULE_32__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 180);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Base = function () {
  function Base(params) {
    _classCallCheck(this, Base);

    this.$el = params.$el;
    this.$templateNodes = params.$templateNodes;
    _mixin.refmixin.call(this, params);
    this.initialize(params);
    this.computed(params);
    this.subscribe(params);
    this.methods(params);
    this.created(params);
  }

  _createClass(Base, [{
    key: 'initialize',
    value: function initialize(params) {}
  }, {
    key: 'computed',
    value: function computed(params) {}
  }, {
    key: 'created',
    value: function created(params) {}
  }, {
    key: 'subscribe',
    value: function subscribe(params) {}
  }, {
    key: 'methods',
    value: function methods(params) {}
  }], [{
    key: 'createViewModel',
    value: function createViewModel(Component) {
      return {
        createViewModel: function createViewModel(params, componentInfo) {
          params.$el = componentInfo.element;
          params.$templateNodes = componentInfo.templateNodes;
          return new Component(params);
        }
      };
    }
  }]);

  return Base;
}();

exports.default = Base;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(187), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(190), __esModule: true };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(200), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  exports.warning = warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ycUserContext = __webpack_require__(203);

var _ycUserContext2 = _interopRequireDefault(_ycUserContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lang = {
  // 英语
  enus: {
    '请选择': 'select',
    '确定': 'ok',
    '更多': 'more',
    '收起': 'collapse',
    '展开': 'open',
    '暂无数据': 'no data',
    '限': 'limited to',
    '字': 'words',
    '还可输入': 'can also input',
    '取消': 'cancel',
    '删除': 'delete',
    '提示': 'tip',
    '清空': 'clear',
    '校验失败！': 'validate error!',
    '上一页': 'prev',
    '下一页': 'next',
    '每页显示': 'show',
    '共': 'total',
    '跳至': 'to',
    '页': 'pages',
    '条': 'lists',
    '暂无匹配数据': 'no data',
    '详细': 'Details',
    '日': 'Sun',
    '一': 'Mon',
    '二': 'Tue',
    '三': 'Wed',
    '四': 'Thu',
    '五': 'Fri',
    '六': 'Sat',
    '年': 'Year',
    '1月': 'Jan',
    '2月': 'Feb',
    '3月': 'Mar',
    '4月': 'Apr',
    '5月': 'May',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Aug',
    '9月': 'Sep',
    '10月': 'Oct',
    '11月': 'Nov',
    '12月': 'Dec',
    '一月': 'Jan',
    '二月': 'Feb',
    '三月': 'Mar',
    '四月': 'Apr',
    '五月': 'May',
    '六月': 'Jun',
    '七月': 'Jul',
    '八月': 'Aug',
    '九月': 'Sep',
    '十月': 'Oct',
    '十一月': 'Nov',
    '十二月': 'Dec',
    '加载中...': 'Loading...'
  },
  // 繁体
  zhtw: {
    '请选择': '請選擇',
    '确定': '確定',
    '更多': '更多',
    '收起': '收起',
    '展开': '展開',
    '暂无数据': '暫無數據',
    '限': '限',
    '字': '字',
    '还可输入': '還可輸入',
    '取消': '取消',
    '删除': '删除',
    '提示': '提示',
    '清空': '清空',
    '校验失败！': '校驗失敗！',
    '上一页': '上壹頁',
    '下一页': '下壹頁',
    '每页显示': '每頁顯示',
    '共': '共',
    '跳至': '跳至',
    '页': '頁',
    '条': '條',
    '暂无匹配数据': '暫無匹配數據',
    '详细': '詳細',
    '日': '日',
    '一': '一',
    '二': '二',
    '三': '三',
    '四': '四',
    '五': '五',
    '六': '六',
    '年': '年',
    '1月': '1月',
    '2月': '2月',
    '3月': '3月',
    '4月': '4月',
    '5月': '5月',
    '6月': '6月',
    '7月': '7月',
    '8月': '8月',
    '9月': '9月',
    '10月': '10月',
    '11月': '11月',
    '12月': '12月',
    '一月': '一月',
    '二月': '二月',
    '三月': '三月',
    '四月': '四月',
    '五月': '五月',
    '六月': '六月',
    '七月': '七月',
    '八月': '八月',
    '九月': '九月',
    '十月': '十月',
    '十一月': '十一月',
    '十二月': '十二月',
    '加载中...': '載入中...'
  },
  // 日语
  jajp: {
    '请选择': '選択してください',
    '确定': 'を選択して、',
    '更多': '詳細',
    '收起': 'やめる',
    '展开': 'てんかい',
    '暂无数据': 'データが一時的にありません',
    '限': '制限',
    '字': 'ワード',
    '还可输入': '入力も可能',
    '取消': 'キャンセル',
    '删除': '削除＃サクジョ＃',
    '提示': 'ヒント',
    '清空': 'クリアランス',
    '校验失败！': '検証に失敗しました！',
    '上一页': '前のページ',
    '下一页': '次のページ',
    '每页显示': 'ページごとに表示',
    '共': '合計',
    '跳至': 'ジャンプ先',
    '页': 'ページ＃ページ＃',
    '条': 'バー',
    '暂无匹配数据': '一致データが一時的にありません',
    '详细': '詳細',
    '日': '日',
    '一': '一',
    '二': '二',
    '三': '三',
    '四': '四',
    '五': '五',
    '六': '六',
    '年': '年',
    '1月': '1月',
    '2月': '2月',
    '3月': '3月',
    '4月': '4月',
    '5月': '5月',
    '6月': '6月',
    '7月': '7月',
    '8月': '8月',
    '9月': '9月',
    '10月': '10月',
    '11月': '11月',
    '12月': '12月',
    '一月': '1月',
    '二月': '2月',
    '三月': '3月',
    '四月': '4月',
    '五月': '5月',
    '六月': '6月',
    '七月': '7月',
    '八月': '8月',
    '九月': '9月',
    '十月': '10月',
    '十一月': '11月',
    '十二月': '12月',
    '加载中...': 'ロード中...'
  },
  // 越南语
  vivn: {
    '请选择': 'Vui lòng chọn',
    '确定': 'Đồng ý',
    '更多': 'Thêm',
    '收起': 'Thu gọn',
    '展开': 'Mở rộng',
    '暂无数据': 'Không có dữ liệu',
    '限': 'Giới hạn',
    '字': 'ký tự',
    '还可输入': 'Có thể nhập thêm',
    '取消': 'Hủy',
    '删除': 'Xóa',
    '提示': 'Thông báo',
    '清空': 'Làm sạch',
    '校验失败！': 'Xác thực thất bại!',
    '上一页': 'Trang trước',
    '下一页': 'Trang sau',
    '每页显示': 'Hiển thị mỗi trang',
    '共': 'Tổng cộng',
    '跳至': 'Đến',
    '页': 'trang',
    '条': 'bản ghi',
    '暂无匹配数据': 'Không tìm thấy dữ liệu phù hợp',
    '详细': 'Chi tiết',
    '日': 'CN',
    '一': 'T2',
    '二': 'T3',
    '三': 'T4',
    '四': 'T5',
    '五': 'T6',
    '六': 'T7',
    '年': 'năm',
    '1月': 'Thg 1',
    '2月': 'Thg 2',
    '3月': 'Thg 3',
    '4月': 'Thg 4',
    '5月': 'Thg 5',
    '6月': 'Thg 6',
    '7月': 'Thg 7',
    '8月': 'Thg 8',
    '9月': 'Thg 9',
    '10月': 'Thg 10',
    '11月': 'Thg 11',
    '12月': 'Thg 12',
    '一月': 'Tháng 1',
    '二月': 'Tháng 2',
    '三月': 'Tháng 3',
    '四月': 'Tháng 4',
    '五月': 'Tháng 5',
    '六月': 'Tháng 6',
    '七月': 'Tháng 7',
    '八月': 'Tháng 8',
    '九月': 'Tháng 9',
    '十月': 'Tháng 10',
    '十一月': 'Tháng 11',
    '十二月': 'Tháng 12',
    '加载中...': 'Đang tải...'
  },
  // 法语
  frfr: {
    '请选择': 'Sélectionner',
    '确定': 'OK',
    '更多': 'Plus',
    '收起': 'Réduire',
    '展开': 'Déplier',
    '暂无数据': 'Aucune donnée',
    '限': 'Limité à',
    '字': 'mots',
    '还可输入': 'Encore saisissable',
    '取消': 'Annuler',
    '删除': 'Supprimer',
    '提示': 'Astuce',
    '清空': 'Vider',
    '校验失败！': 'Erreur de validation !',
    '上一页': 'Précédent',
    '下一页': 'Suivant',
    '每页显示': 'Afficher par page',
    '共': 'Total',
    '跳至': 'Aller à',
    '页': 'pages',
    '条': 'éléments',
    '暂无匹配数据': 'Aucune correspondance',
    '详细': 'Détails',
    '日': 'Dim',
    '一': 'Lun',
    '二': 'Mar',
    '三': 'Mer',
    '四': 'Jeu',
    '五': 'Ven',
    '六': 'Sam',
    '年': 'Année',
    '1月': 'janv',
    '2月': 'févr',
    '3月': 'mars',
    '4月': 'avr',
    '5月': 'mai',
    '6月': 'juin',
    '7月': 'juil',
    '8月': 'août',
    '9月': 'sept',
    '10月': 'oct',
    '11月': 'nov',
    '12月': 'déc',
    '一月': 'janvier',
    '二月': 'février',
    '三月': 'mars',
    '四月': 'avril',
    '五月': 'mai',
    '六月': 'juin',
    '七月': 'juillet',
    '八月': 'août',
    '九月': 'septembre',
    '十月': 'octobre',
    '十一月': 'novembre',
    '十二月': 'décembre',
    '加载中...': 'Chargement...'
  },
  // 韩语
  kokr: {
    '请选择': '선택하세요',
    '确定': '확인',
    '更多': '더보기',
    '收起': '접기',
    '展开': '펼치기',
    '暂无数据': '데이터 없음',
    '限': '제한',
    '字': '자',
    '还可输入': '입력 가능',
    '取消': '취소',
    '删除': '삭제',
    '提示': '안내',
    '清空': '비우기',
    '校验失败！': '유효성 검사 실패!',
    '上一页': '이전',
    '下一页': '다음',
    '每页显示': '페이지당 표시',
    '共': '전체',
    '跳至': '이동',
    '页': '페이지',
    '条': '건',
    '暂无匹配数据': '일치하는 데이터 없음',
    '详细': '상세',
    '日': '일',
    '一': '월',
    '二': '화',
    '三': '수',
    '四': '목',
    '五': '금',
    '六': '토',
    '年': '년',
    '1月': '1월',
    '2月': '2월',
    '3月': '3월',
    '4月': '4월',
    '5月': '5월',
    '6月': '6월',
    '7月': '7월',
    '8月': '8월',
    '9月': '9월',
    '10月': '10월',
    '11月': '11월',
    '12月': '12월',
    '一月': '1월',
    '二月': '2월',
    '三月': '3월',
    '四月': '4월',
    '五月': '5월',
    '六月': '6월',
    '七月': '7월',
    '八月': '8월',
    '九月': '9월',
    '十月': '10월',
    '十一月': '11월',
    '十二月': '12월',
    '加载中...': '로딩 중...'
  },
  // 印尼语
  idid: {
    '请选择': 'Pilih',
    '确定': 'OK',
    '更多': 'Lainnya',
    '收起': 'Ciutkan',
    '展开': 'Bentangkan',
    '暂无数据': 'Tidak ada data',
    '限': 'Dibatasi hingga',
    '字': 'kata',
    '还可输入': 'Masih bisa masukkan',
    '取消': 'Batal',
    '删除': 'Hapus',
    '提示': 'Petunjuk',
    '清空': 'Kosongkan',
    '校验失败！': 'Validasi gagal!',
    '上一页': 'Sebelumnya',
    '下一页': 'Berikutnya',
    '每页显示': 'Tampil per halaman',
    '共': 'Total',
    '跳至': 'Loncat ke',
    '页': 'halaman',
    '条': 'baris',
    '暂无匹配数据': 'Tidak ada data yang cocok',
    '详细': 'Detail',
    '日': 'Min',
    '一': 'Sen',
    '二': 'Sel',
    '三': 'Rab',
    '四': 'Kam',
    '五': 'Jum',
    '六': 'Sab',
    '年': 'tahun',
    '1月': 'Jan',
    '2月': 'Feb',
    '3月': 'Mar',
    '4月': 'Apr',
    '5月': 'Mei',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Agu',
    '9月': 'Sep',
    '10月': 'Okt',
    '11月': 'Nov',
    '12月': 'Des',
    '一月': 'Januari',
    '二月': 'Februari',
    '三月': 'Maret',
    '四月': 'April',
    '五月': 'Mei',
    '六月': 'Juni',
    '七月': 'Juli',
    '八月': 'Agustus',
    '九月': 'September',
    '十月': 'Oktober',
    '十一月': 'November',
    '十二月': 'Desember',
    '加载中...': 'Memuat...'
  },
  // 德语
  dede: {
    '请选择': 'Bitte wählen',
    '确定': 'OK',
    '更多': 'Mehr',
    '收起': 'Einklappen',
    '展开': 'Aufklappen',
    '暂无数据': 'Keine Daten',
    '限': 'Begrenzt auf',
    '字': 'Zeichen',
    '还可输入': 'Noch eingebbar',
    '取消': 'Abbrechen',
    '删除': 'Löschen',
    '提示': 'Hinweis',
    '清空': 'Leeren',
    '校验失败！': 'Validierung fehlgeschlagen!',
    '上一页': 'Zurück',
    '下一页': 'Weiter',
    '每页显示': 'Pro Seite anzeigen',
    '共': 'Gesamt',
    '跳至': 'Gehe zu',
    '页': 'Seiten',
    '条': 'Einträge',
    '暂无匹配数据': 'Keine passenden Daten',
    '详细': 'Details',
    '日': 'So',
    '一': 'Mo',
    '二': 'Di',
    '三': 'Mi',
    '四': 'Do',
    '五': 'Fr',
    '六': 'Sa',
    '年': 'Jahr',
    '1月': 'Jan',
    '2月': 'Feb',
    '3月': 'Mär',
    '4月': 'Apr',
    '5月': 'Mai',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Aug',
    '9月': 'Sep',
    '10月': 'Okt',
    '11月': 'Nov',
    '12月': 'Dez',
    '一月': 'Januar',
    '二月': 'Februar',
    '三月': 'März',
    '四月': 'April',
    '五月': 'Mai',
    '六月': 'Juni',
    '七月': 'Juli',
    '八月': 'August',
    '九月': 'September',
    '十月': 'Oktober',
    '十一月': 'November',
    '十二月': 'Dezember',
    '加载中...': 'Laden...'
  },
  // 意大利语
  itit: {
    '请选择': 'Seleziona',
    '确定': 'OK',
    '更多': 'Altro',
    '收起': 'Comprimi',
    '展开': 'Espandi',
    '暂无数据': 'Nessun dato',
    '限': 'Limite di',
    '字': 'caratteri',
    '还可输入': 'Puoi inserire ancora',
    '取消': 'Annulla',
    '删除': 'Elimina',
    '提示': 'Suggerimento',
    '清空': 'Svuota',
    '校验失败！': 'Validazione fallita!',
    '上一页': 'Precedente',
    '下一页': 'Successivo',
    '每页显示': 'Mostra per pagina',
    '共': 'Totale',
    '跳至': 'Vai a',
    '页': 'pagine',
    '条': 'elementi',
    '暂无匹配数据': 'Nessun dato corrispondente',
    '详细': 'Dettagli',
    '日': 'Dom',
    '一': 'Lun',
    '二': 'Mar',
    '三': 'Mer',
    '四': 'Gio',
    '五': 'Ven',
    '六': 'Sab',
    '年': 'anno',
    '1月': 'gen',
    '2月': 'feb',
    '3月': 'mar',
    '4月': 'apr',
    '5月': 'mag',
    '6月': 'giu',
    '7月': 'lug',
    '8月': 'ago',
    '9月': 'set',
    '10月': 'ott',
    '11月': 'nov',
    '12月': 'dic',
    '一月': 'gennaio',
    '二月': 'febbraio',
    '三月': 'marzo',
    '四月': 'aprile',
    '五月': 'maggio',
    '六月': 'giugno',
    '七月': 'luglio',
    '八月': 'agosto',
    '九月': 'settembre',
    '十月': 'ottobre',
    '十一月': 'novembre',
    '十二月': 'dicembre',
    '加载中...': 'Caricamento...'
  },
  // 西班牙语
  eses: {
    '请选择': 'Seleccionar',
    '确定': 'Aceptar',
    '更多': 'Más',
    '收起': 'Contraer',
    '展开': 'Expandir',
    '暂无数据': 'Sin datos',
    '限': 'Límite de',
    '字': 'caracteres',
    '还可输入': 'Aún puede ingresar',
    '取消': 'Cancelar',
    '删除': 'Eliminar',
    '提示': 'Aviso',
    '清空': 'Vaciar',
    '校验失败！': '¡Error de validación!',
    '上一页': 'Anterior',
    '下一页': 'Siguiente',
    '每页显示': 'Mostrar por página',
    '共': 'Total',
    '跳至': 'Ir a',
    '页': 'páginas',
    '条': 'registros',
    '暂无匹配数据': 'No hay coincidencias',
    '详细': 'Detalles',
    '日': 'Dom',
    '一': 'Lun',
    '二': 'Mar',
    '三': 'Mié',
    '四': 'Jue',
    '五': 'Vie',
    '六': 'Sáb',
    '年': 'Año',
    '1月': 'ene',
    '2月': 'feb',
    '3月': 'mar',
    '4月': 'abr',
    '5月': 'may',
    '6月': 'jun',
    '7月': 'jul',
    '8月': 'ago',
    '9月': 'sep',
    '10月': 'oct',
    '11月': 'nov',
    '12月': 'dic',
    '一月': 'enero',
    '二月': 'febrero',
    '三月': 'marzo',
    '四月': 'abril',
    '五月': 'mayo',
    '六月': 'junio',
    '七月': 'julio',
    '八月': 'agosto',
    '九月': 'septiembre',
    '十月': 'octubre',
    '十一月': 'noviembre',
    '十二月': 'diciembre',
    '加载中...': 'Cargando...'
  },
  // 葡萄牙语
  ptpt: {
    '请选择': 'Selecione',
    '确定': 'OK',
    '更多': 'Mais',
    '收起': 'Recolher',
    '展开': 'Expandir',
    '暂无数据': 'Nenhum dado',
    '限': 'Limite de',
    '字': 'caracteres',
    '还可输入': 'Ainda pode inserir',
    '取消': 'Cancelar',
    '删除': 'Excluir',
    '提示': 'Dica',
    '清空': 'Limpar',
    '校验失败！': 'Erro de validação!',
    '上一页': 'Anterior',
    '下一页': 'Próximo',
    '每页显示': 'Exibir por página',
    '共': 'Total',
    '跳至': 'Ir para',
    '页': 'páginas',
    '条': 'itens',
    '暂无匹配数据': 'Nenhum dado correspondente',
    '详细': 'Detalhes',
    '日': 'Dom',
    '一': 'Seg',
    '二': 'Ter',
    '三': 'Qua',
    '四': 'Qui',
    '五': 'Sex',
    '六': 'Sáb',
    '年': 'Ano',
    '1月': 'Jan',
    '2月': 'Fev',
    '3月': 'Mar',
    '4月': 'Abr',
    '5月': 'Mai',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Ago',
    '9月': 'Set',
    '10月': 'Out',
    '11月': 'Nov',
    '12月': 'Dez',
    '一月': 'Janeiro',
    '二月': 'Fevereiro',
    '三月': 'Março',
    '四月': 'Abril',
    '五月': 'Maio',
    '六月': 'Junho',
    '七月': 'Julho',
    '八月': 'Agosto',
    '九月': 'Setembro',
    '十月': 'Outubro',
    '十一月': 'Novembro',
    '十二月': 'Dezembro',
    '加载中...': 'Carregando...'
  },
  // 俄语
  ruru: {
    '请选择': 'Выберите',
    '确定': 'OK',
    '更多': 'Ещё',
    '收起': 'Свернуть',
    '展开': 'Развернуть',
    '暂无数据': 'Нет данных',
    '限': 'Ограничение',
    '字': 'символов',
    '还可输入': 'Можно ввести ещё',
    '取消': 'Отмена',
    '删除': 'Удалить',
    '提示': 'Подсказка',
    '清空': 'Очистить',
    '校验失败！': 'Ошибка проверки!',
    '上一页': 'Назад',
    '下一页': 'Вперёд',
    '每页显示': 'Показать на странице',
    '共': 'Всего',
    '跳至': 'Перейти к',
    '页': 'стр.',
    '条': 'записей',
    '暂无匹配数据': 'Нет совпадений',
    '详细': 'Подробно',
    '日': 'Вс',
    '一': 'Пн',
    '二': 'Вт',
    '三': 'Ср',
    '四': 'Чт',
    '五': 'Пт',
    '六': 'Сб',
    '年': 'год',
    '1月': 'янв',
    '2月': 'фев',
    '3月': 'мар',
    '4月': 'апр',
    '5月': 'май',
    '6月': 'июн',
    '7月': 'июл',
    '8月': 'авг',
    '9月': 'сен',
    '10月': 'окт',
    '11月': 'ноя',
    '12月': 'дек',
    '一月': 'Январь',
    '二月': 'Февраль',
    '三月': 'Март',
    '四月': 'Апрель',
    '五月': 'Май',
    '六月': 'Июнь',
    '七月': 'Июль',
    '八月': 'Август',
    '九月': 'Сентябрь',
    '十月': 'Октябрь',
    '十一月': 'Ноябрь',
    '十二月': 'Декабрь',
    '加载中...': 'Загрузка...'
  },
  // 阿拉伯语
  arsa: {
    '请选择': 'يرجى التحديد',
    '确定': 'موافق',
    '更多': 'المزيد',
    '收起': 'طي',
    '展开': 'توسيع',
    '暂无数据': 'لا توجد بيانات',
    '限': 'محدود بـ',
    '字': 'كلمة',
    '还可输入': 'يمكن أيضًا إدخال',
    '取消': 'إلغاء',
    '删除': 'حذف',
    '提示': 'تلميح',
    '清空': 'إفراغ',
    '校验失败！': 'فشل التحقق!',
    '上一页': 'السابق',
    '下一页': 'التالي',
    '每页显示': 'عرض لكل صفحة',
    '共': 'الإجمالي',
    '跳至': 'انتقل إلى',
    '页': 'صفحات',
    '条': 'قوائم',
    '暂无匹配数据': 'لا توجد بيانات مطابقة',
    '详细': 'التفاصيل',
    '日': 'الأحد',
    '一': 'الإثنين',
    '二': 'الثلاثاء',
    '三': 'الأربعاء',
    '四': 'الخميس',
    '五': 'الجمعة',
    '六': 'السبت',
    '年': 'سنة',
    '1月': 'يناير',
    '2月': 'فبراير',
    '3月': 'مارس',
    '4月': 'أبريل',
    '5月': 'مايو',
    '6月': 'يونيو',
    '7月': 'يوليو',
    '8月': 'أغسطس',
    '9月': 'سبتمبر',
    '10月': 'أكتوبر',
    '11月': 'نوفمبر',
    '12月': 'ديسمبر',
    '一月': 'يناير',
    '二月': 'فبراير',
    '三月': 'مارس',
    '四月': 'أبريل',
    '五月': 'مايو',
    '六月': 'يونيو',
    '七月': 'يوليو',
    '八月': 'أغسطس',
    '九月': 'سبتمبر',
    '十月': 'أكتوبر',
    '十一月': 'نوفمبر',
    '十二月': 'ديسمبر',
    '加载中...': 'جار التحميل...'
  },
  // 老挝语
  lola: {
    '请选择': 'ກະລຸນາເລືອກ',
    '确定': 'ຕົກລົງ',
    '更多': 'ເພີ່ມເຕີມ',
    '收起': 'ຫຍໍ້',
    '展开': 'ຂະຫຍາຍ',
    '暂无数据': 'ບໍ່ມີຂໍ້ມູນ',
    '限': 'ຈຳກັດທີ່',
    '字': 'ຕົວອັກສອນ',
    '还可输入': 'ຍັງສາມາດໃສ່ເພີ່ມ',
    '取消': 'ຍົກເລີກ',
    '删除': 'ລຶບ',
    '提示': 'ແຈ້ງເຕືອນ',
    '清空': 'ລ້າງ',
    '校验失败！': 'ກວດສອບລົ້ມເຫຼວ!',
    '上一页': 'ກ່ອນໜ້າ',
    '下一页': 'ໜ້າຕໍ່ໄປ',
    '每页显示': 'ສະແດງຕໍ່ໜ້າ',
    '共': 'ລວມ',
    '跳至': 'ຂ້າມໄປ',
    '页': 'ໜ້າ',
    '条': 'ລາຍການ',
    '暂无匹配数据': 'ບໍ່ພົບຂໍ້ມູນທີ່ຕົງກັນ',
    '详细': 'ລາຍລະອຽດ',
    '日': 'ວັນອາທິດ',
    '一': 'ວັນຈັນ',
    '二': 'ວັນອັງຄານ',
    '三': 'ວັນພຸດ',
    '四': 'ວັນພະຫັດ',
    '五': 'ວັນສຸກ',
    '六': 'ວັນເສົາ',
    '年': 'ປີ',
    '1月': 'ມ.ກ.',
    '2月': 'ກ.ພ.',
    '3月': 'ມ.ນ.',
    '4月': 'ມ.ສ.',
    '5月': 'ພ.ພ.',
    '6月': 'ມິ.ຖ.',
    '7月': 'ກ.ລ.',
    '8月': 'ສ.ຫ.',
    '9月': 'ກ.ຍ.',
    '10月': 'ຕ.ລ.',
    '11月': 'ພ.ຈ.',
    '12月': 'ທ.ວ.',
    '一月': 'ມັງກອນ',
    '二月': 'ກຸມພາ',
    '三月': 'ມີນາ',
    '四月': 'ເມສາ',
    '五月': 'ພຶດສະພາ',
    '六月': 'ມິຖຸນາ',
    '七月': 'ກໍລະກົດ',
    '八月': 'ສິງຫາ',
    '九月': 'ກັນຍາ',
    '十月': 'ຕຸລາ',
    '十一月': 'ພະຈິກ',
    '十二月': 'ທັນວາ',
    '加载中...': 'ກຳລັງໂຫຼດ...'
  },
  // 泰语
  thth: {
    '请选择': 'กรุณาเลือก',
    '确定': 'ตกลง',
    '更多': 'เพิ่มเติม',
    '收起': 'ย่อ',
    '展开': 'ขยาย',
    '暂无数据': 'ไม่มีข้อมูล',
    '限': 'จำกัดที่',
    '字': 'คำ',
    '还可输入': 'สามารถป้อนได้อีก',
    '取消': 'ยกเลิก',
    '删除': 'ลบ',
    '提示': 'เคล็ดลับ',
    '清空': 'ล้าง',
    '校验失败！': 'การตรวจสอบล้มเหลว!',
    '上一页': 'ก่อนหน้า',
    '下一页': 'ถัดไป',
    '每页显示': 'แสดงต่อหน้า',
    '共': 'รวม',
    '跳至': 'ข้ามไปที่',
    '页': 'หน้า',
    '条': 'รายการ',
    '暂无匹配数据': 'ไม่พบข้อมูลที่ตรงกัน',
    '详细': 'รายละเอียด',
    '日': 'อา.',
    '一': 'จ.',
    '二': 'อ.',
    '三': 'พ.',
    '四': 'พฤ.',
    '五': 'ศ.',
    '六': 'ส.',
    '年': 'ปี',
    '1月': 'ม.ค.',
    '2月': 'ก.พ.',
    '3月': 'มี.ค.',
    '4月': 'เม.ย.',
    '5月': 'พ.ค.',
    '6月': 'มิ.ย.',
    '7月': 'ก.ค.',
    '8月': 'ส.ค.',
    '9月': 'ก.ย.',
    '10月': 'ต.ค.',
    '11月': 'พ.ย.',
    '12月': 'ธ.ค.',
    '一月': 'มกราคม',
    '二月': 'กุมภาพันธ์',
    '三月': 'มีนาคม',
    '四月': 'เมษายน',
    '五月': 'พฤษภาคม',
    '六月': 'มิถุนายน',
    '七月': 'กรกฎาคม',
    '八月': 'สิงหาคม',
    '九月': 'กันยายน',
    '十月': 'ตุลาคม',
    '十一月': 'พฤศจิกายน',
    '十二月': 'ธันวาคม',
    '加载中...': 'กำลังโหลด...'
  }
};

var locale = null;
var getlang = function getlang(key) {
  // 如果url里带参数则直接用
  if (!locale) {
    var _locale = '';
    if (window._cb && window._cb.lang.lang) {
      _locale = window._cb.lang.lang;
    } else if (window.cb && window.cb.lang && window.cb.lang.lang) {
      _locale = window.cb.lang.lang;
    } else if (window.lang && window.lang.lang) {
      _locale = window.lang.lang;
    } else {
      try {
        _locale = _ycUserContext2.default.getLangLocale();
      } catch (e) {
        // do nothing
      }
    }
    if (_locale) {
      locale = _locale.replace('-', '').replace('_', '').toLowerCase();
    }
  }
  // if (document.cookie.indexOf('u_locale=en_US') >= 0) {
  //   locale = 'enus'
  // }
  // 如果没有设置默认值
  if (!locale) {
    locale = 'zhcn';
  }
  if (locale !== 'zhcn') {
    if (lang.hasOwnProperty(locale)) {
      return lang[locale] ? lang[locale][key] : key;
    } else {
      return key;
    }
  } else {
    return key;
  }
};

exports.default = getlang;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__(149);

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__(376);

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__(377);

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__(378);

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__(379);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(380);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return top; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return basePlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clippingParents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return viewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return popper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return variationPlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return placements; });
/* unused harmony export beforeRead */
/* unused harmony export read */
/* unused harmony export afterRead */
/* unused harmony export beforeMain */
/* unused harmony export main */
/* unused harmony export afterMain */
/* unused harmony export beforeWrite */
/* unused harmony export write */
/* unused harmony export afterWrite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return modifierPhases; });
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isHTMLElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isShadowRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(15);


function isElement(node) {
  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),
/* 11 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(118);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindow;
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(30)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(10);

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["a" /* isElement */])(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(11);
var ctx = __webpack_require__(108);
var hide = __webpack_require__(28);
var has = __webpack_require__(22);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(36);
var IE8_DOM_DEFINE = __webpack_require__(109);
var toPrimitive = __webpack_require__(68);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridRefMixin = exports.changeStyleMixin = exports.validatemixin = exports.refmixin = undefined;

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validatemixin(params) {
  var _this = this;

  this.validate = params.validate || function () {};
  if (params.validate) {
    this.validate(false);
  } else {
    this.validate(true);
  }
  this.judgeValidate = function (val) {
    // 如果不传入validate那么就默认认为检验通过
    if (params.validate) {
      if (val) {
        _this.validate(true);
      } else {
        _this.validate(false);
      }
    } else {
      _this.validate(true);
    }
  };
}

function refmixin(params) {
  if (params.ref) {
    if (window.YCLOUD_REFS) {
      var refs = window.YCLOUD_REFS;
      refs[params.ref] = this;
    } else {
      window.YCLOUD_REFS = {};
      window.YCLOUD_REFS[params.ref] = this;
    }
  }
}

function changeStyleMixin(params) {
  var _this2 = this;

  // 用于input特殊的修改标记，如果值被改变，则变红
  this.oldValue = _knockout2.default.utils.unwrapObservable(this.value);
  this.textChanged = _knockout2.default.observable(false);
  this.enableChangingStyle = params.enableChangingStyle || false;
  this.value.subscribe && this.value.subscribe(function (value) {
    if (_this2.enableChangingStyle && _this2.oldValue === '') {
      _this2.oldValue = value;
    }
  });
}

function gridRefMixin(params) {
  if (params.gridRef) {
    params.gridRef[0].set(this, params.gridRef[1], params.gridRef[2]);
    // 通常表格列不超过30
    this.tabindex = (params.gridRef[1] + 1) * 30 + params.gridRef[2];
  }
  this.tabindex = this.tabindex || '';
}
exports.refmixin = refmixin;
exports.validatemixin = validatemixin;
exports.changeStyleMixin = changeStyleMixin;
exports.gridRefMixin = gridRefMixin;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(242),
    getValue = __webpack_require__(245);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeName;
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBasePlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(9);

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return round; });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(21);
var createDesc = __webpack_require__(49);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(112);
var defined = __webpack_require__(69);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_32__;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(12);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(33),
    getRawTag = __webpack_require__(224),
    objectToString = __webpack_require__(225);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(73)('wks');
var uid = __webpack_require__(52);
var Symbol = __webpack_require__(17).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(114);
var enumBugKeys = __webpack_require__(74);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(69);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(122),
    isLength = __webpack_require__(75);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(137),
    baseKeys = __webpack_require__(296),
    isArrayLike = __webpack_require__(39);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toThousands = undefined;

var _keycode = __webpack_require__(152);

var _keycode2 = _interopRequireDefault(_keycode);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function removeZero(num) {
  if (isNaN(num)) {
    return num;
  }
  var result = Number(num);
  return result;
}
// 数字转成千分位
function toThousands(num, isKeepZero) {
  if (isNaN(num)) {
    return num;
  }
  var orialNum = num;
  if (!isKeepZero) {
    num = Math.abs(num);
  }
  num = (num || 0).toString();
  var result = '';
  var nums = num.split('.');
  // 整数部分
  var integerPart = nums[0];
  // 小数部分
  var decimalPart = nums.length > 1 ? nums[1] : 0;
  while (integerPart.length > 3) {
    result = ',' + integerPart.slice(-3) + result;
    integerPart = integerPart.slice(0, integerPart.length - 3);
  }
  if (integerPart) {
    result = integerPart + result;
  }
  if (isKeepZero) {
    result += '.' + decimalPart;
  } else {
    if (Number(decimalPart)) {
      // 末位去零
      result += '.' + Number('0.' + decimalPart).toString().split('.')[1];
    }
  }
  if (orialNum < 0) {
    result = '-' + result;
  }
  return result;
}
var getAllColumns = function getAllColumns(cols) {
  var forTableHead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var columns = cols;
  var result = [];
  columns.forEach(function (column) {
    if (column.children && column.children.length > 0) {
      if (forTableHead) result.push(column);
      result.push.apply(result, getAllColumns(column.children, forTableHead));
    } else {
      result.push(column);
    }
  });
  return result;
};
var convertToRowsHeader = function convertToRowsHeader(columns) {
  var fixedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // 锁定列要重复处理，确认下，先以最简单的columns为例子
  // const originColumns = fixedType ? fixedType === 'left' ? deepCopy(convertColumnOrder(columns, 'left')) : deepCopy(convertColumnOrder(columns, 'right')) : deepCopy(columns);
  var originColumns = columns;
  var maxLevel = 1;
  var traverse = function traverse(column, parent) {
    if (parent) {
      column.level = parent.level + 1;
      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }
    if (!column._show) {
      column._show = _knockout2.default.observable(true);
    }
    if (!column._needRender) {
      column._needRender = _knockout2.default.observable(true);
    }
    // 对于不显示的列则不进行计算
    if (!_knockout2.default.utils.unwrapObservable(column._show)) {
      column.colspan = 0;
    } else {
      if (column.children && column.children.length > 0) {
        var colSpan = 0;
        column.children.forEach(function (subColumn) {
          traverse(subColumn, column);
          colSpan += subColumn.colspan;
        });
        column.colspan = colSpan;
      } else {
        column.colspan = 1;
      }
    }
  };
  originColumns.forEach(function (column) {
    column.level = 1;
    traverse(column);
  });

  var rows = [];
  for (var i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  var allColumns = getAllColumns(originColumns, true);
  allColumns.forEach(function (column) {
    if (!column.children || column.children.length === 0) {
      column.rowspan = maxLevel - column.level + 1;
    } else {
      column.rowspan = 1;
    }
    rows[column.level - 1].push(column);
  });
  // debugger
  return rows;
};
var util = {
  formatText: function formatText(row, col) {
    var result = void 0;
    if (typeof row.ref === 'function' && col.field) {
      result = row.getValue(col.field); // 使用ko属性数值改变才能被监听到
    } else {
      result = row[col.field];
    }
    return result;
  },
  defaultFormatText: function defaultFormatText(row, col) {
    var result = void 0;
    if (typeof row.ref === 'function' && col.field) {
      result = row.ref(col.field)(); // 使用ko属性数值改变才能被监听到
    } else {
      result = row[col.field];
    }
    if (col.dataType) {
      if (col.dataType === 'date') {
        if (result) {
          result = new Date(result)._format('yyyy-MM-dd');
        }
      } else if (col.dataType === 'datetime') {
        if (result) {
          result = new Date(result)._format('yyyy-MM-dd hh:mm:ss');
        }
      } else if (col.dataType === 'financial') {
        // 财务数字
        if (result) {
          result = toThousands(result);
        }
      } else if (col.dataType === 'removeZero') {
        // 金额 单价类（自动末位0去掉，是几位小数就按几位小数显示）
        if (result) {
          result = removeZero(result);
        }
      }
    }
    return result;
  },
  matches: function matches(element, selector) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
        var matches = element.parentNode.querySelectorAll(s);
        var i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
    }

    return element.matches(selector);
  },
  findClosest: function findClosest(element, selector) {
    if (!element) {
      return null;
    }
    if (util.matches(element, selector)) {
      return element;
    } else {
      return util.findClosest(element.parentNode, selector);
    }
  },
  Aria: {
    KeyCode: _keycode2.default
  },
  convertToRowsHeader: convertToRowsHeader,
  getAllColumns: getAllColumns
};
exports.toThousands = toThousands;
exports.default = util;

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBoundingClientRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_math_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindow_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__ = __webpack_require__(164);




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["b" /* isHTMLElement */])(element)) {
    scaleX = element.offsetWidth > 0 ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["c" /* round */])(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["c" /* round */])(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["a" /* isElement */])(element) ? Object(__WEBPACK_IMPORTED_MODULE_2__getWindow_js__["a" /* default */])(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !Object(__WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__["a" /* default */])() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffsetParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeName_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isTableElement_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getParentNode_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent_js__ = __webpack_require__(165);








function getTrueOffsetParent(element) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element) || // https://github.com/popperjs/popper-core/issues/837
  Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(Object(__WEBPACK_IMPORTED_MODULE_6__utils_userAgent_js__["a" /* default */])());
  var isIE = /Trident/i.test(Object(__WEBPACK_IMPORTED_MODULE_6__utils_userAgent_js__["a" /* default */])());

  if (isIE && Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = Object(__WEBPACK_IMPORTED_MODULE_5__getParentNode_js__["a" /* default */])(element);

  if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["c" /* isShadowRoot */])(currentNode)) {
    currentNode = currentNode.host;
  }

  while (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(currentNode) && ['html', 'body'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(currentNode)) < 0) {
    var css = Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && Object(__WEBPACK_IMPORTED_MODULE_4__isTableElement_js__["a" /* default */])(offsetParent) && Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'html' || Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'body' && Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getComputedStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(15);

function getComputedStyle(element) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element).getComputedStyle(element);
}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getVariation;
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detectOverflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__ = __webpack_require__(170);








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* clippingParents */] : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["o" /* viewport */] : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = Object(__WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : Object(__WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_5__enums_js__["b" /* basePlacements */]));
  var altContext = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["j" /* reference */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */];
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__["a" /* isElement */])(element) ? element : element.contextElement || Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__["a" /* default */])(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__["a" /* default */])(state.elements.reference);
  var popperOffsets = Object(__WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__["a" /* default */])({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = Object(__WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__["a" /* default */])(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["k" /* right */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(key) >= 0 ? 1 : -1;
      var axis = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _split = __webpack_require__(223);

var _split2 = _interopRequireDefault(_split);

var _debounce = __webpack_require__(78);

var _debounce2 = _interopRequireDefault(_debounce);

var _difference = __webpack_require__(237);

var _difference2 = _interopRequireDefault(_difference);

var _findIndex = __webpack_require__(278);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _groupBy = __webpack_require__(316);

var _groupBy2 = _interopRequireDefault(_groupBy);

var _throttle = __webpack_require__(325);

var _throttle2 = _interopRequireDefault(_throttle);

var _cloneDeep = __webpack_require__(326);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = {
  split: _split2.default,
  debounce: _debounce2.default,
  difference: _difference2.default,
  findIndex: _findIndex2.default,
  groupBy: _groupBy2.default,
  throttle: _throttle2.default,
  cloneDeep: _cloneDeep2.default
};
exports.default = _;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(118);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)(module)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(250),
    listCacheDelete = __webpack_require__(251),
    listCacheGet = __webpack_require__(252),
    listCacheHas = __webpack_require__(253),
    listCacheSet = __webpack_require__(254);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(55);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(256);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(298),
    Map = __webpack_require__(80),
    Promise = __webpack_require__(299),
    Set = __webpack_require__(300),
    WeakMap = __webpack_require__(301),
    baseGetTag = __webpack_require__(34),
    toSource = __webpack_require__(126);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(54);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(144),
    baseAssignValue = __webpack_require__(89);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 弹框时禁止滚动条滚动
function hasScroll() {
  return document.body.style.overflow !== 'hidden' && document.body.scroll !== 'no' && document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
}
var scorllWidth = window.innerWidth - document.body.clientWidth;
var locked = false;

function lockScrollEffect() {
  if (window.stopLockEffect) {
    return;
  }
  // 如果有滚动条
  if (!locked && hasScroll()) {
    locked = true;
    document.body.style.overflow = 'hidden';
    // fix #24 select展开后会闪烁
    document.body.style.marginRight = scorllWidth > 0 ? scorllWidth + 'px' : '15px';
  }
}

function resetScrollEffect() {
  if (window.stopLockEffect) {
    return;
  }
  if (locked) {
    locked = false;
    document.body.style.overflow = '';
    // fix #24 select展开后会闪烁
    document.body.style.marginRight = 0;
  }
}
exports.lockScrollEffect = lockScrollEffect;
exports.resetScrollEffect = resetScrollEffect;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_65__;

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParentNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(10);



function getParentNode(element) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    Object(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["c" /* isShadowRoot */])(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element) // fallback

  );
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popper = __webpack_require__(487);

var _popper2 = _interopRequireDefault(_popper);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  initialize: function initialize(params) {
    this.visible = _knockout2.default.observable(0);
    this.position = params.position || 'top';
    this.myPopper = '';
    var reg = /(top)|(right)|(bottom)|(left)/g;
    this.thisClass = 'y-poptip-' + this.position.match(reg);
    if (this.position.indexOf('-') > -1) {
      this.thisClass += ' y-poptip-' + this.position;
    }
  },
  subscribe: function subscribe(params) {
    var _this = this;

    this.visible.subscribe(function (val) {
      if (!_this.myPopper && val) {
        var reference = _this.$el.querySelector('.element');
        var popper = _this.$el.querySelector('.y-poptip-ctn');
        _this.myPopper = new _popper2.default(reference, popper, {
          placement: _this.position,
          onCreate: function onCreate(data) {},
          onUpdate: function onUpdate(data) {},
          positionFixed: true,
          modifiers: {
            preventOverflow: {
              enabled: false
            }
          }
        });
      } else {
        _this.myPopper && _this.myPopper.update();
      }
    });
  }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(29);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(36);
var dPs = __webpack_require__(195);
var enumBugKeys = __webpack_require__(74);
var IE_PROTO = __webpack_require__(72)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(110)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(199).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(73)('keys');
var uid = __webpack_require__(52);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(11);
var global = __webpack_require__(17);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(51) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14),
    now = __webpack_require__(234),
    toNumber = __webpack_require__(124);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(239),
    mapCacheDelete = __webpack_require__(255),
    mapCacheGet = __webpack_require__(257),
    mapCacheHas = __webpack_require__(258),
    mapCacheSet = __webpack_require__(259);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(12);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(269),
    isObjectLike = __webpack_require__(16);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(58),
    stackClear = __webpack_require__(281),
    stackDelete = __webpack_require__(282),
    stackGet = __webpack_require__(283),
    stackHas = __webpack_require__(284),
    stackSet = __webpack_require__(285);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(292),
    stubArray = __webpack_require__(136);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(12),
    stubFalse = __webpack_require__(294);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)(module)))

/***/ }),
/* 87 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(54);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(129);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(137),
    baseKeysIn = __webpack_require__(331),
    isArrayLike = __webpack_require__(39);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(133);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _keys = __webpack_require__(415);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(418);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _lodash = __webpack_require__(53);

var _lodash2 = _interopRequireDefault(_lodash);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _gridutil = __webpack_require__(43);

var _gridutil2 = _interopRequireDefault(_gridutil);

var _fastdom = __webpack_require__(153);

var _fastdom2 = _interopRequireDefault(_fastdom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var PAGESIZE = 10;
var PAGEINDEX = 0;
var MIN_TR_HEIGHT = 44;
// 需要支持外部修改crossPageSeletedRows 同时内部全选的时候又不触发
var isTriggerInside = false;
// 获取视窗宽度，一般表格比视窗窄不了多少
var clientWidth = 0;

var Grid = function (_Base) {
  _inherits(Grid, _Base);

  function Grid() {
    _classCallCheck(this, Grid);

    return _possibleConstructorReturn(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).apply(this, arguments));
  }

  _createClass(Grid, [{
    key: 'initialize',
    value: function initialize(params) {
      clientWidth = document.body.clientWidth + 100;
      // 支持表头通过ctrl+click 多级排序
      this.groupSort = _knockout2.default.observable(params.groupSort || false);
      this.fieldid = params.fieldid;
      // 支持键盘操作
      this.aria = params.aria;
      this.fieldid = params.fieldid;
      this.hidefix = _knockout2.default.observable(false).extend({
        deferred: true
      });
      this.columnsFilterable = !!params.columnsFilterable;
      this.showColumnFilter = _knockout2.default.observable(false);
      this.toolbox = params.toolbox || false;
      this.maxLazyRows = params.maxLazyRows || 50;
      this.setting = {
        borderLight: _knockout2.default.observable(true),
        borderDark: _knockout2.default.observable(false),
        borderDarker: _knockout2.default.observable(false)
      };
      this.defaultValue = (0, _assign2.default)({
        _disable: false
      }, params.defaultValue || {});
      this.toolboxvisible = _knockout2.default.observable(false);
      this.lazy = params.lazy;
      this.lockColumnHeight = _knockout2.default.observable({});
      this.isDataTable = params.isDataTable || false;
      this.hasSummaryRow = params.hasSummaryRow || false;
      this.hasChildGrid = params.hasChildGrid || false;
      this.caculateColumns = params.caculateColumns;
      // 只有当columns1和columns2一起启用的时候才认为是启用了rowspanhead
      this.isRowspanHead = !!params.columns1 && !!params.columns2;
      this.headtransform = _knockout2.default.observable('translateX(0)');
      this.fixColumnTransform = _knockout2.default.observable('translateY(0)');
      this.vertiacalScrollTransform = _knockout2.default.observable({});
      this.lockRightWidth = 0;
      this.fixRightHeadtransform = _knockout2.default.observable('translateX(0)');
      this.fixRightTransform = _knockout2.default.observable('translate(0,0)');
      this.rowspan = params.rowspan;
      this.domId = params.rowspan ? Math.random() : '';
      this.isTableBorder = params.isTableBorder || params.rowspan;
      // fixed 把maxheight改成ko对象
      this.maxheight = _knockout2.default.isObservable(params.maxheight) ? params.maxheight : _knockout2.default.observable(params.maxheight || '486px');
      // fixed issue 111 当设置了auto之后，需要把外层y-grid的overflow设置成visible，防止auto+更多操作按钮的组合遮挡住浮动框
      this.isAutoHeight = _knockout2.default.utils.unwrapObservable(params.maxheight) === 'auto';
      this.minheight = params.minheight || 'auto';
      this.isStripe = params.isStripe || false;
      this.expand = params.expand || true;
      // 是否启用自定义的transform
      this.verticalScroll = params.verticalScroll || false;
      this.scrollStyle = params.scrollStyle || {};
      // 是否显示loading图标
      this.isShowLoading = _knockout2.default.observable(false);
      // 是否隐藏表头
      this.nohead = params.nohead || false;
      this.noborder = params.noborder || false;
      // expand是否默认展开
      this.defaultExpand = params.defaultExpand || false;
      // 是否启用分页组件
      this.pagination = _knockout2.default.observable(params.pagination || false);
      // 是否启用固定列
      this.lockcolumn = _knockout2.default.isObservable(params.lockcolumn) ? params.lockcolumn : _knockout2.default.observable(params.lockcolumn || false);
      this.lockright = params.lockright || false;
      this.showLockRightToolBar = _knockout2.default.observable(true);
      // 固定表头
      this.lockhead = params.lockhead || this.lockcolumn();

      this.headHeight = params.headHeight ? _knockout2.default.observable(params.headHeight) : _knockout2.default.observable('29px');
      this.scrollHeight = params.scrollHeight || '15px';
      this.startIndex = params.startIndex || 0;
      this.pageSize = params.pageSize || _knockout2.default.observable(PAGESIZE);
      this.pageIndex = params.pageIndex || _knockout2.default.observable(PAGEINDEX);
      this.pageSizeList = params.pageSizeList;
      this.totalCount = params.totalCount || _knockout2.default.observable(0);
      this.tdstyle = params.tdstyle || {};
      this.verticalAlign = params.verticalAlign || 'middle';
      // event binding
      // 行选中
      this.onRowSelect = params.onRowSelect || function () {};
      this.onPageChange = params.onPageChange;
      this.onSizeChange = params.onSizeChange;
      this.isSeparate = params.isSeparate || false;
      this.style = params.style || {};
      this.forbitRowSelect = _knockout2.default.observable(params.forbitRowSelect || false);
      this.forbitRowSelectFn = params.forbitRowSelectFn;
      // 放在弹框内部的需要动态内部高度
      this.modalBodyModalHeight = params.modalBodyModalHeight || 0;
      this.modalBodyExtraHeight = params.modalBodyExtraHeight || '0';
      this.onModalOkValidate = params.onModalOkValidate || function () {};
      // add by songhlc 2018-01-02 添加grid跨页选中功能
      this.crossPageSelectedRows = params.crossPageSelectedRows; // 如果rows的是datatable那么这里存的row就是datatable的row
      // 默认使用id属性做为行唯一标识符
      this.crossPageRowPrimaryKey = params.crossPageRowPrimaryKey || 'id';
      // 用于判断是否启用跨页选择
      this.isEnableCrossPage = Boolean(this.crossPageSelectedRows);
      // 用于触发宽度重新计算
      this.reComputedTableWidth = _knockout2.default.observable(false);
      // 当前表格的leftBoy、rightBody、mainBody引用
      this.bodyrefs = {
        mainbody: '',
        leftBody: '',
        rightBody: ''
      };
      this.children = {
        body: ''
      };
    }
  }, {
    key: 'computed',
    value: function computed(params) {
      var _this2 = this;

      var that = this;
      if (this.toolbox) {
        this.borderActive = _knockout2.default.computed(function () {
          if (_this2.setting.borderDarker()) {
            return 'Darker';
          } else if (_this2.setting.borderDark()) {
            return 'Dark';
          } else {
            return 'Light';
          }
        });
      }
      // 计算表格最高高度
      this.computedMaxHeight = _knockout2.default.computed(function () {
        var maxheight = _this2.maxheight();
        // 如果是在modal中，maxheight = 外层height - extraHeight - paginationHeight - 内层padding高度
        if (maxheight === 'auto') {
          return 'auto';
        } else if (_this2.modalBodyModalHeight) {
          var _modalBodyModalHeight = _this2.modalBodyModalHeight.toString().replace('px', '');
          var _modalBodyExtraHeight = _this2.modalBodyExtraHeight.replace('px', '');
          var _paginationHeight = 0;
          var _paddingHeight = 33; // padding+border高度
          if (_this2.pagination()) {
            _paginationHeight = 36;
          }
          var result = _modalBodyModalHeight - _modalBodyExtraHeight - _paginationHeight - _paddingHeight;
          // 如果超过允许外层的最大高度
          if (maxheight.replace('px', '') - 0 > result) {
            return result + 'px';
          } else {
            return maxheight;
          }
        } else {
          return maxheight;
        }
      });
      // 用来动态高度计算用的
      this.columnNumberHeight = _knockout2.default.pureComputed(function () {
        var item = _this2.lockColumnHeight();
        var length = _this2.rows.peek().length;
        var array = new Array(length);
        for (var i = 0; i < length; i++) {
          array[i] = MIN_TR_HEIGHT;
        }
        (0, _keys2.default)(item).map(function (key) {
          array[key] = item[key].height.replace('px', '') - 0;
        });
        return array;
      }).extend({
        deferred: true
      });
      // 外部使用判断当前合适的高度 用于每一行高度不一致的时候
      // 由于更新问题 可能返回-1 当返回-1时需要和外部
      // 老代码 不推荐使用
      this.getFitIndexByScrollTop = function (destHeight) {
        var sum = 0;
        var index = -1;
        var lockColumnHeight = _this2.columnNumberHeight();
        for (var i = 0; i < lockColumnHeight.length; i++) {
          if (destHeight > sum) {
            sum += lockColumnHeight[i];
          } else {
            index = i;
            break;
          }
        }
        return index;
      };
      // 外部使用判断当前合适的高度 用于每一行高度不一致的时候
      this.getCurIndexByScrollTop = function (destHeight) {
        var sum = 0;
        var index = -1;
        var lockColumnHeight = _this2.columnNumberHeight();
        for (var i = 0; i < lockColumnHeight.length; i++) {
          if (destHeight > sum) {
            sum += lockColumnHeight[i];
          } else {
            index = i;
            break;
          }
        }
        if (index === -1) {
          // 有些没有算对的高度 通过最小高度来补齐
          index = lockColumnHeight.length + Math.round((destHeight - sum) / MIN_TR_HEIGHT);
        }
        return index;
      };
      // 已选中的ids
      this.crossPageSelectedIds = _knockout2.default.computed(function () {
        if (_this2.isEnableCrossPage) {
          return _this2.crossPageSelectedRows().map(function (row) {
            if (_this2.isDataTable) {
              return row.ref(_this2.crossPageRowPrimaryKey)();
            } else {
              return row[_this2.crossPageRowPrimaryKey];
            }
          });
        } else {
          return [];
        }
      }).extend({
        defered: true
      });
      this.rows = _knockout2.default.computed(function () {
        // 如果是内部设置setRowSelect 则不重新触发,直接返回原来的数据
        if (!isTriggerInside) {
          var datas = params.rows();
          datas.forEach(function (row, index) {
            // 减轻重复赋值的压力
            if (!row._delete) {
              row._delete = _knockout2.default.observable(false);
            }
            if (!row._hover) {
              row._hover = _knockout2.default.observable(false);
            }

            if (!row._disabled) {
              row._disabled = _knockout2.default.observable(_this2.defaultValue._disable);
            }
            if (!row._expand) {
              row._expand = _knockout2.default.observable(_this2.defaultExpand);
            }

            // 用户保存行状态
            !row._rowStatus && (row._rowStatus = _knockout2.default.observable(''));
            if (_this2.isDataTable) {
              // 如果是dataTable设置成计算属性
              !row._selected && (row._selected = _knockout2.default.pureComputed({
                read: function read() {
                  return row.selected();
                },
                write: function write(val) {
                  isTriggerInside = true;
                  // 设置datatable的选中
                  if (val) {
                    row.parent.addRowSelect(row);
                  } else {
                    row.parent.setRowUnSelect(row);
                  }
                  if (that.crossPageSelectedRows) {
                    // 设置已选中rows的值
                    var _index = that.crossPageSelectedIds().indexOf(row.getValue(that.crossPageRowPrimaryKey));
                    if (val) {
                      if (_index === -1) {
                        that.crossPageSelectedRows.push(row);
                      }
                    } else {
                      if (_index >= 0) {
                        that.crossPageSelectedRows.splice(_index, 1);
                      }
                    }
                  }
                  setTimeout(function () {
                    isTriggerInside = false;
                  });
                  that.onRowSelect(row);
                }
              }));
              // setRowSelect会触发rows重新渲染,此处要避免
              // 如果当前行在已选中的ids中则设置选中（设置默认选中）这里不能使用监听对象，初始化的时候要用peek
              if (that.isEnableCrossPage && that.crossPageSelectedIds.peek().indexOf(row.getValue(that.crossPageRowPrimaryKey)) >= 0) {
                row.parent.addRowSelect(row);
              }
            } else {
              var newRow = !row._selected;
              newRow && (row._selected = _knockout2.default.observable(false));
              if (that.isEnableCrossPage) {
                // 初始化选中状态
                if (that.crossPageSelectedIds().indexOf(row[that.crossPageRowPrimaryKey]) >= 0) {
                  row._selected(true);
                } else {
                  row._selected(false);
                }
              }
              if (newRow) {
                row._selected.subscribe(function (val) {
                  if (that.isEnableCrossPage) {
                    // 设置已选中rows的值
                    var _index = that.crossPageSelectedIds().indexOf(row[that.crossPageRowPrimaryKey]);
                    if (val) {
                      if (_index === -1) {
                        params.crossPageSelectedRows.push(row);
                      }
                    } else {
                      if (_index >= 0) {
                        params.crossPageSelectedRows.splice(_index, 1);
                      }
                    }
                  }
                  that.onRowSelect(row);
                });
              }
            }
          });
        }
        return params.rows();
      }).extend({
        deferred: true
      });
      this.rows.subscribe(function () {
        _knockout2.default.tasks.schedule(function () {
          var _el = params.$el.querySelector('.y-grid');
          if (_el.scrollHeight > _el.clientHeight || _el.offsetHeight > _el.clientHeight) {
            _this2.hasVerticalSroll(true);
          } else {
            _this2.hasVerticalSroll(false);
          }
        });
      });
      // 用于存储对应关系
      this.columns1UniqueKeys = {};
      this.columns1 = _knockout2.default.computed(function () {
        if (params.columns1) {
          var _columns1 = [];
          params.columns1().forEach(function (col) {
            if (!col.loop) {
              _columns1.push(col);
            } else {
              // 有数据才根据数据显示loop列
              if (_this2.rows().length > 0) {
                var looplength = col.looplength(_this2.rows()[0]);
                for (var i = 0; i < looplength; i++) {
                  var title = '';
                  // 为了支持索引自定义
                  if (typeof col.title === 'function') {
                    title = col.title(i + 1, looplength);
                  } else {
                    title = col.title.replace('{n}', i + 1);
                  }
                  var _col = (0, _assign2.default)({}, col, {
                    title: title
                  });
                  _columns1.push(_col);
                }
                if (_knockout2.default.isObservable(_this2.columns1UniqueKeys[col.uniqueKey])) {
                  _this2.columns1UniqueKeys[col.uniqueKey](looplength);
                } else {
                  _this2.columns1UniqueKeys[col.uniqueKey] = _knockout2.default.observable(looplength);
                }
              } else {
                _this2.columns1UniqueKeys[col.uniqueKey] = _knockout2.default.observable(0);
              }
            }
          });
          return _columns1;
        } else {
          return [];
        }
      });
      // 暂定只支持ko对象
      this.columns2 = _knockout2.default.computed(function () {
        if (params.columns2) {
          var _columns2 = [];
          params.columns2().forEach(function (col) {
            if (!col.loop) {
              _columns2.length++;
            } else {
              _columns2.length += _this2.columns1UniqueKeys[col.uniqueKey]();
            }
          });
          var crossLength = _lodash2.default.groupBy(params.columns2().map(function (col) {
            return {
              key: col.uniqueKey
            };
          }), 'key');
          var index = 0;
          params.columns2().forEach(function (col) {
            // 找到第一个没有赋值的列然后塞入
            while (_columns2[index]) {
              index++;
            }
            if (!col.loop) {
              _columns2[index] = col;
              index++;
            } else {
              var _length = _this2.columns1UniqueKeys[col.uniqueKey]();
              for (var i = 0; i < _length; i++) {
                _columns2[index + i * crossLength[col.uniqueKey].length] = (0, _assign2.default)({}, col, {
                  _childIndex: i
                });
              }
              // 计算索引
              if (_length > 0) {
                index++;
              }
            }
          });
          return _columns2;
        } else {
          return [];
        }
      });
      var findMaxSortIndex = function findMaxSortIndex(cols) {
        // columns.push方法获取的sortIndex是错误的
        // TODO: 需要splice的情况
        var hasSortIndex = cols.filter(function (item) {
          return item.sortIndex || item._sortIndex;
        }).map(function (item) {
          return {
            sortIndex: item.sortIndex || item._sortIndex
          };
        });
        if (hasSortIndex.length === 0) {
          return cols.length;
        } else {
          return hasSortIndex.reduce(function (prev, next) {
            if (prev.sortIndex > next.sortIndex) {
              return prev;
            } else {
              return next;
            }
          }, { sortIndex: 0 }).sortIndex;
        }
      };
      // 添加ycloud 列顺序，如果columns存在sort属性，则会根据sort进行重新排序
      this.sortColumn = function (columns) {
        if (_this2.isRowspanHead) {
          return columns;
        }
        var sortedCols = [];
        var allColumns = findMaxSortIndex(columns);
        columns.forEach(function (col, index) {
          if (!col.sortIndex) {
            col._sortIndex = ++allColumns;
          } else {
            if (window.isNaN(Number(col.sortIndex))) {
              console.error('columns ' + col.field + '\'s props sortIndex should be a Number');
            } else {
              // 现在的算法会给没有sortIndex的列也添加sortIndex（改成添加_sortIndex）
              // 如果有sortIndex则优先级变得很高, -100 保证有sortInde肯定在前面，一般来说100列够用列
              col._sortIndex = col.sortIndex - 100;
            }
          }
          sortedCols.push(col);
        });
        sortedCols.sort(function (pre, next) {
          return pre._sortIndex - next._sortIndex;
        });
        return sortedCols;
      };
      // 支持外部重新设置表格的顺序
      this.resetColumnSortIndex = function (fieldMap) {
        if (!_knockout2.default.isObservable(params.columns)) {
          console.error('使用resetColumnSortIndex，传入的columns需要是ko.observableArray对象！');
        } else {
          var originFieldIndexMap = {};
          params.columns().forEach(function (col, index) {
            if (col.field) {
              if (originFieldIndexMap[col.field]) {
                console.warn('存在重复的field定义，请确认');
              }
              originFieldIndexMap[col.field] = index;
            }
          });
          (0, _keys2.default)(fieldMap).forEach(function (field) {
            var colIndex = originFieldIndexMap[field];
            if (isNaN(colIndex)) {
              console.error('field:' + field + '在原columns中不存在，请确认！');
            } else {
              params.columns()[colIndex].sortIndex = fieldMap[field];
            }
          });
          params.columns.splice(0, 0);
        }
      };
      // 在需要的时候重新计算列
      this.triggerReset = _knockout2.default.observable(false);
      this.colsWidth = _knockout2.default.observable(0);
      var cacheOffsetWidth = 0;
      this.fullWidth = function (cols) {
        var colWidth = cols.map(function (cell) {
          return cell._width || cell.width;
        }).reduce(function (a, b) {
          return Number(a || 0) + Number(b || 0);
        }, 0);
        _this2.colsWidth(colWidth);
        var outerCtnWidth = 0;
        // 缓存数据，防止重复查询offsetWidth 空数组时不处理
        if (cols.length > 0) {
          if (cacheOffsetWidth === 0) {
            outerCtnWidth = params.$el.querySelector('.y-grid-wrapper').offsetWidth;
            if (outerCtnWidth !== 0) {
              cacheOffsetWidth = outerCtnWidth;
            }
          } else {
            var _width = params.$el.querySelector('.y-grid-wrapper').offsetWidth;
            // 滚动条差异 取小的
            cacheOffsetWidth = Math.abs(_width - cacheOffsetWidth) < 20 ? Math.min(_width, cacheOffsetWidth) : _width;
            outerCtnWidth = cacheOffsetWidth;
          }
        }
        return outerCtnWidth > colWidth;
      };
      // 表格的宽度
      var resetChildrenWidth = function resetChildrenWidth(children, width) {
        var size = children.length;
        var delta = Number(width / size).toFixed(2) - 0;
        children.forEach(function (col) {
          if (!col._width) {
            col._width = col.width;
          }
          col.width = (col._width + '').replace('px', '') - 0 + delta;
          if (col.children) {
            resetChildrenWidth(col.children, delta);
          }
        });
      };
      // 计算真是的columns列
      this.columns = _knockout2.default.computed(function () {
        var columns = [];
        // 重新计算宽度base
        _this2.triggerReset();
        // 先判断是否启用columns1和columns2
        if (_this2.isRowspanHead) {
          var columns2 = [];
          _this2.columns1().forEach(function (col) {
            // 原来是colspan > 1才计算，实际上只要colspan有值就应该处理
            if (col.colspan) {
              var colspanlength = col.colspan;
              if (columns2.length === 0) {
                columns2 = [].concat(_this2.columns2());
              }
              var row2columns = columns2.splice(0, colspanlength);
              columns = columns.concat(row2columns);
            } else {
              columns.push(col);
            }
          });
        }
        if (columns.length === 0) {
          columns = params.columns;
        }
        // 出事化列内置一些属性 _show 用来隐藏和显示列
        var columnsValue = columns;
        if (_knockout2.default.isObservable(columns)) {
          columnsValue = columns();
        }
        columnsValue.forEach(function (col, index) {
          // checkbox设定特殊宽度
          if (col.type === 'checkbox') {
            col.width = 35;
          } else {
            //  某个版本存在设置minWidth不设置width的场景
            if (col.minWidth) {
              col.width = col.minWidth;
            }
            var _width = col.width;
            // 把字符串都转成数字
            if (_width && typeof _width === 'string') {
              try {
                col.width = Number(_width.replace('px', ''));
              } catch (e) {
                console.error('表格列宽度:' + _width + '请设置成数字或合法字符串');
              }
            }
          }
          col.observeTitle = col.observeTitle || false;
          col._show = col._show ? col._show : _knockout2.default.observable(!col.hidden);
          // 如果不是lazy 那么 所有的都是需要渲染的
          col._needRender = col._needRender || _knockout2.default.observable(col.needRender || !_this2.lazy || col.lockright);
        });
        // 原来column1 + columns2 的情况不处理
        if (!params.columns1) {
          var showColumn = columnsValue.filter(function (col) {
            return _knockout2.default.utils.unwrapObservable(col._show);
          });
          if (_this2.fullWidth(showColumn) && _this2.colsWidth() > 0 && cacheOffsetWidth) {
            // 计算要依托于最基础的宽度
            var _colsWidth = showColumn.reduce(function (pre, next) {
              pre.width = pre.width + (next._width || next.width);
              return pre;
            }, {
              width: 0
            }).width;
            var delta = Number((cacheOffsetWidth - _colsWidth) / showColumn.length).toFixed(2) - 0;
            if (delta > 0) {
              // 如果需要计算 把默认y-grid的overflow设置成hidden
              params.$el.querySelector('.y-grid').style['overflow-x'] = 'hidden';
              showColumn.forEach(function (col, index) {
                // 尾差减去1px
                var lastColumnWidthFixed = index === 0 ? 1 : 0;
                if (col.width) {
                  // 把老的宽度缓存下来
                  if (!col._width) {
                    col._width = col.width;
                  }
                  col.width = (col._width + '').replace('px', '') - lastColumnWidthFixed + delta;
                }
                if (col.children) {
                  resetChildrenWidth(col.children, delta - lastColumnWidthFixed);
                }
              });
            } else {
              params.$el.querySelector('.y-grid').style['overflow-x'] = '';
            }
          }
        }
        return _this2.sortColumn(columnsValue);
      });
      // 用于计算当前列索引的宽度
      this.columnsWidth = _knockout2.default.computed(function () {
        var _colsWidth = [];
        var showColWidth = 0;
        _this2.columns().forEach(function (col, index) {
          var _show = null;
          // 可能存在设置固定值的情况
          if (typeof col._show === 'function') {
            _show = col._show();
          } else {
            _show = !!col._show;
          }
          if (_show) {
            showColWidth += col.width || 0;
            // 显示了才触发
            if (showColWidth <= clientWidth) {
              col._needRender(true);
            }
          }
          _colsWidth.push(col.width || 0);
        });
        return _colsWidth;
      });
      this.convertedRows = _knockout2.default.computed(function () {
        if (_this2.isRowspanHead) {
          return _this2.columns();
        } else {
          return _gridutil2.default.convertToRowsHeader(_this2.columns());
        }
      });
      this.convertedColumns = _knockout2.default.computed(function () {
        var columns = _gridutil2.default.getAllColumns(_this2.columns());
        return columns;
      });
      this.lockleftColumns = _knockout2.default.computed(function () {
        var _columns = _this2.columns().filter(function (col) {
          return col.lock;
        });
        // 补充列用于填充行，方便行列合并计算
        _columns.push({
          title: '',
          type: 'render',
          _show: true,
          hideTd: true,
          width: 0,
          _needRender: _knockout2.default.observable(false),
          renderFn: function renderFn(row, index) {
            return index % 2;
          }
        });
        return _columns;
      });
      // 只有表格数据大于10条才显示分页
      this.isShowPagination = _knockout2.default.computed(function () {
        return params.pagination && _this2.totalCount() > Math.min.apply(null, params.pageSizeList ? params.pageSizeList.concat([10]) : [10]);
      });
      this.hasVerticalSroll = _knockout2.default.observable(false);
      this.tableWidth = _knockout2.default.computed(function () {
        var cols = _this2.columns();
        _this2.reComputedTableWidth();
        var isUseOuterWidth = cols.some(function (cell) {
          return isNaN(cell.width);
        });
        if (isUseOuterWidth) {
          return '100%';
        } else {
          return _this2.colsWidth() + 'px';
        }
      });
      this.fixBodyHeight = _knockout2.default.pureComputed(function () {
        if (_this2.height !== 'auto') {
          return _this2.computedMaxHeight().replace('px', '') - _this2.scrollHeight.replace('px', '') + 'px';
        } else {
          return 'auto';
        }
      });
      // 计算锁定列的宽度
      this.fixedTableWidth = _knockout2.default.pureComputed(function () {
        var cols = _this2.columns();
        _this2.triggerReset();
        // lock列需要指定宽度
        var isUseOuterWidth = cols.filter(function (cell) {
          return cell.lock;
        }).filter(function (cell) {
          return cell._show();
        }).some(function (cell) {
          return isNaN(cell.width);
        });
        if (isUseOuterWidth) {
          return '0px';
        } else {
          return cols.filter(function (cell) {
            return cell.lock;
          }).filter(function (cell) {
            return cell._show();
          }).map(function (cell) {
            return cell.width;
          }).reduce(function (a, b) {
            return Number(a) + Number(b);
          }, 0) + 'px';
        }
      });
      this.fixedLockRightTableWidth = _knockout2.default.pureComputed(function () {
        var cols = _this2.columns();
        // lock列需要指定宽度
        var isUseOuterWidth = cols.filter(function (cell) {
          return cell.lockright;
        }).filter(function (cell) {
          return cell._show();
        }).some(function (cell) {
          return isNaN(cell.width);
        });
        if (isUseOuterWidth) {
          return '0px';
        } else {
          return cols.filter(function (cell) {
            return cell.lockright;
          }).filter(function (cell) {
            return cell._show();
          }).map(function (cell) {
            return cell.width;
          }).reduce(function (a, b) {
            return Number(a) + Number(b);
          }, 0) + 'px';
        }
      });
      // grid下有传入自定义组件
      this.hasMarkup = _knockout2.default.computed(function () {
        if (_this2.$templateNodes.length > 0) {
          var nodeList = _this2.$templateNodes.filter(function (node) {
            return node.nodeName !== '#text' && node.nodeName !== '#comment';
          });
          return nodeList.length > 0;
        } else {
          return false;
        }
      });
      // 全选
      this.allRowChecked = _knockout2.default.computed({
        read: function read() {
          var rows = params.rows();
          var flag = rows.length > 0;
          for (var i = 0; i < rows.length; i++) {
            if (this.isDataTable) {
              if (!rows[i].selected()) {
                flag = false;
                break;
              }
            } else {
              if (rows[i]._selected) {
                if (!rows[i]._selected()) {
                  flag = false;
                  break;
                }
              } else {
                flag = false;
              }
            }
          }
          return flag;
        },
        write: function write(isChecked) {
          if (this.isDataTable && this.crossPageSelectedRows) {
            var seletedRow = this.crossPageSelectedRows.peek();
            var seletedIds = seletedRow.map(function (val) {
              return val.getValue(that.crossPageRowPrimaryKey);
            });
            if (isChecked) {
              params.rows().forEach(function (row) {
                var index = seletedIds.indexOf(row.getValue(that.crossPageRowPrimaryKey));
                if (index < 0) {
                  seletedRow.push(row);
                  seletedIds.push(row.rowId);
                }
              });
            } else {
              params.rows().forEach(function (row) {
                var index = seletedIds.indexOf(row.getValue(that.crossPageRowPrimaryKey));
                if (index >= 0) {
                  seletedRow.splice(index, 1);
                  seletedIds.splice(index, 1);
                }
              });
            }
            this.crossPageSelectedRows(seletedRow);
          } else {
            // 如果是dataTable则直接调用dataTable的setAllRowsSelect和setAllRowsUnSelect
            if (this.isDataTable) {
              var _row = params.rows()[0];
              if (_row) {
                var dt = _row.parent;
                if (isChecked) {
                  dt.setAllRowsSelect();
                } else {
                  dt.setAllRowsUnSelect();
                }
              }
            } else {
              params.rows().forEach(function (row) {
                row._selected(isChecked);
              });
              params.rows.splice(0, 0);
            }
          }
        },
        owner: this
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      var _this3 = this;

      this.columns.subscribe(function (val) {
        if (_this3.lockright) {
          _this3.recomputedLockRight();
        }
      });
      this.crossPageSelectedIds.subscribe(function (ids) {
        if (_this3.isDataTable) {
          if (!isTriggerInside) {
            params.rows.peek().forEach(function (row) {
              if (ids.indexOf(row.getValue(_this3.crossPageRowPrimaryKey)) > -1) {
                row.parent.addRowSelect(row);
              } else {
                row.parent.setRowUnSelect(row);
              }
            });
          }
        }
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this4 = this;

      this.handleSettingBorder = function (vm) {
        (0, _keys2.default)(_this4.setting).map(function (key) {
          if ('border' + vm.tag === key) {
            this.setting[key](true);
          } else {
            this.setting[key](false);
          }
        }.bind(_this4));
      };
      this.handleSetting = function () {
        _this4.toolboxvisible(!_this4.toolboxvisible());
      };
      this.setBodyContext = function (Context) {
        _this4.children.body = Context;
      };
      // 切换lockright动态显示
      this.handleToogleLockright = function (vm, event) {
        if (event.currentTarget.classList.contains('y-lock-toolbar-hide')) {
          _this4.showLockRightToolBar(true);
          event.currentTarget.classList.remove('y-lock-toolbar-hide');
        } else {
          _this4.showLockRightToolBar(false);
          event.currentTarget.classList.add('y-lock-toolbar-hide');
        }
      };
      this.recomputedLockRight = function () {
        var columns = _this4.columns();
        _this4.lockRightWidth = columns.filter(function (col) {
          return !col.lockright;
        }).filter(function (col) {
          return col._show();
        }).map(function (cell) {
          return cell.width;
        }).reduce(function (a, b) {
          return Number(a) + Number(b);
        }, 0);
        _this4.fixRightHeadtransform('translateX(-' + _this4.lockRightWidth + 'px)');
        _this4.fixRightTransform('translate(-' + _this4.lockRightWidth + 'px,0)');
      };

      this.resetColumnRender = _lodash2.default.throttle(function (scrollLeft) {
        var _columnsWidth = _this4.columnsWidth.peek();
        var columns = _this4.columns.peek();
        var width = 0;
        var startWidth = scrollLeft;
        startWidth = startWidth > 0 ? startWidth : 0;
        var endWidth = scrollLeft + clientWidth;
        for (var i = 0; i < _columnsWidth.length; i++) {
          // 只计算显示的列
          if (columns[i]._show && columns[i]._show()) {
            width += columns[i].width;
          }
          // 只处理可视范围内的列
          if (width >= startWidth && endWidth >= width) {
            columns[i]._needRender(true);
          } else if (width > endWidth || width < startWidth && i > 3) {
            // 有lazy才启用
            columns[i]._needRender(columns[i].needRender || !_this4.lazy || columns[i].lockright);
          }
        }
      }, 16);
      var resetGridLazy = function resetGridLazy(start, end, ignoreSet) {
        if (!ignoreSet) {
          _this4.lazy.lazyStart(start);
          _this4.lazy.lazyEnd(end);
        }
        if (_this4.rowspan) {
          _knockout2.default.tasks.schedule(function () {
            var body = _this4.children.body;
            // 如果有锁定列，则只设置fix的表格，否则设置默认表格
            var domId = _knockout2.default.unwrap(_this4.lockcolumn) ? _this4.domId + '_fix' : _this4.domId;
            if (_this4.rowspan.maxCol) {
              body.caculateRowspan(_this4.rowspan.maxCol, domId, body, start);
            } else if (_this4.rowspan.columnIndex) {
              body.caculateRowspanByIndex(_this4.rowspan.columnIndex, domId, body);
            }
          });
        }
      };
      var once = false;
      this.defaultHanldeScroll = _lodash2.default.throttle(function (e, scrollTop) {
        if (_this4.rows.peek().length <= _this4.maxLazyRows) {
          _this4.lazy.lazyEnd(_this4.maxLazyRows);
          if (!once) {
            resetGridLazy(0, _this4.maxLazyRows, true);
          }
          once = true;
          return;
        }
        // 获取当前已记录的大致行索引
        var index = _this4.getCurIndexByScrollTop(scrollTop);
        var endIndex = index + 14;
        var startIndex = index - 6;
        var oldEnd = _this4.lazy.lazyEnd();
        var oldStart = _this4.lazy.lazyStart();
        if (endIndex - oldEnd >= 5 || oldStart - startIndex >= 5) {
          resetGridLazy(startIndex, endIndex);
        }
      }, 16);
      var showFixColumn = _lodash2.default.debounce(function () {
        _this4.hidefix(false);
      }, 100);
      var lastScrollLeft = 0;
      this.handleScroll = function (vm, event) {
        _fastdom2.default.measure(function () {
          // 仅当锁定表头时才自动滚动列
          var scrollLeft = event.currentTarget.scrollLeft;
          var scrollTop = event.currentTarget.scrollTop;
          // 纵向滚动才隐藏,横向滚动不隐藏
          if (Math.abs(lastScrollLeft - scrollLeft) < 2) {
            if (_this4.lockhead || _this4.lockcolumn()) {
              _this4.hidefix(true);
            }
          } else {
            _this4.hidefix(false);
          }
          console.log('abs:', Math.abs(lastScrollLeft - scrollLeft));
          _fastdom2.default.mutate(function () {
            lastScrollLeft = scrollLeft;
            _this4.resetColumnRender(scrollLeft);
            if (_this4.lockhead || _this4.lockcolumn()) {
              _this4.headtransform('translateX(-' + scrollLeft + 'px)');
              _this4.fixColumnTransform('translateY(-' + scrollTop + 'px)');
              if (_this4.verticalScroll) {
                _this4.vertiacalScrollTransform('translateX(-' + scrollLeft + 'px)');
              }
              _this4.fixRightTransform('translate(-' + _this4.lockRightWidth + 'px, -' + scrollTop + 'px)');
              _this4.lazy && _this4.defaultHanldeScroll(event, scrollTop, scrollLeft);
              showFixColumn();
            }
          });
        });
      };
      // 设置loading图标是否显示
      this.showLoading = function (isShow) {
        _this4.isShowLoading(isShow);
      };
      // 获取所有选中的行数据
      this.getSelectedRows = function () {
        var selectedRows = [];
        params.rows().forEach(function (item) {
          if (item._selected && item._selected()) {
            selectedRows.push(item);
          }
        });
        return selectedRows;
      };
      // 设置列显示隐藏
      this.setColVisibleByField = function (field, visible) {
        _this4.columns().forEach(function (col) {
          if (col.field === field) {
            col._show(visible);
          }
        });
        if (_this4.lockright) {
          _this4.recomputedLockRight();
        }
        _this4.reComputedTableWidth(!_this4.reComputedTableWidth());
      };
      this.setColVisibleByFields = function (fields, visible, stopUpdateView) {
        _this4.columns().forEach(function (col) {
          if (fields.indexOf(col.field) >= 0) {
            col._show(visible);
          }
        });
        if (!stopUpdateView) {
          if (_this4.lockright) {
            _this4.recomputedLockRight();
          }
          _this4.reComputedTableWidth(!_this4.reComputedTableWidth());
        }
      };
      // 根据field获取column
      this.getColByField = function (field) {
        var curColumn = {};
        _this4.columns().forEach(function (col) {
          if (col.field === field) {
            curColumn = col;
          }
        });
        return curColumn;
      };
      // 切换行是否禁止选中
      this.setRowSelectEnable = function (isEnable) {
        _this4.forbitRowSelect(isEnable);
      };
      this.lastScrollTop = '';
      this.handleScrollTop = function (target, mainBody, bodyrefs) {
        var scrollTop = target.scrollTop;
        if (scrollTop !== _this4.lastScrollTop) {
          if (bodyrefs.leftBody) {
            var leftBody = bodyrefs.leftBody.querySelectorAll('.y-grid-body')[0];
            if (target !== leftBody) {
              _knockout2.default.tasks.schedule(function () {
                leftBody.scrollTop = scrollTop;
              });
            }
          }
          if (target !== mainBody) {
            _knockout2.default.tasks.schedule(function () {
              mainBody.scrollTop = scrollTop;
            });
          }
          if (bodyrefs.rightBody) {
            var rightBody = bodyrefs.rightBody.querySelectorAll('.y-grid-body')[0];
            if (target !== rightBody) {
              _knockout2.default.tasks.schedule(function () {
                rightBody.scrollTop = scrollTop;
              });
            }
          }
        }
        _this4.lastScrollTop = scrollTop;
      };
      this.handleScrollLeft = function (target, mainBody, bodyrefs) {
        if (target !== mainBody) {
          if (bodyrefs.leftBody) {
            var leftBody = bodyrefs.leftBody.querySelectorAll('.y-grid-body')[0];
            if (target === leftBody) {
              _knockout2.default.tasks.schedule(function () {
                leftBody.scrollLeft = 0;
              });
            }
          }
          if (bodyrefs.rightBody) {
            var rightBody = bodyrefs.rightBody.querySelectorAll('.y-grid-body')[0];
            if (target === rightBody) {
              rightBody.scrollLeft = 0;
            }
          }
        } else {
          var mainHead = bodyrefs.mainbody.querySelectorAll('.y-grid-head')[0];
          _knockout2.default.tasks.schedule(function () {
            mainHead.scrollLeft = target.scrollLeft;
          });
        }
      };
      this.handleBodyScroll = function (vm, e) {
        var target = e.target;
        var bodyrefs = _this4.bodyrefs;
        var mainBody = bodyrefs.mainbody.querySelectorAll('.y-grid-body')[0];
        _this4.handleScrollLeft(target, mainBody, bodyrefs);
        _this4.handleScrollTop(target, mainBody, bodyrefs);
      };
    }
  }, {
    key: 'created',
    value: function created(params) {
      if (this.lockright) {
        this.recomputedLockRight();
      }
    }
  }]);

  return Grid;
}(_base2.default);

exports.default = Grid;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(21).f;
var has = __webpack_require__(22);
var TAG = __webpack_require__(35)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(35);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(11);
var LIBRARY = __webpack_require__(51);
var wksExt = __webpack_require__(96);
var defineProperty = __webpack_require__(21).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__ = __webpack_require__(10);

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLayoutRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(44);
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMainAxisFromPlacement;
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapToStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(27);







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(x * dpr) / dpr || 0,
    y: Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];
  var sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */];
  var win = window;

  if (adaptive) {
    var offsetParent = Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__["a" /* default */])(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__["a" /* default */])(popper)) {
      offsetParent = Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__["a" /* default */])(popper);

      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__["a" /* default */])(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["e" /* end */]) {
      sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */];
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["e" /* end */]) {
      sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__["a" /* default */])(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: Object(__WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__["a" /* default */])(state.placement),
    variation: Object(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__ = __webpack_require__(15);
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__["a" /* default */])(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScrollBarX;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__ = __webpack_require__(104);



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element)).left + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__["a" /* default */])(element).scrollLeft;
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(15);

function getWindowScroll(node) {
  var win = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__ = __webpack_require__(46);

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = Object(__WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__["a" /* default */])(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__ = __webpack_require__(174);


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__["a" /* default */])({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = popperGenerator;
/* unused harmony export createPopper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_orderModifiers_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debounce_js__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mergeByName_js__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_utils_instanceOf_js__ = __webpack_require__(10);
/* unused harmony reexport detectOverflow */









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: Object(__WEBPACK_IMPORTED_MODULE_8__dom_utils_instanceOf_js__["a" /* isElement */])(reference) ? Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference) : reference.contextElement ? Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference.contextElement) : [],
          popper: Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = Object(__WEBPACK_IMPORTED_MODULE_4__utils_orderModifiers_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_mergeByName_js__["a" /* default */])([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__["a" /* default */])(reference, Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(popper), state.options.strategy === 'fixed'),
          popper: Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Object(__WEBPACK_IMPORTED_MODULE_5__utils_debounce_js__["a" /* default */])(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(189);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(30)(function () {
  return Object.defineProperty(__webpack_require__(110)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
var document = __webpack_require__(17).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(50);
var createDesc = __webpack_require__(49);
var toIObject = __webpack_require__(31);
var toPrimitive = __webpack_require__(68);
var has = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(109);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(113);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(22);
var toIObject = __webpack_require__(31);
var arrayIndexOf = __webpack_require__(196)(false);
var IE_PROTO = __webpack_require__(72)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(22);
var toObject = __webpack_require__(38);
var IE_PROTO = __webpack_require__(72)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(20);
var core = __webpack_require__(11);
var fails = __webpack_require__(30);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(33),
    arrayMap = __webpack_require__(120),
    isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(54);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)))

/***/ }),
/* 119 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObject = __webpack_require__(14);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(117);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(235),
    isObject = __webpack_require__(14),
    isSymbol = __webpack_require__(54);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(79),
    setCacheAdd = __webpack_require__(260),
    setCacheHas = __webpack_require__(261);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(279),
    baseMatchesProperty = __webpack_require__(303),
    identity = __webpack_require__(83),
    isArray = __webpack_require__(13),
    property = __webpack_require__(311);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(286),
    isObjectLike = __webpack_require__(16);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(125),
    arraySome = __webpack_require__(287),
    cacheHas = __webpack_require__(128);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(12);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(135),
    getSymbols = __webpack_require__(85),
    keys = __webpack_require__(41);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(81),
    isArray = __webpack_require__(13);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(293),
    isArguments = __webpack_require__(82),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(86),
    isIndex = __webpack_require__(76),
    isTypedArray = __webpack_require__(138);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(295),
    baseUnary = __webpack_require__(40),
    nodeUtil = __webpack_require__(56);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(143),
    toKey = __webpack_require__(62);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isKey = __webpack_require__(88),
    stringToPath = __webpack_require__(305),
    toString = __webpack_require__(123);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89),
    eq = __webpack_require__(55);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(81),
    getPrototype = __webpack_require__(146),
    getSymbols = __webpack_require__(85),
    stubArray = __webpack_require__(136);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(139);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setData = setData;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDayCountOfMonth = getDayCountOfMonth;
exports.getWeekNumber = getWeekNumber;
exports.getStartDateOfMonth = getStartDateOfMonth;
var DAY_DURATION = 86400000;
var isValidateDate = function isValidateDate(v) {
  return v instanceof Date && !isNaN(v.getTime());
};
// 判断是不是合法的日期输入,如果输入20201212 这种自动转成2020-12-12
var formatValidateDate = function formatValidateDate(v, isTimer) {
  var _v = new Date(v);
  if (!isValidateDate(_v)) {
    try {
      v = v + '';
      // 如果非法 先都转换成统一格式
      v = v.replaceAll(' ', '').replaceAll('/', '').replaceAll('-', '').replaceAll(':', '');
      // 如果不是时间默认取前8位
      if (!isTimer) {
        v = v.substr(0, 8);
      } else {
        v = v.substr(0, 14);
      }
      // 日期
      _v = v.substr(0, 4) + '-' + v.substr(4, 2) + '-' + v.substr(6, 2);
      // 时间
      if (isTimer) {
        _v += ' ';
        // 时间有可能漏了写了 补充上，补充上:
        _v += (v.substr(8, 2) || '00') + ':' + (v.substr(10, 2) || '00') + ':' + (v.substr(12, 2) || '00');
      }
      v = _v;
      if (!isValidateDate(new Date(_v))) {
        return null;
      } else {
        return v;
      }
    } catch (e) {
      return null;
    }
  } else {
    return v;
  }
};
// 如果
function setData(value, observable, isNumbericValue) {
  var v = formatValidateDate(value, this.isTimer);
  var curDateValue = (v ? new Date(v) : new Date()).toDateString();
  var oldDateValue = isNumbericValue ? observable() - 0 : observable();
  oldDateValue = new Date(oldDateValue).toDateString();
  // 如果不是timer 则只比较日期是否一样不比较时间，
  if (!this.isTimer && curDateValue === oldDateValue) {
    return '';
  } else {
    if (v && isNumbericValue) {
      v = new Date(v).getTime();
    }
    observable(v);
  }
}
// 获取每个月的第一天
function getFirstDayOfMonth(date) {
  var temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
}
// 获取每个月的天数
function getDayCountOfMonth(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }
  if (month === 1) {
    // 计算闰年
    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
}

function getWeekNumber(src) {
  var date = new Date(src.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}

function getStartDateOfMonth(year, month) {
  var result = new Date(year, month - 1, 1);
  var day = result.getDay();

  if (day === 0) {
    result.setTime(result.getTime() - DAY_DURATION * 7);
  } else {
    result.setTime(result.getTime() - DAY_DURATION * day);
  }
  return result;
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(6);

var _validator = __webpack_require__(374);

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__(394);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(6);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var eventList = [];

var holdKey = [];
var groupSortField = [];
var sortType = [];
var getHoldKeyInstance = {
  get: function get() {
    return holdKey;
  },
  set: function set(hkey) {
    holdKey = hkey;
  },
  isHoldKeyCode: function isHoldKeyCode(keyCode) {
    // 确保只按下了一个比如ctrl
    return holdKey.length === 1 && holdKey.indexOf(keyCode) === 0;
  },
  getGroupSortField: function getGroupSortField() {
    return groupSortField;
  },
  setGroupSortField: function setGroupSortField(v) {
    groupSortField = v;
  },
  addGroupSortField: function addGroupSortField(v) {
    groupSortField.push(v);
  },
  addSortType: function addSortType(v) {
    sortType.push(v);
  },
  getSortType: function getSortType() {
    return sortType;
  },
  setSortType: function setSortType(v) {
    sortType = v;
  },
  setSortTypeByIndex: function setSortTypeByIndex(index, v) {
    sortType[index] = v;
  }
};
var addKeyHoldListener = function addKeyHoldListener(el) {
  if (eventList.length === 0) {
    eventList.push('inited');
    document.addEventListener('keydown', function (event) {
      var index = holdKey.indexOf(event.keyCode);
      if (index < 0) {
        holdKey.push(event.keyCode);
      }
    }, false);
    document.addEventListener('keyup', function (event) {
      holdKey = [];
    }, false);
  }
  return getHoldKeyInstance;
};
exports.default = {
  addKeyHoldListener: addKeyHoldListener
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _gridutil = __webpack_require__(43);

var _gridutil2 = _interopRequireDefault(_gridutil);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _ariamixin = __webpack_require__(406);

var _ariamixin2 = _interopRequireDefault(_ariamixin);

var _fastdom = __webpack_require__(153);

var _fastdom2 = _interopRequireDefault(_fastdom);

var _eventlistener = __webpack_require__(150);

var _eventlistener2 = _interopRequireDefault(_eventlistener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_Base) {
  _inherits(Body, _Base);

  function Body() {
    _classCallCheck(this, Body);

    return _possibleConstructorReturn(this, (Body.__proto__ || (0, _getPrototypeOf2.default)(Body)).apply(this, arguments));
  }

  _createClass(Body, [{
    key: 'initialize',
    value: function initialize(params) {
      var _this2 = this;

      params.setBodyContext && params.setBodyContext(this);
      this.lazy = params.lazy;
      this.i18nNoData = (0, _i18n2.default)('暂无数据');
      this.nodatapng = 'url(' + __webpack_require__(408) + ')';
      this.hasSummaryRow = params.hasSummaryRow || false;
      // 用在子表一对多的场景之中
      this.hasChildGrid = params.hasChildGrid || false;
      this.isDataTable = params.isDataTable;
      this.caculateColumns = params.caculateColumns;
      this.expand = params.expand;
      var _columns = params.columns;
      this.columns = _knockout2.default.observableArray(_columns());
      _columns.subscribe(function (vals) {
        _this2.columns(vals);
        _this2.columns.splice(0, 0);
      });
      this.rows = params.rows;
      this.domId = params.domId;
      this.onRowSelect = params.onRowSelect;
      this.defaultExpand = params.defaultExpand || false;
      this.isNoDataCustomTpl = params.isNoDataCustomTpl || false;
      this.lockhead = params.lockhead;
      this.tdstyle = params.tdstyle;
      this.isSeparate = params.isSeparate;
      this.forbitRowSelect = params.forbitRowSelect || function () {};
      this.forbitRowSelectFn = params.forbitRowSelectFn || function () {
        return false;
      };
      var tableFieldid = params.fieldid || '';
      if (tableFieldid) {
        tableFieldid = tableFieldid + '|';
      }
      this.getFieldId = function (col, rowIndex, ColIndex) {
        if (col.fieldid) {
          return tableFieldid + col.fieldid + '_cell_' + rowIndex;
        } else if (col.field) {
          return tableFieldid + col.field + '_cell_' + rowIndex + '_' + ColIndex;
        } else if (col.type === 'checkbox') {
          return tableFieldid + 'checkbox_cell_' + rowIndex;
        }
      };
      this.isShowLoading = params.isShowLoading;
      this.transform = params.transform;
      this.headHeight = params.headHeight;
      this.verticalAlign = params.verticalAlign;
      this.lockColumnHeight = params.lockColumnHeight;
      this.lockcolumn = _knockout2.default.isObservable(params.lockcolumn) ? params.lockcolumn : _knockout2.default.observable(params.lockcolumn || false);
      this.isLockLeft = params.isLockLeft || _knockout2.default.observable(false);
      this.tableWidth = params.isLockLeft ? function () {
        return '100%';
      } : params.tableWidth;
      this.computedLockColumnHeight = _knockout2.default.observable({});
      // 每一行的高度（转换为数字的行高）
      this.columnNumberHeight = params.columnNumberHeight;
      if (this.lockcolumn() && params.bodyrefs) {
        params.bodyrefs.leftBody = params.$el;
      } else if (params.lockright && params.bodyrefs) {
        params.bodyrefs.rightBody = params.$el;
      } else {
        if (params.bodyrefs) {
          params.bodyrefs.mainbody = params.$el.parentElement;
        }
      }
      // 是否开启复杂
      this.aria = !!params.aria;
      if (this.aria) {
        _ariamixin2.default.call(this, params);
      }
    }
  }, {
    key: 'computed',
    value: function computed(params) {
      var _this3 = this;

      var that = this;
      this.isEmtpyData = _knockout2.default.computed(function () {
        return _this3.rows().length === 0;
      });
      // 判断当前行是否显示（在lazy启用的状态下可能出现false）
      this.isTrShow = function (row, index, lazy) {
        return !lazy || lazy && index >= lazy.lazyStart() && index <= lazy.lazyEnd();
      };
      // lazy场景上用于上方占位用的高度
      this.getUpHeight = _knockout2.default.computed(function () {
        if (!_this3.lazy) {
          return 0;
        } else {
          var start = _this3.lazy.lazyStart();
          // 如果
          if (start === 0) {
            return 0;
          } else {
            var height = 0;
            // 因为滚动的过程中lazyStart和lazyEnd 肯定会改变
            var heightNumbers = _this3.columnNumberHeight.peek();
            for (var i = 0; i < start; i++) {
              height += heightNumbers[i];
            }
            return height + 'px';
          }
        }
      });
      // lazy场景上用于下方占位用的高度
      this.getDownHeight = _knockout2.default.computed(function () {
        var rowsLength = _this3.rows().length;
        if (!_this3.lazy || rowsLength === 0) {
          return 0;
        } else {
          var end = _this3.lazy.lazyEnd();
          // 如果
          if (end === rowsLength) {
            return 0;
          } else {
            var height = 0;
            var heightNumbers = _this3.columnNumberHeight.peek();
            for (var i = end + 1; i < rowsLength; i++) {
              height += heightNumbers[i];
            }
            return height + 'px';
          }
        }
      });
      this.getRowHeight = function (rowIndex) {
        if (params.isLockLeft || params.lazy) {
          return params.lockColumnHeight()[rowIndex] ? params.lockColumnHeight()[rowIndex].height : 'auto';
        } else {
          return 'auto';
        }
      };
      // 状态tab切换或重新加载不同数据后需要清空缓存的列高度
      // songhlc，只用处理非锁定的表格即可，最终都会修改lockColumnHeight 并触发getRowHeight
      if (!_knockout2.default.utils.unwrapObservable(this.isLockLeft)) {
        this.rows.subscribe(function () {
          // 当调用addSimpleData的时候 需要只把原来没变化的设置成needRefresh=true 保留原来的高度（已经渲染过的不会重新走afterrender）
          var allHeight = this.computedLockColumnHeight();
          for (var prop in allHeight) {
            if (allHeight.hasOwnProperty(prop)) {
              // 这里扩展了对象,所以必须判断
              allHeight[prop].needRefresh = true;
            }
          }
          that.computedLockColumnHeight(allHeight);
        }, this, 'beforeChange');
      }
      this.summaryAfterRender = function (elements, data) {
        _knockout2.default.tasks.schedule(function () {
          var element = elements.filter(function (el) {
            return el.nodeName === 'TR';
          })[0];
          element.style.width = '100%';
        });
      };
      var lockcolumn = this.lockcolumn;
      this.afterTrRender = function (elements, data) {
        //
      };
      var tdHeightCache = {};
      this.afterTdRender = function (elements, data) {
        // 只有启用锁定列 或 启用lazy 才计算
        if (!params.isLockLeft && (lockcolumn.peek() || params.lazy)) {
          var key = data.rowIndex + '_' + data.colIndex;
          // 没有渲染过才需要渲染
          if (!tdHeightCache[key] || data.col.needRender) {
            var lockColumnHeight = that.computedLockColumnHeight.peek();
            // 找到parentTr
            _fastdom2.default.measure(function () {
              var pnode = elements[0].parentElement;
              if (pnode && pnode.parentElement) {
                var height = pnode.parentElement.offsetHeight;
                tdHeightCache[key] = height;
                var oldHeight = lockColumnHeight[data.rowIndex];
                oldHeight = oldHeight ? oldHeight.height.replace('px', '') - 0 : undefined;
                if (!oldHeight || height > oldHeight) {
                  _fastdom2.default.mutate(function () {
                    lockColumnHeight[data.rowIndex] = {
                      height: height + 'px',
                      needRefresh: false
                    };
                    that.computedLockColumnHeight(lockColumnHeight);
                  });
                }
              }
            });
          }
        }
      };
      // 要把行的afterRender 改成td的afterRender
      this.afterRender = function (elements, data) {
        // 只有启用锁定列才计算
        if (!params.isLockLeft && _this3.lockcolumn.peek()) {
          var lockColumnHeight = that.computedLockColumnHeight.peek();
          if (!lockColumnHeight[data.rowIndex] || lockColumnHeight[data.rowIndex].needRefresh) {
            _knockout2.default.tasks.schedule(function () {
              var el = elements.filter(function (el) {
                return el.nodeName === 'TR';
              })[0];
              var i = 0;
              // 这里因为不知道组件内部什么时候真正渲染完毕，所以循环了1s
              var _interval = setInterval(function () {
                _fastdom2.default.measure(function () {
                  var height = el.offsetHeight;
                  _fastdom2.default.mutate(function () {
                    if (height > 0) {
                      clearInterval(_interval);
                      lockColumnHeight[data.rowIndex] = {
                        height: height + 'px',
                        needRefresh: false
                      };
                      that.computedLockColumnHeight({});
                      that.computedLockColumnHeight(lockColumnHeight);
                    }
                    i++;
                    // 出于性能考虑以及可能存在的行高为0的情况不处理
                    if (i > 10) {
                      clearInterval(_interval);
                    }
                  });
                });
              }, 100);
            });
          }
        }
      };
      // td渲染的不同模板
      this.displayMode = function (data) {
        switch (data.col.type) {
          case 'index':
            return 'y-template-index';
          case 'checkbox':
            return 'y-template-checkbox';
          case 'render':
            return 'y-template-render';
          case 'component':
            return 'y-template-component';
          case 'comp':
            return 'y-template-component';
          case 'operation':
            return 'y-template-operation';
          case 'text':
            return 'y-template-text';
          case 'rendertext':
            return 'y-template-rendertext';
          default:
            return 'y-template-noType';
        }
      };
      // 格式化表格默认值
      this.defaultFormatText = _gridutil2.default.defaultFormatText;
      this.formatText = _gridutil2.default.formatText;
      this.gridBodyStyle = _knockout2.default.computed(function () {
        var style = {};
        if (_this3.lockhead) {
          if (_knockout2.default.isObservable(_this3.headHeight)) {
            style.marginTop = _this3.headHeight();
          } else {
            style.marginTop = _this3.headHeight;
          }
        }
        return style;
      });
      // 计算暂无数据的单元格合并
      this.nodataColSpan = _knockout2.default.computed(function () {
        if (params.columns && params.columns.subscribe) {
          return params.columns().length;
        } else {
          return params.columns.length;
        }
      });
      // 是否支持多选
      this.isMultiSelect = _knockout2.default.computed(function () {
        if (params.columns.subscribe) {
          return params.columns().filter(function (col) {
            return col.type === 'checkbox';
          }).length > 0;
        } else {
          return params.columns.filter(function (col) {
            return col.type === 'checkbox';
          }).length > 0;
        }
      });
      this.expandColspan = _knockout2.default.computed(function () {
        var count = 0;
        _this3.columns().forEach(function (col) {
          if (_knockout2.default.utils.unwrapObservable(col._show)) {
            count++;
          }
        });
        return count;
      });
      // 暂无数据区域的高度
      this.noDataHeight = _knockout2.default.computed(function () {
        var maxheight = params.maxheight();
        if (maxheight === 'auto') {
          return 'auto';
        } else {
          return maxheight.replace('px', '') - 150 + 'px';
        }
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      var _this4 = this;

      this.computedLockColumnHeight.subscribe(function (val) {
        var length = _this4.rows.peek().length;
        var count = 0;
        for (var pro in val) {
          if (val.hasOwnProperty(pro)) {
            // 这里扩展了对象,所以必须判断
            count++;
          }
        }
        // 如果所有的都渲染完了 count可能比实际数量多（重新setSimpleData 数量变少）
        if (length <= count && length > 0 || params.lazy) {
          params.lockColumnHeight(val);
        }
      });
    }
  }, {
    key: 'created',
    value: function created(params) {
      var _this5 = this;

      if (params.rowspan) {
        setTimeout(function () {
          if (params.rows.peek().length > 0) {
            _knockout2.default.tasks.schedule(function () {
              if (params.rowspan.columnIndex) {
                this.caculateRowspanByIndex(params.rowspan.columnIndex, params.domId, this);
              } else if (params.rowspan.maxCol) {
                this.caculateRowspan(params.rowspan.maxCol, params.domId, this);
              }
              if (params.rowspan.fields) {
                this.caculateRowspanByFields(params.rowspan.fields, params.domId, this);
              }
            }.bind(_this5));
          }
        });
        params.rows.subscribe(function (val) {
          // 确保子组件重绘之后再进行合并单元格，component调用的是后会遇到此问题
          setTimeout(function () {
            _knockout2.default.tasks.schedule(function () {
              if (params.rowspan.columnIndex) {
                this.caculateRowspanByIndex(params.rowspan.columnIndex, params.domId, this);
              } else if (params.rowspan.maxCol) {
                this.caculateRowspan(params.rowspan.maxCol, params.domId, this);
              }
              if (params.rowspan.fields) {
                this.caculateRowspanByFields(params.rowspan.fields, params.domId, this);
              }
            }.bind(this));
          }.bind(_this5));
        });
      }
    }
    // 判断点击事件是否触发行选中

  }, {
    key: 'isTriggerRowSelect',
    value: function isTriggerRowSelect(evt) {
      // 如果点击的是input则不触发
      if (evt.target.tagName === 'INPUT') {
        return false;
      }
      if (evt.target.tagName === 'A') {
        return false;
      }
      if (evt.target.classList.contains('y-grid-stoprowselect') || evt.target.classList.contains('y-grid-operation') || evt.target.classList.contains('y-select-single')) {
        return false;
      }
      return true;
    }
  }, {
    key: 'needRowCombine',
    value: function needRowCombine(columnIndex, rowIndex, val, tabItem, i, delta) {
      var rowCombineFn = this.columns.peek()[columnIndex].needRowCombine;
      if (rowCombineFn) {
        return rowCombineFn(this.rows()[rowIndex]) === val;
      } else {
        return val === tabItem.innerHTML;
      }
    }
  }, {
    key: 'caculateRowspanByFields',
    value: function caculateRowspanByFields(fields, domId, context) {
      var columns = this.columns.peek();
      var indexes = [];
      columns.forEach(function (col, index) {
        if (fields.indexOf(col.field) > -1) {
          indexes.push(index);
        }
      });
      if (indexes.length > 0) {
        this.caculateRowspanByIndex(indexes, domId, this);
      }
    }
  }, {
    key: 'caculateRowspanByIndex',
    value: function caculateRowspanByIndex(indexes, domId, context) {
      var _this6 = this;

      var tab = document.getElementById(domId);
      // fix列动态的情况下会出问题 添加异常判断
      if (!tab) {
        return;
      }
      // val表示单元格的内容
      var val = '';
      var count = 0;
      var start = 0;
      var endCaculateRowStart = 0;
      indexes.forEach(function (index) {
        // 不同列的合并开始每次需要重置val值
        val = '';
        count = 1;
        var delta = 0;
        // 需要减掉用于显示暂无数据的那一行
        for (var i = 0; i < tab.rows.length - 1; i++) {
          // delta用于计算无用的行 确保后续的i-delta能取到正确的数据行
          if (tab.rows[i].classList.contains('stopCaculate')) {
            delta++;
          }
          // fixed rowspan 在数据切换之后产生的bug
          if (tab.rows[i].cells[index] && !tab.rows[i].classList.contains('stopCaculate') && !tab.rows[i].cells[index].classList.contains('hide-by-col')) {
            // fixed rowspan 在数据切换之后产生的bug
            if (tab.rows[i].cells[index].style.display === 'none') {
              tab.rows[i].cells[index].style.display = 'table-cell';
            }
            // 每次初始化之前要把当前rowSpan重置
            tab.rows[i].cells[index].rowSpan = 1;
            // 第一列不需要校验左侧是否被合并了（display === 'none'表示被合并了）
            if (_this6.needRowCombine(index, i - delta, val, tab.rows[i].cells[index])) {
              count++;
            } else {
              if (count > 1) {
                // 合并
                start = i - count;
                tab.rows[start].cells[index].rowSpan = count;
                for (var j = start + 1; j < i; j++) {
                  // 被合并的列隐藏
                  tab.rows[j].cells[index].style.display = 'none';
                }
                count = 1;
              }
              var needRowCombineFn = _this6.columns.peek()[index].needRowCombine;
              var lastRowValue = needRowCombineFn ? needRowCombineFn(_this6.rows.peek()[i - delta]) : tab.rows[i].cells[index].innerHTML;
              val = lastRowValue;
            }
            endCaculateRowStart = i + 1;
          }
        }
        if (count > 1) {
          // 合并，最后几行相同的情况下
          start = endCaculateRowStart - count;
          tab.rows[start].cells[index].rowSpan = count;
          for (var _j = start + 1; _j < endCaculateRowStart; _j++) {
            if (!tab.rows[_j].classList.contains('stopCaculate')) {
              tab.rows[_j].cells[index].style.display = 'none';
            }
          }
        }
      });
    }
    // 动态计算rowspan

  }, {
    key: 'caculateRowspan',
    value: function caculateRowspan(maxColumns, domId, context, deltaStart) {
      var tab = document.getElementById(domId);
      // lazy的情况下需要额外传入默认起始行
      if (!deltaStart || deltaStart < 0) {
        deltaStart = 0;
      }
      // fix列动态的情况下会出问题 添加异常判断
      if (!tab) {
        return;
      }
      var maxCol = maxColumns;
      var val = '';
      var count = 0;
      var start = 0;
      var endCaculateRowStart = 0;
      // fix by songhlc 从左边第一列开始判断
      for (var col = 0; col <= maxCol - 1; col++) {
        count = 1;
        val = '';
        var delta = 0;
        // 需要减掉用于显示暂无数据的那一行
        for (var i = 0; i < tab.rows.length - 1; i++) {
          // delta用于计算无用的行 确保后续的i-delta能取到正确的数据行
          if (tab.rows[i].classList.contains('stopCaculate')) {
            delta++;
          }
          var curCol = tab.rows[i].cells[col];
          // fixed rowspan 在数据切换之后产生的bug
          if (curCol && !tab.rows[i].classList.contains('stopCaculate') && !curCol.classList.contains('hide-by-col')) {
            if (curCol.style.display === 'none') {
              curCol.style.display = 'table-cell';
            }
            // 每次初始化之前要把当前rowSpan重置
            curCol.rowSpan = 1;
            // 第一列不需要校验左侧是否被合并了（display === 'none'表示被合并了）
            if (this.needRowCombine(col, i - delta + deltaStart, val, curCol, i, delta) && (col === 0 || tab.rows[i].cells[col - 1].style.display === 'none')) {
              count++;
            } else {
              if (count > 1) {
                // 合并
                start = i - count;
                tab.rows[start].cells[col].rowSpan = count;
                for (var j = start + 1; j < i; j++) {
                  // 被合并的列隐藏
                  tab.rows[j].cells[col].style.display = 'none';
                }
                count = 1;
              }
              var needRowCombineFn = this.columns.peek()[col].needRowCombine;
              var lastRowValue = needRowCombineFn ? needRowCombineFn(this.rows.peek()[i - delta + deltaStart]) : tab.rows[i].cells[col].innerHTML;
              val = lastRowValue;
            }
            endCaculateRowStart = i + 1;
          }
        }
        if (count > 1) {
          // 合并，最后几行相同的情况下
          start = endCaculateRowStart - count;
          tab.rows[start].cells[col].rowSpan = count;
          for (var _j2 = start + 1; _j2 < endCaculateRowStart; _j2++) {
            if (!tab.rows[_j2].classList.contains('stopCaculate')) {
              tab.rows[_j2].cells[col].style.display = 'none';
            }
          }
        }
      }
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this7 = this;

      // ariamixin中具体实现
      this.onBodyClick = this.onBodyClick || function () {
        return true;
      };
      // ariamixin中具体实现
      this.onBodyKeyDown = this.onBodyKeyDown || function () {
        return true;
      };
      this.handleBodyScroll = params.handleBodyScroll;
      this.handleMouseOut = function (row) {
        row._hover(false);
        return true;
      };
      // mousein
      this.handleMouseIn = function (row) {
        if (row._hover()) return true;
        row._hover(true);
        return true;
      };
      this.holdKeyInstance = _eventlistener2.default.addKeyHoldListener();
      // 上一个选中的数据
      this.lastSelectedRowIndex = _knockout2.default.observable();
      this.handleClick = function (row, evt, index) {
        // 如果组织行选中则直接返回不选中任何行
        if (_this7.forbitRowSelect() || _this7.forbitRowSelectFn(row)) {
          return false;
        }
        // 对于一些输入框不选中
        if (!_this7.isTriggerRowSelect(evt)) {
          return true;
        }
        // todo:需要将选中的数据放入缓存当中或从缓存中剔除
        if (_this7.isMultiSelect()) {
          var _selected = !row._selected();
          row._selected(_selected);
          var holdKey = _this7.holdKeyInstance.get();
          if (holdKey && holdKey.length > 0) {
            // 如果按下了shift键 且 和上一次选中的不是同一行
            if (_this7.holdKeyInstance.isHoldKeyCode(16) && index !== _this7.lastSelectedRowIndex()) {
              var min = Math.min(index, _this7.lastSelectedRowIndex());
              var max = Math.max(index, _this7.lastSelectedRowIndex());
              _this7.rows().forEach(function (r, index) {
                if (index >= min && index <= max) {
                  r._selected && r._selected(_selected);
                }
              });
            }
          }
          _this7.lastSelectedRowIndex(index);
        } else {
          // 一些单行选中的场景
          _this7.onRowSelect && _this7.onRowSelect(row);
        }
        // return true
      };
    }
  }]);

  return Body;
}(_base2.default);

exports.default = Body;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(function(win) {

/**
 * FastDom
 *
 * Eliminates layout thrashing
 * by batching DOM read/write
 * interactions.
 *
 * @author Wilson Page <wilsonpage@me.com>
 * @author Kornel Lesinski <kornel.lesinski@ft.com>
 */

'use strict';

/**
 * Mini logger
 *
 * @return {Function}
 */
var debug = 0 ? console.log.bind(console, '[fastdom]') : function() {};

/**
 * Normalized rAF
 *
 * @type {Function}
 */
var raf = win.requestAnimationFrame
  || win.webkitRequestAnimationFrame
  || win.mozRequestAnimationFrame
  || win.msRequestAnimationFrame
  || function(cb) { return setTimeout(cb, 16); };

/**
 * Initialize a `FastDom`.
 *
 * @constructor
 */
function FastDom() {
  var self = this;
  self.reads = [];
  self.writes = [];
  self.raf = raf.bind(win); // test hook
  debug('initialized', self);
}

FastDom.prototype = {
  constructor: FastDom,

  /**
   * We run this inside a try catch
   * so that if any jobs error, we
   * are able to recover and continue
   * to flush the batch until it's empty.
   *
   * @param {Array} tasks
   */
  runTasks: function(tasks) {
    debug('run tasks');
    var task; while (task = tasks.shift()) task();
  },

  /**
   * Adds a job to the read batch and
   * schedules a new frame if need be.
   *
   * @param  {Function} fn
   * @param  {Object} ctx the context to be bound to `fn` (optional).
   * @public
   */
  measure: function(fn, ctx) {
    debug('measure');
    var task = !ctx ? fn : fn.bind(ctx);
    this.reads.push(task);
    scheduleFlush(this);
    return task;
  },

  /**
   * Adds a job to the
   * write batch and schedules
   * a new frame if need be.
   *
   * @param  {Function} fn
   * @param  {Object} ctx the context to be bound to `fn` (optional).
   * @public
   */
  mutate: function(fn, ctx) {
    debug('mutate');
    var task = !ctx ? fn : fn.bind(ctx);
    this.writes.push(task);
    scheduleFlush(this);
    return task;
  },

  /**
   * Clears a scheduled 'read' or 'write' task.
   *
   * @param {Object} task
   * @return {Boolean} success
   * @public
   */
  clear: function(task) {
    debug('clear', task);
    return remove(this.reads, task) || remove(this.writes, task);
  },

  /**
   * Extend this FastDom with some
   * custom functionality.
   *
   * Because fastdom must *always* be a
   * singleton, we're actually extending
   * the fastdom instance. This means tasks
   * scheduled by an extension still enter
   * fastdom's global task queue.
   *
   * The 'super' instance can be accessed
   * from `this.fastdom`.
   *
   * @example
   *
   * var myFastdom = fastdom.extend({
   *   initialize: function() {
   *     // runs on creation
   *   },
   *
   *   // override a method
   *   measure: function(fn) {
   *     // do extra stuff ...
   *
   *     // then call the original
   *     return this.fastdom.measure(fn);
   *   },
   *
   *   ...
   * });
   *
   * @param  {Object} props  properties to mixin
   * @return {FastDom}
   */
  extend: function(props) {
    debug('extend', props);
    if (typeof props != 'object') throw new Error('expected object');

    var child = Object.create(this);
    mixin(child, props);
    child.fastdom = this;

    // run optional creation hook
    if (child.initialize) child.initialize();

    return child;
  },

  // override this with a function
  // to prevent Errors in console
  // when tasks throw
  catch: null
};

/**
 * Schedules a new read/write
 * batch if one isn't pending.
 *
 * @private
 */
function scheduleFlush(fastdom) {
  if (!fastdom.scheduled) {
    fastdom.scheduled = true;
    fastdom.raf(flush.bind(null, fastdom));
    debug('flush scheduled');
  }
}

/**
 * Runs queued `read` and `write` tasks.
 *
 * Errors are caught and thrown by default.
 * If a `.catch` function has been defined
 * it is called instead.
 *
 * @private
 */
function flush(fastdom) {
  debug('flush');

  var writes = fastdom.writes;
  var reads = fastdom.reads;
  var error;

  try {
    debug('flushing reads', reads.length);
    fastdom.runTasks(reads);
    debug('flushing writes', writes.length);
    fastdom.runTasks(writes);
  } catch (e) { error = e; }

  fastdom.scheduled = false;

  // If the batch errored we may still have tasks queued
  if (reads.length || writes.length) scheduleFlush(fastdom);

  if (error) {
    debug('task errored', error.message);
    if (fastdom.catch) fastdom.catch(error);
    else throw error;
  }
}

/**
 * Remove an item from an Array.
 *
 * @param  {Array} array
 * @param  {*} item
 * @return {Boolean}
 */
function remove(array, item) {
  var index = array.indexOf(item);
  return !!~index && !!array.splice(index, 1);
}

/**
 * Mixin own properties of source
 * object into the target.
 *
 * @param  {Object} target
 * @param  {Object} source
 */
function mixin(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) target[key] = source[key];
  }
}

// There should never be more than
// one instance of `FastDom` in an app
var exports = win.fastdom = (win.fastdom || new FastDom()); // jshint ignore:line

// Expose to CJS & AMD
if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return exports; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
else if ((typeof module) == 'object') module.exports = exports;

})( typeof window !== 'undefined' ? window : typeof this != 'undefined' ? this : globalThis);


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(429), __esModule: true };

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(51);
var $export = __webpack_require__(20);
var redefine = __webpack_require__(156);
var hide = __webpack_require__(28);
var Iterators = __webpack_require__(94);
var $iterCreate = __webpack_require__(432);
var setToStringTag = __webpack_require__(95);
var getPrototypeOf = __webpack_require__(115);
var ITERATOR = __webpack_require__(35)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(28);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(437), __esModule: true };

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(114);
var hiddenKeys = __webpack_require__(74).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _numberPrecision = __webpack_require__(449);

var _numberPrecision2 = _interopRequireDefault(_numberPrecision);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _mixin = __webpack_require__(23);

var _formatFunc = __webpack_require__(160);

var _gridutil = __webpack_require__(43);

var _tippy = __webpack_require__(161);

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }
// js计算时精度问题引入number-precision


var _INTERGER = 'integer';
var _POSITIVEINTEGER = 'positiveinteger';
var _POSITIVENUMBER = 'positivenumber';
var _CUSTOMTYPELIST = [_INTERGER, _POSITIVEINTEGER, _POSITIVENUMBER];

var Input = function (_Base) {
  _inherits(Input, _Base);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: 'initialize',
    value: function initialize(params) {
      var _this2 = this;

      this.value = params.value || _knockout2.default.observable();
      this.size = params.size || 'md';
      this.placeholder = params.placeholder || '';
      this.prepend = params.prepend || false;
      this.append = params.append || false;
      this.fieldid = params.fieldid || this.value._fieldid || '';
      // 是否支持可清楚
      this.clearable = params.clearable || false;
      this.align = params.align || 'left';
      this.isHasForm = !!params.onSubmit;
      this.handleSubmit = params.onSubmit || function () {};
      this.handleIconClick = params.onIconClick || function () {};
      this.iconClass = params.iconClass || '';
      this.precision = params.precision;
      this.disabled = params.disabled || _knockout2.default.observable(false);
      // positiveinteger 是否包含0
      this.inCludeZero = params.inCludeZero || false;
      // thousands为千分位格式
      this.formatter = params.formatter;
      this.thousandsShow = _knockout2.default.observable(this.formatter === 'thousands');
      _mixin.gridRefMixin.call(this, params);
      // implement for aira grid
      this.setFocus = function () {
        var el = _this2.$el.querySelector('input');
        el.click();
        setTimeout(function () {
          el.select();
        });
      };
      this.typeList = ['text', 'textarea', 'password', 'url', 'email', 'date', 'number'];
      this.maxlength = params.maxlength || 250;
      this.required = params.required || false;
      _mixin.changeStyleMixin.call(this, params);
    }
  }, {
    key: 'computed',
    value: function computed(params) {
      var _this3 = this;

      // this.ctnClass = params.class || ''
      this.ctnClass = _knockout2.default.computed(function () {
        var _ctnClass = '';
        if (params.class) {
          _ctnClass = params.class;
        }
        // 确保只支持计算属性
        if (params.computedCls) {
          _ctnClass += ' ' + params.computedCls();
        }
        _ctnClass += ' y-input-' + _this3.size;
        var needRequired = false;
        // 支持requrei传入ko对象同
        if (_knockout2.default.isObservable(_this3.required)) {
          needRequired = _this3.required();
        } else {
          needRequired = _this3.required;
        }
        if (needRequired) {
          if (_knockout2.default.isObservable(_this3.value)) {
            var _value = _this3.value();
            // 如果输入值为空
            if (_value === undefined || _value === null || _value === '') {
              _ctnClass += ' y-input-required';
            }
          }
        }
        return _ctnClass;
      });
      this.type = _knockout2.default.computed(function () {
        if (params.type && _this3.typeList.indexOf(params.type) > -1) {
          return params.type;
        } else {
          // 如果要求输入整数、正整数，正数
          return 'text';
        }
      });
      this.showIcon = _knockout2.default.computed(function () {
        return _this3.iconClass.length > 0;
      });
      this.thousandsVal = _knockout2.default.computed(function () {
        if (_this3.formatter === 'thousands') {
          var precision = _knockout2.default.unwrap(_this3.precision);
          if (!_this3.value() && _this3.value() !== 0) {
            _this3.thousandsShow(false);
            return '';
          }
          var value = parseFloat(_this3.value());
          value = value.toFixed(precision);
          return (0, _gridutil.toThousands)(value, true);
        } else {
          return '';
        }
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this4 = this;

      // 输入删除
      this.handleClose = function () {
        if (_knockout2.default.isObservable(_this4.value)) {
          _this4.value('');
        } else {
          _this4.value = '';
        }
      };

      // 默认校验
      this.defaultValidate = function (vm, e) {
        if (_CUSTOMTYPELIST.indexOf(params.type) > -1) {
          switch (params.type) {
            case _INTERGER:
              return _formatFunc.isInteger.call(_this4, 'input');
            case _POSITIVEINTEGER:
              return _formatFunc.isPositiveInteger.call(_this4, 'input');
            case _POSITIVENUMBER:
              return _formatFunc.isPositivenumber.call(_this4, 'input');
          }
        } else {
          return true;
        }
      };
      this.onKeyup = params.onKeyup || function () {
        this.defaultValidate();
      }.bind(this);
      this.onChange = params.onChange || function () {};
      this.onInput = function (vm, e) {
        this.defaultValidate();
        // 4.1.26增加精度处理
        if (this.precision !== undefined) {
          var precision = _knockout2.default.unwrap(this.precision);
          // 处理小数点后为0,10,100等时不能输入的情况调整
          var arr = [];
          // 根据.拆分value值
          arr = (e.target.value + '').split('.');
          // 小数点后输入位数h大于precision值时做一下截取处理
          if (arr[1]) {
            if (arr[1].length >= precision) {
              arr[1] = arr[1].slice(0, precision);
              e.target.value = arr[0] + '.' + arr[1];
            }
          }
          // 最后一位为0到时候不做处理，不然会导致e.target.value的值抹零
          if (e.target.value.charAt(e.target.value.length - 1) === "0") {
            if (arr[1]) {
              if (arr[1].length >= precision) {
                arr[1] = arr[1].slice(0, precision);
              }
              e.target.value = arr[0] + '.' + arr[1];
              return;
            }
          }
          // 整数不做处理
          if (!isNaN(e.target.value) && e.target.value !== '' && e.target.value % 1 !== 0) {
            if (!isNaN(precision)) {
              var rate = Math.pow(10, precision);
              var rideValue = _numberPrecision2.default.times(e.target.value, rate);
              e.target.value = _numberPrecision2.default.divide(Math.floor(rideValue), rate);
            }
          }
        }
        params.onInput && params.onInput(e);
        if (this.enableChangingStyle) {
          if (String(this.oldValue) !== String(e.target.value)) {
            this.textChanged(true);
          } else {
            this.textChanged(false);
          }
        }
      }.bind(this);
      this.onBlur = function (e) {
        if (params.formatter === "thousands") {
          // 光标脱离输入框
          // 金额输入框或者不为空进行
          if (!params.value() && params.value() !== 0) {
            return;
          }
          this.thousandsShow(true);
        }
        if (params.onBlur) {
          params.onBlur(e);
        }
      };
      this.onThousandsShowClick = function () {
        if (_knockout2.default.unwrap(_this4.disabled)) {
          return;
        }
        _this4.thousandsShow(false);
        _this4.$el.querySelector('input').focus();
      };
      _knockout2.default.tasks.schedule(function () {
        if (params.tipContent) {
          _this4.tippyInstance = (0, _tippy2.default)(_this4.$el.querySelector('input'), { allowHTML: true, theme: 'light', placement: 'bottom' });
          var content = params.tipContent();
          _this4.tippyInstance.setContent(content);
        }
      });
      var that = this;
      var tippyShow = function tippyShow() {
        if (that.tippyInstance) {
          var content = params.tipContent();
          that.tippyInstance.setContent(content);
          that.tippyInstance.show();
        }
      };
      this.onFocus = function (e) {
        if (params.tipContent) {
          tippyShow();
        }
        if (params.formatter === "thousands") {
          // 金额输入框或者不为空进行
          if (!params.value()) {
            return;
          }
          this.thousandsShow(false);
        }
        if (params.onFocus) {
          params.onFocus(e);
        }
      };
      this.onClick = function () {
        if (params.tipContent) {
          tippyShow();
        }
        return false;
      };
    }
  }]);

  return Input;
}(_base2.default);

exports.default = Input;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 判断是整数
// 在某种特殊情况下lodash的isNaN被写入全局下 需要此种方法来处理
var _isNaN = function _isNaN(val) {
  return isNaN(Number(val));
};
var removeBlank = function removeBlank(el, val) {
  var newValue = val.replace(/\s/g, '');
  if (val !== newValue) {
    el.value = newValue;
  }
};
var isInteger = function isInteger(element) {
  var el = this.$el.querySelector(element);
  var val = el.value;
  // 适配ie
  if (val === '') {
    return val;
  }
  if (val !== '-' && (_isNaN(val) || /\./g.test(val))) {
    val = val.replace(/[^\d]/g, '').replace(/-{2,}/g, '-');
    el.value = val;
  } else {
    removeBlank.call(this, el, val);
  }
  return val;
};
// 判断是正整数
var isPositiveInteger = function isPositiveInteger(element) {
  var el = this.$el.querySelector(element);
  var val = el.value;
  // 适配ie
  if (val === '') {
    return val;
  }
  if (_isNaN(val) || /(\.|-)/g.test(val)) {
    val = val.replace(/[^\d]/g, '').replace(/-/g, '');
    el.value = val;
  }
  if (this.inCludeZero && val === 0) {
    removeBlank.call(this, el, val);
  } else {
    if (val <= 0) {
      el.value = '';
    } else {
      removeBlank.call(this, el, val);
    }
  }
  return val;
};
// 判断是正数
var isPositivenumber = function isPositivenumber(element) {
  var el = this.$el.querySelector(element);
  var val = el.value;
  // 适配ie
  if (val === '') {
    return val;
  }
  if (_isNaN(val)) {
    val = val.replace(/[^\d]/g, '').replace(/-{2,}/g, '-');
    el.value = val;
  }
  if (val <= 0) {
    el.value = val.replace(/-/g, '');
  } else {
    removeBlank.call(this, el, val);
  }
  return val;
};
exports.isInteger = isInteger;
exports.isPositiveInteger = isPositiveInteger;
exports.isPositivenumber = isPositivenumber;

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateFill", function() { return animateFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSingleton", function() { return createSingleton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delegate", function() { return delegate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "followCursor", function() { return followCursor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideAll", function() { return hideAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inlinePositioning", function() { return inlinePositioning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "roundArrow", function() { return ROUND_ARROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sticky", function() { return sticky; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popperjs_core__ = __webpack_require__(450);
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/


var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (false) {
  resetVisitedMessages();
}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (false) {
    validateProps(partialProps, []);
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (false) {
      errorWhen(true, 'render() function has not been supplied.');
    }

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = Object(__WEBPACK_IMPORTED_MODULE_0__popperjs_core__["b" /* createPopper */])(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (false) {
      // Accessibility check
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
    }
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
    } // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
    } // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
    }

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
    }

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (false) {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (false) {
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
  }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  mountedInstances.forEach(function (instance) {
    var isExcluded = false;

    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }

    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();

      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__popperjs_core__["a" /* applyStyles */], {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;

  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (false) {
    errorWhen(!Array.isArray(tippyInstances), ['The first argument passed to createSingleton() must be an array of', 'tippy instances. The passed value was', String(tippyInstances)].join(' '));
  }

  var individualInstances = tippyInstances;
  var references = [];
  var triggerTargets = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;

  function setTriggerTargets() {
    triggerTargets = individualInstances.map(function (instance) {
      return normalizeToArray(instance.props.triggerTarget || instance.reference);
    }).reduce(function (acc, item) {
      return acc.concat(item);
    }, []);
  }

  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }

  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }

  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;

      instance.setProps = function (props) {
        originalSetProps(props);

        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };

      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call


  function prepareInstance(singleton, target) {
    var index = triggerTargets.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }

    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        var _references$index;

        return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
      }
    }));
  }

  enableInstances(false);
  setReferences();
  setTriggerTargets();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: triggerTargets,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;

  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)


    if (currentTarget && target == null) {
      return;
    } // target is index of instance


    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance


    if (individualInstances.indexOf(target) >= 0) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement


    if (references.indexOf(target) >= 0) {
      return prepareInstance(singleton, target);
    }
  };

  singleton.showNext = function () {
    var first = references[0];

    if (!currentTarget) {
      return singleton.show(0);
    }

    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };

  singleton.showPrevious = function () {
    var last = references[references.length - 1];

    if (!currentTarget) {
      return singleton.show(last);
    }

    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };

  var originalSetProps = singleton.setProps;

  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };

  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    interceptSetPropsCleanups = interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: triggerTargets
    });
  };

  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};

var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (false) {
    errorWhen(!(props && props.target), ['You must specity a `target` prop indicating a CSS selector string matching', 'the target elements that should receive a tippy.'].join(' '));
  }

  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({
    touch: defaultProps.touch
  }, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);

  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }

    var targetNode = event.target.closest(target);

    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`


    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }

    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }

    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }

    var instance = tippy(targetNode, childProps);

    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }

  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }

  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }

  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;

    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }

      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }

      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };

    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };

    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };

    addEventListeners(instance);
  }

  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}

var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
      if (false) {
        errorWhen(instance.props.animateFill, 'The `animateFill` plugin requires the default render function.');
      }

      return {};
    }

    var _getChildren = getChildren(instance.popper),
        box = _getChildren.box,
        content = _getChildren.content;

    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}

var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];

function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}

function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}

function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}

var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;

    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }

    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }

    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }

    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }

    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
          clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;

      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;

            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }

            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }

    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }

    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });

      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }

    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;

        if (isInternalUpdate) {
          return;
        }

        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();

          if (followCursor) {
            create();

            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }

          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }

        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};

function getProps(props, modifier) {
  var _props$popperOptions;

  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}

var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;

    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }

    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var triedPlacements = [];
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (isEnabled()) {
          if (triedPlacements.indexOf(state.placement) !== -1) {
            triedPlacements = [];
          }

          if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
            triedPlacements.push(state.placement);
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }

          placement = state.placement;
        }
      }
    };

    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }

    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }

    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }

    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          var index = rects.indexOf(cursorRect);
          cursorRectIndex = index > -1 ? index : cursorRectIndex;
        }
      },
      onHidden: function onHidden() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined


  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }

  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }

    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;

        var _width = _right - _left;

        var _height = _bottom - _top;

        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }

    default:
      {
        return boundingRect;
      }
  }
}

var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
        popper = instance.popper;

    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }

    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }

    var prevRefRect = null;
    var prevPopRect = null;

    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }

      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};

function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }

  return true;
}

tippy.setDefaultProps({
  render: render
});

/* harmony default export */ __webpack_exports__["default"] = (tippy);

//# sourceMappingURL=tippy.esm.js.map


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyStyles_js__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__applyStyles_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrow_js__ = __webpack_require__(163);
/* unused harmony reexport arrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__computeStyles_js__ = __webpack_require__(101);
/* unused harmony reexport computeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventListeners_js__ = __webpack_require__(102);
/* unused harmony reexport eventListeners */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flip_js__ = __webpack_require__(171);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hide_js__ = __webpack_require__(175);
/* unused harmony reexport hide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__offset_js__ = __webpack_require__(176);
/* unused harmony reexport offset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__popperOffsets_js__ = __webpack_require__(106);
/* unused harmony reexport popperOffsets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__preventOverflow_js__ = __webpack_require__(177);
/* unused harmony reexport preventOverflow */










/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_within_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_js__ = __webpack_require__(9);








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return Object(__WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : Object(__WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_8__enums_js__["b" /* basePlacements */]));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var axis = Object(__WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var isVertical = [__WEBPACK_IMPORTED_MODULE_8__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_8__enums_js__["k" /* right */]].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement);
  var minProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["f" /* left */];
  var maxProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["k" /* right */];
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = Object(__WEBPACK_IMPORTED_MODULE_5__utils_within_js__["a" /* within */])(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__["a" /* default */])(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLayoutViewport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_userAgent_js__ = __webpack_require__(165);

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(Object(__WEBPACK_IMPORTED_MODULE_0__utils_userAgent_js__["a" /* default */])());
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUAString;
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(10);

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["c" /* isShadowRoot */])(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = within;
/* harmony export (immutable) */ __webpack_exports__["b"] = withinMaxClamp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(27);

function within(min, value, max) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* max */])(min, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* min */])(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergePaddingObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__ = __webpack_require__(169);

function mergePaddingObject(paddingObject) {
  return Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__["a" /* default */])(), paddingObject);
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFreshSideObject;
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expandToHashMap;
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(47);






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["a" /* auto */]) {
    return [];
  }

  var oppositePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(placement);
  return [Object(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(placement), oppositePlacement, Object(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["a" /* auto */] ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement);

    var isStartVariation = Object(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["l" /* start */];
    var isVertical = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = Object(__WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["k" /* right */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["f" /* left */] : isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */];

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    }

    var altVariationSide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listScrollParents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getParentNode_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindow_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__ = __webpack_require__(105);




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = Object(__WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__["a" /* default */])(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = Object(__WEBPACK_IMPORTED_MODULE_2__getWindow_js__["a" /* default */])(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], Object(__WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__["a" /* default */])(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(Object(__WEBPACK_IMPORTED_MODULE_1__getParentNode_js__["a" /* default */])(target)));
}

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rectToClientRect;
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeOffsets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVariation_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_js__ = __webpack_require__(9);




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? Object(__WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__["a" /* default */])(placement) : null;
  var variation = placement ? Object(__WEBPACK_IMPORTED_MODULE_1__getVariation_js__["a" /* default */])(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["m" /* top */]:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["c" /* bottom */]:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["k" /* right */]:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["f" /* left */]:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? Object(__WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__["a" /* default */])(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["l" /* start */]:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["e" /* end */]:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__ = __webpack_require__(48);



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [__WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */]].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distanceAndSkiddingToXY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(9);

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(placement);
  var invertDistance = [__WEBPACK_IMPORTED_MODULE_1__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["m" /* top */]].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [__WEBPACK_IMPORTED_MODULE_1__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["k" /* right */]].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = __WEBPACK_IMPORTED_MODULE_1__enums_js__["h" /* placements */].reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_within_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_math_js__ = __webpack_require__(27);












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = Object(__WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__["a" /* default */])(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var variation = Object(__WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__["a" /* default */])(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = Object(__WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var altAxis = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__["a" /* default */])(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];
    var altSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* start */] ? referenceRect[len] : popperRect[len];
    var maxLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* start */] ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? Object(__WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : Object(__WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__["a" /* default */])();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && Object(__WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__["a" /* default */])(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["b" /* min */])(min, tetherMin) : min, offset, tether ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["a" /* max */])(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];

    var _altSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [__WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */]].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["b" /* withinMaxClamp */])(_tetherMin, _offset, _tetherMax) : Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPopper */
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(98);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */





var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */]];
var createPopper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global ko*/
// Github repository: https://github.com/One-com/knockout-dragdrop
// License: standard 3-clause BSD license https://raw.github.com/One-com/knockout-dragdrop/master/LICENSE

(function (factory) {
    if (true) {
        // AMD anonymous module with hard-coded dependency on "knockout"
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS or Node: hard-coded dependency on "knockout"
        module.exports = factory(require("knockout"));
    } else {
        // <script> tag: use the global `ko`
        factory(ko);
    }
})(function (ko) {
    var dropZones = {};
    var eventZones = {};

    var forEach = ko.utils.arrayForEach;
    var first = ko.utils.arrayFirst;
    var filter = ko.utils.arrayFilter;

    var touchSupport = 'ontouchstart' in document.documentElement;

    var dragging = false;

    function extend(out) {
        out = out || {};

        for (var i = 1; i < arguments.length; i++) {
            if (!arguments[i]) {
                continue;
            }

            for (var key in arguments[i]) {
                if (arguments[i].hasOwnProperty(key)) {
                    out[key] = arguments[i][key];
                }
            }
        }

        return out;
    }

    function toggleClass(element, className, addOrRemove) {
        var classes = element.className.split(' ');
        var existingIndex = classes.indexOf(className);
        if (existingIndex >= 0 && !addOrRemove) {
            classes.splice(existingIndex, 1);
        }
        if (existingIndex < 0 && addOrRemove) {
            classes.push(className);
        }
        element.className = classes.join(' ');
    }

    function matches(element, selector) {
        if (!element.tagName) {
            return null;
        }
        var docEl = document.documentElement;
        var match = docEl.matches || docEl.matchesSelector || docEl.webkitMatchesSelector || docEl.mozMatchesSelector || docEl.msMatchesSelector || docEl.oMatchesSelector;
        return match.call(element, selector);
    }

    function getClosest(element, selector) {
        do {
            if (matches(element, selector)) {
                return element;
            }
            element = element.parentNode;
        } while (element);
        return null;
    }

    function Zone(args) {
        this.init(args);
    }

    function getEventCoord(event, axis) {
        if (event.type.indexOf('touch') >= 0) {
            // if multi touch this will be the first touch
            return event.changedTouches[0][axis];
        } else {
            return event[axis];
        }
    }

    Zone.prototype.init = function (args) {
        this.element = args.element;
        this.data = args.data;
        this.dragEnter = args.dragEnter;
        this.dragOver = args.dragOver;
        this.dragLeave = args.dragLeave;
        this.active = false;
        this.inside = false;
        this.dirty = false;
    };

    Zone.prototype.refreshDomInfo = function () {
        this.hidden = this.element.style.display === 'none';
        if (!this.hidden) {
            var rect = this.element.getBoundingClientRect();
            this.top = rect.top + window.pageYOffset - document.documentElement.clientTop;
            this.left = rect.left + window.pageXOffset - document.documentElement.clientLeft;
            this.width = rect.width;
            this.height = rect.height;
        }
    };

    Zone.prototype.isInside = function (x, y) {
        if (this.hidden) {
            return false;
        }

        if (x < this.left || y < this.top) {
            return false;
        }

        if (this.left + this.width < x) {
            return false;
        }

        if (this.top + this.height < y) {
            return false;
        }
        return true;
    };

    Zone.prototype.update = function (event, data) {
        if (this.isInside(getEventCoord(event, 'pageX'), getEventCoord(event, 'pageY'))) {
            if (!this.inside) {
                this.enter(event, data);
            }

            if (this.dragOver) {
                this.dragOver(event, data, this.data);
            }
        } else {
            this.leave(event);
        }
    };

    Zone.prototype.enter = function (event, data) {
        this.inside = true;
        if (this.dragEnter) {
            this.active = this.dragEnter(event, data, this.data) !== false;
        } else {
            this.active = true;
        }
        this.dirty = true;
    };

    Zone.prototype.leave = function (event) {
        if (event) {
            event.target = this.element;
        }

        if (this.inside && this.dragLeave) {
            this.dragLeave(event, this.data);
        }
        this.active = false;
        this.inside = false;
        this.dirty = true;
    };

    function DropZone(args) {
        this.init(args);
        this.drop = function (data) {
            args.drop(data, args.data);
        };
    }
    DropZone.prototype = Zone.prototype;

    DropZone.prototype.updateStyling = function () {
        if (this.dirty) {
            toggleClass(this.element, 'drag-over', this.active);
            toggleClass(this.element, 'drop-rejected', this.inside && !this.active);
        }
        this.dirty = false;
    };

    function DragElement(element) {
        this.element = element;
        toggleClass(this.element, 'drag-element', true);
        this.element.style.position = 'fixed';
        this.element.style.zIndex = 9998;
        this.element.addEventListener('selectstart', function () { return false; }, true);
    }

    DragElement.prototype.updatePosition = function (event) {
        this.element.style.top = (event.pageY - window.pageYOffset) + 'px';
        this.element.style.left = (event.pageX - window.pageXOffset) + 'px';
        this.element.style.top = (getEventCoord(event, 'pageY') - window.pageYOffset) + 'px';
        this.element.style.left = (getEventCoord(event, 'pageX') - window.pageXOffset) + 'px';
    };

    DragElement.prototype.remove = function () {
        ko.removeNode(this.element);
    };

    function Draggable(args) {
        this.element = args.element;
        this.name = args.name;
        this.dragStart = args.dragStart;
        this.dragEnd = args.dragEnd;
        this.data = args.data;
    }

    Draggable.prototype.startDrag = function (event) {
        if (this.dragStart && this.dragStart(this.data, event) === false) {
            return false;
        }
        toggleClass(document.body, 'drag-active', true);
    };

    Draggable.prototype.drag = function (event) {
        var that = this;
        var name = this.name;
        var zones = dropZones[name].concat(eventZones[name]);

        forEach(zones, function (zone) {
            zone.refreshDomInfo();
        });

        forEach(zones, function (zone) {
            event.target = zone.element;
            zone.update(event, that.data);
        });

        forEach(dropZones[name], function (zone) {
            zone.updateStyling();
        });
    };

    Draggable.prototype.dropRejected = function () {
        var name = this.name;
        var insideAZone = first(dropZones[name], function (zone) {
            return zone.inside;
        });
        if (!insideAZone) {
            return true;
        }
        var noActiveZone = !first(dropZones[name], function (zone) {
            return zone.active;
        });
        return noActiveZone;
    };

    Draggable.prototype.cancelDrag = function (event) {
        if (this.dragEnd) {
            this.dragEnd(this.data, event);
        }
        toggleClass(document.body, 'drag-active', false);
    };

    Draggable.prototype.drop = function (event) {
        var name = this.name;

        var dropZoneElement = getClosest(event.target, '.drop-zone');
        var activeZones = filter(dropZones[name], function (zone) {
            return zone.active;
        });
        var winningDropZone = filter(activeZones, function (zone) {
            return zone.element === dropZoneElement;
        })[0];

        forEach(dropZones[name].concat(eventZones[name]), function (zone) {
            zone.leave(event);
        });

        forEach(dropZones[name], function (zone) {
            zone.updateStyling();
        });

        if (winningDropZone && winningDropZone.drop) {
            winningDropZone.drop(this.data);
        }

        if (this.dragEnd) {
            this.dragEnd(this.data, event);
        }
        toggleClass(document.body, 'drag-active', false);
    };

    function ScrollArea(element, delay) {
        var rect = element.getBoundingClientRect();
        this.element = element;
        this.scrollMarginHeight = Math.floor(rect.height / 10);
        this.scrollMarginWidth = Math.floor(rect.width / 10);
        this.offset = {
            'top': rect.top + window.pageYOffset - document.documentElement.clientTop,
            'left': rect.left + window.pageXOffset - document.documentElement.clientLeft
        };
        this.innerHeight = rect.height;
        this.innerWidth = rect.width;
        this.scrollDeltaMin = 5;
        this.scrollDeltaMax = 30;
        this.delay = delay || 0;
        this.inZone = 'center';
        this.scrolling = false;
    }

    ScrollArea.prototype.scroll = function (x, y) {
        this.x = x;
        this.y = y;
        this.topLimit = this.scrollMarginHeight + this.offset.top;
        this.bottomLimit = this.offset.top + this.innerHeight - this.scrollMarginHeight;
        this.leftLimit = this.scrollMarginWidth + this.offset.left;
        this.rightLimit = this.offset.left + this.innerWidth - this.scrollMarginWidth;

        var activeZone = '';
        if (y < this.topLimit) {
            activeZone += 'top';
        } else if (y > this.bottomLimit) {
            activeZone += 'bottom';
        }
        if (x < this.leftLimit) {
            activeZone += 'left';
        } else if (x > this.rightLimit) {
            activeZone += 'right';
        }
        if (activeZone === '') {
            activeZone = 'center';
        }

        this.updateZone(activeZone);
    };

    ScrollArea.prototype.enter = function (zone) {
        var that = this;
        this.delayTimer = setTimeout(function () {
            that.scrolling = true;
        }, this.delay);
    };

    ScrollArea.prototype.leave = function (zone) {
        this.scrolling = false;
        clearTimeout(this.delayTimer);
    };

    ScrollArea.prototype.over = function (zone) {
        var speed, scrollDelta = function (speed) {
            return speed * (this.scrollDeltaMax - this.scrollDeltaMin) + this.scrollDeltaMin;
        }.bind(this);
        if (this.scrolling) {
            if (zone.indexOf('top') !== -1) {
                speed = (this.topLimit - this.y) / this.scrollMarginHeight;
                this.element.scrollTop -= scrollDelta(speed);
            } else if (zone.indexOf('bottom') !== -1) {
                speed = (this.y - this.bottomLimit) / this.scrollMarginHeight;
                this.element.scrollTop += scrollDelta(speed);
            }
            if (zone.indexOf('left') !== -1) {
                speed = (this.leftLimit - this.x) / this.scrollMarginWidth;
                this.element.scrollLeft -= scrollDelta(speed);
            } else if (zone.indexOf('right') !== -1) {
                speed = (this.x - this.rightLimit) / this.scrollMarginWidth;
                this.element.scrollLeft += scrollDelta(speed);
            }
        }
    };

    ScrollArea.prototype.updateZone = function (zone) {
        if (this.zone !== zone) {
            this.leave(this.zone);
            this.enter(zone);
        }
        this.zone = zone;
        this.over(zone);
    };

    function getAcceptedDragZones(options) {
        if (options.accepts) {
            return [].concat(options.accepts);
        } else if (options.name) {
            // options.name is deprecated
            return [options.name];
        } else {
            throw new Error('A drop zone must specify the drag zones it accepts');
        }
    }

    ko.utils.extend(ko.bindingHandlers, {
        dropZone: {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var options = ko.utils.unwrapObservable(valueAccessor());
                var accepts = getAcceptedDragZones(options);

                toggleClass(element, 'drop-zone', true);

                var data = options.data ||
                    (bindingContext && bindingContext.$data);

                var zone = new DropZone({
                    element: element,
                    data: data,
                    drop: options.drop,
                    dragEnter: options.dragEnter,
                    dragOver: options.dragOver,
                    dragLeave: options.dragLeave
                });

                accepts.forEach(function (zoneName) {
                    dropZones[zoneName] = dropZones[zoneName] || [];
                    dropZones[zoneName].push(zone);
                });

                ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                    zone.leave();
                    accepts.forEach(function (zoneName) {
                        dropZones[zoneName].splice(dropZones[zoneName].indexOf(zone), 1);
                    });
                });
            }
        },

        dragEvents: {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var options = ko.utils.unwrapObservable(valueAccessor());
                var accepts = getAcceptedDragZones(options);

                var data = options.data ||
                    (bindingContext && bindingContext.$data);

                var zone = new Zone({
                    element: element,
                    data: data,
                    dragEnter: options.dragEnter,
                    dragOver: options.dragOver,
                    dragLeave: options.dragLeave
                });

                accepts.forEach(function (zoneName) {
                    eventZones[zoneName] = eventZones[zoneName] || [];
                    eventZones[zoneName].push(zone);
                });

                ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                    zone.leave();
                    accepts.forEach(function (zoneName) {
                        eventZones[zoneName].splice(eventZones[zoneName].indexOf(zone), 1);
                    });
                });
            }
        },

        dragZone: {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var options = ko.utils.unwrapObservable(valueAccessor());
                var name = options.name;
                var dragDistance = typeof options.dragDistance === 'number' ? options.dragDistance : 10;
                dropZones[name] = dropZones[name] || [];
                eventZones[name] = eventZones[name] || [];
                if (!name || typeof name !== 'string') {
                    throw new Error('A drag zone must specify a name');
                }

                if (options.disabled) {
                    return;
                }


                var data = options.data ||
                    (bindingContext && bindingContext.$data);

                var draggable = new Draggable({
                    element: element,
                    name: name,
                    data: data,
                    dragStart: options.dragStart,
                    dragEnd: options.dragEnd
                });

                if (typeof options.longTapDelay === 'undefined') {
                    options.longTapDelay = 500;
                }

                function createCloneProxyElement() {
                    var dragProxy = element.cloneNode(true);
                    element.parentNode.appendChild(dragProxy);
                    var style = window.getComputedStyle(element, null);
                    dragProxy.style.height = style.getPropertyValue('height');
                    dragProxy.style.width = style.getPropertyValue('width');
                    dragProxy.style.opacity = 70 / 100;
                    dragProxy.style.filter = 'alpha(opacity=70)';
                    return dragProxy;
                }

                function createTemplateProxyElement() {
                    var dragProxy = document.createElement('div');
                    document.body.appendChild(dragProxy);
                    var innerBindingContext = ('data' in options) ?
                        bindingContext.createChildContext(options.data) :
                        bindingContext;
                    ko.renderTemplate(options.element, innerBindingContext, {}, dragProxy);
                    return dragProxy;
                }

                function onSelectStartDrag(event) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                element.addEventListener('selectstart', function (event) {
                    if (!event.target.tagName || event.target.tagName.toLowerCase() !== 'input' && event.target.tagName.toLowerCase() !== 'textarea') {
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    }
                    return true;
                }, true);

                toggleClass(element, 'draggable', true);
                function beginEvent(downEvent) {
                    if (downEvent.button > 0) {
                        return true;
                    }

                    document.addEventListener('selectstart', onSelectStartDrag, true);

                    function startDragging(startEvent) {
                        document.removeEventListener('mouseup', onMouseUpStartDrag, true);
                        document.removeEventListener('touchend', onMouseUpStartDrag, true);
                        document.removeEventListener('click', onMouseUpStartDrag, true);
                        document.removeEventListener('mousemove', onMouseMoveStartDrag, true);
                        document.removeEventListener('touchmove', onTouchMoveStartDrag, true);

                        if (dragging) {
                            return true;
                        }

                        if (draggable.startDrag(downEvent) === false) {
                            startEvent.preventDefault();
                            startEvent.stopPropagation();
                            return false;
                        }

                        dragging = true;

                        var dragElement = null;
                        if (typeof options.element === 'undefined') {
                            dragElement = new DragElement(createCloneProxyElement());
                        }

                        var overlay = document.createElement('div');
                        overlay.className = 'drag-overlay';
                        overlay.setAttribute('unselectable', 'on');
                        overlay.style.zIndex = 9999;
                        overlay.style.position = 'fixed';
                        overlay.style.top = 0;
                        overlay.style.left = 0;
                        overlay.style.right = 0;
                        overlay.style.bottom = 0;
                        overlay.style.cursor = 'move';
                        overlay.style.backgroundColor = 'white';
                        overlay.style.opacity = 0;
                        overlay.style.filter = 'alpha(opacity=0)';
                        overlay.style.userSelect = 'none';
                        overlay.style.webkitUserSelect = 'none';
                        overlay.style.MozUserSelect = 'none';
                        overlay.style.msUserSelect = 'none';
                        overlay.style.OUserSelect = 'none';

                        overlay.addEventListener('selectstart', onSelectStartDrag);
                        document.body.appendChild(overlay);

                        if (options.element) {
                            dragElement = new DragElement(createTemplateProxyElement());
                        }

                        if (dragElement) {
                            dragElement.updatePosition(downEvent);
                        }

                        var dragTimer = null;
                        var dropRejected = false;
                        function drag(event) {
                            draggable.drag(event);
                            var draggableDropRejected = draggable.dropRejected();
                            if (draggableDropRejected !== dropRejected) {
                                toggleClass(overlay, 'drop-rejected', draggableDropRejected);
                                overlay.style.cursor = draggableDropRejected ? 'no-drop' : 'move';
                                dropRejected = draggableDropRejected;
                            }
                            dragTimer = setTimeout(function () {
                                drag(event);
                            }, 100);
                        }

                        function cancelDrag(e) {
                            dragging = false;
                            clearTimeout(touchDragTimer);
                            clearTimeout(dragTimer);
                            if (dragElement) {
                                dragElement.remove();
                            }
                            overlay.parentNode.removeChild(overlay);
                            draggable.cancelDrag(e);

                            //cleanup the touch events because they are on the document not the overlay
                            document.removeEventListener('touchmove', dragHandler);
                            document.removeEventListener('touchend', finishEvent);

                            e.preventDefault();
                            e.stopPropagation();
                            return true;
                        }

                        function dragHandler(moveEvent) {
                            if (moveEvent.button > 0) {
                                return cancelDrag(moveEvent);
                            }

                            clearTimeout(dragTimer);
                            if (dragElement) {
                                dragElement.updatePosition(moveEvent);
                            }
                            drag(moveEvent);
                            moveEvent.preventDefault();
                            moveEvent.stopPropagation();
                            return false;
                        }

                        if (!touchSupport) {
                            overlay.addEventListener('mousedown', cancelDrag);
                        }
                        overlay.addEventListener('mousemove', dragHandler);
                        document.addEventListener('touchmove', dragHandler);

                        function finishEvent(upEvent) {
                            dragging = false;
                            clearTimeout(touchDragTimer);
                            clearTimeout(dragTimer);
                            if (dragElement) {
                                dragElement.remove();
                            }
                            overlay.parentNode.removeChild(overlay);
                            var cloneEvent = extend({}, upEvent);
                            cloneEvent.target = document.elementFromPoint(
                                getEventCoord(upEvent, 'clientX'),
                                getEventCoord(upEvent, 'clientY')
                            );
                            draggable.drop(cloneEvent);

                            document.removeEventListener('selectstart', onSelectStartDrag, true);
                            //cleanup the touch events because they are on the document not the overlay
                            document.removeEventListener('touchmove', dragHandler);
                            document.removeEventListener('touchend', finishEvent);

                            upEvent.preventDefault();
                            upEvent.stopPropagation();
                            return false;
                        }
                        overlay.addEventListener('mouseup', finishEvent);
                        document.addEventListener('touchend', finishEvent);
                    }

                    function onMouseUpStartDrag(event) {
                        document.removeEventListener('mouseup', onMouseUpStartDrag, true);
                        document.removeEventListener('touchend', onMouseUpStartDrag, true);
                        document.removeEventListener('click', onMouseUpStartDrag, true);
                        document.removeEventListener('mousemove', onMouseMoveStartDrag, true);
                        document.removeEventListener('touchmove', onTouchMoveStartDrag, true);
                        document.removeEventListener('selectstart', onSelectStartDrag, true);
                        return true;
                    }
                    document.addEventListener('mouseup', onMouseUpStartDrag, true);
                    document.addEventListener('touchend', onMouseUpStartDrag, true);
                    document.addEventListener('click', onMouseUpStartDrag, true);

                    function onMouseMoveStartDrag(event) {
                        if (event.target.tagName && event.target.tagName.toLowerCase() === 'input') {
                            return true;
                        }
                        var xDifference = getEventCoord(downEvent, 'pageX') - getEventCoord(event, 'pageX'),
                            yDifference = getEventCoord(downEvent, 'pageY') - getEventCoord(event, 'pageY'),
                            distance = Math.sqrt(Math.pow(xDifference, 2) +
                                                 Math.pow(yDifference, 2));
                        if (distance > dragDistance) {
                            startDragging(event);
                        }
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    }

                    var touchDragTimer;
                    if (downEvent.type === 'touchstart') {
                        touchDragTimer = setTimeout(function () {
                            startDragging(downEvent);
                        }, ko.unwrap(options.longTapDelay));

                        element.addEventListener('touchend', function () {
                            clearTimeout(touchDragTimer);
                        });
                    }

                    function onTouchMoveStartDrag(event) {
                        if (event.target.tagName && event.target.tagName.toLowerCase() === 'input') {
                            return true;
                        }

                        var xDifference = getEventCoord(downEvent, 'pageX') - getEventCoord(event, 'pageX'),
                            yDifference = getEventCoord(downEvent, 'pageY') - getEventCoord(event, 'pageY'),
                            distance = Math.sqrt(Math.pow(xDifference, 2) +
                                                 Math.pow(yDifference, 2));
                        if (distance > dragDistance) {
                            clearTimeout(touchDragTimer);
                        }
                    }

                    document.addEventListener('mousemove', onMouseMoveStartDrag, true);
                    document.addEventListener('touchmove', onTouchMoveStartDrag, true);

                    return true;
                }
                element.addEventListener('mousedown', beginEvent);
                element.addEventListener('touchstart', beginEvent);

                ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                    document.removeEventListener('selectstart', onSelectStartDrag, true);
                });
            }
        },

        scrollableOnDragOver: {
            init: function (element, valueAccessor, allBindingAccessor) {
                var options = ko.utils.unwrapObservable(valueAccessor());
                if (typeof options === 'string' || Array.isArray(options)) {
                    options = { accepts: options };
                }
                options.delay = options.delay || 0;
                var accepts = getAcceptedDragZones(options);

                var scrollArea = null;
                var x, y;
                var scrollInterval;

                function scroll() {
                    scrollArea.scroll(x, y);
                }
                function dragEnter(e) {
                    scrollArea = new ScrollArea(element, options.delay);
                    scrollInterval = setInterval(scroll, 100);
                }

                function dragOver(e) {
                    x = getEventCoord(e, 'pageX');
                    y = getEventCoord(e, 'pageY');
                }

                function dragLeave(e) {
                    clearInterval(scrollInterval);
                }

                ko.bindingHandlers.dragEvents.init(element, function () {
                    return {
                        accepts: accepts,
                        dragEnter: dragEnter,
                        dragOver: dragOver,
                        dragLeave: dragLeave
                    };
                });
            }
        }
    });
});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(181);


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(182);

var _components = __webpack_require__(183);

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ycloud = _components2.default;
exports.default = _components2.default;

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _casitem = __webpack_require__(184);

var _casitem2 = _interopRequireDefault(_casitem);

var _cascader = __webpack_require__(186);

var _cascader2 = _interopRequireDefault(_cascader);

var _radio = __webpack_require__(204);

var _radio2 = _interopRequireDefault(_radio);

var _checkbox = __webpack_require__(209);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _box = __webpack_require__(213);

var _box2 = _interopRequireDefault(_box);

var _boxcontent = __webpack_require__(215);

var _boxcontent2 = _interopRequireDefault(_boxcontent);

var _boxfilter = __webpack_require__(217);

var _boxfilter2 = _interopRequireDefault(_boxfilter);

var _boxsticky = __webpack_require__(219);

var _boxsticky2 = _interopRequireDefault(_boxsticky);

var _button = __webpack_require__(221);

var _button2 = _interopRequireDefault(_button);

var _datepicker = __webpack_require__(350);

var _datepicker2 = _interopRequireDefault(_datepicker);

var _datetimepicker = __webpack_require__(366);

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _demo = __webpack_require__(368);

var _demo2 = _interopRequireDefault(_demo);

var _dropdown = __webpack_require__(370);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _form = __webpack_require__(372);

var _form2 = _interopRequireDefault(_form);

var _formitem = __webpack_require__(395);

var _formitem2 = _interopRequireDefault(_formitem);

var _formview = __webpack_require__(397);

var _formview2 = _interopRequireDefault(_formview);

var _grid = __webpack_require__(399);

var _grid2 = _interopRequireDefault(_grid);

var _gridedit = __webpack_require__(422);

var _gridedit2 = _interopRequireDefault(_gridedit);

var _gridchild = __webpack_require__(424);

var _gridchild2 = _interopRequireDefault(_gridchild);

var _gridbasic = __webpack_require__(426);

var _gridbasic2 = _interopRequireDefault(_gridbasic);

var _icon = __webpack_require__(428);

var _icon2 = _interopRequireDefault(_icon);

var _input = __webpack_require__(447);

var _input2 = _interopRequireDefault(_input);

var _simpleinput = __webpack_require__(467);

var _simpleinput2 = _interopRequireDefault(_simpleinput);

var _modal = __webpack_require__(469);

var _modal2 = _interopRequireDefault(_modal);

var _pagination = __webpack_require__(471);

var _pagination2 = _interopRequireDefault(_pagination);

var _searchtag = __webpack_require__(473);

var _searchtag2 = _interopRequireDefault(_searchtag);

var _select = __webpack_require__(475);

var _select2 = _interopRequireDefault(_select);

var _statetabs = __webpack_require__(479);

var _statetabs2 = _interopRequireDefault(_statetabs);

var _tag = __webpack_require__(481);

var _tag2 = _interopRequireDefault(_tag);

var _tree = __webpack_require__(483);

var _tree2 = _interopRequireDefault(_tree);

var _switch = __webpack_require__(488);

var _switch2 = _interopRequireDefault(_switch);

var _tooltip = __webpack_require__(490);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _timepicker = __webpack_require__(494);

var _timepicker2 = _interopRequireDefault(_timepicker);

var _popper = __webpack_require__(496);

var _popper2 = _interopRequireDefault(_popper);

var _base = __webpack_require__(500);

var _breadcrumb = __webpack_require__(503);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _showdetail = __webpack_require__(505);

var _showdetail2 = _interopRequireDefault(_showdetail);

var _poptip = __webpack_require__(507);

var _poptip2 = _interopRequireDefault(_poptip);

var _sortablelist = __webpack_require__(509);

var _sortablelist2 = _interopRequireDefault(_sortablelist);

var _dragablelist = __webpack_require__(511);

var _dragablelist2 = _interopRequireDefault(_dragablelist);

var _textarea = __webpack_require__(513);

var _textarea2 = _interopRequireDefault(_textarea);

__webpack_require__(515);

var _dropbutton = __webpack_require__(516);

var _dropbutton2 = _interopRequireDefault(_dropbutton);

var _mousedialog = __webpack_require__(519);

var _mousedialog2 = _interopRequireDefault(_mousedialog);

var _popdialog = __webpack_require__(521);

var _popdialog2 = _interopRequireDefault(_popdialog);

var _table = __webpack_require__(523);

var _table2 = _interopRequireDefault(_table);

var _fullscreen = __webpack_require__(525);

var _fullscreen2 = _interopRequireDefault(_fullscreen);

var _validator = __webpack_require__(526);

var _validator2 = _interopRequireDefault(_validator);

var _scrollable = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIX = 'y-';

function register(model) {
  _knockout2.default.components.register(PREFIX + model.name, {
    viewModel: model.init,
    template: model.template
  });
}
register(_box2.default);
register(_boxcontent2.default);
register(_boxfilter2.default);
register(_modal2.default);
register(_demo2.default);
register(_dropdown2.default);
register(_switch2.default);
register(_select2.default);
register(_button2.default);
register(_radio2.default);
register(_checkbox2.default);
register(_tag2.default);
register(_boxsticky2.default);
register(_formitem2.default);
register(_form2.default);
register(_icon2.default);
register(_tree2.default);
register(_casitem2.default);
register(_cascader2.default);
register(_pagination2.default);
register(_grid2.default);
register(_gridedit2.default);
register(_gridchild2.default);
register(_gridbasic2.default);
register(_input2.default);
register(_simpleinput2.default);
register(_datepicker2.default);
register(_datetimepicker2.default);
register(_statetabs2.default);
register(_searchtag2.default);
register(_tooltip2.default);
register(_breadcrumb2.default);
register(_showdetail2.default);
register(_formview2.default);
register(_poptip2.default);
register(_sortablelist2.default);
register(_dragablelist2.default);
register(_textarea2.default);
register(_dropbutton2.default);
register(_popdialog2.default);
register(_table2.default);
register(_timepicker2.default);
register(_popper2.default);
register(_mousedialog2.default);
var ycloud = {
  notice: _base.notice,
  $refs: _base.$refs,
  loading: _base.loading,
  fullScreen: _fullscreen2.default,
  util: {
    lockScrollEffect: _scrollable.lockScrollEffect,
    resetScrollEffect: _scrollable.resetScrollEffect
  },
  validator: _validator2.default
  // 3.5.0-rc版本开始 breaking change,所以ycloud要适配老版本的代码需要添加参数
};if (_knockout2.default.options && _knockout2.default.options.createChildContextWithAs !== undefined) {
  _knockout2.default.options.createChildContextWithAs = true;
}
exports.default = ycloud;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(185);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  this.multiple = params.multiple;
  this.subList = _knockout2.default.observableArray([]);
  this.data = params.data;
  this.isLoading = function (val) {
    if (val) {
      return val();
    } else {
      return false;
    }
  };
  this.selectedValue = params.selectedValue;
  this.loadData = params.loadData;
  this.activeIndex = _knockout2.default.observable(-1);
  this.casitmevisible = params.casitmevisible;
  this.expandChild = function (event, data, index) {
    // 再次点击本节点不刷新数据
    if (_this.loadData) {
      // 异步加载
      if (data.isLoaded) {
        // 根据isLoaded 标志判断是否已经加载数据，如果已经加载那就直接显示
        return _this.subList(data.children);
      }
      _this.subList([]);
      _this.data().forEach(function (item) {
        item.isLoading(false);
      });
      data.isLoading(true);
      _this.loadData(data, function (childrenData) {
        data.isLoading(false);
        if (childrenData && childrenData.length > 0) {
          childrenData.forEach(function (item) {
            item.isLoading = _knockout2.default.observable(false);
          });
          data.children = childrenData;
          data.isLoaded = true;
          _this.subList(childrenData);
        } else {
          _this.subList([]);
          // 如果支持多选，不隐藏下拉菜单，直接return
          if (_this.multiple()) return;
          _this.casitmevisible(false);
        }
      });
    } else {
      // 静态数据加载
      if (data.children && data.children.length > 0) {
        _this.subList(data.children);
      } else {
        _this.subList([]);
        // 如果支持多选，不隐藏下拉菜单，直接return
        if (_this.multiple()) return;
        _this.casitmevisible(false);
      }
    }
    _this.activeIndex(index);
    // 如果支持多选 如何改变selectedValue的值
    if (_this.multiple()) {
      // 表示末级，末级可以选择
      if (!data.leafNode) return;
      var selectedValue = _this.selectedValue();
      var position = selectedValue.findIndex(function (item) {
        return item.id === data.id;
      });
      if (position >= 0) {
        selectedValue.splice(position, 1);
        return _this.selectedValue(selectedValue);
      }
      return _this.selectedValue(selectedValue.concat(data));
    }
    _this.selectedValue(data);
  };
}
exports.default = {
  name: 'casitem',
  init: init,
  template: _index2.default
};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "<ul data-bind=\"foreach: { data: data(), as: 'row' }\" class=\"y-casitem\">\n  <li data-bind=\"click: function(){ return $parent.expandChild(event, $data, $index())}, css:{active:$index() == $parent.activeIndex()}\" class=\"y-casitem-item\">\n    <span data-bind=\"text:row.name\"></span>\n    <!-- ko if: !$parent.isLoading(row.isLoading) && row.children && row.children.length > 0 -->\n    <i class=\"fa fa-angle-right\"></i>\n    <!-- /ko -->\n    <!-- ko if: $parent.isLoading(row.isLoading) -->\n    <i class=\"fa fa-spinner y-casitem-isloading\"></i>\n    <!-- /ko -->\n    <!-- ko if: $parent.multiple() && $parent.selectedValue().some(item=>item.id===row.id) -->\n    <i style=\"color:#EE2223;top:33%;\">✔</i>\n    <!-- /ko --> \n  </li>\n</ul>\n<!-- ko if: subList().length > 0 -->\n<y-casitem params=\"multiple: multiple, data: subList, selectedValue: selectedValue, loadData: loadData, casitmevisible: casitmevisible\" class=\"y-casitem-fix\"></y-casitem>\n<!-- /ko -->\n";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(202);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _mixin = __webpack_require__(23);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @author: songhlc liuxu7
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @date: 2017-10-25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @description: 级联列表组件
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * data:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * selectedValue:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * */


var Cascader = function (_Base) {
  _inherits(Cascader, _Base);

  function Cascader() {
    _classCallCheck(this, Cascader);

    return _possibleConstructorReturn(this, (Cascader.__proto__ || (0, _getPrototypeOf2.default)(Cascader)).apply(this, arguments));
  }

  _createClass(Cascader, [{
    key: 'initialize',
    value: function initialize(params) {
      var _this2 = this;

      params.data().forEach(function (item) {
        item.isLoading = _knockout2.default.observable(false);
      });
      this.selectedValueIsShow = _knockout2.default.observable(false);
      this.multiple = params.multiple || _knockout2.default.observable(false);
      this.data = params.data;
      this.selectedValue = params.selectedValue;
      this.loadData = params.loadData;
      this.hidden = _knockout2.default.observable(true);
      this.multipleplaceholder = _knockout2.default.observable((0, _i18n2.default)('请选择'));
      _mixin.gridRefMixin.call(this, params);
      // hook for ariagrid
      this.setFocus = function () {
        _this2.$el.querySelector('.j-handle').click();
        _this2.$el.querySelector('.j-handle').focus();
      };
      this.casitmevisible = _knockout2.default.observable(false);
      this.casitmevisible.subscribe(function (val) {
        if (val) {
          _this2.hidden(!val);
        } else {
          setTimeout(function () {
            _this2.hidden(!val);
          }, 500);
        }
      });
      this.clearable = params.clearable || false;
      // 用于判断是否显示关闭按钮
      this.showCloseIcon = _knockout2.default.computed(function () {
        var isClear = false;
        // 选中数据有一个属性不为空就可清除
        for (var key in _this2.selectedValue()) {
          if (_this2.selectedValue()[key] !== '') {
            isClear = true;
            break;
          }
        }
        return _this2.clearable && isClear;
      });
      this.handlerClear = function (e) {
        // window.event ? window.event.cancelBubble = true : e.stopPropagation()
        if (_this2.multiple()) {
          _this2.selectedValue([]);
          return;
        }
        var obj = {};
        for (var key in _this2.selectedValue()) {
          obj[key] = '';
        }
        _this2.selectedValue(obj);
      };
      // this.handleVisible = () => this.casitmevisible(true)
      // this.handleClose = () => this.casitmevisible(false)
      this.handleVisible = function () {
        _this2.casitmevisible(true);
        _this2.selectedValueIsShow(false);
      };
      this.handleClose = function () {
        _this2.casitmevisible(false);
        _this2.selectedValueIsShow(false);
      };
      this.deleteSelectedItem = function (rowData, e) {
        e.stopPropagation();
        var selectedValue = _this2.selectedValue();
        selectedValue = selectedValue.filter(function (item) {
          return item.id !== rowData.id;
        });
        _this2.selectedValue(selectedValue);
      };
      this.selectedValueShow = function (data, e) {
        e.stopPropagation();
        _this2.casitmevisible(false);
        _this2.selectedValueIsShow(true);
      };
      this.handleDeleteSelected = function (item, e) {
        e.stopPropagation();
        var selectedValue = _this2.selectedValue();
        var index = selectedValue.indexOf(item);
        selectedValue.splice(index, 1);
        _this2.selectedValue(selectedValue);
        window.ycloud.notice.info('删除成功', {
          timeout: 2000
        });
      };
    }
  }]);

  return Cascader;
}(_base2.default);

exports.default = {
  name: 'cascader',
  init: _base2.default.createViewModel(Cascader),
  template: _index2.default
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(188);
var $Object = __webpack_require__(11).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(20);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(21).f });


/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191);
module.exports = __webpack_require__(11).Object.setPrototypeOf;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(20);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(192).set });


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(29);
var anObject = __webpack_require__(36);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(108)(Function.call, __webpack_require__(111).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(194);
var $Object = __webpack_require__(11).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(20);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(70) });


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(21);
var anObject = __webpack_require__(36);
var getKeys = __webpack_require__(37);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(31);
var toLength = __webpack_require__(197);
var toAbsoluteIndex = __webpack_require__(198);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(71);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(17).document;
module.exports = document && document.documentElement;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(201);
module.exports = __webpack_require__(11).Object.getPrototypeOf;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(38);
var $getPrototypeOf = __webpack_require__(115);

__webpack_require__(116)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = "<div data-bind=\"clickoutside: handleClose\" style=\"white-space: nowrap;height: 32px;\">\n  <div class=\"y-inline-block y-relative y-width-100 j-handle\" data-bind=\"click: handleVisible, css:{selected:casitmevisible}, attr:{tabindex: tabindex}\"\n    style=\"cursor: pointer\">\n    <div class=\"y-select-ctn y-input\">\n      <!-- <div class=\"y-select-single\" data-bind=\"text: selectedValue().name || '请选择', style: {color: selectedValue().name? '':'#999'}\"></div> -->\n      <div class=\"y-select-single\" style=\"height:30px;text-indent:0;\">\n        <!-- ko if: !multiple() -->\n        <span data-bind=\"text: selectedValue().name || multipleplaceholder, style: {color: selectedValue().name? '':'#999'}\">\n        </span>\n        <!-- /ko -->\n        <!-- ko if: multiple() -->\n            <!-- ko if:selectedValue().length <= 0 -->\n              <span class=\"y-select-text\" style=\"color:#999\" data-bind=\"text: multipleplaceholder\">\n              </span>\n            <!-- /ko -->\n            <!-- ko if: selectedValue().length>0 -->\n              <div class=\"y-select-tagContainer\">\n                <!-- ko foreach: {data: selectedValue(), as: 'col'} -->\n                  <y-tag\n                    params=\"item: col,text: col.name,closeable:true,handleClose:function(data,e){$parent.deleteSelectedItem(col,e)}\">\n                  </y-tag>\n                <!-- /ko -->\n              </div>\n              <span class=\"y-select-selectedValueMore\" data-bind=\"click:selectedValueShow\">\n                <y-tag params=\"text: '....'\">\n                </y-tag>\n              </span>\n            <!-- /ko -->\n            <!-- ko if: selectedValueIsShow() -->\n              <div class=\"y-select-selectedValue y-selemultiselectct-dropdown\">\n                <div data-bind=\"foreach:{data: selectedValue, as: 'tag'}\">\n                  <y-tag\n                    params=\"item: tag,text: tag.name,closeable:true,handleClose:function(data,e){$parent.handleDeleteSelected(tag,e)}\">\n                  </y-tag>\n                </div>\n              </div>\n            <!-- /ko -->\n        <!-- /ko -->\n      </div>\n      <!-- 待完善 -->\n      <!-- <input class=\"y-select-filter\" type=\"text\" data-bind=\"textInput: selectedValue().name\"> -->\n      <i class=\"y-select-arrow fa fa-close\" data-bind=\"css: {'y-select-showclose': showCloseIcon}, click: function(data, event){handlerClear(event)}, clickBubble: false\"></i>\n      <i class=\"y-select-arrow fa fa-angle-down\" data-bind=\"css: {'y-select-showdrop': showCloseIcon}\"></i>\n    </div>\n  </div>\n  <div class=\"y-cascader-dropdown animated\" data-bind=\"css:{slideInUp: casitmevisible, slideOutDown: !casitmevisible(), hidden: hidden}\">\n    <!-- <y-casitem params=\"data: data, selectedValue: selectedValue, loadData: loadData, casitmevisible: casitmevisible\"></y-casitem> -->\n    <y-casitem params=\"multiple: multiple, data: data, selectedValue: selectedValue, loadData: loadData, casitmevisible: casitmevisible\"></y-casitem>\n  </div>\n</div>\n";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// yc-user-context v2.0.14 by wangjk;songhlc
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self).userContext=t()}(this,function(){"use strict";function t(){var e,t,n=localStorage.getItem("user");return n&&s(n)?(n=((t=s(n)).enterprise||(n=(n=localStorage.getItem("enterprise"))?s(n):(t=u(!0)).enterprise)).tenantid,e="",e=t.user?t.user.ucuserid+"_"+(sessionStorage.getItem("approve_tenantId")||n):t.ucuserid+"_"+(sessionStorage.getItem("approve_tenantId")||n),t.user&&e==p("_yc_user")||(t=u(!0))?t.enterprise:null):(t=u(!0))?t.enterprise:null}function r(){var e=t();return e?e.id:""}function n(e,t){""===(e=s(localStorage.getItem(e+"mdd_switch")))||null==e?c(t):t(e)}function e(t){window.self===window.top?n(a(),t):window.jDiwork&&window.jDiwork.getContext(function(e){n(e.tenantid,t)})}var s=function(e){return window.JsonBigParse?window.JsonBigParse(e):JSON.parse(e)},a=function(){var e=null==(e=window.cb)||null==(e=e.context)?void 0:e.getTenantId();return e||((e=t())?e.tenantid:null)},d="",i="yuncai",o={};function u(e,t,n){var o=null,r=window.localStorage.getItem("user"),a=null==(a=r=s(r))||null==(a=a.enterprise)?void 0:a.tenantid,i=null==(i=window.cb)||null==(i=i.context)?void 0:i.getTenantId(),u=!0;a&&i&&a!==i&&(u=!1);try{if(r&&u&&!e)return r}catch(e){}return m(d+"/yonbip-cpu-portal/yuncai/ebvplogin",{method:"GET",async:!1,headParams:!0,authToken:t,xA01:n},function(e){e.needrelogin||(g("_yc_user",e.user.ucuserid+"_"+e.enterprise.tenantid),window.localStorage.setItem("user",JSON.stringify(e)),o=e)}),o}function c(t){var n=null,o=a()+"mdd_switch";return m(d+"/yonbip-cpu-portal/tenant/mdd",{method:"GET",async:!!t,headParams:!0},function(e){1==e.status&&(window.localStorage.setItem(o,e.data),n=e.data),t&&t(n)}),n}function l(e,t,n){var o=null,t=t||r();return m(d+"/yonbip-cpu-bctask/param/queryParamValue",{method:"GET",data:{paramDefCode:e,entid:t},async:!1},function(e){1==e.status&&(o=e.data,""!=n&&null!=n&&n&&n(o))}),o}function p(e){return window.sessionStorage.getItem(e)}function g(e,t){window.sessionStorage.setItem(e,t)}var m=function(e,t,n){var o=new XMLHttpRequest;t.method=t.method||"GET",t.async=!1!==t.async,t.contentType=t.contentType||"application/json",t.dataType=t.dataType||"json",t.data=t.data||null,"get"==t.method||"GET"==t.method?t.data?o.open(t.method,e+"?"+function(e){var t,n=[];for(t in e)n.push(t+"="+e[t]);return n.join("&")}(t.data)+"&domainKey="+i,t.async):o.open(t.method,e+"?domainKey="+i,t.async):"post"!=t.method&&"POST"!=t.method||o.open(t.method,e+"?domainKey="+i,t.async),t.headParams&&(e=sessionStorage.getItem("approve_tenantId")||"")&&o.setRequestHeader("queryTenantId",e),t.authToken&&o.setRequestHeader("dynamic-auth-token",t.authToken),t.xA01&&o.setRequestHeader("x-a01",t.xA01),o.onload=function(){200===o.status?n&&n(s(this.responseText)):console.error("Error occurred:"+this.statusText)},o.setRequestHeader("X-Requested-With","XMLHttpRequest"),o.send(t.data)};return window.jDiwork&&window.jDiwork.getContext(function(e){e=e.userid+"_"+e.tenantid;p("_yc_user")&&p("_yc_user")!=e&&u(!0)}),{getUserContext:function(e,t){var n,o,r=localStorage.getItem("user");return r&&s(r)?(r=((o=s(r)).enterprise||(r=(r=localStorage.getItem("enterprise"))?s(r):(o=u(!0,e,t)).enterprise)).tenantid,n="",n=o.user?o.user.ucuserid+"_"+(sessionStorage.getItem("approve_tenantId")||r):o.ucuserid+"_"+(sessionStorage.getItem("approve_tenantId")||r),o.user&&n==p("_yc_user")||(o=u(!0,e,t))?o.user:null):(o=u(!0,e,t))?o.user:null},getEnterpriseContext:t,setCookie:function(e,t){var n=new Date;n.setTime(n.getTime()+864e5),document.cookie=e+"="+escape(t)+";expires="+n.toGMTString()+";path=/"},getCookie:function(e){return console.warn("get Cookie 方法已不推荐使用，建议今早修改为getStorage和setStorage方法"),new RegExp("(?:; )?"+e+"=([^;]*);?").test(document.cookie)?decodeURIComponent(RegExp.$1):null},getStorage:p,setStorage:g,getHostUrl:function(){var e=window._YMSHOST_||window.__MAIN_ORIGIN__;return e?(console.log("wjk"+e),e):0<(e=window.location.origin).indexOf("www.diwork.com")||-1<e.indexOf("https://diwork.com")||0<e.indexOf("yonsuite.diwork.com")?"https://yonbip.diwork.com":e},isLogin:function(){return!!u(0<arguments.length&&void 0!==arguments[0]&&arguments[0])},getEnterpriseId:r,getEnterpriseName:function(){var e=t();return e?e.name:""},getTenantId:a,getLangLocale:function(){var e=u(0<arguments.length&&void 0!==arguments[0]&&arguments[0]);return e?e.locale:null},getAllLoginData:function(){var e=u();return e||null},getMddSwitch:function(){var e=a(),e=s(localStorage.getItem(e+"mdd_switch"));return""===e||null==e?c():e},getMddSwitchAsync:e,jumpMddPage:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null;e(function(e){"true"!=e&&1!=e||(e=window.location.search,t&&(e+=t),window.location="/yonbip-cpu-portal/ucf-wh/cpu-portal/mdd.html"+e)})},getParamData:l,getIsMultipleUnits:function(e,t){var n=null;return""==t||null==t?n=l("multiUnitStatus",e):t&&t(n=l("multiUnitStatus",e,t)),n},setPrefix:function(e){d=e},setDoMainKey:function(e){i=e},getPurTenantId:function(e,t){var n=null;return o["PurTenantIdMap"+e]?(t&&t(o["PurTenantIdMap"+e]),o["PurTenantIdMap"+e]):(m(d+"/yonbip-cpu-portal/yuncai/ycrest/tenant/getEnterpriseById",{method:"GET",async:!!t,data:{id:e}},function(e){1==e.status&&(n=e.data.tenantid),t&&t(n)}),n)}}});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(205);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _radioitem = __webpack_require__(206);

var _radioitem2 = _interopRequireDefault(_radioitem);

var _base = __webpack_require__(208);

var _base2 = _interopRequireDefault(_base);

var _base3 = __webpack_require__(1);

var _base4 = _interopRequireDefault(_base3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIX = 'y-';
_knockout2.default.components.register(PREFIX + _radioitem2.default.name, {
  viewModel: _radioitem2.default.init,
  template: _radioitem2.default.template
});
exports.default = {
  name: 'radio',
  init: _base4.default.createViewModel(_base2.default),
  template: _index2.default
};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = "<div id=\"y-radio\" class=\"y-radio\"\n  data-bind=\"foreach: {data: dataList, as: 'item'}, css:{'y-radio-hor':direction == 'horizontal','y-radio-ver':direction == 'vertical'}\">\n  <y-radio-item params=\"fieldid: $parent.fieldid ,radioname: $parent.radioname, value: item, currentValue: $parent.value, onChange: $parent.onChange\"></y-radio-item>\n</div>\n";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radioitem = __webpack_require__(207);

var _radioitem2 = _interopRequireDefault(_radioitem);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIELDIDAFFIX = '_radio';
function init(params) {
  var _this = this;

  this.value = params.value;
  this.currentValue = params.currentValue;
  this.radioname = params.radioname;
  this.fieldid = params.fieldid + params.value.value + FIELDIDAFFIX;
  this.disabled = this.value.disabled;
  this.checked = _knockout2.default.computed(function () {
    // todo 默认是value/label 后续要改成其他自定义格式
    return _this.currentValue() === _this.value.value;
  });
  this.change = function (data) {
    _this.currentValue(_this.value.value);
    params.onChange && params.onChange(_this.value.value);
  };
}
exports.default = {
  name: 'radio-item',
  init: init,
  template: _radioitem2.default
};

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "<label class=\"y-radio-item\" data-bind=\"attr: {fieldid: fieldid},css:{'y-radio-item-checked': checked,'y-radio-item-disabled':disabled}\">\n  <span class=\"y-radio-item--inner-warpper\">\n    <span class=\"y-radio-item-inner\">\n      <input type=\"radio\" data-bind=\"attr:{disabled:disabled,name:radioname},checked: checked, event:{change:change }\">\n    </span>\n  </span>\n  <span class=\"y-radio-label\" data-bind=\"text:value.label\"></span>\n</label>\n";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var Radio = function (_Base) {
  _inherits(Radio, _Base);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, (Radio.__proto__ || (0, _getPrototypeOf2.default)(Radio)).apply(this, arguments));
  }

  _createClass(Radio, [{
    key: 'initialize',
    value: function initialize(params) {
      this.value = params.value || _knockout2.default.observable();
      this.fieldid = params.fieldid || this.value._fieldid || '';
      this.dataList = params.dataList && params.dataList.subscribe ? params.dataList : _knockout2.default.observableArray(params.dataList || []);
      this.direction = params.direction || 'horizontal';
      this.radioname = 'y-radio' + Math.random();
      this.onChange = params.onChange || function () {};
    }
  }]);

  return Radio;
}(_base2.default);

exports.default = Radio;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(210);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _checkboxitem = __webpack_require__(211);

var _checkboxitem2 = _interopRequireDefault(_checkboxitem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIX = 'y-';

_knockout2.default.components.register(PREFIX + _checkboxitem2.default.name, {
  viewModel: _checkboxitem2.default.init,
  template: _checkboxitem2.default.template
});

function init(params) {
  var _this = this;

  if (params.dataList && params.dataList.subscribe) {
    this.dataList = params.dataList;
  } else {
    this.dataList = _knockout2.default.observableArray(params.dataList || []);
  }
  this.value = params.value || _knockout2.default.observableArray([]);
  this.fieldid = params.fieldid || this.value._fieldid || '';
  this.stringValue = params.stringValue || _knockout2.default.observable('');
  this.value.subscribe(function (val) {
    if (_this.stringValue) {
      var v = val.toString();
      // 当存在stringValue时 需要判断String值是否一样 防止多次触发
      if (v !== _this.stringValue()) {
        _this.stringValue(v);
      }
    }
  });
  var that = this;
  var setValue = function setValue(val) {
    if (val) {
      if (val !== _this.value().toString()) {
        if (val instanceof Array) {
          that.value(val);
        } else {
          that.value(val.split(','));
        }
      }
    } else {
      that.value([]);
    }
  };
  // 如果stringValue有默认值 要给value赋值
  if (this.stringValue && this.stringValue()) {
    setValue(this.stringValue());
  }
  this.stringValue.subscribe(function (val) {
    setValue(val);
  });
  this.direction = params.direction || 'horizontal';
}

exports.default = {
  name: 'checkbox',
  init: init,
  template: _index2.default
};

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-checkbox\" data-bind=\"foreach: {data: dataList, as: 'item'}, css:{'y-checkbox-hor':direction == 'horizontal','y-checkbox-ver':direction == 'vertical'}\">\n  <y-checkbox-item params=\"fieldid: $parent.fieldid, disabled: item.disabled, secondarylabel: item.secondarylabel, label: item.label, value: item.value, valueList: $parent.value\"></y-checkbox-item>\n</div>\n";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkboxitem = __webpack_require__(212);

var _checkboxitem2 = _interopRequireDefault(_checkboxitem);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import stringHash from 'string-hash'

var FIELDIDAFFIX = '_checkbox';
function init(params) {
  var _this = this;

  this.label = params.label;
  this.disabled = params.disabled || _knockout2.default.observable(false);
  this.secondarylabel = params.secondarylabel || '';
  // 选项对应的值
  this.value = params.value;
  this.checked = params.checked || _knockout2.default.observable(false);
  this.falseValue = params.falseValue || false;
  this.clickBubble = !!params.clickBubble;
  this.trueValue = params.trueValue ? params.trueValue : true;
  this.fieldid = params.fieldid + this.value + FIELDIDAFFIX;
  // 当在checkbox中使用时，valueList表示所有选中的值
  params.valueList = params.valueList || [];
  // 初始化，如果
  if (params.valueList.indexOf(this.value) >= 0) {
    this.checked(this.trueValue);
  }
  params.valueList.subscribe && params.valueList.subscribe(function (val) {
    // 统一需要转成字符串来判断
    var stringArray = val.map(function (item) {
      return item ? item + '' : '';
    });
    // 统一用string来判断
    if (stringArray.indexOf(_this.value + '') >= 0) {
      _this.checked(_this.trueValue);
    } else {
      _this.checked(_this.falseValue);
    }
  });
  this.checked.subscribe(function (val) {
    // 统一需要转成字符串来判断
    var stringArray = _knockout2.default.isObservable(params.valueList) ? params.valueList().map(function (item) {
      return item ? item + '' : '';
    }) : [];
    var index = stringArray.indexOf(_this.value + '');
    if (index < 0 && val) {
      params.valueList.push(_this.value);
    } else if (!val && index >= 0) {
      params.valueList.splice(index, 1);
    }
  });
  // checkbox重构，不和input进行绑定，在modal+checkbox-grid场景 全选始终无法选中，
  // 于是干脆不绑定了，直接用 试一下
  this.hanldeClick = function (data, event) {
    if (!_knockout2.default.utils.unwrapObservable(_this.disabled)) {
      if (data.checked() === _this.trueValue) {
        data.checked(_this.falseValue);
      } else {
        data.checked(_this.trueValue);
      }
    }
  };
}
exports.default = {
  name: 'checkbox-item',
  init: init,
  template: _checkboxitem2.default
};

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = "<label class=\"y-checkbox-item\" data-bind=\"attr: {fieldid: fieldid},clickBubble: clickBubble,event:{click:hanldeClick},css:{'y-checkbox-item-checked': checked() && checked() != 0, 'y-checkbox-item-disabled': disabled }\">\n  <span class=\"y-checkbox-item--inner-warpper\">\n    <span class=\"y-checkbox-item-inner\">\n      <input type=\"checkbox\" data-bind=\"attr:{disabled:disabled}\">\n    </span>\n  </span>\n  <span class=\"y-checkbox-label\" data-bind=\"text:label\"></span>\n  <span class=\"y-checkbox-second-secondarylabel\" data-bind=\"text:secondarylabel\"></span>\n</label>\n";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(214);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {}

exports.default = {
  name: 'box',
  init: init,
  template: _index2.default
};

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-box\">\n  <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n</div>\n";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _index = __webpack_require__(216);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initialize(params) {
  var _this = this;

  this.title = params.title;
  this.vm = params.vm;
  this.label = params.label;
  this.labelStyle = params.labelStyle;
  this.style = params.style;
  // 是否开启折叠 true 展开  false 折叠  undefined 不开启   折叠不能与自定义标题一起使用
  this.expand = _knockout2.default.observable(params.expand);
  // 根据expand判断图标内容
  this.expandValue = _knockout2.default.computed(function () {
    return _this.expand() ? '-' : '+';
  });
  // 不影响原来title样式
  this.leftBorderStyle = this.expand() !== undefined ? {
    borderLeft: 'none'
  } : '';
  this.animated = params.animated || _knockout2.default.observable(false);
  // 外界动态改变动画效果
  this.classes = _knockout2.default.computed(function () {
    if (_this.animated && _this.animated.subscribe) {
      return _this.animated() ? 'slideInUp animated' : '';
    } else {
      return _this.animated ? 'slideInUp animated' : '';
    }
  });
  this.showContent = _knockout2.default.computed(function () {
    return _this.expand() === undefined ? true : _this.expand();
  });
  // 控制展开收起
  this.expandClick = function () {
    this.expand(!this.expand());
  };
}
exports.default = {
  name: 'boxcontent',
  init: initialize,
  template: _index2.default
};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-box-content\" data-bind=\"css:classes,style:style\">\n  <!-- ko if: expand() !== undefined -->\n  <div class=\"y-box-content-collapse\" data-bind=\"text:expandValue,click:expandClick\"></div>\n  <!-- /ko -->\n  <!-- ko if: title -->\n  <div class=\"y-box-content-title\" data-bind=\"text:title,style:leftBorderStyle\"></div>\n  <!-- /ko -->\n  <!-- ko if: label -->\n  <div class=\"y-box-content-label\" data-bind=\"text:label,style:labelStyle\"></div>\n  <!-- /ko -->\n  <div data-bind=\"visible: showContent\">\n    <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n  </div>\n</div>\n";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(218);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  this.title = params.title;
  this.vm = params.vm;
}
exports.default = {
  name: 'boxfilter',
  init: init,
  template: _index2.default
};

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-box-filter\">\n  <div class=\"pull-left y-box-filter-title\">\n    <span data-bind=\"text:title\"></span>\n  </div>\n  <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n</div>\n";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(32);

var _jquery2 = _interopRequireDefault(_jquery);

var _index = __webpack_require__(220);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * 参考 https://github.com/garand/sticky/blob/master/jquery.sticky.js实现
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * */


var o = {
  currentTop: null,
  topSpacing: 0,
  className: 'is-sticky'
};
window.isRecomputeActiveAnchor = true;

var Boxsticky = function (_Base) {
  _inherits(Boxsticky, _Base);

  function Boxsticky() {
    _classCallCheck(this, Boxsticky);

    return _possibleConstructorReturn(this, (Boxsticky.__proto__ || (0, _getPrototypeOf2.default)(Boxsticky)).apply(this, arguments));
  }

  _createClass(Boxsticky, [{
    key: 'initialize',
    value: function initialize(params) {
      this.title = params.title;
      var stickyElement = (0, _jquery2.default)(this.$el).find('.y-box-sticky');
      var stickyWrapper = stickyElement.parent();
      o.stickyElement = stickyElement;
      o.stickyWrapper = stickyWrapper;
      o = _jquery2.default.extend({}, o, params);
      var timeout = null;
      stickyElement.delegate('.sticky-anchor', 'click', function () {
        if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
          var target = (0, _jquery2.default)(this.hash);
          (0, _jquery2.default)('.sticky-anchor').removeClass('active');
          (0, _jquery2.default)(this).addClass('active');
          // 至于滚轮滚动的时候才会触发 鼠标点击上面不会触发
          window.isRecomputeActiveAnchor = false;
          // 快速点击时清除之前的定时器
          if (timeout) {
            clearTimeout(timeout);
          }
          // 2s后方便鼠标滚轮事件触发
          timeout = setTimeout(function () {
            window.isRecomputeActiveAnchor = true;
          }, 2000);
          target = target.length ? target : (0, _jquery2.default)('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            (0, _jquery2.default)('html, body').animate({
              // 改成更合适的高度
              scrollTop: target.offset().top - 50
            }, 1000);
            return false;
          }
        }
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var anchor = null;
      var anchorlist = [];
      var cachedOffsetTop = {};
      var cachedHeight = 0;
      var outerHeight = 0;
      var wrapperOuterHeight = 0;
      var outterOffsetTop = 0;
      this.scroller = function () {
        // 如果不存在元素
        if (!anchor) {
          anchor = (0, _jquery2.default)('.sticky-anchor');
          anchor.each(function () {
            anchorlist.push((0, _jquery2.default)(this).attr('href'));
          });
        }
        var documentHeight = (0, _jquery2.default)(document).height();
        var scrollTop = (0, _jquery2.default)(window).scrollTop();
        var windowHeight = (0, _jquery2.default)(window).height();
        // 至于滚轮滚动的时候才会触发 鼠标点击上面不会触发
        if (window.isRecomputeActiveAnchor) {
          anchorlist.forEach(function (item) {
            if (documentHeight !== cachedHeight) {
              cachedOffsetTop[item] = (0, _jquery2.default)(item).offset().top;
            }
            var pos = cachedOffsetTop[item] - scrollTop;
            // 确保滚轮滚动时 会定位到相应的选项
            if (pos - windowHeight / 2 < 50) {
              var anchorItem = (0, _jquery2.default)('.sticky-anchor[href="' + item + '"]');
              if (!anchorItem.hasClass('active')) {
                (0, _jquery2.default)('.sticky-anchor').removeClass('active');
                anchorItem.addClass('active');
              }
            }
          });
          cachedHeight = documentHeight;
        }
        if (!outerHeight) {
          outerHeight = o.stickyElement.outerHeight();
        }
        // update height in case of dynamic content
        o.stickyWrapper.css('height', outerHeight);

        var dwh = documentHeight - windowHeight;
        var extra = scrollTop > dwh ? dwh - scrollTop : 0;
        var elementTop = wrapperOuterHeight || o.stickyWrapper.offset().top;
        wrapperOuterHeight = elementTop;
        var etse = elementTop - o.topSpacing - extra;
        if (scrollTop <= etse) {
          if (o.currentTop !== null) {
            o.stickyElement.css({
              'width': '',
              'position': '',
              'top': '',
              'z-index': ''
            });
            o.stickyElement.parent().removeClass(o.className);
            o.currentTop = null;
          }
        } else {
          var newTop = documentHeight - outerHeight - o.topSpacing - o.bottomSpacing - scrollTop - extra;
          if (newTop < 0) {
            newTop = newTop + o.topSpacing;
          } else {
            newTop = o.topSpacing;
          }
          if (o.currentTop !== newTop) {
            var newWidth;
            if (newWidth == null) {
              newWidth = o.stickyElement.outerWidth();
            }
            o.stickyElement.css('width', newWidth).css('position', 'fixed').css('top', newTop).css('z-index', o.zIndex);

            o.stickyElement.parent().addClass(o.className);
            o.currentTop = newTop;
          }

          // Check if sticky has reached end of container and stop sticking
          var stickyWrapperContainer = o.stickyWrapper.parent();
          var _innerOffsetTop = o.stickyElement.offset().top;
          var _outterOffsetTop = outterOffsetTop || stickyWrapperContainer.offset().top;
          outterOffsetTop = _outterOffsetTop;
          var unstick = _innerOffsetTop + outerHeight >= _outterOffsetTop + stickyWrapperContainer.outerHeight() && _innerOffsetTop <= o.topSpacing;
          if (unstick) {
            o.stickyElement.css({
              'position': 'absolute',
              'top': '',
              'bottom': 0,
              'z-index': ''
            });
          } else {
            o.stickyElement.css({
              'position': 'fixed',
              'top': newTop,
              'bottom': '',
              'z-index': o.zIndex
            });
          }
        }
      };
    }
  }, {
    key: 'created',
    value: function created(params) {
      if (window.addEventListener) {
        window.addEventListener('scroll', this.scroller, false);
        // TODO 浏览器窗口resize的时候也需要重新计算
        // window.addEventListener('resize', resizer, false)
      } else if (window.attachEvent) {
        window.attachEvent('onscroll', this.scroller);
        // window.attachEvent('onresize', resizer)
      }
      setTimeout(this.scroller, 0);
    }
  }]);

  return Boxsticky;
}(_base2.default);

exports.default = {
  name: 'boxsticky',
  init: _base2.default.createViewModel(Boxsticky),
  template: _index2.default
};

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-box-sticky-ctn\">\n  <div class=\"y-box-sticky\">\n    <div class=\"row\">\n      <!-- ko if: title -->\n      <div class=\"col-sm-2 y-box-sticky-title\">\n        <span data-bind=\"text:title\"></span>\n      </div>\n      <!-- /ko -->\n      <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(222);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _lodash = __webpack_require__(53);

var _lodash2 = _interopRequireDefault(_lodash);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _stringHash = __webpack_require__(42);

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @author: liuxu7
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @date: 2017-10-25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @description: 按钮组件
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * type: primary/ghost/dashed/text/info/success/warning/error
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * size: large/small/default
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * shape: circle
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * btnType: 原生button属性 + a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * disabled: true/false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * loading: true/false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * */


var PREFIX = 'y-button-';
var FIELDIDAFFIX = '_btn';

var Button = function (_Base) {
  _inherits(Button, _Base);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'initialize',
    value: function initialize(params) {
      var _this2 = this;

      var innerTpl = params.label || (params.$templateNodes.length > 0 ? params.$templateNodes[0].textContent : '');
      this.fieldid = '';
      if (params.fieldid) {
        this.fieldid = params.fieldid + FIELDIDAFFIX;
      } else if (innerTpl) {
        this.fieldid = (0, _stringHash2.default)(innerTpl) + FIELDIDAFFIX;
      }
      // button
      var defaultFun = function defaultFun() {};
      this.type = params.type ? PREFIX + params.type : '';
      this.size = params.size ? PREFIX + params.size : '';
      this.shape = params.shape ? PREFIX + params.shape : '';
      this.clickBubble = params.StopClickBubble ? !params.StopClickBubble : true;
      this.long = params.long ? PREFIX + 'long' : '';
      this.btnType = params.btnType || 'button';
      this.disabled = _knockout2.default.isObservable(params.disabled) ? params.disabled : _knockout2.default.observable(params.disabled || false);
      this.disabledCls = _knockout2.default.computed(function () {
        if (typeof _this2.disabled === 'function') {
          return _this2.disabled() ? PREFIX + 'disabled' : '';
        } else {
          return _this2.disabled ? PREFIX + 'disabled' : '';
        }
      });
      this.classes = _knockout2.default.computed(function () {
        return _this2.type + ' ' + _this2.size + ' ' + _this2.shape + ' ' + _this2.long + ' ' + _this2.disabledCls();
      });
      this.loading = params.loading || _knockout2.default.observable(false);
      this.loadingText = params.loadingText || 'loading..';
      this.label = params.label || '';
      this.handleClick = params.click || defaultFun;
      this.handleReClick = _lodash2.default.debounce(function (data, event) {
        // 如果正在loading中则不允许再次点击
        if (!_this2.loading()) {
          _this2.handleClick(data, event);
          _this2.disabled(true);
          setTimeout(function () {
            _this2.disabled(false);
          }, params.wait || 0);
        }
      }, params.wait || 0, {
        'leading': true
      });

      // a target
      this.url = params.url || 'javascript:;';
      if (params.rootPath) {
        this.url = 'http://' + this.url;
      }
      this.target = params.target || '_self';
    }
  }]);

  return Button;
}(_base2.default);

exports.default = {
  name: 'button',
  init: _base2.default.createViewModel(Button),
  template: _index2.default
};

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = "<!-- ko if: btnType==='a' -->\n<a class=\"y-button\" data-bind=\"css: classes, attr: {href: url, target: target, fieldid: fieldid}\">\n  <span data-bind=\"text:label\"></span>\n  <!-- ko template: { nodes: $componentTemplateNodes } -->\n  <!-- /ko -->\n</a>\n<!-- /ko -->\n\n<!-- ko if: btnType!=='a' -->\n<button class=\"y-button\" data-bind=\"css: classes, attr: {type: btnType, disabled: disabled, fieldid: fieldid}, style: {opacity: loading() || disabled() ? 0.5 : 1}, click: handleReClick, clickBubble: clickBubble\">\n  <span data-bind=\"visible: loading\">\n    <span class=\"fa fa-repeat y-load-loop\"></span> <span data-bind=\"text: loadingText\"></span>\n  </span>\n  <span data-bind=\"visible: !loading()\">\n    <span data-bind=\"text:label, attr: {title: type === 'y-button-text' ? label : ''}\"></span>\n    <!-- ko template: { nodes: $componentTemplateNodes } -->\n    <!-- /ko -->\n  </span>\n</button>\n<!-- /ko -->";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(117),
    castSlice = __webpack_require__(226),
    hasUnicode = __webpack_require__(121),
    isIterateeCall = __webpack_require__(228),
    isRegExp = __webpack_require__(229),
    stringToArray = __webpack_require__(231),
    toString = __webpack_require__(123);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(33);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(227);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(55),
    isArrayLike = __webpack_require__(39),
    isIndex = __webpack_require__(76),
    isObject = __webpack_require__(14);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(230),
    baseUnary = __webpack_require__(40),
    nodeUtil = __webpack_require__(56);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(232),
    hasUnicode = __webpack_require__(121),
    unicodeToArray = __webpack_require__(233);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 232 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(12);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(236);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(238),
    baseFlatten = __webpack_require__(267),
    baseRest = __webpack_require__(270),
    isArrayLikeObject = __webpack_require__(277);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(125),
    arrayIncludes = __webpack_require__(262),
    arrayIncludesWith = __webpack_require__(266),
    arrayMap = __webpack_require__(120),
    baseUnary = __webpack_require__(40),
    cacheHas = __webpack_require__(128);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(240),
    ListCache = __webpack_require__(58),
    Map = __webpack_require__(80);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(241),
    hashDelete = __webpack_require__(246),
    hashGet = __webpack_require__(247),
    hashHas = __webpack_require__(248),
    hashSet = __webpack_require__(249);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(57);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(122),
    isMasked = __webpack_require__(243),
    isObject = __webpack_require__(14),
    toSource = __webpack_require__(126);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(244);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(12);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(57);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(57);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(57);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(59);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(60);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(60);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(60);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(60);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(263);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(127),
    baseIsNaN = __webpack_require__(264),
    strictIndexOf = __webpack_require__(265);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(81),
    isFlattenable = __webpack_require__(268);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(33),
    isArguments = __webpack_require__(82),
    isArray = __webpack_require__(13);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(83),
    overRest = __webpack_require__(271),
    setToString = __webpack_require__(273);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(272);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(274),
    shortOut = __webpack_require__(276);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(275),
    defineProperty = __webpack_require__(129),
    identity = __webpack_require__(83);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(39),
    isObjectLike = __webpack_require__(16);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(127),
    baseIteratee = __webpack_require__(130),
    toInteger = __webpack_require__(314);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(280),
    getMatchData = __webpack_require__(302),
    matchesStrictComparable = __webpack_require__(141);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(84),
    baseIsEqual = __webpack_require__(131);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(58);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(58),
    Map = __webpack_require__(80),
    MapCache = __webpack_require__(79);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(84),
    equalArrays = __webpack_require__(132),
    equalByTag = __webpack_require__(288),
    equalObjects = __webpack_require__(291),
    getTag = __webpack_require__(61),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(86),
    isTypedArray = __webpack_require__(138);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(33),
    Uint8Array = __webpack_require__(133),
    eq = __webpack_require__(55),
    equalArrays = __webpack_require__(132),
    mapToArray = __webpack_require__(289),
    setToArray = __webpack_require__(290);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(134);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isLength = __webpack_require__(75),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(87),
    nativeKeys = __webpack_require__(297);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(139);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(12);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(12);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(12);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(12);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(140),
    keys = __webpack_require__(41);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(131),
    get = __webpack_require__(304),
    hasIn = __webpack_require__(308),
    isKey = __webpack_require__(88),
    isStrictComparable = __webpack_require__(140),
    matchesStrictComparable = __webpack_require__(141),
    toKey = __webpack_require__(62);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(142);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(306);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(307);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(79);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(309),
    hasPath = __webpack_require__(310);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(143),
    isArguments = __webpack_require__(82),
    isArray = __webpack_require__(13),
    isIndex = __webpack_require__(76),
    isLength = __webpack_require__(75),
    toKey = __webpack_require__(62);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(312),
    basePropertyDeep = __webpack_require__(313),
    isKey = __webpack_require__(88),
    toKey = __webpack_require__(62);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(142);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(315);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(124);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89),
    createAggregator = __webpack_require__(317);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(318),
    baseAggregator = __webpack_require__(319),
    baseIteratee = __webpack_require__(130),
    isArray = __webpack_require__(13);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(320);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(321),
    createBaseEach = __webpack_require__(324);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(322),
    keys = __webpack_require__(41);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(323);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(39);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(78),
    isObject = __webpack_require__(14);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(327);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(84),
    arrayEach = __webpack_require__(328),
    assignValue = __webpack_require__(144),
    baseAssign = __webpack_require__(329),
    baseAssignIn = __webpack_require__(330),
    cloneBuffer = __webpack_require__(333),
    copyArray = __webpack_require__(334),
    copySymbols = __webpack_require__(335),
    copySymbolsIn = __webpack_require__(336),
    getAllKeys = __webpack_require__(134),
    getAllKeysIn = __webpack_require__(337),
    getTag = __webpack_require__(61),
    initCloneArray = __webpack_require__(338),
    initCloneByTag = __webpack_require__(339),
    initCloneObject = __webpack_require__(344),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(86),
    isMap = __webpack_require__(346),
    isObject = __webpack_require__(14),
    isSet = __webpack_require__(348),
    keys = __webpack_require__(41),
    keysIn = __webpack_require__(90);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(63),
    keys = __webpack_require__(41);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(63),
    keysIn = __webpack_require__(90);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14),
    isPrototype = __webpack_require__(87),
    nativeKeysIn = __webpack_require__(332);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(12);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)(module)))

/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(63),
    getSymbols = __webpack_require__(85);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(63),
    getSymbolsIn = __webpack_require__(145);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(135),
    getSymbolsIn = __webpack_require__(145),
    keysIn = __webpack_require__(90);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(91),
    cloneDataView = __webpack_require__(340),
    cloneRegExp = __webpack_require__(341),
    cloneSymbol = __webpack_require__(342),
    cloneTypedArray = __webpack_require__(343);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(91);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(33);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(91);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(345),
    getPrototype = __webpack_require__(146),
    isPrototype = __webpack_require__(87);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(347),
    baseUnary = __webpack_require__(40),
    nodeUtil = __webpack_require__(56);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(61),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(349),
    baseUnary = __webpack_require__(40),
    nodeUtil = __webpack_require__(56);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(61),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(351);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _index = __webpack_require__(352);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _util = __webpack_require__(147);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _mixin = __webpack_require__(23);

var _scrollable = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var PREIFX = 'y-';
// 日期组件要验证的点
// 1.默认日期没有值
// 2.默认日期有值
// 3.动态修改日期的值
// 4.只修改时间的值
// 5.日期选择范围测试
// 6.默认数字格式，默认日期格式，默认日期时间格式
_knockout2.default.components.register(PREIFX + 'datepicker-year', {
  viewModel: __webpack_require__(353).default,
  template: __webpack_require__(355)
});

_knockout2.default.components.register(PREIFX + 'datepicker-month', {
  viewModel: __webpack_require__(356).default,
  template: __webpack_require__(358)
});

_knockout2.default.components.register(PREIFX + 'datepicker-day', {
  viewModel: __webpack_require__(359).default,
  template: __webpack_require__(360)
});

_knockout2.default.components.register(PREIFX + 'datepicker-timer', {
  viewModel: __webpack_require__(361).default,
  template: __webpack_require__(363)
});

_knockout2.default.components.register(PREIFX + 'year', {
  viewModel: _base2.default.createViewModel(__webpack_require__(364).default),
  template: __webpack_require__(365)
});
var DATEFORMAT = 'yyyy-MM-dd';
var DATETIMEFORMAT = 'yyyy-MM-dd hh:mm:ss';
// 获取元素距离窗口左侧距离
var getElementLeft = function getElementLeft(element) {
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
};
var FIELDIDAFFIX = '_input';

var DatePicker = function (_Base) {
  _inherits(DatePicker, _Base);

  function DatePicker() {
    _classCallCheck(this, DatePicker);

    return _possibleConstructorReturn(this, (DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).apply(this, arguments));
  }

  _createClass(DatePicker, [{
    key: 'initialize',
    value: function initialize(_ref) {
      var _this2 = this;

      var placeholder = _ref.placeholder,
          position = _ref.position,
          data = _ref.data,
          _ref$isTimer = _ref.isTimer,
          isTimer = _ref$isTimer === undefined ? false : _ref$isTimer,
          _ref$lang = _ref.lang,
          lang = _ref$lang === undefined ? 'zh' : _ref$lang,
          minDate = _ref.minDate,
          maxDate = _ref.maxDate,
          _ref$numbericValue = _ref.numbericValue,
          numbericValue = _ref$numbericValue === undefined ? false : _ref$numbericValue,
          dropStyle = _ref.dropStyle,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === undefined ? false : _ref$disabled,
          _ref$gridRef = _ref.gridRef,
          gridRef = _ref$gridRef === undefined ? false : _ref$gridRef,
          fieldid = _ref.fieldid;

      this.lang = lang;
      this.dropStyle = dropStyle;
      this.isTimer = isTimer;
      this.placeholder = placeholder;
      if (position === 'top') {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
      this.data = data;
      this.isNumbericValue = numbericValue;
      if (!_knockout2.default.isObservable(disabled)) {
        disabled = _knockout2.default.observable(disabled);
      }
      this.disabled = disabled;
      this.year = _knockout2.default.observable();
      this.month = _knockout2.default.observable();
      this.day = _knockout2.default.observable();
      this.hour = _knockout2.default.observable(0);
      this.minutes = _knockout2.default.observable(0);
      this.seconds = _knockout2.default.observable(0);
      this.currentChange = '';
      this.visChoosenow = _knockout2.default.observable(true);
      this.minDate = minDate || _knockout2.default.observable('1600-01-01');
      this.maxDate = maxDate || _knockout2.default.observable('2599-12-31');
      this.isPopup = _knockout2.default.observable(false);
      this.initFlag = true;
      // 是否忽略监听
      this.ignoreSubscribe = false;
      // 显示对应输入框
      this.showyear = _knockout2.default.observable(false);
      this.showmonth = _knockout2.default.observable(false);
      this.showday = _knockout2.default.observable(true);
      this.showtimer = _knockout2.default.observable(false);
      this.alignright = _knockout2.default.observable(false);
      this.i18nConfirm = (0, _i18n2.default)('确定');
      this.fieldid = (fieldid || this.data._fieldid || '') + FIELDIDAFFIX;
      _mixin.gridRefMixin.call(this, {
        gridRef: gridRef
      });
      this.setFocus = function () {
        _this2.$el.querySelector('.y-input').click();
        _this2.$el.querySelector('.y-input').focus();
      };
      this.setUnFoucs = function () {
        _this2.isPopup(false);
      };
    }
  }, {
    key: 'computed',
    value: function computed(params) {
      var _this3 = this;

      // 最终显示的值为计算属性 close #88
      this.computedData = _knockout2.default.pureComputed({
        read: function read() {
          var _date;
          if (_this3.isTimer) {
            _date = new Date(_this3.year(), _this3.month() - 1, _this3.day(), _this3.hour(), _this3.minutes(), _this3.seconds())._format(DATETIMEFORMAT);
          } else {
            _date = new Date(_this3.year(), _this3.month() - 1, _this3.day())._format(DATEFORMAT);
          }
          if (_this3.data()) {
            return _date;
          } else {
            return '';
          }
        },
        write: function write(val) {
          _this3.setData(val, _this3.data, _this3.isNumbericValue);
        }
      });
      this.visChoosenow = _knockout2.default.pureComputed(function () {
        var maxDate = _this3.maxDate();
        var nowData = new Date()._format(DATEFORMAT);
        if (maxDate <= nowData) {
          return false;
        }
        return true;
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      var _this4 = this;

      this.data.subscribe(function (value) {
        _this4.generateDate(value);
      });
      this.year.subscribe(function (value) {
        _this4.currentChange = 'year';
        if (!_this4.ignoreSubscribe) {
          _this4.showyear(false);
          _this4.showmonth(true);
          _this4.bindModelValue(true);
        }
      });
      this.month.subscribe(function (value) {
        _this4.currentChange = 'month';
        if (!_this4.ignoreSubscribe) {
          _this4.showmonth(false);
          _this4.showday(true);
          _this4.bindModelValue(true);
        }
      });
      this.day.subscribe(function (value) {
        _this4.currentChange = 'day';
        if (!_this4.ignoreSubscribe) {
          if (!_this4.isTimer) {
            _this4.bindModelValue();
          }
        }
      });
      this.hour.subscribe(function (value) {
        if (!_this4.ignoreSubscribe) {
          if (_this4.isTimer) {
            _this4.bindModelValue();
          }
        }
      });
      this.minutes.subscribe(function (value) {
        if (!_this4.ignoreSubscribe) {
          if (_this4.isTimer) {
            _this4.bindModelValue();
          }
        }
      });
      this.seconds.subscribe(function (value) {
        if (!_this4.ignoreSubscribe) {
          if (_this4.isTimer) {
            _this4.bindModelValue();
          }
        }
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this5 = this;

      this.setData = _util.setData;
      this.onMaskHover = function () {
        (0, _scrollable.resetScrollEffect)();
      };
      // 生成初始化的值
      this.generateDate = function (v) {
        var _date;
        if (v) {
          // 支持数字
          _date = isNaN(v - 0) ? new Date(v.replace(/-/g, '/')) : new Date(v - 0);
          _date = _date.toString() === "Invalid Date" ? new Date(v) : _date;
        } else {
          _date = new Date();
          // 如果没有默认值 需要优先设置默认值，防止后续触发到bindModelValue
          _this5.initFlag = false;
        }
        // 修改老的值 同时不触发subscribe, 原来会多次触发有问题
        _this5.ignoreSubscribe = true;
        _this5.year(_date.getFullYear());
        _this5.month(_date.getMonth() + 1);
        _this5.day(_date.getDate());
        if (_this5.isTimer) {
          _this5.hour(_date.getHours());
          _this5.minutes(_date.getMinutes());
          _this5.seconds(_date.getSeconds());
        }
        _this5.ignoreSubscribe = false;
        _this5.bindModelValue();
        // 第一次初始化完之后设置flag
        _this5.initFlag = false;
      };
      // 选中输入框
      this.focus = function (data, event) {
        var leftPosition = getElementLeft(event.target);
        // 获取viewport 宽度
        var screenWidth = document.documentElement.clientWidth;
        try {
          // 如果元素距离右侧的距离小于280 则将弹出浮动款左移，设置right：0
          if (screenWidth - leftPosition < 280) {
            _this5.alignright(true);
          } else {
            _this5.alignright(false);
          }
        } catch (e) {
          console.error(e);
        }
        _this5.isPopup(true);
        _this5.showyear(false);
        _this5.showmonth(false);
        _this5.showday(true);
      };
      // 遮罩点击
      this.maskClick = function () {
        _this5.isPopup(false);
      };
      // 绑定最终选择的模型
      this.bindModelValue = function (stopCloseModal) {
        // 如果不是时间选择,则直接关闭窗口,如果当前改变的是月份 或者年份则不关闭
        if (!_this5.isTimer && !stopCloseModal && _this5.currentChange !== 'year' && _this5.currentChange !== 'month') {
          _this5.closeModal();
        }
        var _date = void 0;
        if (_this5.isTimer) {
          _date = new Date(_this5.year(), _this5.month() - 1, _this5.day(), _this5.hour(), _this5.minutes(), _this5.seconds())._format(DATETIMEFORMAT);
        } else {
          _date = new Date(_this5.year(), _this5.month() - 1, _this5.day())._format(DATEFORMAT);
        }
        // 改变年月的时候，如果日期不正确则不setData
        if (stopCloseModal && _date.indexOf('NaN') >= 0) {
          return null;
        }
        // 如果还处于初始化则不重新赋值, 数据初始化的时候有默认值，则会重新设置一下日期格式
        if (_this5.initFlag) {
          _this5.setData(_date, _this5.data, _this5.isNumbericValue);
        }
        // 如果有旧值，则存在只修改了时间没有修改日期的操作，需要动态更新值
        var oldData = _this5.data();
        if (oldData !== undefined && oldData !== '' && oldData !== null) {
          _this5.setData(_date, _this5.data, _this5.isNumbericValue);
        }
      };
      //
      this.confirm = function () {
        _this5.bindModelValue();
        _this5.closeModal();
      };
      this.timerpanel = function () {
        _this5.showtimer(!_this5.showtimer());
      };
      this.choosenow = function () {
        var _date = void 0;
        if (_this5.isTimer) {
          _date = new Date()._format(DATETIMEFORMAT);
        } else {
          _date = new Date()._format(DATEFORMAT);
        }
        _this5.setData(_date, _this5.data, _this5.isNumbericValue);
        _this5.closeModal();
      };
      // 关闭弹框
      this.closeModal = function () {
        _this5.showyear(false);
        _this5.showmonth(false);
        _this5.showday(false);
        _this5.isPopup(false);
      };
    }
  }, {
    key: 'created',
    value: function created(params) {
      // 初始化值
      this.generateDate(this.data());
    }
  }]);

  return DatePicker;
}(_base2.default);

exports.default = {
  name: 'datepicker',
  init: _base2.default.createViewModel(DatePicker),
  template: _index2.default
};

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position: relative\">\n  <div class=\"y-datepicker-input z-indexPicture\">\n    <input type=\"text\" class=\"y-input\" data-bind=\"value:computedData,event:{focus:focus},attr:{tabindex: tabindex, disabled: disabled(), 'placeholder': placeholder,fieldid: fieldid}\">\n    <span class=\"fa fa-calendar\"></span>\n  </div>\n  <y-dropdown params=\"style: dropStyle,targetEl:$el,isShow:isPopup, width:'240', maxHeight: '258', overflow:'hidden',isTop: isTop\">\n    <div class=\"y-datepicker-ctn\" data-bind=\"if: $parent.isPopup, css:{'select-date': $parent.isPopup, 'isTimer': $parent.isTimer, 'alignright': $parent.alignright}\">\n      <div class=\"y-datepicker-header\">\n      </div>\n      <div class=\"y-datepicker-footer\">\n        <y-datepicker-year params=\"\n          year: $parent.year,\n          showmonth:$parent.showmonth,\n          showyear:$parent.showyear\"\n          class=\"hide\" data-bind=\"css:{'show':$parent.showyear}\"></y-datepicker-year>\n        <y-datepicker-month params=\"\n          year: $parent.year,\n          month: $parent.month,\n          showday:$parent.showday,\n          showmonth:$parent.showmonth,\n          showyear:$parent.showyear\"\n          class=\"hide\" data-bind=\"css:{'show':$parent.showmonth}\"></y-datepicker-month>\n        <y-datepicker-day params=\"\n          isNumbericValue: $parent.isNumbericValue,\n          minDate: $parent.minDate,\n          maxDate:$parent.maxDate,\n          hour:$parent.hour,\n          minutes:$parent.minutes,\n          seconds:$parent.seconds,\n          isTimer:$parent.isTimer,\n          data: $parent.data,\n          year: $parent.year,\n          month: $parent.month,\n          day: $parent.day,\n          showday:$parent.showday,\n          showyear:$parent.showyear,\n          showmonth:$parent.showmonth\"\n          class=\"hide\" data-bind=\"css:{'show':$parent.showday}\"></y-datepicker-day>\n        <y-datepicker-timer params=\"\n          hour:$parent.hour,\n          minutes:$parent.minutes,\n          seconds:$parent.seconds,\n          showtimer:$parent.showtimer\"></y-datepicker-timer>\n        <div class=\"y-datepicker-option\">\n          <div class=\"curdate\" data-bind=\"click:$parent.choosenow,visible: $parent.visChoosenow()\">\n            <span class=\"fa fa-arrows\"></span>\n          </div>\n          <div class=\"timer-picker\" data-bind=\"click:$parent.timerpanel\">\n            <span class=\"fa fa-clock-o\" data-bind=\"css:{'fa-calendar':$parent.showtimer}\"></span>\n          </div>\n          <div class=\"confirmbutton pull-right\" data-bind=\"click:$parent.confirm, text: $parent.i18nConfirm\"></div>\n        </div>\n      </div>\n      <div class=\"y-datepicker-mask\" data-bind=\"event:{mousemove:$parent.onMaskHover},click:$parent.maskClick\"></div>\n    </div>\n  </y-dropdown>\n</div>\n";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(354);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  // 实际选择的年份
  this.year = params.year;
  this._year = _knockout2.default.observable(params.year());
  // 监控开始年份
  this.startyear = _knockout2.default.computed(function () {
    return Math.floor(this._year() / 10) * 10;
  }, this);
  // 选择年份
  this.handleYearClick = function (val) {
    _this.year(_this.startyear() + val);
    params.showyear(false);
    params.showmonth(true);
  };
  // 前十年
  this.last10year = function () {
    _this._year(_this._year() - 10);
  };
  // 后十年
  this.next10year = function () {
    _this._year(_this._year() + 10);
  };
}

exports.default = init;

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-year-ctn\">\n  <div class=\"y-year-header\">\n    <div class=\"last10year\" data-bind=\"click: last10year\">&lt;&lt;</div>\n    <div class=\"cur10year\">\n      <span data-bind=\"text:startyear\"></span>\n      <span>-</span>\n      <span data-bind=\"text:startyear() + 9\"></span>\n    </div>\n    <div class=\"next10year\" data-bind=\"click: next10year\">&gt;&gt;</div>\n  </div>\n  <table class=\"y-year-body\">\n    <tr>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+0}\"><div class=\"cell\" data-bind=\"text: startyear,click:function(){handleYearClick(0)}\"></div></td>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+1}\"><div class=\"cell\" data-bind=\"text: startyear() + 1,click:function(){handleYearClick(1)}\"></div></td>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+2}\"><div class=\"cell\" data-bind=\"text: startyear() + 2,click:function(){handleYearClick(2)}\"></div></td>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+3}\"><div class=\"cell\" data-bind=\"text: startyear() + 3,click:function(){handleYearClick(3)}\"></div></td>\n    </tr>\n    <tr>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+4}\"><div class=\"cell\" data-bind=\"text: startyear() + 4,click:function(){handleYearClick(4)}\"></div></td>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+5}\"><div class=\"cell\" data-bind=\"text: startyear() + 5,click:function(){handleYearClick(5)}\"></div></td>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+6}\"><div class=\"cell\" data-bind=\"text: startyear() + 6,click:function(){handleYearClick(6)}\"></div></td>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+7}\"><div class=\"cell\" data-bind=\"text: startyear() + 7,click:function(){handleYearClick(7)}\"></div></td>\n    </tr>\n    <tr>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+8}\"><div class=\"cell\" data-bind=\"text: startyear() + 8,click:function(){handleYearClick(8)}\"></div></td>\n      <td class=\"available\" data-bind=\"css:{curry:year() == startyear()+9}\"><div class=\"cell\" data-bind=\"text: startyear() + 9,click:function(){handleYearClick(9)}\"></div></td>\n    </tr>\n  </table>\n</div>\n";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(357);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  this.month = params.month;
  this.year = params.year;
  // 选择月份
  this.handleMonthClick = function (val) {
    _this.month(val);
    params.showday(true);
    params.showmonth(false);
  };
  // 前十年
  this.lastyear = function () {
    _this.year(_this.year() - 1);
  };
  // 后十年
  this.nextyear = function () {
    _this.year(_this.year() + 1);
  };
  // 年份选择
  this.chooseyear = function () {
    params.showyear(true);
    params.showmonth(false);
  };
  this.month1 = (0, _i18n2.default)('一月');
  this.month2 = (0, _i18n2.default)('二月');
  this.month3 = (0, _i18n2.default)('三月');
  this.month4 = (0, _i18n2.default)('四月');
  this.month5 = (0, _i18n2.default)('五月');
  this.month6 = (0, _i18n2.default)('六月');
  this.month7 = (0, _i18n2.default)('七月');
  this.month8 = (0, _i18n2.default)('八月');
  this.month9 = (0, _i18n2.default)('九月');
  this.month10 = (0, _i18n2.default)('十月');
  this.month11 = (0, _i18n2.default)('十一月');
  this.month12 = (0, _i18n2.default)('十二月');
}

exports.default = init;

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-month-ctn\">\n  <div class=\"y-month-header\">\n    <div class=\"lastyear\" data-bind=\"click: lastyear\">&lt;&lt;</div>\n    <div class=\"curyear\">\n      <span data-bind=\"text:year,click:chooseyear\"></span>\n    </div>\n    <div class=\"nextyear\" data-bind=\"click: nextyear\">&gt;&gt;</div>\n  </div>\n  <table class=\"y-month-body\">\n    <tbody>\n    <tr>\n      <td data-bind=\"css:{curry:month() == 1}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(1)}, text: month1\">一月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 2}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(2)}, text: month2\">二月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 3}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(3)}, text: month3\">三月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 4}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(4)}, text: month4\">四月</div>\n      </td>\n    </tr>\n    <tr>\n      <td data-bind=\"css:{curry:month() == 5}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(5)}, text: month5\">五月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 6}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(6)}, text: month6\">六月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 7}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(7)}, text: month7\">七月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 8}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(8)}, text: month8\">八月</div>\n      </td>\n    </tr>\n    <tr>\n      <td data-bind=\"css:{curry:month() == 9}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(9)}, text: month9\">九月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 10}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(10)}, text: month10\">十月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 11}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(11)}, text: month11\">十一月</div>\n      </td>\n      <td data-bind=\"css:{curry:month() == 12}\">\n        <div class=\"cell\" data-bind=\"click:function(){handleMonthClick(12)}, text: month12\">十二月</div>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n\n</div>\n";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(147);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DAY_DURATION = 86400000; // 1天
var clearHours = function clearHours(time) {
  var cloneDate = new Date(time);
  cloneDate.setHours(0, 0, 0, 0);
  return cloneDate.getTime();
};

function init(params) {
  var _this = this;

  var that = this;
  this.month = params.month;
  this.year = params.year;
  this.showYear = _knockout2.default.computed(function () {
    return this.year() + (0, _i18n2.default)('年');
  }.bind(this));
  this.showMonth = _knockout2.default.computed(function () {
    return (0, _i18n2.default)(this.month() + '月');
  }.bind(this));
  this.day = params.day;
  this.i18nSun = (0, _i18n2.default)('日');
  this.i18nMon = (0, _i18n2.default)('一');
  this.i18nTue = (0, _i18n2.default)('二');
  this.i18nWed = (0, _i18n2.default)('三');
  this.i18nThu = (0, _i18n2.default)('四');
  this.i18nFri = (0, _i18n2.default)('五');
  this.i18nSat = (0, _i18n2.default)('六');
  this.tableRows = _knockout2.default.observableArray([_knockout2.default.observableArray([]), _knockout2.default.observableArray([]), _knockout2.default.observableArray([]), _knockout2.default.observableArray([]), _knockout2.default.observableArray([]), _knockout2.default.observableArray([])]);
  // todo
  this.firstDayOfWeek = _knockout2.default.observable(7);
  // 开始日期
  this.startDate = _knockout2.default.computed(function () {
    return (0, _util.getStartDateOfMonth)(this.year(), this.month());
  }, this);
  this.disabledDate = function (time) {
    if (params.minDate() && clearHours(time) <= clearHours(new Date(params.minDate()))) {
      return true;
    } else if (params.maxDate() && clearHours(time) >= clearHours(new Date(params.maxDate()))) {
      return true;
    } else {
      return false;
    }
  };

  this.showWeekNumber = false;
  this.offsetDay = _knockout2.default.computed(function () {
    var week = this.firstDayOfWeek();
    // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
    return week > 3 ? 7 - week : -week;
  }, this);
  // 选择日期
  this.handleDayClick = function (cell) {
    if (cell.disabled) {
      return;
    }
    var year = this.year();
    var month = this.month();
    var day = cell.text;
    // 跨页选取
    if (cell.type === 'prev-month') {
      if (month === 1) {
        year--;
        month = 12;
      } else {
        month--;
      }
    } else if (cell.type === 'next-month') {
      if (month === 12) {
        year++;
        month = 1;
      } else {
        month++;
      }
    }
    // 切换到其他月份的时候
    _util.setData.call(params, new Date(year, month - 1, day, params.hour(), params.minutes(), params.seconds())._format(params.isTimer ? 'yyyy-MM-dd hh:mm:ss' : 'yyyy-MM-dd'), params.data, params.isNumbericValue);
  };
  // 判断是否当前天
  this.isSelectedDay = function (cellType, cellDay) {
    if (cellType === 'normal' || cellType === 'today') {
      // fix ie and edge new date bug
      var d = params.data();
      if (d) {
        var _date = null;
        if (isNaN(d)) {
          _date = new Date((d + '').replace(/-/g, '/'));
        } else {
          _date = new Date(d);
        }
        if (cellDay === _this.day() && _this.month() === _date.getMonth() + 1 && _this.year() === _date.getFullYear()) {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  // 年份选择
  this.chooseyear = function () {
    params.showyear(true);
    params.showday(false);
  };
  // 月份选择
  this.choosemonth = function () {
    params.showmonth(true);
    params.showday(false);
  };
  this.lastyear = function () {
    _this.year(_this.year() - 1);
    _this.showday();
  };
  this.lastmonth = function () {
    var curmonth = _this.month();
    if (curmonth === 1) {
      _this.year(_this.year() - 1);
      _this.month(12);
    } else {
      _this.month(_this.month() - 1);
    }
    _this.showday();
  };
  this.nextyear = function () {
    _this.year(_this.year() + 1);
    _this.showday();
  };
  this.nextmonth = function () {
    var curmonth = _this.month();
    if (curmonth === 12) {
      _this.year(_this.year() + 1);
      _this.month(1);
    } else {
      _this.month(_this.month() + 1);
    }
    _this.showday();
  };
  this.showday = function () {
    params.showmonth(false);
    params.showday(true);
  };
  this.rows = _knockout2.default.computed(function () {
    var date = new Date(this.year(), this.month() - 1, 1);
    var day = (0, _util.getFirstDayOfMonth)(date); // day of first day
    var dateCountOfMonth = (0, _util.getDayCountOfMonth)(date.getFullYear(), date.getMonth());
    var dateCountOfLastMonth = (0, _util.getDayCountOfMonth)(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);
    day = day === 0 ? 7 : day;
    var offset = this.offsetDay();
    var rows = this.tableRows();
    var count = 1;
    var firstDayPosition = void 0;
    var startDate = this.startDate();
    var disabledDate = this.disabledDate;
    var now = clearHours(new Date());
    debugger;
    for (var i = 0; i < 6; i++) {
      // 每一行
      var row = rows[i]();
      if (this.showWeekNumber) {
        if (!row[0]) {
          row[0] = { type: 'week', text: (0, _util.getWeekNumber)(new Date(startDate.getTime() + DAY_DURATION * (i * 7 + 1))) };
        }
      }
      for (var j = 0; j < 7; j++) {
        var cell = row[this.showWeekNumber ? j + 1 : j];
        if (!cell) {
          cell = { row: i, column: j, type: 'normal' };
        }
        cell['$parent'] = that;
        cell.type = 'normal';
        var index = i * 7 + j;
        var time = startDate.getTime() + DAY_DURATION * (index - offset);
        var isToday = time === now;
        if (isToday) {
          cell.type = 'today';
        }
        if (i >= 0 && i <= 1) {
          if (j + i * 7 >= day + offset) {
            cell.text = count++;
            if (count === 2) {
              firstDayPosition = i * 7 + j;
            }
          } else {
            cell.text = dateCountOfLastMonth - (day + offset - j % 7) + 1 + i * 7;
            cell.type = 'prev-month';
          }
        } else {
          if (count <= dateCountOfMonth) {
            cell.text = count++;
            if (count === 2) {
              firstDayPosition = i * 7 + j;
            }
          } else {
            cell.text = count++ - dateCountOfMonth;
            cell.type = 'next-month';
          }
        }
        cell.disabled = typeof disabledDate === 'function' && disabledDate(new Date(time));
        if (this.showWeekNumber) {
          row[j + 1] = cell;
        } else {
          row[j] = cell;
        }
        // this.$set(row, this.showWeekNumber ? j + 1 : j, cell)
      }
      rows[i](row);
    }
    rows.firstDayPosition = firstDayPosition;
    return rows;
  }, this);
}

exports.default = init;

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-day-ctn\">\n  <div class=\"y-day-header\">\n    <span class=\"lastyear\" data-bind=\"click: lastyear\">&lt;&lt;</span>\n    <span class=\"lastmonth\" data-bind=\"click: lastmonth\">&lt;</span>\n    <span class=\"yearandmonth\">\n      <span data-bind=\"text: showYear, click: chooseyear\"></span>\n      <span data-bind=\"text: showMonth, click: choosemonth\"></span>\n    </span>\n    <span class=\"nextmonth\" data-bind=\"click: nextmonth\">&gt;</span>\n    <span class=\"nextyear\" data-bind=\"click: nextyear\">&gt;&gt;</span>\n  </div>\n  <table class=\"y-day-body\">\n    <tr style=\"color: #bbb;\">\n      <td data-bind=\"text: i18nSun\">日</td>\n      <td data-bind=\"text: i18nMon\">一</td>\n      <td data-bind=\"text: i18nTue\">二</td>\n      <td data-bind=\"text: i18nWed\">三</td>\n      <td data-bind=\"text: i18nThu\">四</td>\n      <td data-bind=\"text: i18nFri\">五</td>\n      <td data-bind=\"text: i18nSat\">六</td>\n    </tr>\n    <!-- ko foreach: { data: rows(), as: 'row' } -->\n    <tr data-bind=\"foreach: { data: row, as: 'cell' }\">\n      <td data-bind=\"click:function(){$parent.handleDayClick(cell)},css:{disable:cell.disabled,nextmonth:cell.type=='next-month',prevmonth:cell.type=='prev-month',today: cell.type=='today',selectedDay: $parent.isSelectedDay(cell.type, cell.text)}\">\n         <div data-bind=\"text:cell.text\"></div>\n      </td>\n    </tr>\n    <!-- /ko -->\n  </table>\n</div>\n";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(362);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var _this = this;

  var hour = _ref.hour,
      minutes = _ref.minutes,
      seconds = _ref.seconds,
      showtimer = _ref.showtimer;

  this.showtimer = showtimer;
  this.hour = _knockout2.default.computed(function () {
    return hour() > 9 ? hour() : '0' + hour();
  });
  this.minutes = _knockout2.default.computed(function () {
    return minutes() > 9 ? minutes() : '0' + minutes();
  });
  this.seconds = _knockout2.default.computed(function () {
    return seconds() > 9 ? seconds() : '0' + seconds();
  });
  this.onInput = function (e) {
    var val = parseFloat(e.target.value);
    if (!/^[0-9]*[1-9][0-9]*$/.test(val)) {
      e.target.value = '00';
    }
  };
  this.nexthour = function () {
    var _hour = hour() + 1;
    if (_hour === 24) {
      hour(0);
    } else {
      hour(_hour);
    }
  };
  this.lasthour = function () {
    var _hour = hour() - 1;
    if (_hour <= 0) {
      hour(23);
    } else {
      hour(_hour);
    }
  };
  // 小时手动输入
  this.blurHour = function (e) {
    var _hour = e.target.value;
    if (_hour >= 24 || _hour <= 0) {
      hour(0);
      e.target.value = '00';
    } else {
      hour(_hour);
    }
  };
  var timerTimeout;
  var innerInterval;
  // 小时选择长按
  this.nexthourholddown = function () {
    timerTimeout = setTimeout(function () {
      innerInterval = setInterval(function () {
        _this.nexthour();
      }, 100);
    }, 200);
  };
  this.lasthourholddown = function () {
    timerTimeout = setTimeout(function () {
      innerInterval = setInterval(function () {
        _this.lasthour();
      }, 100);
    }, 200);
  };
  // 分钟选择长按
  this.nextminholddown = function () {
    timerTimeout = setTimeout(function () {
      innerInterval = setInterval(function () {
        _this.nextminutes();
      }, 50);
    }, 200);
  };
  // 分钟选择长按
  this.lastminholddown = function () {
    timerTimeout = setTimeout(function () {
      innerInterval = setInterval(function () {
        _this.lastminutes();
      }, 50);
    }, 200);
  };
  // 秒选择长按
  this.nextsecholddown = function () {
    timerTimeout = setTimeout(function () {
      innerInterval = setInterval(function () {
        _this.nextseconds();
      }, 50);
    }, 200);
  };
  // 秒选择长按
  this.lastsecholddown = function () {
    timerTimeout = setTimeout(function () {
      innerInterval = setInterval(function () {
        _this.lastseconds();
      }, 50);
    }, 200);
  };
  this.holdup = function () {
    clearInterval(innerInterval);
    clearTimeout(timerTimeout);
  };
  this.blur = function () {
    clearInterval(innerInterval);
    clearTimeout(timerTimeout);
  };

  this.nextminutes = function () {
    var _minutes = minutes() + 1;
    if (_minutes >= 60) {
      minutes(0);
    } else {
      minutes(_minutes);
    }
  };
  this.lastminutes = function () {
    var _minutes = minutes() - 1;
    if (_minutes <= 0) {
      minutes(59);
    } else {
      minutes(_minutes);
    }
  };
  // 分钟手动输入
  this.blurMinutes = function (e) {
    var _minutes = e.target.value;
    if (_minutes >= 60 || _minutes <= 0) {
      minutes(0);
      e.target.value = '00';
    } else {
      minutes(_minutes);
    }
  };
  this.nextseconds = function () {
    var _seconds = seconds() + 1;
    if (_seconds >= 60) {
      seconds(0);
    } else {
      seconds(_seconds);
    }
  };
  this.lastseconds = function () {
    var _seconds = seconds() - 1;
    if (_seconds <= 0) {
      seconds(59);
    } else {
      seconds(_seconds);
    }
  };
  // 秒手动输入
  this.blurSeconds = function (e) {
    var _seconds = e.target.value;
    if (_seconds >= 60 || _seconds <= 0) {
      seconds(0);
      e.target.value = '00';
    } else {
      seconds(_seconds);
    }
  };
}
exports.default = init;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-timer-ctn\" data-bind=\"css:{'hidden':!showtimer()}\">\n  <div class=\"y-timer-header\">\n\n  </div>\n  <table class=\"y-timer-body\">\n    <tr>\n      <td>\n        <div>\n          <div class=\"fa fa-angle-up\" data-bind=\"click: nexthour, event:{mousedown:nexthourholddown,mouseup:holdup,blur:blur}\"></div>\n          <!-- <div class=\"timer\" data-bind=\"text:hour\"></div> -->\n          <input class=\"timer\" type=\"text\"  data-bind=\"value:hour, event:{blur:function(){blurHour(event)},input:function(){onInput(event)}}\">\n          <div class=\"fa fa-angle-down\" data-bind=\"click: lasthour,event:{mousedown:lasthourholddown,mouseup:holdup,blur:blur}\"></div>\n        </div>\n      </td>\n      <td>:</td>\n      <td>\n        <div>\n          <div class=\"fa fa-angle-up\" data-bind=\"click: nextminutes, event:{mousedown:nextminholddown,mouseup:holdup,blur:blur}\"></div>\n          <!-- <div class=\"timer\" data-bind=\"text:minutes\"></div> -->\n          <input class=\"timer\" type=\"text\"  data-bind=\"value:minutes, event:{blur:function(){blurMinutes(event)},input:function(){onInput(event)}}\">\n          <div class=\"fa fa-angle-down\" data-bind=\"click: lastminutes, event:{mousedown:lastminholddown,mouseup:holdup,blur:blur}\"></div>\n        </div>\n      </td>\n      <td>:</td>\n      <td>\n        <div>\n          <div class=\"fa fa-angle-up\" data-bind=\"click: nextseconds, event:{mousedown:nextsecholddown,mouseup:holdup,blur:blur}\"></div>\n          <!-- <div class=\"timer\" data-bind=\"text:seconds\"></div> -->\n          <input class=\"timer\" type=\"text\"  data-bind=\"value:seconds, event:{blur:function(){blurSeconds(event)},input:function(){onInput(event)}}\">\n          <div class=\"fa fa-angle-down\" data-bind=\"click: lastseconds,event:{mousedown:lastsecholddown,mouseup:holdup,blur:blur}\"></div>\n        </div>\n      </td>\n    </tr>\n  </table>\n</div>\n";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDIDAFFIX = '_year_input';

var YearPicker = function (_Base) {
  _inherits(YearPicker, _Base);

  function YearPicker() {
    _classCallCheck(this, YearPicker);

    return _possibleConstructorReturn(this, (YearPicker.__proto__ || (0, _getPrototypeOf2.default)(YearPicker)).apply(this, arguments));
  }

  _createClass(YearPicker, [{
    key: 'initialize',
    value: function initialize(params) {
      this.data = params.data;
      this.year = _knockout2.default.observable(this.data() || new Date().getFullYear());
      this.fieldid = (params.fieldid || this.data._fieldid || '') + FIELDIDAFFIX;
      this.disabled = params.disabled;
      this.placeholder = params.placeholder;
      if (!_knockout2.default.isObservable(params.disabled)) {
        this.disabled = _knockout2.default.observable(params.disabled);
      }
      this.isPopup = _knockout2.default.observable(false);
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      var _this2 = this;

      this.data.subscribe(function (val) {
        _this2.year(val);
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this3 = this;

      this.maskClick = function () {
        _this3.isPopup(false);
      };
      this.showyear = function () {};
      this.focus = function () {
        _this3.isPopup(true);
      };
      this.onOk = function () {
        var _data = _this3.year();
        if (_knockout2.default.isObservable(_this3.data)) {
          _this3.data(Number(_data));
        }
        _this3.isPopup(false);
      };
    }
  }]);

  return YearPicker;
}(_base2.default);

exports.default = YearPicker;

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position: relative\">\n  <div class=\"y-datepicker-input z-indexPicture\">\n    <input type=\"text\" class=\"y-input\" data-bind=\"value:data,event:{focus:focus},attr:{disabled: disabled(), 'placeholder': placeholder,fieldid: fieldid}\">\n    <span class=\"fa fa-calendar\"></span>\n  </div>\n  <y-dropdown params=\"targetEl:$el,isShow:isPopup, width:'240', maxHeight: '258', overflow:'hidden',isTop: false\">\n    <div class=\"y-datepicker-ctn\" data-bind=\"if: $parent.isPopup\">\n      <div class=\"y-datepicker-footer\">\n        <y-datepicker-year params=\"\n          year: $parent.year,\n          showmonth:$parent.onOk,\n          showyear:function () {}\"\n          class=\"hide\" data-bind=\"css:{'show':$parent.showyear}\"></y-datepicker-year>\n      </div>\n      <div class=\"y-datepicker-mask\" data-bind=\"click:$parent.maskClick\"></div>\n    </div>\n  </y-dropdown>\n</div>\n";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(367);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var placeholder = _ref.placeholder,
      data = _ref.data,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      numbericValue = _ref.numbericValue,
      position = _ref.position,
      disabled = _ref.disabled,
      fieldid = _ref.fieldid;

  this.placeholder = placeholder;
  this.data = data;
  this.disabled = disabled;
  this.position = position;
  this.minDate = minDate || _knockout2.default.observable('1600-01-01');
  this.maxDate = maxDate || _knockout2.default.observable('2099-12-31');
  this.numbericValue = numbericValue;
  this.fieldid = fieldid || this.data._fieldid || '';
}
exports.default = {
  name: 'datetimepicker',
  init: init,
  template: _index2.default
};

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "<y-datepicker params=\"numbericValue:numbericValue,minDate:minDate,maxDate:maxDate,placeholder:placeholder,data: data, isTimer:true,position: position,disabled:disabled,fieldid: fieldid\">\n</y-datepicker>\n";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(369);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  this.text = 'i am demo';
}
exports.default = {
  name: 'demo',
  init: init,
  template: _index2.default
};

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "<div class=\"yc-demo\">\n  <span data-bind=\"text:text\"></span>\n</div>\n";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(371);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _jquery = __webpack_require__(32);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _init(params, el) {
  var _this = this;

  this.isTop = params.isTop;
  this.isShow = params.isShow || _knockout2.default.observable(false);
  this.scrollTop = params.scrollTop || _knockout2.default.observable();
  var _el = el.element;
  this.scrollTop.subscribe(function (val) {
    _el.children[0].scrollTop = val;
  });
  this.dropStyle = params.style;
  this.$el = el;
  this.isTransferDom = !params.isStopTransferDom;
  this.targetEl = params.targetEl;
  this.top = _knockout2.default.observable();
  this.left = _knockout2.default.observable();
  this.topAdjust = params.topAdjust || 0;
  this.width = _knockout2.default.observable(params.width || '100%');
  var scrollEvent = function () {
    if (this.isShow()) {
      this.top(this.targetEl.children[0].getBoundingClientRect().top + 32);
    }
  }.bind(this);
  this.onEnter = function () {
    // lockScrollEffect()
  };
  this.onLeave = function () {}
  // resetScrollEffect()

  // 切换时重新设置下拉的未知
  ;this.isShow.subscribe(function (val) {
    // 多选情况比较复杂，暂不支持穿越overflowhidden
    if (val && _this.isTransferDom) {
      var _el2 = _this.targetEl.children[0];
      var position = _el2.getBoundingClientRect();
      var left = position.left;
      var right = position.right;
      var dropWidth = _this.width() === '100%' ? _el2.offsetWidth : _this.width().toString().replace('px', '') - 0;
      // 如果距离右侧屏幕宽度小于250
      if (document.documentElement.clientWidth - position.left < dropWidth) {
        left = right - dropWidth;
      }
      if (!params.width) {
        _this.width((0, _jquery2.default)(_el2).width());
      }
      _this.left(left);
      // select 默认高度 + 32
      _this.top(position.top + _el2.offsetHeight);
      document.addEventListener('scroll', scrollEvent);
    } else {
      document.removeEventListener('scroll', scrollEvent);
    }
  });
  this.style = _knockout2.default.computed(function () {
    var style = params.style || {};
    // width 支持ko和非ko对象
    if (_this.width && _this.width.subscribe) {
      // 存在传入 100%的情况
      if (isNaN(_this.width())) {
        style.width = _this.width();
      } else {
        style.width = _this.width() + 'px';
      }
    }
    if (params.maxHeight) {
      style.maxHeight = params.maxHeight + 'px';
    }
    if (params.overflow) {
      style.overflow = params.overflow;
    }
    if (_this.top()) {
      if (_this.isTop) {
        style.top = _this.top() + Number(_this.topAdjust) - 300 + 'px';
      } else {
        style.top = _this.top() + Number(_this.topAdjust) + 'px';
      }
      style.left = _this.left() + 'px';
      style.position = 'fixed';
    } else {
      style.position = 'absolute';
    }

    return style;
  });
  this.animated = _knockout2.default.observable(false);
  this.isShow.subscribe(function (val) {
    if (!val) {
      // 关闭的时候一定要恢复 防止点透
      // resetScrollEffect()
    }
    _this.animated(true);
    setTimeout(function () {
      _this.animated(false);
    }, 1500);
  });
}
// import {
//   lockScrollEffect,
//   resetScrollEffect
// } from '../../util/scrollable'

var init = {
  createViewModel: function createViewModel(params, componentInfo) {
    return new _init(params, componentInfo);
  }
};
exports.default = {
  name: 'dropdown',
  init: init,
  template: _index2.default
};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-dropdown\" data-bind=\"\n  transferdom: isTransferDom,\n  style: style,\n  event: {\n    mouseenter: onEnter,\n    mouseleave: onLeave\n  },\n  css: {\n    animated: animated,\n    slideInUp: isShow && !dropStyle,\n    slideOutUp: !isShow(),\n    hidden:!isShow()\n  }\">\n  <!-- ko template: { nodes: $componentTemplateNodes } -->\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(373);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _asyncValidator = __webpack_require__(148);

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_Base) {
  _inherits(Form, _Base);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'initialize',
    value: function initialize(params) {
      this.validateList = _knockout2.default.observableArray();
      this.model = params.model;
      this.labelWidth = params.labelWidth || '80px';
      this.textAlignCls = (params.labelAlign || 'right') === 'right' ? 'y-form-text-right' : 'y-form-text-left';
      this.vRules = params.vRules;
    }
  }, {
    key: 'formValidate',
    value: function formValidate(data, handleCallback) {
      var _this2 = this;

      var validator = new _asyncValidator2.default(this.vRules);
      validator.validate(data, function (errors, fields) {
        if (errors) {
          _this2.validateList([]);
          errors.forEach(function (error) {
            _this2.validateList.push({ key: error.field, message: error.message });
          });
          return handleCallback(errors, fields);
        } else {
          _this2.validateList([]);
          return handleCallback(null);
        }
      });
    }
  }]);

  return Form;
}(_base2.default);

exports.default = {
  name: 'form',
  init: _base2.default.createViewModel(Form),
  template: _index2.default
};

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-form\" data-bind=\"css:textAlignCls\">\n  <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n</div>\n";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__(375);

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__(381);

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__(382);

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__(383);

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__(384);

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__(385);

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__(386);

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__(387);

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__(388);

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__(389);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(390);

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__(391);

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__(392);

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__(393);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(6);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(6);

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__(149);

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(6);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(6);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(6);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(6);

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(8);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(396);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  this.model = params.model;
  this.tooltip = params.tooltip;
  this.required = params.required || false;
  this.label = params.label;
  this.style = params.style;
  this.visible = params.visible || _knockout2.default.observable(true);
  this.errorMsg = _knockout2.default.observable('error msg');
  this.vMap = params.vMap || false;
  this.validate = _knockout2.default.computed(function () {
    if (params.vMap) {
      var filteList = params.vMap().filter(function (item) {
        return item.key === params.vKey;
      });
      if (filteList.length > 0) {
        _this.errorMsg(filteList[0].message);
      }
      return filteList.length > 0;
    } else {
      return false;
    }
  });
}

exports.default = {
  name: 'formitem',
  init: init,
  template: _index2.default
};

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-form-item\" data-bind=\"visible:visible,css:{'y-form-validate': vMap}\">\n  <label for=\"\" class=\"y-form-item-label\" data-bind=\"style:{width: $parent.labelWidth}\">\n    <span class=\"y-form-item-required\" data-bind=\"visible:required\">*</span>\n    <!-- ko if:tooltip -->\n      <y-tooltip params=\"title: label,question:true\">\n        <y-tooltipctn params=\"targetEl: $el, title: '', show:isShow,position: 'bottomleft'\">\n          <div data-bind=\"html: $parentContext.$parent.tooltip\"></div>\n        </y-tooltipctn>\n      </y-tooltip>\n    <!-- /ko -->\n    <!-- ko ifnot:tooltip -->\n    <span data-bind=\"text:label\"></span>\n    <!-- /ko -->\n  </label>\n  <div class=\"y-form-item-ctn\" data-bind=\"style:{'margin-left': $parent.labelWidth}\">\n    <div class=\"y-form-wrapper\" data-bind=\"style:style\">\n      <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n    </div>\n    <div class=\"y-form-item-error\" data-bind=\"visible:validate, text:errorMsg\"></div>\n  </div>\n</div>\n";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(398);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  this.label = params.label;
  this.style = params.style;
  this.visible = params.visible || _knockout2.default.observable(true);
}

exports.default = {
  name: 'formview',
  init: init,
  template: _index2.default
};

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-formview\" data-bind=\"visible:visible\">\n  <label for=\"\" style=\"display: block\" data-bind=\"style:{width: $parent.labelWidth}\">\n  </label>\n  <div class=\"y-formview-ctn\" data-bind=\"style:{'margin-left': $parent.labelWidth}\">\n    <span class=\"y-formview-label\" data-bind=\"text:label\"></span>\n    <div class=\"y-formview-wrapper\" data-bind=\"style:style\">\n      <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n</div>\n";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(400);

var _index2 = _interopRequireDefault(_index);

var _gridtemplate = __webpack_require__(401);

var _gridtemplate2 = _interopRequireDefault(_gridtemplate);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _head = __webpack_require__(402);

var _head2 = _interopRequireDefault(_head);

var _body = __webpack_require__(404);

var _body2 = _interopRequireDefault(_body);

var _bodybasic = __webpack_require__(409);

var _bodybasic2 = _interopRequireDefault(_bodybasic);

var _mergetd = __webpack_require__(411);

var _mergetd2 = _interopRequireDefault(_mergetd);

var _operation = __webpack_require__(413);

var _operation2 = _interopRequireDefault(_operation);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _base3 = __webpack_require__(92);

var _base4 = _interopRequireDefault(_base3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIX = 'y-';
_knockout2.default.components.register(PREFIX + _head2.default.name, {
  viewModel: _head2.default.init,
  template: _head2.default.template
});
_knockout2.default.components.register(PREFIX + _body2.default.name, {
  viewModel: _body2.default.init,
  template: _body2.default.template
});
_knockout2.default.components.register(PREFIX + _mergetd2.default.name, {
  viewModel: _mergetd2.default.init,
  template: _mergetd2.default.template
});
_knockout2.default.components.register(PREFIX + _operation2.default.name, {
  viewModel: _operation2.default.init,
  template: _operation2.default.template
});
_knockout2.default.components.register(PREFIX + _bodybasic2.default.name, {
  viewModel: _bodybasic2.default.init,
  template: _bodybasic2.default.template
});
if (!document.getElementById('y-template-noType')) {
  var node = document.createElement("DIV");
  node.style.display = 'none';
  node.innerHTML = _gridtemplate2.default;
  document.body.appendChild(node);
}
exports.default = {
  name: 'grid',
  init: _base2.default.createViewModel(_base4.default),
  template: _index2.default
};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "<div style=\"clear:both\">\n  <div class=\"y-grid-wrapper\" data-bind=\"css: {'y-grid-noborder':noborder, 'y-grid-separate': isSeparate, 'y-hasCollapseToolbar': lockright},style:style\">\n    <div class=\"y-grid\" data-bind=\"event:{scroll:handleScroll},css:{'y-grid-stripe':isStripe, 'y-grid-verticalScroll':verticalScroll,'y-grid-border': isTableBorder},style:{height:computedMaxHeight,minHeight:minheight}\">\n      <y-grid-head data-bind=\"visible:!nohead\" params=\"triggerReset:triggerReset,groupSort:groupSort,hasVerticalSroll:hasVerticalSroll, maintable: true, headtransform:headtransform,el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:convertedRows,convertedColumns:convertedColumns,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n      <y-grid-body params=\"fieldid: fieldid,lazy: lazy,transform:vertiacalScrollTransform,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,caculateColumns:caculateColumns,hasChildGrid:hasChildGrid,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,isEnableCrossPage:isEnableCrossPage,crossPageRowPrimaryKey:crossPageRowPrimaryKey,crossPageSelectedRows:crossPageSelectedRows,isShowLoading:isShowLoading,forbitRowSelect:forbitRowSelect,isSeparate:isSeparate,tdstyle: tdstyle, lockhead:lockhead,isNoDataCustomTpl: hasMarkup,defaultExpand:defaultExpand,tableWidth:tableWidth,rowspan:rowspan,domId:domId,expand:expand,maxheight:computedMaxHeight, isDataTable:isDataTable, columns:convertedColumns, rows:rows, onRowSelect:onRowSelect\">\n        <!-- ko template: { nodes: $parent.$templateNodes } --><!-- /ko -->\n      </y-grid-body>\n      <!-- ko if:lockcolumn-->\n      <div class=\"y-grid-fixed\" data-bind=\"style:{width: fixedTableWidth}\">\n        <div class=\"y-grid-fixed-head\">\n          <y-grid-head data-bind=\"visible:!nohead\" params=\"triggerReset:triggerReset, groupSort:groupSort,el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:convertedRows,convertedColumns:convertedColumns,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n        </div>\n        <div class=\"y-grid-fixed-body\" data-bind=\"style:{height: fixBodyHeight}\">\n          <y-grid-body params=\"fieldid: fieldid,lockcolumn:true, lazy: lazy,isLockLeft: true,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,transform:fixColumnTransform,tdstyle: tdstyle, lockhead:true,tableWidth:tableWidth,rowspan:rowspan,domId:domId+'_fix',expand:expand,maxheight:computedMaxHeight, isDataTable:isDataTable, columns:lockleftColumns,forbitRowSelect:forbitRowSelect,rows:rows, onRowSelect:onRowSelect\">\n          </y-grid-body>\n        </div>\n      </div>\n      <!-- /ko -->\n      <!-- ko if:lockright-->\n      <div class=\"y-grid-fixed-right\" style=\"margin-right: 15px\" data-bind=\"style:{width: fixedLockRightTableWidth}, visible: showLockRightToolBar\">\n        <div class=\"y-grid-fixed-head\">\n          <y-grid-head data-bind=\"visible:!nohead\" params=\"triggerReset:triggerReset,groupSort:groupSort,headtransform:fixRightHeadtransform,el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:convertedRows,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n        </div>\n        <div class=\"y-grid-fixed-body\" data-bind=\"style:{height: fixBodyHeight}, visible: !hidefix()\">\n          <y-grid-body params=\"fieldid: fieldid,lockcolumn:true, lazy: lazy,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,caculateColumns:caculateColumns,hasChildGrid:hasChildGrid,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,transform:fixRightTransform,tdstyle: tdstyle, lockhead:true,tableWidth:tableWidth,rowspan:rowspan,domId:domId+'_fixRight',expand:expand,maxheight:computedMaxHeight, isDataTable:isDataTable, columns:convertedColumns,forbitRowSelect:forbitRowSelect,rows:rows, onRowSelect:onRowSelect\">\n          </y-grid-body>\n        </div>\n      </div>\n      <div class=\"y-lock-toolbar\" title=\"收起/展开\" data-bind=\"style: {height:computedMaxHeight},click:handleToogleLockright\">\n        <div class=\"y-lock-toolbar-i\">\n          <i class=\"fa fa-angle-left\"></i>\n          <i class=\"fa fa-angle-right\"></i>\n        </div>\n      </div>\n      <div class=\"y-fixtopright-space\"></div>\n      <!-- /ko -->\n      <!-- ko if: verticalScroll -->\n      <div class=\"y-vertical-scroll\" data-bind=\"event:{scroll:handleScroll},style:scrollStyle\" >\n        <div data-bind=\"style:{width: tableWidth}\" style=\"height: 1px\"></div>\n      </div>\n      <!-- /ko -->\n    </div>\n  </div>\n  <!-- ko if: pagination -->\n  <y-pagination data-bind=\"visible: isShowPagination\" params=\"\n    pageSizeList: pageSizeList,\n    onSizeChange: onSizeChange,\n    onPageChage: onPageChange,\n    pageSize: pageSize,\n    totalCount: totalCount,\n    startIndex: startIndex,\n    pageIndex: pageIndex\"></y-pagination>\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "<!-- td 模板 -->\n<script type=\"text/html\" id=\"y-template-text\">\n  <div class=\"y-cell\" data-bind=\"style: col.computedStyle && col.computedStyle(row),text: formatText(row, col),css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n  </div>\n</script>\n<script type=\"text/html\" id=\"y-template-rendertext\">\n  <div class=\"y-cell\" data-bind=\"style: col.computedStyle && col.computedStyle(row),text: col.renderFn(row, rowIndex, col),css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n  </div>\n</script>\n<script type=\"text/html\" id=\"y-template-noType\">\n  <div class=\"y-cell\" data-bind=\"style: col.computedStyle && col.computedStyle(row),text: defaultFormatText(row, col),css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n  </div>\n</script>\n<script type=\"text/html\" id=\"y-template-index\">\n  <div class=\"y-cell\" data-bind=\"text: rowIndex + 1\">\n  </div>\n</script>\n<script type=\"text/html\" id=\"y-template-checkbox\">\n  <div class=\"y-cell y-cell-checkbox\">\n    <!-- ko if: !forbitRowSelectFn(row) -->\n    <y-checkbox-item class=\"y-grid-checkbox\" params=\"value:row._selected(),label:'',checked:row._selected\"></y-checkbox-item>\n    <!-- /ko -->\n  </div>\n</script>\n<script type=\"text/html\" id=\"y-template-render\">\n  <div class=\"y-cell\" data-bind=\"css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'},\n  html: col.renderFn(row, rowIndex, col, gridRef),style:col.style\">\n  </div>\n</script>\n<script type=\"text/html\" id=\"y-template-component\">\n  <div class=\"y-cell y-cell-overflow-auto\" data-bind=\"css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'},\n  component: col.compFn(row, rowIndex, col, gridRef),style:col.style\">\n  </div>\n</script>\n<script type=\"text/html\" id=\"y-template-operation\">\n  <y-grid-operation params=\"operationList: col.operationList, row: row, col: col, rowIndex: rowIndex\"></y-grid-operation>\n</script>\n<!-- td 模板 -->\n<!-- tr 模板 -->\n<script type=\"text/html\" id=\"y-template-summaryRow\">\n  <tr>\n    <td style=\"border: none\" data-bind=\"attr:{colspan: expandColspan()}\">\n      <!-- ko if: columns()[0].summaryType === 'render' -->\n      <div class=\"y-cell y-cell-summary\" data-bind=\"html: columns()[0].summaryFn(row)\">\n      </div>\n      <!-- /ko -->\n      <!-- ko if: columns()[0].summaryType === 'comp' || columns()[0].summaryType === 'component'-->\n      <div class=\"y-cell y-cell-summary\" data-bind=\"component: columns()[0].summaryFn(row)\">\n      </div>\n      <!-- /ko -->\n    </td>\n  </tr>\n</script>\n<script type=\"text/html\" id=\"y-template-tr\">\n  <tr data-bind=\"style: {\n          height: getRowHeight(rowIndex),\n        },\n        attr:{'aria-rowindex': rowIndex},\n        css:{\n          'y-grid-row-hover':row._hover,\n          'y-grid-row-selected':row._selected,\n          'y-grid-lastrow': rows().length >= 3 && rowIndex == rows().length - 1,\n          'y-grid-rowstatus-del': row._rowStatus() == 'del'\n        },event:{\n          click: function (vm, event) { return handleClick(row, event, rowIndex)},\n          mouseenter: function (vm, event) { return handleMouseIn(row, event, rowIndex)},\n          mouseleave: function (vm, event) { return handleMouseOut(row, event, rowIndex)}}\">\n      <!-- ko foreach:{data: columns, as: 'col'} -->\n        <!-- ko if: col._needRender() && (col._show === true || col._show()) -->\n        <td data-bind=\"\n          attr:{'aria-colindex': $index, fieldid: $parent.getFieldId(col, $parent.rowIndex, $index())},\n          visible: col._show,\n          style: col.tdstyle || $parent.tdstyle,\n          css:{'y-relative': col.type == 'operation', 'hidden': col.hideTd},\n          template: {\n            name: $parent.displayMode,\n            data: {\n              forbitRowSelectFn: $parent.forbitRowSelectFn,\n              col: col,\n              rowIndex: $parent.rowIndex,\n              gridRef: $parent.gridRef,\n              colIndex: $index(),\n              defaultFormatText:$parent.defaultFormatText,\n              formatText: $parent.formatText\n            },\n            afterRender: $parent.afterTdRender\n          }\">\n        </td>\n        <!-- /ko -->\n        <!-- ko ifnot: col._needRender() && (col._show === true || col._show()) -->\n        <td data-bind=\"visible: col._show, css:{'hide-by-col': ko.computed(function () {\n          // 存在hidetd列\n          if (typeof col._show === 'function') {\n            return !col._show()\n          }\n          return false\n        })}\">\n        </td>\n        <!-- /ko -->\n      <!-- /ko -->\n  </tr>\n</script>\n<!-- tr 模板 -->\n";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(403);

var _head2 = _interopRequireDefault(_head);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _eventlistener = __webpack_require__(150);

var _eventlistener2 = _interopRequireDefault(_eventlistener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _init(params, componentInfo) {
  var _this = this;

  this.setCellWidth = function () {
    return '200';
  };
  this.columns = params.columns;
  var _columns = params.convertedColumns;
  this.convertedColumns = _knockout2.default.observableArray(_columns());
  this.triggerReset = params.triggerReset;
  this.columns1 = params.columns1 || _knockout2.default.observableArray([]);
  // 用于多行的rowspan
  this.columns2 = params.columns2 || _knockout2.default.observableArray([]);
  this.tableWidth = params.tableWidth;
  this.hasVerticalSroll = params.hasVerticalSroll || _knockout2.default.observable(false);
  this.compoutedTableWidth = _knockout2.default.computed(function () {
    if (!_this.tableWidth) {
      return '';
    }
    var width = _this.tableWidth();
    var hasScroll = _this.hasVerticalSroll();
    if (width === '100%' && hasScroll) {
      return 'calc(100% - 15px)';
    } else {
      return width;
    }
  });
  this.el = params.el;
  this.outterWidth = _knockout2.default.observable();
  this.headHeight = null;
  if (_knockout2.default.unwrap(params.lockcolumn)) {
    if (!params.maintable) {
      this.headHeight = params.headHeight;
    }
  } else {
    this.headHeight = params.headHeight;
  }
  var nowOuterWidth = 0;
  var nowHeaderHeight = 0;
  var loopCount = 0;
  var _interval = null;
  var recaculateHeader = function recaculateHeader() {
    _interval = setInterval(function () {
      window.requestAnimationFrame(function () {
        if (params.el) {
          if (loopCount > 10) {
            _interval && clearInterval(_interval);
            loopCount = 0;
          } else {
            loopCount++;
          }
          var width = params.el.firstElementChild.offsetWidth;
          var height = componentInfo.element.firstElementChild.offsetHeight;
          // 对于多级表头+lockhead/lockcolumn的情况，body的margin-top需要动态计算
          if (nowHeaderHeight !== height) {
            if (_this.headHeight) {
              nowHeaderHeight = height;
              _this.headHeight(height + 'px');
            }
          }
          // 对于在modal中的grid需要特殊处理
          if (nowOuterWidth !== width) {
            _this.triggerReset && _this.triggerReset(!_this.triggerReset());
            nowOuterWidth = width;
            if (width > 0) {
              _this.outterWidth(width - 1 + 'px');
            } else {
              _this.outterWidth('100%');
            }
          }
        }
      });
    }, 500);
  };
  if (params.lockhead) {
    recaculateHeader();
  }
  typeof params.convertedColumns === 'function' && params.convertedColumns.subscribe(function (cols) {
    _this.convertedColumns(cols);
    _this.convertedColumns.splice(0, 0);
    if (cols && cols.length > 0) {
      recaculateHeader();
    }
  });
  this.allRowChecked = params.allRowChecked;
  this.lockhead = params.lockhead;
  this.headtransform = params.headtransform;
  if (params.groupSort) {
    if (params.groupSort()) {
      this.holdKeyInstance = _eventlistener2.default.addKeyHoldListener();
    } else {
      params.groupSort.subscribe(function (val) {
        if (val) {
          _this.holdKeyInstance = _eventlistener2.default.addKeyHoldListener();
        } else {
          _this.holdKeyInstance = null;
        }
      });
    }
  }
  this.onHeadKeyDown = function (e) {
    debugger;
  };
  // 排序算法回调
  this.handleSort = function (vm, event) {
    if (vm.sort) {
      var node = event.currentTarget;
      var holdKey = _this.holdKeyInstance && _this.holdKeyInstance.get();
      // 如果启用了组合
      if (holdKey && holdKey.length > 0) {
        _this.groupSortField = _this.holdKeyInstance.getGroupSortField();
        // ctrl(windows) 或 commnad(mac)
        if (_this.holdKeyInstance.isHoldKeyCode(17) || _this.holdKeyInstance.isHoldKeyCode(91)) {
          var existIndex = _this.groupSortField.indexOf(vm.field);
          // 如果已经选过了 再选那么要重新排序
          if (existIndex < 0) {
            _this.holdKeyInstance.addGroupSortField(vm.field);
            _this.holdKeyInstance.addSortType('asc');
          } else {
            if (node.classList.contains('y-sort-asc')) {
              _this.holdKeyInstance.setSortTypeByIndex(existIndex, 'desc');
            } else {
              _this.holdKeyInstance.setSortTypeByIndex(existIndex, 'asc');
            }
          }
          _this.el.querySelectorAll('.y-cell-sortable').forEach(function (element) {
            var index = _this.groupSortField.indexOf(element.attributes['data-key'].value);
            if (index >= 0) {
              element.querySelector('.sort-index').innerText = index + 1;
            } else {
              element.querySelector('.sort-index').innerText = '';
            }
            if (node !== element && index < 0) {
              element.classList.remove('y-sort-asc');
              element.classList.remove('y-sort-desc');
            }
          });
        }
        _this.sortType = _this.holdKeyInstance.getSortType();
      } else {
        if (_this.holdKeyInstance) {
          _this.holdKeyInstance.setGroupSortField([]);
          _this.holdKeyInstance.setSortType([]);
        }
        // 同一个表格排序以前需要把其他排序列的标识先清空
        _this.el.querySelectorAll('.y-cell-sortable').forEach(function (element) {
          element.querySelector('.sort-index').innerText = '';
          if (node !== element) {
            element.classList.remove('y-sort-asc');
            element.classList.remove('y-sort-desc');
          }
        });
      }
      if (_this.holdKeyInstance) {
        _this.sortType = _this.holdKeyInstance.getSortType();
        _this.groupSortField = _this.holdKeyInstance.getGroupSortField();
      }
      // 设置当前列的升序,降序
      if (node.classList.contains('y-sort-asc')) {
        node.classList.add('y-sort-desc');
        node.classList.remove('y-sort-asc');
        vm.sortFn && vm.sortFn('desc', _this.groupSortField, _this.sortType);
      } else {
        node.classList.add('y-sort-asc');
        node.classList.remove('y-sort-desc');
        vm.sortFn && vm.sortFn('asc', _this.groupSortField, _this.sortType);
      }
    }
  };
}
var init = {
  createViewModel: function createViewModel(params, componentInfo) {
    return new _init(params, componentInfo);
  }
};
exports.default = {
  name: 'grid-head',
  init: init,
  template: _head2.default
};

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-grid-head\"\n  data-bind=\"event: {keydown:onHeadKeyDown},css:{'y-grid-head-lock':lockhead},let:{allRowChecked:allRowChecked},style:{width:outterWidth}\">\n  <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" data-bind=\"style:{width:compoutedTableWidth,transform:headtransform}\">\n    <colgroup data-bind=\"foreach:{data: convertedColumns,as: 'col'}\">\n      <col data-bind=\"visible: col._show, attr:{width: col.width}\">\n    </colgroup>\n    <thead>\n      <!-- ko if: columns1().length == 0 -->\n        <!-- ko foreach: {data: columns, as: 'cols'}-->\n        <tr data-bind=\"foreach:{data: cols,as: 'col'}\">\n          <th data-bind=\"style:col.headerStyle, attr:{'data-key': col.field || '', rowspan:col.rowspan || 1,colspan:col.colspan || 1}, click: $parentContext.$parent.handleSort, visible: col._show,css:{'y-cell-sortable': col.sort}\">\n            <!-- ko if: col.type == 'checkbox' -->\n            <div class=\"y-cell y-cell-checkbox\" style=\"position: relative;top: 2px;\">\n              <y-checkbox-item class=\"y-grid-checkbox\" params=\"value:'',label:'',checked:allRowChecked\"></y-checkbox-item>\n            </div>\n            <!-- /ko -->\n            <!-- ko ifnot: col.type == 'checkbox' -->\n            <!-- ko if: typeof col.title == 'function'-->\n            <div class=\"y-cell\"\n              data-bind=\"css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n              <!-- ko if: col.titleType == 'component'-->\n              <span data-bind=\"component: col.title(col)\"></span>\n              <!-- /ko -->\n              <!-- ko ifnot: col.titleType == 'component'-->\n              <span data-bind=\"html: col.title()\"></span>\n              <!-- /ko -->\n\n              <!-- ko if:col.sort -->\n              <i class=\"fa fa-sort-asc\"></i>\n              <i class=\"fa fa-sort-desc\" style=\"position:relative;left: -11px;\"></i>\n              <span class=\"sort-index\"></span>\n              <!-- /ko -->\n            </div>\n\n            <!-- /ko -->\n            <!-- ko ifnot: typeof col.title == 'function' -->\n            <div class=\"y-cell\"\n              data-bind=\"css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n              <span data-bind=\"html:col.title\"></span>\n              <!-- ko if:col.sort -->\n              <i class=\"fa fa-sort-asc\"></i>\n              <i class=\"fa fa-sort-desc\" style=\"position:relative;left: -11px;\"></i>\n              <span class=\"sort-index\"></span>\n              <!-- /ko -->\n            </div>\n            <!-- /ko -->\n            <!-- /ko -->\n          </th>\n        </tr>\n        <!-- /ko -->\n      <!-- /ko -->\n      <!-- ko if: columns1().length > 0 -->\n      <tr data-bind=\"foreach:{data:columns1, as: 'col'}\">\n        <th data-bind=\"attr:{rowspan:col.rowspan || 1,colspan:col.colspan || 1}\">\n          <!-- ko if: typeof col.title == 'function'-->\n          <div class=\"y-cell\"\n            data-bind=\"html:col.title(),css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n          </div>\n          <!-- /ko -->\n          <!-- ko ifnot: typeof col.title == 'function' -->\n          <div class=\"y-cell\"\n            data-bind=\"html:col.title,css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n          </div>\n          <!-- /ko -->\n        </th>\n      </tr>\n      <!-- /ko -->\n      <!-- ko if: columns2().length > 0 -->\n      <tr data-bind=\"foreach:{data:columns2, as: 'col'}\">\n        <th>\n          <!-- ko if: typeof col.title == 'function'-->\n          <div class=\"y-cell\"\n            data-bind=\"html:col.title(),css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n          </div>\n          <!-- /ko -->\n          <!-- ko ifnot: typeof col.title == 'function' -->\n          <div class=\"y-cell\"\n            data-bind=\"html:col.title,css:{'text-left':col.align == 'left','text-right':col.align == 'right','text-center':col.align == 'center'}\">\n          </div>\n          <!-- /ko -->\n        </th>\n      </tr>\n      <!-- /ko -->\n    </thead>\n  </table>\n</div>\n";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _body = __webpack_require__(405);

var _body2 = _interopRequireDefault(_body);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _bodybase = __webpack_require__(151);

var _bodybase2 = _interopRequireDefault(_bodybase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'grid-body',
  init: _base2.default.createViewModel(_bodybase2.default),
  template: _body2.default
};

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-grid-body\" data-bind=\"style:gridBodyStyle,css:{'y-grid-body-lock':lockhead, 'y-grid-summary':hasSummaryRow}\">\n  <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" data-bind=\"attr:{id:domId},style:{width:tableWidth,transform:transform},css:{'y-table-separate':isSeparate}\">\n    <colgroup data-bind=\"foreach:{data: columns,as: 'col'}\">\n      <col data-bind=\"visible: col._show, attr:{width: col.width}\">\n    </colgroup>\n    <tbody data-bind=\"foreach: {data: rows, as: 'row'}, css:{'y-grid-body-verticaltop':verticalAlign === 'top'}\">\n      <!-- ko ifnot: row._delete -->\n      <!-- ko if: $parent.hasSummaryRow-->\n      <!-- ko template: {name:'y-template-summaryRow',\n            data:{\n              columns: $parent.columns,\n              expandColspan: $parent.expandColspan\n            },\n            afterRender: $parent.summaryAfterRender}\n          -->\n      <!-- /ko -->\n      <!-- /ko -->\n      <!-- ko ifnot: $parent.hasChildGrid -->\n      <!-- ko template: {\n            if: ko.pureComputed(function () {\n              return !$parent.lazy || ($parent.lazy && $index() >= $parent.lazy.lazyStart() && $index() <= $parent.lazy.lazyEnd())\n            }),\n            name:'y-template-tr',\n            data:{\n              columns: $parent.columns,\n              displayMode:$parent.displayMode,\n              afterRender: $parent.afterRender,\n              afterTdRender: function () {},\n              forbitRowSelectFn: $parent.forbitRowSelectFn,\n              defaultFormatText: $parent.defaultFormatText,\n              formatText: $parent.formatText,\n              rowIndex: $index(),\n              gridRef: $parent.gridRef,\n              row: row,\n              rows: $parent.rows,\n              getRowHeight: $parent.getRowHeight,\n              handleClick: $parent.handleClick,\n              handleMouseIn: $parent.handleMouseIn,\n              handleMouseOut: $parent.handleMouseOut,\n              getFieldId: $parent.getFieldId\n            },\n            afterRender: $parent.afterRender}\n          -->\n      <!-- /ko -->\n      <!-- /ko -->\n      <!-- ko if: row._expand && row._expand() && $parent.columns()[0].expandCompFn -->\n      <tr>\n        <td style=\"border-bottom: none\" data-bind=\"attr:{colspan: $parent.expandColspan()}\">\n          <div data-bind=\"component: $parent.columns()[0].expandCompFn(row)\">\n          </div>\n        </td>\n      </tr>\n      <!-- /ko -->\n      <!-- ko if: $parent.hasChildGrid -->\n      <tr>\n        <td style=\"border-bottom: none\" data-bind=\"attr:{colspan: $parent.expandColspan()}\">\n          <div data-bind=\"component: $parent.columns()[0].childGridFn(row)\">\n          </div>\n        </td>\n      </tr>\n      <!-- /ko -->\n      <!-- /ko -->\n      <!-- ko if: $parent.caculateColumns && $index() ==  $parent.rows().length - 1-->\n      <tr>\n        <!-- ko foreach:{data: $parent.caculateColumns, as: 'col'} -->\n        <td data-bind=\"\n            visible: col._show,\n            style: col.tdstyle || $parentContext.$parent.tdstyle,\n            css:{'y-relative': col.type == 'operation'},\n            template: {\n              name: $parentContext.$parent.displayMode,\n              data: {\n                forbitRowSelectFn: $parentContext.$parent.forbitRowSelectFn,\n                col: col,\n                gridRef: $parent.gridRef,\n                rowIndex: $parentContext.$index(),\n                colIndex:$index(),\n                defaultFormatText:$parentContext.$parent.defaultFormatText}}\">\n        </td>\n        <!-- /ko -->\n      </tr>\n      <!-- /ko -->\n    </tbody>\n    <tbody class=\"y-grid-empty\">\n      <tr>\n        <td data-bind=\"attr:{colspan: nodataColSpan},style:{height: noDataHeight, padding: '12px'}\">\n          <!-- ko ifnot: isShowLoading -->\n          <!-- ko if: isNoDataCustomTpl -->\n          <!-- ko template: { nodes: $componentTemplateNodes } -->\n          <!-- /ko -->\n          <!-- /ko -->\n          <!-- ko ifnot: isNoDataCustomTpl -->\n          <div data-bind=\"if:!lockcolumn()\">\n            <div data-bind=\"{style:{left: 'calc(50% - 31px)',position: 'relative',height:'62px',width:'62px',backgroundImage:nodatapng, backgroundSize: '100%',backgroundRepeat: 'no-repeat'}}\" alt=\"\"></div>\n            <p data-bind=\"text: i18nNoData\" style=\"color:#c9c9c9;margin-top: 6px;\">暂无数据</p>\n          </div>\n          <!-- /ko -->\n          <!-- /ko -->\n        </td>\n      </tr>\n    </tbody>\n  </table>\n  <div class=\"y-loading-letter-ctn\" data-bind=\"visible:isShowLoading\">\n    <span class=\"l-1 y-loading-letter\">L</span>\n    <span class=\"l-2 y-loading-letter\">o</span>\n    <span class=\"l-3 y-loading-letter\">a</span>\n    <span class=\"l-4 y-loading-letter\">d</span>\n    <span class=\"l-5 y-loading-letter\">i</span>\n    <span class=\"l-6 y-loading-letter\">n</span>\n    <span class=\"l-7 y-loading-letter\">g</span>\n    <span class=\"l-8 y-loading-letter\">.</span>\n    <span class=\"l-9 y-loading-letter\">.</span>\n    <span class=\"l-10 y-loading-letter\">.</span>\n  </div>\n</div>\n";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gridRef = __webpack_require__(407);

var _gridRef2 = _interopRequireDefault(_gridRef);

var _gridutil = __webpack_require__(43);

var _gridutil2 = _interopRequireDefault(_gridutil);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Airamixin = function Airamixin(params) {
  var _this = this;

  this.focusedRow = _knockout2.default.observable(0);
  this.focusedCol = _knockout2.default.observable(0);
  this.gridRef = new _gridRef2.default();
  this.isValidCell = function (row, col) {
    return !isNaN(row) && !isNaN(col) && row >= 0 && col >= 0 && _this.rows && _this.rows.peek().length && row < _this.rows.peek().length && col < _knockout2.default.utils.unwrapObservable(_this.columns).length;
  };
  // 获取下一个单元格
  this.getNextCell = function (curRow, curCol, directionX, directionY) {
    var row = curRow + directionY;
    var col = curCol + directionX;
    var rowCount = _this.rows().length;
    var isLeftRight = directionX !== 0;

    if (!rowCount) {
      return false;
    }

    var colCount = _this.columns().length;

    if (isLeftRight) {
      if (col < 0) {
        col = colCount - 1;
        row--;
      }

      if (col >= colCount) {
        col = 0;
        row++;
      }
    }

    if (!isLeftRight) {
      if (row < 0) {
        col--;
        row = rowCount - 1;
        if (col >= 0 && !_this.gridRef.get(row, col)) {
          // Sometimes the bottom row is not completely filled in. In this case,
          // jump to the next filled in cell.
          row--;
        }
      } else if (row >= rowCount || !_this.gridRef.get(row, col)) {
        row = 0;
        col++;
      }
    }
    if (_this.isValidCell(row, col)) {
      return {
        row: row,
        col: col
      };
    } else if (_this.isValidCell(curRow, curCol)) {
      return {
        row: curRow,
        col: curCol
      };
    } else {
      return false;
    }
  };
  this.isEditable = function (col) {
    var column = _knockout2.default.utils.unwrapObservable(_this.columns)[col];
    if (column && column.aria) {
      return !!column.aria;
    } else {
      return false;
    }
  };
  // 获取下一个可编辑的单元格
  this.getNextEditableCell = function (directionX, directionY) {
    var nextCell = this.getNextCell(this.focusedRow(), this.focusedCol(), directionX, directionY);
    while (!this.isEditable(nextCell.col)) {
      var currRow = nextCell.row;
      var currCol = nextCell.col;

      nextCell = this.getNextCell(currRow, currCol, directionX, directionY);

      if (currRow === nextCell.row && currCol === nextCell.col) {
        // There are no more cells to try if getNextCell returns the current cell
        return false;
      }
    }
    return nextCell;
  };
  this.setFocus = function (row, col) {
    var lastInstance = _this.gridRef.get(_this.focusedRow(), _this.focusedCol());
    if (lastInstance && lastInstance.setUnFoucs) {
      lastInstance.setUnFoucs();
    }
    _this.focusedRow(row);
    _this.focusedCol(col);
    var instance = _this.gridRef.get(row, col);
    if (instance) {
      if (instance.setFocus) {
        instance.setFocus();
      } else {
        console.warn('td component should implements the "setFoucs" function');
      }
    }
  };
  this.onBodyClick = function (vm, evt) {
    if (_this.aria) {
      var elTd = _gridutil2.default.findClosest(evt.target, '[aria-colindex]');
      var elRow = elTd.parentNode;
      var focusIndex = {
        col: +elTd.attributes['aria-colindex'].value,
        row: +elRow.attributes['aria-rowindex'].value
      };
      _this.focusedRow(focusIndex.row);
      _this.focusedCol(focusIndex.col);
    }
    return true;
  };

  this.onBodyKeyDown = function (vm, event) {
    if (_this.aria) {
      var key = event.which || event.keyCode;
      var rowCaret = _this.focusedRow();
      var colCaret = _this.focusedCol();
      var nextCell;

      switch (key) {
        case _gridutil2.default.Aria.KeyCode.UP:
          nextCell = _this.getNextEditableCell(0, -1);
          rowCaret = nextCell.row;
          colCaret = nextCell.col;
          _this.setFocus(rowCaret, colCaret);
          break;
        case _gridutil2.default.Aria.KeyCode.DOWN:
          nextCell = _this.getNextEditableCell(0, 1);
          rowCaret = nextCell.row;
          colCaret = nextCell.col;
          _this.setFocus(rowCaret, colCaret);
          break;
        case _gridutil2.default.Aria.KeyCode.LEFT:
          nextCell = _this.getNextEditableCell(-1, 0);
          rowCaret = nextCell.row;
          colCaret = nextCell.col;
          _this.setFocus(rowCaret, colCaret);
          break;
        case _gridutil2.default.Aria.KeyCode.RIGHT:
          nextCell = _this.getNextEditableCell(1, 0);
          rowCaret = nextCell.row;
          colCaret = nextCell.col;
          _this.setFocus(rowCaret, colCaret);
          break;
        case _gridutil2.default.Aria.KeyCode.HOME:
          if (event.ctrlKey) {
            rowCaret = 0;
          }
          colCaret = 0;
          _this.setFocus(rowCaret, colCaret);
          break;
        case _gridutil2.default.Aria.KeyCode.END:
          if (event.ctrlKey) {
            rowCaret = _this.rows().length - 1;
          }
          colCaret = _knockout2.default.utils.unwrapObservable(_this.columns).length - 1;
          _this.setFocus(rowCaret, colCaret);
          break;
        case _gridutil2.default.Aria.KeyCode.TAB:
          nextCell = _this.getNextEditableCell(1, 0);
          rowCaret = nextCell.row;
          colCaret = nextCell.col;
          _this.setFocus(rowCaret, colCaret);
          return false;
        default:
      }
    }
    return true;
  };
};
exports.default = Airamixin;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GridRef = function GridRef() {
  this.instance = {};
};
GridRef.prototype.set = function (item, row, col) {
  if (!this.instance[row]) {
    this.instance[row] = {};
  }
  this.instance[row][col] = item;
};
GridRef.prototype.get = function (row, col) {
  if (this.instance[row] && this.instance[row][col]) {
    return this.instance[row][col];
  } else {
    return null;
  }
};
exports.default = GridRef;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bodybasic = __webpack_require__(410);

var _bodybasic2 = _interopRequireDefault(_bodybasic);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _bodybase = __webpack_require__(151);

var _bodybase2 = _interopRequireDefault(_bodybase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'grid-body-basic',
  init: _base2.default.createViewModel(_bodybase2.default),
  template: _bodybasic2.default
};

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-grid-body\" data-bind=\"click: onBodyClick, event:{keydown : onBodyKeyDown, scroll: handleBodyScroll}, style:gridBodyStyle,css:{'y-grid-body-lock':lockhead, 'y-grid-summary':hasSummaryRow}\">\n  <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" data-bind=\"attr:{id:domId},style:{width:tableWidth,transform:transform},css:{'y-table-separate':isSeparate}\">\n    <colgroup data-bind=\"foreach:{data: columns,as: 'col'}\">\n      <col data-bind=\"visible: col._show, attr:{width: col.width}\">\n    </colgroup>\n    <tbody data-bind=\"css:{'y-grid-body-verticaltop':verticalAlign === 'top'}\">\n      <!-- ko if: lazy -->\n      <tr class=\"stopCaculate\" style=\"height: 0\" data-bind=\"style:{height: getUpHeight}\"></tr>\n      <!-- /ko -->\n      <!-- ko foreach: {data: rows, as: 'row'} -->\n      <!-- ko ifnot: row._delete -->\n      <!-- ko if: $parent.isTrShow(row, $index(), $parent.lazy)-->\n      <!-- ko template: {\n            name:'y-template-tr',\n            data:{\n              columns: $parent.columns,\n              displayMode:$parent.displayMode,\n              afterRender: $parent.afterTrRender,\n              afterTdRender: $parent.afterTdRender,\n              forbitRowSelectFn: $parent.forbitRowSelectFn,\n              defaultFormatText: $parent.defaultFormatText,\n              formatText: $parent.formatText,\n              gridRef: $parent.gridRef,\n              rowIndex: $index(),\n              row: row,\n              rows: $parent.rows,\n              getRowHeight: $parent.getRowHeight,\n              handleClick: $parent.handleClick,\n              handleMouseIn: $parent.handleMouseIn,\n              handleMouseOut: $parent.handleMouseOut,\n              getFieldId: $parent.getFieldId\n            }\n          }\n          -->\n      <!-- /ko -->\n      <!-- /ko -->\n      <!-- /ko -->\n      <!-- /ko -->\n      <!-- ko if: lazy -->\n      <tr class=\"stopCaculate\" style=\"height: 0\" data-bind=\"style:{height: getDownHeight}\"></tr>\n      <!-- /ko -->\n    </tbody>\n    <tbody class=\"y-grid-empty\" data-bind=\"visible:isEmtpyData, style:{'display':isEmtpyData() ? 'table-row-group': 'none'}\">\n      <tr>\n        <td data-bind=\"attr:{colspan: nodataColSpan},style:{border: 'none',height: noDataHeight, padding: '12px'}\">\n          <div data-bind=\"if:!lockcolumn()\">\n            <div data-bind=\"{style:{left: 'calc(50% - 31px)',position: 'relative',height:'48px',width:'62px',backgroundImage:nodatapng, backgroundSize: '100%',backgroundRepeat: 'no-repeat'}}\" alt=\"\"></div>\n            <p data-bind=\"text: i18nNoData\" style=\"text-align: center;color:#c9c9c9;margin-top: 6px;\">暂无数据</p>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n  <div class=\"y-loading-letter-ctn\" data-bind=\"visible:isShowLoading\">\n    <span class=\"l-1 y-loading-letter\">L</span>\n    <span class=\"l-2 y-loading-letter\">o</span>\n    <span class=\"l-3 y-loading-letter\">a</span>\n    <span class=\"l-4 y-loading-letter\">d</span>\n    <span class=\"l-5 y-loading-letter\">i</span>\n    <span class=\"l-6 y-loading-letter\">n</span>\n    <span class=\"l-7 y-loading-letter\">g</span>\n    <span class=\"l-8 y-loading-letter\">.</span>\n    <span class=\"l-9 y-loading-letter\">.</span>\n    <span class=\"l-10 y-loading-letter\">.</span>\n  </div>\n</div>\n";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mergetd = __webpack_require__(412);

var _mergetd2 = _interopRequireDefault(_mergetd);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _gridutil = __webpack_require__(43);

var _gridutil2 = _interopRequireDefault(_gridutil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var Mergetd = function (_Base) {
  _inherits(Mergetd, _Base);

  function Mergetd() {
    _classCallCheck(this, Mergetd);

    return _possibleConstructorReturn(this, (Mergetd.__proto__ || (0, _getPrototypeOf2.default)(Mergetd)).apply(this, arguments));
  }

  _createClass(Mergetd, [{
    key: 'initialize',
    value: function initialize(params) {
      /*
      * like this [col,col,col]
      * */
      this.dataList = params.dataList;
      this.row = params.row;
      this.defaultFormatText = _gridutil2.default.defaultFormatText;
      this.formatText = _gridutil2.default.formatText;
    }
  }]);

  return Mergetd;
}(_base2.default);

exports.default = {
  name: 'grid-merge-td',
  init: _base2.default.createViewModel(Mergetd),
  template: _mergetd2.default
};

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "<div data-bind=\"foreach: {data: dataList, as: 'col'}\">\n  <!-- ko if: col.type -->\n  <!-- ko if: col.type == 'render' -->\n  <div class=\"text-left\" data-bind=\"html: col.renderFn(row),style:col.style\">\n  </div>\n  <!-- /ko -->\n  <!-- ko if: col.type == 'component' -->\n  <div class=\"text-left\" data-bind=\"component: col.compFn(row),style:col.style\">\n  </div>\n  <!-- /ko -->\n  <!-- /ko -->\n  <!-- ko ifnot: col.type -->\n  <div class=\"text-left\" data-bind=\"text: $parent.defaultFormatText(row, col)\"></div>\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _operation = __webpack_require__(414);

var _operation2 = _interopRequireDefault(_operation);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _stringHash = __webpack_require__(42);

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDIDAFFIX = '_link';

var OperationList = function (_Base) {
  _inherits(OperationList, _Base);

  function OperationList() {
    _classCallCheck(this, OperationList);

    return _possibleConstructorReturn(this, (OperationList.__proto__ || (0, _getPrototypeOf2.default)(OperationList)).apply(this, arguments));
  }

  _createClass(OperationList, [{
    key: 'initialize',
    value: function initialize(_ref) {
      var _this2 = this;

      var row = _ref.row,
          col = _ref.col,
          operationList = _ref.operationList,
          rowIndex = _ref.rowIndex;

      this.row = row;
      this.rowIndex = rowIndex;
      this.col = col;
      this.dropWidth = col.dropWidth || 84;
      this.i18nMore = (0, _i18n2.default)('更多');
      this.orginOperationList = _knockout2.default.observableArray(operationList);
      this.operationList = _knockout2.default.computed(function () {
        var list = [];
        _this2.orginOperationList().forEach(function (operate) {
          // 如果不设置visible则默认都显示
          if (!operate.visible) {
            list.push(operate);
          }
          // 如果设置visible 且visible方法返回true
          if (operate.visible && operate.visible(_this2.row)) {
            list.push(operate);
          }
        });
        return list;
      });
      // 当数量大于3时，前两个操作
      this.quickList = _knockout2.default.computed(function () {
        if (_this2.operationList().length > 3) {
          return _this2.operationList().slice(0, 2);
        } else {
          return [];
        }
      });
      // 更多操作
      this.moreList = _knockout2.default.computed(function () {
        if (_this2.operationList().length > 3) {
          return _this2.operationList().slice(2, _this2.operationList().length);
        } else {
          return [];
        }
      });
      // 鼠标放在more按钮上
      this.isOnMore = _knockout2.default.observable(false);
      // 鼠标放在更多列表上
      this.isOnPanel = _knockout2.default.observable(false);
      this.showDropdown = _knockout2.default.computed(function () {
        return _this2.isOnMore() || _this2.isOnPanel();
      });
      this.moreEl = this.$el.querySelector('.y-grid-operation-morectn');
    }
  }, {
    key: 'methods',
    value: function methods(_ref2) {
      var _this3 = this;

      var row = _ref2.row;

      this.getFieldId = function (item) {
        var title = item.title;
        if (typeof title === 'function') {
          title = title(row);
        }
        return 'op_' + (0, _stringHash2.default)(title) + '_' + this.rowIndex + FIELDIDAFFIX;
      };
      this.enableMore = function () {
        _this3.isOnMore(true);
      };
      this.disableMore = function () {
        setTimeout(function () {
          _this3.isOnMore(false);
        }, 200);
      };
      this.enableMorePanel = function () {
        _this3.isOnPanel(true);
      };
      this.disableMorePanel = function () {
        setTimeout(function () {
          _this3.isOnPanel(false);
        }, 200);
      };
      // 让title支持函数
      this.formatTitle = function (title) {
        if (typeof title === 'function') {
          return title(row);
        } else {
          return title;
        }
      };
      this.operClick = function (item, evt) {
        item.click(row, evt);
        var index = _this3.orginOperationList.indexOf(item);
        // 为了重新出发visible
        _this3.orginOperationList.splice(index, 1, item);
      };
      this.visible = function (item) {
        if (item.visible) {
          return item.visible(row);
        } else {
          return true;
        }
      };
    }
  }]);

  return OperationList;
}(_base2.default);

exports.default = {
  name: 'grid-operation',
  init: _base2.default.createViewModel(OperationList),
  template: _operation2.default
};

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "<!-- ko if: operationList().length < 4 -->\n<div class=\"y-cell\" data-bind=\"foreach:{data:operationList, as: 'item'}\">\n  <!-- ko if: item.type == 'popdialog' -->\n  <y-popdialog\n    params=\"action: item.action,hideOperation: item.hideOperation, rowData: $parent.row, onOk:function (vm, evt) {$parent.operClick(item, evt)},css: 'y-grid-operation',data: $parent.row, tipText: item.tipText, operText: $parent.formatTitle(item.title), okTitle: item.okTitle, cancelTitle: item.cancelTitle\">\n  </y-popdialog>\n  <!-- /ko -->\n  <!-- ko if: item.type != 'popdialog' -->\n  <span class=\"y-grid-operation\" data-bind=\"attr:{'data-action':item.action, fieldid: $parent.getFieldId(item)},click:$parent.operClick, text: $parent.formatTitle(item.title)\"></span>\n  <!-- /ko -->\n</div>\n<!-- /ko -->\n<!-- ko if: operationList().length > 3 -->\n<div class=\"y-cell\">\n  <!-- ko foreach: {data:quickList, as: 'item'} -->\n  <!-- ko if: item.type == 'popdialog' -->\n  <y-popdialog\n    params=\"action: item.action,hideOperation: item.hideOperation, rowData: $parent.row, onOk:function (vm, evt) {$parent.operClick(item, evt)}, css: 'y-grid-operation', data: $parent.row, tipText: item.tipText, operText: $parent.formatTitle(item.title), okTitle: item.okTitle, cancelTitle: item.cancelTitle\">\n  </y-popdialog>\n  <!-- /ko -->\n  <!-- ko if: item.type != 'popdialog' -->\n  <span class=\"y-grid-operation\" data-bind=\"attr:{'data-action':item.action, fieldid: $parent.getFieldId(item)},click:$parent.operClick, text:$parent.formatTitle(item.title)\"></span>\n  <!-- /ko -->\n  <!-- /ko -->\n  <div class=\"y-inline-block y-grid-operation-morectn\">\n    <span class=\"y-grid-operation\"\n      data-bind=\"text: i18nMore,event: { mouseover: enableMore, mouseout: disableMore }\">更多</span>\n    <span class=\"fa fa-sort-down\" data-bind=\"event: { mouseover: enableMore, mouseout: disableMore }\"></span>\n    <y-dropdown\n      params=\"style: {overflow:'visible',background: '#eee'},width: dropWidth,topAdjust: 0, targetEl:moreEl, isShow:showDropdown\">\n      <ul class=\"y-grid-operation-more\"\n        data-bind=\"event: { mouseenter: $parent.enableMorePanel, mouseleave: $parent.disableMorePanel },foreach:{data:$parent.moreList, as: 'item'}\">\n        <!-- ko if: item.type == 'popdialog' -->\n        <li class=\"y-grid-stoprowselect\">\n          <y-popdialog\n            params=\"hideOperation: item.hideOperation, rowData: $parentContext.$parent.row,onOk:function (vm, evt) {$parentContext.$parent.operClick(item, evt)}, data: $parent.row, tipText: item.tipText, operText: $parentContext.$parent.formatTitle(item.title), okTitle: item.okTitle, cancelTitle: item.cancelTitle\">\n          </y-popdialog>\n        </li>\n        <!-- /ko -->\n        <!-- ko if: item.type != 'popdialog' -->\n        <li class=\"y-grid-stoprowselect\"\n          data-bind=\"attr:{'data-action':item.action, fieldid: $parentContext.$parent.getFieldId(item)},click:$parentContext.$parent.operClick, text:$parentContext.$parent.formatTitle(item.title)\"></li>\n        <!-- /ko -->\n      </ul>\n    </y-dropdown>\n\n  </div>\n</div>\n<!-- /ko -->\n";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(416), __esModule: true };

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(417);
module.exports = __webpack_require__(11).Object.keys;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(38);
var $keys = __webpack_require__(37);

__webpack_require__(116)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(419), __esModule: true };

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(420);
module.exports = __webpack_require__(11).Object.assign;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(20);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(421) });


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(18);
var getKeys = __webpack_require__(37);
var gOPS = __webpack_require__(93);
var pIE = __webpack_require__(50);
var toObject = __webpack_require__(38);
var IObject = __webpack_require__(112);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(30)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(423);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var EditGrid = function (_Base) {
  _inherits(EditGrid, _Base);

  function EditGrid() {
    _classCallCheck(this, EditGrid);

    return _possibleConstructorReturn(this, (EditGrid.__proto__ || (0, _getPrototypeOf2.default)(EditGrid)).apply(this, arguments));
  }

  _createClass(EditGrid, [{
    key: 'initialize',
    value: function initialize(params) {
      this.maxheight = params.maxheight || 'auto';
      this.isDataTable = params.isDataTable;
      this.columns = params.columns;
      // 保证表头和标题的_show绑定到同一个ko对象
      if (_knockout2.default.isObservable(this.columns)) {
        this.columns().forEach(function (col) {
          col._show = col._show ? col._show : _knockout2.default.observable(!col.hidden);
        });
      } else {
        this.columns.forEach(function (col) {
          col._show = col._show ? col._show : _knockout2.default.observable(!col.hidden);
        });
      }
      this.rows = params.rows;
      this.maxheight = params.maxheight;
      this.minheight = params.minheight;
      this.tdstyle = params.tdstyle;
      // event binding
      // 行选中
      this.onRowSelect = params.onRowSelect;
      this.style = params.style;
      // 放在弹框内部的需要动态内部高度
      this.modalBodyModalHeight = params.modalBodyModalHeight;
      this.modalBodyExtraHeight = params.modalBodyExtraHeight;
      this.onModalOkValidate = params.onModalOkValidate;
    }
  }, {
    key: 'computed',
    value: function computed(params) {}
  }, {
    key: 'subscribe',
    value: function subscribe(params) {}
  }, {
    key: 'methods',
    value: function methods(params) {}
  }, {
    key: 'created',
    value: function created(params) {}
  }]);

  return EditGrid;
}(_base2.default);

exports.default = {
  name: 'editgrid',
  init: _base2.default.createViewModel(EditGrid),
  template: _index2.default
};

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-grid-wrapper\" style=\"margin-bottom: 0\">\n  <div class=\"y-grid\">\n    <y-grid-head params=\"convertedColumns:columns, columns:[columns]\"></y-grid-head>\n  </div>\n</div>\n<y-grid params=\"\n  isDataTable: isDataTable,\n  rows: rows,\n  columns: columns,\n  isSeparate:true,\n  minheight: minheight,\n  maxheight: maxheight,\n  nohead: true,\n  hasSummaryRow: true,\n  isStripe: false\">\n</y-grid>\n";

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(425);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var ChildGrid = function (_Base) {
  _inherits(ChildGrid, _Base);

  function ChildGrid() {
    _classCallCheck(this, ChildGrid);

    return _possibleConstructorReturn(this, (ChildGrid.__proto__ || (0, _getPrototypeOf2.default)(ChildGrid)).apply(this, arguments));
  }

  _createClass(ChildGrid, [{
    key: 'initialize',
    value: function initialize(params) {
      this.isDataTable = params.isDataTable;
      this.columns = params.columns;
      this.pagination = params.pagination;
      this.totalCount = params.totalCount;
      this.pageSize = params.pageSize || _knockout2.default.observable(10);
      this.pageIndex = params.pageIndex || _knockout2.default.observable(0);
      this.onSizeChange = params.onSizeChange;
      this.onPageChange = params.onPageChange;
      this.rows = params.rows;
      this.maxheight = params.maxheight;
      this.minheight = params.minheight;
      this.tdstyle = params.tdstyle;
      // event binding
      // 行选中
      this.onRowSelect = params.onRowSelect;
      this.style = params.style;
      // 放在弹框内部的需要动态内部高度
      this.modalBodyModalHeight = params.modalBodyModalHeight;
      this.modalBodyExtraHeight = params.modalBodyExtraHeight;
      this.onModalOkValidate = params.onModalOkValidate;
    }
  }, {
    key: 'computed',
    value: function computed(params) {}
  }, {
    key: 'subscribe',
    value: function subscribe(params) {}
  }, {
    key: 'methods',
    value: function methods(params) {}
  }, {
    key: 'created',
    value: function created(params) {}
  }]);

  return ChildGrid;
}(_base2.default);

exports.default = {
  name: 'childgrid',
  init: _base2.default.createViewModel(ChildGrid),
  template: _index2.default
};

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-grid-wrapper\" style=\"margin-bottom: 0\">\n  <div class=\"y-grid\">\n    <y-grid-head params=\"convertedColumns:columns, columns:[columns]\"></y-grid-head>\n  </div>\n</div>\n<y-grid params=\"\n  isDataTable: isDataTable,\n  hasChildGrid: true,\n  rows: rows,\n  columns: columns,\n  isSeparate:true,\n  minheight: minheight,\n  maxheight: 'auto',\n  onSizeChange:onSizeChange,\n  onPageChange:onPageChange,\n  pagination: pagination,\n  totalCount: totalCount,\n  nohead: true,\n  hasSummaryRow: true,\n  pageSize: pageSize,\n  pageIndex: pageIndex,\n  isStripe: false\">\n</y-grid>\n";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(427);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _base3 = __webpack_require__(92);

var _base4 = _interopRequireDefault(_base3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'basicgrid',
  init: _base2.default.createViewModel(_base4.default),
  template: _index2.default
};

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "<div style=\"clear:both\">\n  <div class=\"y-grid-wrapper\" data-bind=\"css: {'y-b-dark': setting.borderDark,'y-b-darker':setting.borderDarker,'y-grid-noborder':noborder, 'y-grid-separate': isSeparate, 'y-hasCollapseToolbar': lockright},style:style\">\n    <!-- ko if: columnsFilterable -->\n    <div class=\"y-grid-filter\" data-bind=\"click: e => showColumnFilter(true)\">\n      <span class=\"fa fa-filter\"></span>\n      <div class=\"y-grid-filter-list\" data-bind=\"visible: showColumnFilter\">\n        <!-- ko foreach: {data: columns, as: 'col'} -->\n        <y-checkbox-item params=\"value:col._show(),label:col.title,checked:col._show\"></y-checkbox-item>\n        <!-- /ko -->\n        <div>\n          <y-button params=\"size: 'small', click: e => showColumnFilter(false), StopClickBubble: true \">关闭</y-button>\n        </div>\n      </div>\n\n    </div>\n    <!-- /ko -->\n    <div class=\"y-grid\" data-bind=\"event:{scroll:handleScroll},css:{'y-grid-stripe':isStripe, 'y-grid-verticalScroll':verticalScroll,'y-grid-border': isTableBorder},style:{height:computedMaxHeight,minHeight:minheight}\">\n      <y-grid-head data-bind=\"visible:!nohead\" params=\"triggerReset:triggerReset,groupSort:groupSort,hasVerticalSroll:hasVerticalSroll, maintable: true, lockcolumn:lockcolumn,headHeight:headHeight,headtransform:headtransform,el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:convertedRows,convertedColumns:convertedColumns,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n      <y-grid-body-basic params=\"fieldid: fieldid,lockcolumn:lockcolumn, aria: aria,columnNumberHeight: columnNumberHeight,setBodyContext: setBodyContext, lazy: lazy,transform:vertiacalScrollTransform,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,caculateColumns:caculateColumns,hasChildGrid:hasChildGrid,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,isEnableCrossPage:isEnableCrossPage,crossPageRowPrimaryKey:crossPageRowPrimaryKey,crossPageSelectedRows:crossPageSelectedRows,isShowLoading:isShowLoading,forbitRowSelect:forbitRowSelect,isSeparate:isSeparate,tdstyle: tdstyle, lockhead:lockhead,isNoDataCustomTpl: hasMarkup,defaultExpand:defaultExpand,tableWidth:tableWidth,rowspan:rowspan,domId:domId,expand:expand,maxheight:computedMaxHeight, isDataTable:isDataTable, columns:convertedColumns, rows:rows, onRowSelect:onRowSelect\">\n        <!-- ko template: { nodes: $parent.$templateNodes } -->\n        <!-- /ko -->\n      </y-grid-body-basic>\n      <!-- ko if:lockcolumn-->\n      <div class=\"y-grid-fixed\" data-bind=\"style:{width: fixedTableWidth}\">\n        <div class=\"y-grid-fixed-head\">\n          <y-grid-head data-bind=\"visible:!nohead\" params=\"triggerReset:triggerReset,groupSort:groupSort,lockcolumn:lockcolumn,headHeight:headHeight,el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:convertedRows,convertedColumns:convertedColumns,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n        </div>\n        <div class=\"y-grid-fixed-body\" data-bind=\"style:{height: fixBodyHeight}\">\n          <y-grid-body-basic params=\"fieldid: fieldid,columnNumberHeight: columnNumberHeight,lockcolumn: lockcolumn,lazy: lazy,isLockLeft: true,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,transform:fixColumnTransform,tdstyle: tdstyle, lockhead:true,tableWidth:tableWidth,rowspan:rowspan,domId:domId+'_fix',expand:expand,maxheight:computedMaxHeight, isDataTable:isDataTable, columns:lockleftColumns,forbitRowSelect:forbitRowSelect,rows:rows, onRowSelect:onRowSelect\">\n          </y-grid-body-basic>\n        </div>\n      </div>\n      <!-- /ko -->\n      <!-- ko if:lockright-->\n      <div class=\"y-grid-fixed-right\" style=\"margin-right: 15px\" data-bind=\"style:{width: fixedLockRightTableWidth}, visible: showLockRightToolBar\">\n        <div class=\"y-grid-fixed-head\">\n          <y-grid-head data-bind=\"visible:!nohead\" params=\"triggerReset:triggerReset,groupSort:groupSort,headtransform:fixRightHeadtransform,el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:convertedRows,convertedColumns:convertedColumns,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n        </div>\n        <div class=\"y-grid-fixed-body\" data-bind=\"style:{height: fixBodyHeight}, visible: !hidefix()\">\n          <y-grid-body-basic params=\"fieldid: fieldid,columnNumberHeight: columnNumberHeight,lazy: lazy,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,caculateColumns:caculateColumns,hasChildGrid:hasChildGrid,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,transform:fixRightTransform,tdstyle: tdstyle, lockhead:true,tableWidth:tableWidth,rowspan:rowspan,domId:domId+'_fixRight',expand:expand,maxheight:computedMaxHeight, isDataTable:isDataTable, columns:convertedColumns,forbitRowSelect:forbitRowSelect,rows:rows, onRowSelect:onRowSelect\">\n          </y-grid-body-basic>\n        </div>\n      </div>\n      <div class=\"y-lock-toolbar\" title=\"收起/展开\" data-bind=\"style: {height:computedMaxHeight},click:handleToogleLockright\">\n        <div class=\"y-lock-toolbar-i\">\n          <i class=\"fa fa-angle-left\"></i>\n          <i class=\"fa fa-angle-right\"></i>\n        </div>\n      </div>\n      <div class=\"y-fixtopright-space\"></div>\n      <!-- /ko -->\n      <!-- ko if: verticalScroll -->\n      <div class=\"y-vertical-scroll\" data-bind=\"event:{scroll:handleScroll},style:scrollStyle\">\n        <div data-bind=\"style:{width: tableWidth}\" style=\"height: 1px\"></div>\n      </div>\n      <!-- /ko -->\n    </div>\n    <!-- ko if: toolbox -->\n    <div class=\"y-grid-toolbox\" data-bind=\"click: handleSetting\">\n      表格设置\n    </div>\n    <y-modal params=\"visible: toolboxvisible, width: '600px', title: '表格属性设置'\">\n      <y-form params=\"model:$parentContext.$parent.settingModel,labelWidth:'120px',labelAlign:'right'\">\n        <y-formitem params=\"label:'边框颜色:'\">\n          <ul data-bind=\"foreach: {data: [{value:'#ececec',tag:'Light'}, {value: '#dbdbdb', tag:'Dark'}, {value:'#333',tag:'Darker'}], as: 'item'}\"\n            style=\"padding-top: 5px;\">\n            <li class=\"y-pickr\" data-bind=\"css:{'active':item.tag==$parentContext.$parentContext.$parentContext.$parent.borderActive()},click:$parentContext.$parentContext.$parentContext.$parent.handleSettingBorder\">\n              <div data-bind=\"style:{borderTopColor: item.value}\"></div>\n            </li>\n          </ul>\n        </y-formitem>\n        <y-formitem params=\"label:'固定列:',style:{height:'auto'}\">\n          <div data-bind=\"let: {fixedleft: $parentContext.$parentContext.$parent.lockcolumn}\">\n            <y-switch params=\"checked: fixedleft, size: 'large'\">\n              <span data-bind=\"text: fixedleft() ? '展开': '收起'\">展开</span>\n            </y-switch>\n            <br>\n            当表格数据较多时，建议收起左侧固定列来获取更流畅的操作\n          </div>\n\n          <!--<y-radio params=\"value: $parentContext.$parentContext.$parentContext.$parent.fixedColumns,dataList:[{value: false,label:'收起固定列'},{value: true,label:'展开固定列'}]\"></y-radio>-->\n\n\n        </y-formitem>\n      </y-form>\n    </y-modal>\n    <!-- /ko -->\n  </div>\n  <!-- ko if: pagination -->\n  <y-pagination data-bind=\"visible: isShowPagination\" params=\"pageSizeList:pageSizeList,onSizeChange:onSizeChange,onPageChage:onPageChange,pageSize: pageSize, totalCount: totalCount, pageIndex: pageIndex\"></y-pagination>\n  <!-- /ko -->\n</div>";

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iterator = __webpack_require__(154);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(157);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                                                                         * @author: liuxu7
                                                                                                                                                                                                                                                                                                                         * @date: 2017-10-25
                                                                                                                                                                                                                                                                                                                         * @description: 按钮组件
                                                                                                                                                                                                                                                                                                                         * type: fa类名
                                                                                                                                                                                                                                                                                                                         * size: 图标大小
                                                                                                                                                                                                                                                                                                                         * color: 图标颜色
                                                                                                                                                                                                                                                                                                                         * padding: 图标内间距
                                                                                                                                                                                                                                                                                                                         * */


var _index = __webpack_require__(446);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var PREFIX = 'fa-';
  this.type = params.type ? PREFIX + params.type : '';
  this.size = (params.size || '') + 'px';
  this.color = params.color || '#333';
  var padding = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  if (_typeof(params.padding) === 'object') {
    for (var key in params.padding) {
      padding[key] = params.padding[key];
    }
    this.padding = padding.top + ' ' + padding.right + ' ' + padding.bottom + ' ' + padding.left + ' ';
  } else {
    this.padding = params.padding;
  }
}
exports.default = {
  name: 'icon',
  init: init,
  template: _index2.default
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(430);
__webpack_require__(433);
module.exports = __webpack_require__(96).f('iterator');


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(431)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(155)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var defined = __webpack_require__(69);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(70);
var descriptor = __webpack_require__(49);
var setToStringTag = __webpack_require__(95);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(28)(IteratorPrototype, __webpack_require__(35)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(434);
var global = __webpack_require__(17);
var hide = __webpack_require__(28);
var Iterators = __webpack_require__(94);
var TO_STRING_TAG = __webpack_require__(35)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(435);
var step = __webpack_require__(436);
var Iterators = __webpack_require__(94);
var toIObject = __webpack_require__(31);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(155)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(438);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
module.exports = __webpack_require__(11).Symbol;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(20);
var redefine = __webpack_require__(156);
var META = __webpack_require__(439).KEY;
var $fails = __webpack_require__(30);
var shared = __webpack_require__(73);
var setToStringTag = __webpack_require__(95);
var uid = __webpack_require__(52);
var wks = __webpack_require__(35);
var wksExt = __webpack_require__(96);
var wksDefine = __webpack_require__(97);
var enumKeys = __webpack_require__(440);
var isArray = __webpack_require__(441);
var anObject = __webpack_require__(36);
var isObject = __webpack_require__(29);
var toObject = __webpack_require__(38);
var toIObject = __webpack_require__(31);
var toPrimitive = __webpack_require__(68);
var createDesc = __webpack_require__(49);
var _create = __webpack_require__(70);
var gOPNExt = __webpack_require__(442);
var $GOPD = __webpack_require__(111);
var $GOPS = __webpack_require__(93);
var $DP = __webpack_require__(21);
var $keys = __webpack_require__(37);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(158).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(50).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(51)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(28)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(52)('meta');
var isObject = __webpack_require__(29);
var has = __webpack_require__(22);
var setDesc = __webpack_require__(21).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(30)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(37);
var gOPS = __webpack_require__(93);
var pIE = __webpack_require__(50);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(113);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(31);
var gOPN = __webpack_require__(158).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 443 */
/***/ (function(module, exports) {



/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97)('asyncIterator');


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97)('observable');


/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "<span class=\"fa\" data-bind=\"css: type, style: {fontSize: size, color: color, padding: padding}\"></span>";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(448);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _base3 = __webpack_require__(159);

var _base4 = _interopRequireDefault(_base3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'input',
  init: _base2.default.createViewModel(_base4.default),
  template: _index2.default
};

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-input-ctn\" data-bind=\"css: ctnClass\">\n  <!-- ko if: isHasForm -->\n  <form data-bind=\"submit:handleSubmit\">\n    <input class=\"y-input\" data-bind=\"\n      css: {'text-right': align === 'right'},\n      click: onClick,\n      event: {keyup: onKeyup, blur: onBlur, input: onInput, focus: onFocus},\n      attr: {tabindex: tabindex,maxlength: maxlength, type: type, placeholder: placeholder, disabled: disabled, fieldid: fieldid},\n      value: value\" />\n    <i data-bind=\"visible: showIcon, css:iconClass,click: handleIconClick, attr:{fieldid: fieldid + '|icon'}\"></i>\n  </form>\n  <!-- /ko -->\n  <!-- ko ifnot: isHasForm -->\n  <!-- ko if: prepend -->\n  <div class=\"y-input-prepend\">\n    <span data-bind=\"text: prepend, attr: {fieldid: fieldid + '|prepend'}\" ></span>\n  </div>\n  <!-- /ko -->\n  <!-- ko ifnot: thousandsShow -->\n  <input class=\"y-input\" data-bind=\"\n      css: {'y-hasprepend': prepend, 'y-text-changed': enableChangingStyle && textChanged(), 'y-hasappend': append, 'text-right': align === 'right'},\n      click: onClick,\n      event: {keyup: onKeyup, blur: onBlur, input: onInput, focus: onFocus},\n      attr: {tabindex: tabindex, maxlength: maxlength, type: type, placeholder: placeholder, disabled: disabled, fieldid: fieldid},\n      value: value\" />\n  <!-- /ko -->\n  <!-- ko if: thousandsShow -->\n  <div class=\"y-input y-input-thousands y-relative\" data-bind=\"click: onThousandsShowClick\">\n    <div class=\"y-input-thousandsContent\" data-bind=\"text: thousandsVal,attr:{title:thousandsVal, fieldid: fieldid}\"></div>\n  </div>\n  <!-- /ko -->\n  <!-- ko if: append -->\n  <div class=\"y-input-append\">\n    <span data-bind=\"text: append, attr:{fieldid: fieldid + '|append'}\" ></span>\n  </div>\n  <!-- /ko -->\n  <i data-bind=\"visible: showIcon, css:iconClass,click: handleIconClick,attr:{fieldid: fieldid + '|icon'}\"></i>\n  <!-- /ko -->\n  <i class=\"fa fa-close y-input-clear\" data-bind=\"visible:clearable, click:handleClose,attr:{fieldid: fieldid + '|clear'}\"></i>\n</div>\n";

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strip", function() { return strip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plus", function() { return plus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minus", function() { return minus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "times", function() { return times; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "divide", function() { return divide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "round", function() { return round; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "digitLength", function() { return digitLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "float2Fixed", function() { return float2Fixed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableBoundaryChecking", function() { return enableBoundaryChecking; });
/**
 * @desc 解决浮动运算问题，避免小数点后产生多位数和计算精度损失。
 *
 * 问题示例：2.3 + 2.4 = 4.699999999999999，1.0 - 0.9 = 0.09999999999999998
 */
/**
 * Correct the given number to specifying significant digits.
 *
 * @param num The input number
 * @param precision An integer specifying the number of significant digits
 *
 * @example strip(0.09999999999999998) === 0.1 // true
 */
function strip(num, precision) {
    if (precision === void 0) { precision = 15; }
    return +parseFloat(Number(num).toPrecision(precision));
}
/**
 * Return digits length of a number.
 *
 * @param num The input number
 */
function digitLength(num) {
    // Get digit length of e
    var eSplit = num.toString().split(/[eE]/);
    var len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
    return len > 0 ? len : 0;
}
/**
 * Convert the given number to integer, support scientific notation.
 * The number will be scale up if it is decimal.
 *
 * @param num The input number
 */
function float2Fixed(num) {
    if (num.toString().indexOf('e') === -1) {
        return Number(num.toString().replace('.', ''));
    }
    var dLen = digitLength(num);
    return dLen > 0 ? strip(Number(num) * Math.pow(10, dLen)) : Number(num);
}
/**
 * Log a warning if the given number is out of bounds.
 *
 * @param num The input number
 */
function checkBoundary(num) {
    if (_boundaryCheckingState) {
        if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
            console.warn(num + " is beyond boundary when transfer to integer, the results may not be accurate");
        }
    }
}
/**
 * Create an operation to support rest params.
 *
 * @param operation The original operation
 */
function createOperation(operation) {
    return function () {
        var nums = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nums[_i] = arguments[_i];
        }
        var first = nums[0], others = nums.slice(1);
        return others.reduce(function (prev, next) { return operation(prev, next); }, first);
    };
}
/**
 * Accurate multiplication.
 *
 * @param nums The numbers to multiply
 */
var times = createOperation(function (num1, num2) {
    var num1Changed = float2Fixed(num1);
    var num2Changed = float2Fixed(num2);
    var baseNum = digitLength(num1) + digitLength(num2);
    var leftValue = num1Changed * num2Changed;
    checkBoundary(leftValue);
    return leftValue / Math.pow(10, baseNum);
});
/**
 * Accurate addition.
 *
 * @param nums The numbers to add
 */
var plus = createOperation(function (num1, num2) {
    // 取最大的小数位
    var baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
    // 把小数都转为整数然后再计算
    return (times(num1, baseNum) + times(num2, baseNum)) / baseNum;
});
/**
 * Accurate subtraction.
 *
 * @param nums The numbers to subtract
 */
var minus = createOperation(function (num1, num2) {
    var baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
    return (times(num1, baseNum) - times(num2, baseNum)) / baseNum;
});
/**
 * Accurate division.
 *
 * @param nums The numbers to divide
 */
var divide = createOperation(function (num1, num2) {
    var num1Changed = float2Fixed(num1);
    var num2Changed = float2Fixed(num2);
    checkBoundary(num1Changed);
    checkBoundary(num2Changed);
    // fix: 类似 10 ** -4 为 0.00009999999999999999，strip 修正
    return times(num1Changed / num2Changed, strip(Math.pow(10, digitLength(num2) - digitLength(num1))));
});
/**
 * Accurate rounding method.
 *
 * @param num The number to round
 * @param decimal An integer specifying the decimal digits
 */
function round(num, decimal) {
    var base = Math.pow(10, decimal);
    var result = divide(Math.round(Math.abs(times(num, base))), base);
    if (num < 0 && result !== 0) {
        result = times(result, -1);
    }
    return result;
}
var _boundaryCheckingState = true;
/**
 * Whether to check the bounds of number, default is enabled.
 *
 * @param flag The value to indicate whether is enabled
 */
function enableBoundaryChecking(flag) {
    if (flag === void 0) { flag = true; }
    _boundaryCheckingState = flag;
}
var index = {
    strip: strip,
    plus: plus,
    minus: minus,
    times: times,
    divide: divide,
    round: round,
    digitLength: digitLength,
    float2Fixed: float2Fixed,
    enableBoundaryChecking: enableBoundaryChecking,
};


/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_index_js__ = __webpack_require__(162);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__modifiers_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPopper_js__ = __webpack_require__(107);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* unused harmony reexport createPopperBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popper_js__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__popper_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popper_lite_js__ = __webpack_require__(178);
/* unused harmony reexport createPopperLite */

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTableElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(25);

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element)) >= 0;
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositePlacement;
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositeVariationPlacement;
var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getClippingRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__instanceOf_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getParentNode_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contains_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getNodeName_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_math_js__ = __webpack_require__(27);















function getInnerBoundingClientRect(element, strategy) {
  var rect = Object(__WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__["a" /* default */])(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === __WEBPACK_IMPORTED_MODULE_0__enums_js__["o" /* viewport */] ? Object(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__["a" /* default */])(element, strategy)) : Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : Object(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = Object(__WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__getParentNode_js__["a" /* default */])(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__["a" /* default */])(element).position) >= 0;
  var clipperElement = canEscapeClipping && Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["b" /* isHTMLElement */])(element) ? Object(__WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__["a" /* default */])(element) : element;

  if (!Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) && Object(__WEBPACK_IMPORTED_MODULE_10__contains_js__["a" /* default */])(clippingParent, clipperElement) && Object(__WEBPACK_IMPORTED_MODULE_11__getNodeName_js__["a" /* default */])(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["a" /* max */])(rect.top, accRect.top);
    accRect.right = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* min */])(rect.right, accRect.right);
    accRect.bottom = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* min */])(rect.bottom, accRect.bottom);
    accRect.left = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["a" /* max */])(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getViewportRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__ = __webpack_require__(164);




function getViewportRect(element, strategy) {
  var win = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var html = Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = Object(__WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__["a" /* default */])();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element),
    y: y
  };
}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math_js__ = __webpack_require__(27);




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = Object(__WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__["a" /* default */])(element);
  var winScroll = Object(__WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__["a" /* default */])(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element);
  var y = -winScroll.scrollTop;

  if (Object(__WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__["a" /* default */])(body || html).direction === 'rtl') {
    x += Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getParentNode_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(10);




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(node) && Object(__WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__["a" /* default */])(node)) {
    return node;
  }

  return getScrollParent(Object(__WEBPACK_IMPORTED_MODULE_0__getParentNode_js__["a" /* default */])(node));
}

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeAutoPlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getVariation_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__ = __webpack_require__(26);




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["h" /* placements */] : _options$allowedAutoP;
  var variation = Object(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement);
  var placements = variation ? flipVariations ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* variationPlacements */] : __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* variationPlacements */].filter(function (placement) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement) === variation;
  }) : __WEBPACK_IMPORTED_MODULE_1__enums_js__["b" /* basePlacements */];
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = Object(__WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[Object(__WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__["a" /* default */])(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAltAxis;
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCompositeRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(27);









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(rect.width) / element.offsetWidth || 1;
  var scaleY = Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent);
  var offsetParentIsScaled = Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent) && isElementScaled(offsetParent);
  var documentElement = Object(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(offsetParent);
  var rect = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    Object(__WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__["a" /* default */])(documentElement)) {
      scroll = Object(__WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__["a" /* default */])(offsetParent);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent)) {
      offsets = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = Object(__WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__["a" /* default */])(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getWindow_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__ = __webpack_require__(462);




function getNodeScroll(node) {
  if (node === Object(__WEBPACK_IMPORTED_MODULE_1__getWindow_js__["a" /* default */])(node) || !Object(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["b" /* isHTMLElement */])(node)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__["a" /* default */])(node);
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__["a" /* default */])(node);
  }
}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHTMLElementScroll;
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = orderModifiers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(9);
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* modifierPhases */].reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeByName;
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPopper; });
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__ = __webpack_require__(175);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__popper_lite_js__ = __webpack_require__(178);
/* unused harmony reexport createPopperLite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modifiers_index_js__ = __webpack_require__(162);
/* unused harmony namespace reexport */










var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__["a" /* default */]];
var createPopper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleinput = __webpack_require__(468);

var _simpleinput2 = _interopRequireDefault(_simpleinput);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _base3 = __webpack_require__(159);

var _base4 = _interopRequireDefault(_base3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'simpleinput',
  init: _base2.default.createViewModel(_base4.default),
  template: _simpleinput2.default
};

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-input-ctn y-simpleinput\" data-bind=\"css: ctnClass\">\n  <input class=\"y-input\" data-bind=\"\n      css: {'y-text-changed': enableChangingStyle && textChanged(), 'text-right': align === 'right'},\n      click: onClick,\n      event: {keyup: onKeyup, blur: onBlur, input: onInput, focus: onFocus},\n      attr: {maxlength: maxlength, type: type, placeholder: placeholder, disabled: disabled,fieldid: fieldid},\n      value: value\" />\n</div>\n";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(470);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

__webpack_require__(65);

var _scrollable = __webpack_require__(64);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _stringHash = __webpack_require__(42);

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  this.addtionButton = params.textClear || false;
  // 隐藏foot ok 取消按钮  传true就会隐藏
  this.hideFoot = params.hideFoot || _knockout2.default.observable(false);
  this.hideOk = params.hideOk || _knockout2.default.observable(false);
  this.hideCancel = params.hideCancel || _knockout2.default.observable(false);
  this.visible = params.visible || _knockout2.default.observable(false);
  this.textOk = params.textOk || (0, _i18n2.default)('确定');
  this.action = params.action || '';
  this.textCancel = params.textCancel || (0, _i18n2.default)('取消');
  this.textDelete = params.textDelete;
  this.showDelete = params.showDelete || false;
  this.textClear = params.textClear;
  this.isShow = _knockout2.default.observable(false);
  this.width = params.width || '400px';
  this.title = params.title || (0, _i18n2.default)('提示');
  this.fieldid = '';
  if (params.fieldid) {
    this.fieldid = params.fieldid;
  } else if (this.title) {
    this.fieldid = (0, _stringHash2.default)(this.title);
  }
  this.isNotLazy = params.lazy === undefined ? false : !params.lazy;
  this.top = window.innerHeight * 0.06 + 'px';
  this.ref = null;
  this.setRef = function (ref) {
    _knockout2.default.tasks.schedule(function () {
      _this.ref = ref;
      ref.click();
    });
  };
  var handleOk = params.ok || params.onOk || function () {};
  var handleCancel = params.onCancel || function () {};

  var headAndFootHeightRate = (43 + 57) / window.innerHeight;
  // 容器最大高度等于 屏幕可视高度 - 头部 - 尾部 - 内存padding - 距离顶部距离10% - 距离底部最小距离10%
  this.bodyMaxHeight = window.innerHeight * (1 - 0.12 - headAndFootHeightRate) + 'px';
  this.stopMaskClick = params.stopMaskClick;
  // 关闭事件
  this.handleClose = function (data, event) {
    if (!_this.stopMaskClick) {
      var className = event.target.getAttribute('class');
      if (className && className.indexOf('modal-wrap') > -1) {
        _this.visible(false);
      }
    }
    return true;
  };
  this.validateFn = params.validateFn || function () {
    return true;
  };
  this.asyncValidateFn = params.asyncValidateFn;
  // 时间
  this.handleCancel = function () {
    _this.visible(false);
    handleCancel();
  };
  this.handleClear = function (data, event) {
    if (params.handleClear) {
      params.handleClear(data, event);
    }
  };
  this.handleDelete = function (data, event) {
    if (params.handleDelete) {
      params.handleDelete(data, event);
    }
  };
  this.handleOk = function (data, event) {
    if (_this.isValidate) {
      // 异步校验
      if (_this.asyncValidateFn) {
        _this.asyncValidateFn().then(function (flag) {
          if (flag) {
            _this.errormsg('');
            _this.visible(false);
            handleOk(data, event);
          } else {
            _this.errormsg(_knockout2.default.utils.unwrapObservable(params.errormsg) || '校验失败！');
          }
        });
      } else if (_this.validateFn()) {
        // 同步校验
        _this.errormsg('');
        _this.visible(false);
        handleOk(data, event);
      } else {
        _this.errormsg(_knockout2.default.utils.unwrapObservable(params.errormsg) || '校验失败！');
      }
    } else {
      _this.errormsg(_knockout2.default.utils.unwrapObservable(params.errormsg) || '校验失败！');
    }
  };
  this.visible.subscribe(function (val) {
    if (val) {
      if (_this.ref) {
        _knockout2.default.tasks.schedule(function () {
          _this.ref.click();
        });
      }
      (0, _scrollable.lockScrollEffect)();
    } else {
      (0, _scrollable.resetScrollEffect)();
    }
  });
  // 仅当visible第一次是true的时候切换if
  if (this.isNotLazy) {
    this.isShow(true);
  } else {
    _knockout2.default.when(function () {
      return _this.visible();
    }, function () {
      _this.isShow(true);
    }, this);
  }

  // 添加外层错误校验
  this.errormsg = _knockout2.default.observable('');
  this.isValidate = true;
  this.onModalOkValidate = function (validateResult) {
    if (validateResult) {
      this.isValidate = true;
    } else {
      this.isValidate = false;
    }
  }.bind(this);
}

exports.default = {
  name: 'modal',
  init: init,
  template: _index2.default
};

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "<div data-bind=\"transferdom,if:isShow,visible:visible\" style=\"display: none\">\n  <div class=\"y-modal-mask\"></div>\n  <div class=\"y-modal-wrap\" data-bind=\"click:handleClose,css:{animated: visible, fadeInUp: visible}\">\n    <div class=\"y-modal\" data-bind=\"style:{width:width,top:top}\">\n      <div class=\"y-modal-ctn\" data-bind=\"ref:setRef\">\n        <div class=\"y-modal-head\">\n          <span class=\"y-modal-head-title\" data-bind=\"text:title\"></span>\n        </div>\n        <div class=\"y-modal-body\" data-bind=\"style:{maxHeight:bodyMaxHeight}\">\n          <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n        </div>\n        <div class=\"y-modal-foot\" data-bind=\"visible:!hideFoot()\">\n          <span class=\"y-modal-error-msg\" data-bind=\"text:errormsg\"></span>\n          <!-- ko if: showDelete -->\n          <y-button params=\"fieldid:fieldid + '|handleDelete', type:'error', click: handleDelete\" class=\"pull-left\"><span data-bind=\"text: $parent.textDelete\">删除</span></y-button>\n          <!-- /ko -->\n          <!-- ko if: textClear-->\n          <y-button params=\"fieldid:fieldid + '|handleClear', type:'primary', click: handleClear\"><span data-bind=\"text: $parent.textClear\">清空</span></y-button>\n          <!-- /ko -->\n          <!-- ko if: !hideCancel()-->\n          <y-button params=\"fieldid:fieldid + '|handleCancel', type:'secondary', click: handleCancel\"><span data-bind=\"text: $parent.textCancel\">取消</span></y-button>\n          <!-- /ko -->\n          <!-- ko if: !hideOk()-->\n          <y-button params=\"fieldid:fieldid + '|handleOk', type:'primary', click: handleOk\"><span data-bind=\"attr:{'data-action':$parent.action}, text: $parent.textOk\"></span></y-button>\n          <!-- /ko -->\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(472);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  // 外部默认分页默认从0 开始 而分页从1开始显示 所以要添加一个INDEX_DIFF,如果传入startIndex 为1 则差值为0
  var INDEX_DIFF = params.startIndex === 1 ? 0 : 1;
  this.value = _knockout2.default.observable();
  this.pageIndex = _knockout2.default.computed(function () {
    return params.pageIndex() + INDEX_DIFF;
  });
  this.i18nShowPage = (0, _i18n2.default)('每页显示');
  this.i18nShowLists = (0, _i18n2.default)('条');
  this.i18nTotal = (0, _i18n2.default)('共');
  this.i18nTo = (0, _i18n2.default)('跳至');
  this.i18nPages = (0, _i18n2.default)('页');
  // 对齐
  this.align = params.align || 'right';
  this.pageSize = params.pageSize;
  var _defaultCurPage = params.pageSize() ? { value: params.pageSize(), label: params.pageSize() + '' } : null;
  this.curPage = _knockout2.default.observable(_defaultCurPage || { value: 10, label: '10' });
  this.pageSize.subscribe(function (val) {
    if (isNaN(val - 0)) {
      console.error('传入的pageSize,必须为数字');
    } else {
      _this.curPage({
        value: val - 0,
        label: val.toString() });
    }
  });
  this.totalCount = params.totalCount;
  var defaultList = [500, 100, 50, 20, 10];
  if (params.pageSizeList) {
    defaultList = params.pageSizeList;
  }
  this.pageList = defaultList.map(function (item) {
    return {
      value: item,
      label: item + ''
    };
  });
  this.totalPage = _knockout2.default.computed(function () {
    return Math.ceil(_this.totalCount() / _this.pageSize());
  });
  this.pageChange = function () {
    // 以前写错了，这里保留旧版代码兼容以前版本
    params.onPageChage && params.onPageChage(_this.pageIndex() - INDEX_DIFF, _this.pageSize());
    params.onPageChange && params.onPageChange(_this.pageIndex() - INDEX_DIFF, _this.pageSize());
  };
  this.sizeChange = function (page) {
    _this.pageSize(page.value);
    // fix #55 size Change之后要从第一页重新开始
    params.pageIndex(1 - INDEX_DIFF);
    params.onSizeChange && params.onSizeChange(_this.pageIndex() - INDEX_DIFF, _this.pageSize());
  };
  // 进入某一页
  this.handlePageChange = function (destIndex) {
    if (destIndex > this.totalPage()) {
      destIndex = this.totalPage();
      this.value(destIndex);
    }
    if (destIndex.toString() === 'NaN' || destIndex <= 0) {
      destIndex = 1;
      this.value(destIndex);
    }
    params.pageIndex(destIndex - INDEX_DIFF);
    this.pageChange();
  };
  // 下一页
  this.handleNext = function () {
    var current = _this.pageIndex();
    if (current >= _this.totalPage()) {
      return false;
    }
    params.pageIndex(params.pageIndex() + 1);
    _this.pageChange();
  };
  // 上一页
  this.handlePrev = function () {
    var current = this.pageIndex();
    if (current <= 1) {
      return false;
    }
    params.pageIndex(params.pageIndex() - 1);
    this.pageChange();
  };
}

exports.default = {
  name: 'pagination',
  init: init,
  template: _index2.default
};

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-pagination\" data-bind=\"css:{'text-left':align == 'left','text-center':align == 'center','text-right':align == 'right'}\">\n  <ul :class=\"wrapClasses\" :style=\"styles\" v-else>\n    <!--<span :class=\"[prefixCls + '-total']\" v-if=\"showTotal\">-->\n        <!--<slot>{{ t('i.page.total') }} {{ total }} <template v-if=\"total <= 1\">{{ t('i.page.item') }}</template><template v-else>{{ t('i.page.items') }}</template></slot>-->\n    <!--</span>-->\n    <li class=\"y-page-total\">\n      <span data-bind=\"text:i18nTotal\">共</span> <span data-bind=\"text:totalCount\"></span> <span data-bind=\"text:i18nShowLists\">条</span>\n    </li>\n    <li title=\"\" class=\"y-page-prev\" data-bind=\"click: handlePrev,css:{'y-page-disable':pageIndex()<=1}\">\n      <a><i class=\"fa fa-angle-left\"></i></a>\n    </li>\n    <li title=\"1\" class=\"y-page-item\" data-bind=\"css:{'y-page-item-cur': pageIndex() == 1},click:function(){handlePageChange(1)}\"><a>1</a></li>\n    <!--<li title=\"向前5页\" data-bind=\"visible: currentPage() - 3 > 1\" @click=\"fastPrev\"><a><i class=\"ivu-icon ivu-icon-ios-arrow-left\"></i></a></li>-->\n    <li class=\"y-page-item\" data-bind=\"attr:{title:pageIndex() - 2},visible:pageIndex() - 2 > 1,click:function(){handlePageChange(pageIndex() - 2)}\"><a data-bind=\"text:pageIndex() - 2\"></a></li>\n    <li class=\"y-page-item\" data-bind=\"attr:{title:pageIndex() - 1},visible:pageIndex() - 1 > 1,click:function(){handlePageChange(pageIndex() - 1)}\"><a data-bind=\"text:pageIndex() - 1\"></a></li>\n    <li class=\"y-page-item y-page-item-cur\" data-bind=\"attr:{title:pageIndex},visible:pageIndex() != 1 && pageIndex() != totalPage()\"><a data-bind=\"text:pageIndex\"></a></li>\n    <li class=\"y-page-item\" data-bind=\"attr:{title:pageIndex() + 1},visible:pageIndex() + 1 < totalPage(),click:function(){handlePageChange(pageIndex() + 1)}\"><a data-bind=\"text:pageIndex() + 1\"></a></li>\n    <li class=\"y-page-item\" data-bind=\"attr:{title:pageIndex() + 2},visible:pageIndex() + 2 < totalPage(),click:function(){handlePageChange(pageIndex() + 2)}\"><a data-bind=\"text:pageIndex() + 2\"></a></li>\n    <!--<li :title=\"t('i.page.next5')\" v-if=\"currentPage + 3 < allPages\" :class=\"[prefixCls + '-item-jump-next']\" @click=\"fastNext\"><a><i class=\"ivu-icon ivu-icon-ios-arrow-right\"></i></a></li>-->\n    <li class=\"y-page-item\" data-bind=\"css:{'y-page-item-cur': pageIndex() == totalPage()},attr:{title:totalPage},visible:totalPage() > 1,click:function(){handlePageChange(totalPage())}\"><a data-bind=\"text:totalPage()\"></a></li>\n    <li title=\"\" class=\"y-page-next\" data-bind=\"click: handleNext, css:{'y-page-disable':pageIndex()==totalPage()}\">\n      <a><i class=\"fa fa-angle-right\"></i></a>\n    </li>\n    <li class=\"y-inline-block text-left\" style=\"margin-left:5px;\">\n      <y-select class=\"y-inline-block\" style=\"width: 60px;position: relative;top:2px;vertical-align: middle\" params=\"size: 'sm', topAdjust:'-180',stopLockScroll:true,dataList: pageList,value:curPage,onChange:sizeChange\"></y-select>\n      <span class=\"y-inline-block\" data-bind=\"text: i18nShowLists\">条</span>\n    </li>\n    <li class=\"y-inline-block\" style=\"margin-left:5px;\">\n      <span class=\"y-inline-block\" data-bind=\"text: i18nTo\">跳至</span>\n        <y-input class=\"y-inline-block inputPage\" style=\"width: 40px; position: relative; vertical-align: middle;\" params=\"value:value, onSubmit:function(){handlePageChange(parseInt(value()))}\"></y-input>\n      <span class=\"y-inline-block\" data-bind=\"text: i18nPages\">页</span>\n    </li>\n  </ul>  \n</div>\n";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(474);

var _index2 = _interopRequireDefault(_index);

var _jquery = __webpack_require__(32);

var _jquery2 = _interopRequireDefault(_jquery);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function computedHeight(element) {
  this.height = (0, _jquery2.default)(element).find('.y-searchtag-ctn').height();
  if (this.height > 30) {
    this.showMore(true);
  } else {
    this.showMore(false);
  }
}
function _init(params, el) {
  var _this = this;

  var _el = el.element;
  this.tagList = params.tagList;
  this.tagList.subscribe(function (val) {
    setTimeout(function () {
      // 确保渲染完再计算
      computedHeight.call(_this, _el);
    }, 100);
  });
  this.titleKey = params.titleKey || 'title';
  this.height = 'auto';
  this.showMore = _knockout2.default.observable(false);
  this.enableActive = params.enableActive || false;
  this.expandMore = _knockout2.default.observable(false);
  this.operation = _knockout2.default.observable((0, _i18n2.default)('展开'));
  this.style = _knockout2.default.computed(function () {
    if (_this.expandMore()) {
      return {
        height: _this.height + 'px'
      };
    } else {
      return {
        height: '30px'
      };
    }
  });
  this.handleMoreClick = function () {
    _this.expandMore(!_this.expandMore());
    if (_this.expandMore()) {
      _this.operation((0, _i18n2.default)('收起'));
    } else {
      _this.operation((0, _i18n2.default)('展开'));
    }
  };
  setTimeout(function () {
    computedHeight.call(_this, _el);
  }, 100);
}
var init = {
  createViewModel: function createViewModel(params, componentInfo) {
    return new _init(params, componentInfo);
  }
};
exports.default = {
  name: 'searchtag',
  init: init,
  template: _index2.default
};

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-searchtag-wrapper\" data-bind=\"style: style\">\n  <div class=\"y-searchtag-ctn\" data-bind=\"foreach: {data: tagList, as: 'tag'}\">\n    <y-tag params=\"\n      enableActive: $parent.enableActive,\n      item: tag,\n      handleClick: tag.handleClick,\n      text: tag[$parent.titleKey],\n      type: 'blank',\n      style: {marginRight:'10px'}\">\n    </y-tag>\n  </div>\n  <div class=\"y-searchtag-expand disable-select-text\"\n    data-bind=\"visible: showMore, click: handleMoreClick\">\n    <span data-bind=\"text: operation\">展开</span> <i class=\"fa fa-angle-down\" data-bind=\"css: {'y-searchtag-expanded': expandMore}\"></i>\n  <div>\n</div>\n";

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(476);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

__webpack_require__(65);

var _keycode = __webpack_require__(152);

var _keycode2 = _interopRequireDefault(_keycode);

var _option = __webpack_require__(477);

var _option2 = _interopRequireDefault(_option);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _jquery = __webpack_require__(32);

var _jquery2 = _interopRequireDefault(_jquery);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _mixin = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @author: songhlc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @date: 2017-10-23
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @description: 下拉组件
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * */


var PREFIX = 'y-';
_knockout2.default.components.register(PREFIX + _option2.default.name, {
  viewModel: _option2.default.init,
  template: _option2.default.template
});

var Select = function (_Base) {
  _inherits(Select, _Base);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).apply(this, arguments));
  }

  _createClass(Select, [{
    key: 'initialize',
    value: function initialize(params) {
      var _this2 = this;

      // 单选绑定value
      this.value = params.value || _knockout2.default.observable();
      this.size = params.size || 'middle';
      // 多选选中值绑定multiValue
      this.multiValue = params.multiValue || _knockout2.default.observableArray();
      // 格式换要求 通常要求传入的格式是 {label:'xx',value:'xx'} 但实际用户的数据格式未知，
      // 所以可以自定义传入labelkey 和valuekey
      this.labelkey = params.labelkey || 'label';
      this.valuekey = params.valuekey || 'value';
      this.dropWidth = params.dropWidth;
      // 自定义文字
      this.resettext = params.resettext || _knockout2.default.observable('');
      // 是否支持清空
      this.clearable = params.clearable || false;
      // 是否支持查询
      this.filterable = _knockout2.default.observable(params.filterable || false);
      // 自定义icon图标
      this.icon = params.icon ? 'y-select-arrow fa y-select-hasmore ' + params.icon : 'y-select-arrow fa y-select-hasmore fa-list';
      // 是否支持多选
      this.multiple = params.multiple || false;
      // 是否有更多按钮（一般用于各种参照）
      this.hasmore = params.hasmore || false;
      this.resetable = params.resetable || false;
      // 设置placeholder提示
      this.placeholder = params.placeholder || (0, _i18n2.default)('请选择');
      this.i18nNoData = (0, _i18n2.default)('暂无匹配数据');
      // 选中的文本
      this.selectedLabel = params.label || _knockout2.default.observable();
      this.selectedLabel.subscribe(function (val) {
        // select 在单选+filterable的情况下 通过代码设置无法选中 被查询输入框挡住了
        if (_this2.filterable() && !_this2.multiple) {
          _this2.key(val);
        }
      });
      this.selectedValue = params.id || _knockout2.default.observable();
      this.fieldid = params.fieldid || '';
      if (!params.fieldid && this.selectedValue._fieldid) {
        this.fieldid = this.selectedValue._fieldid;
      }
      if (this.fieldid) {
        this.fieldid = this.fieldid;
      }
      // 最终用于显示的过滤完的数据
      this.filterDataList = params.filterDataList || _knockout2.default.observableArray();
      // 用于判断是否显示下拉
      this.showDropdown = _knockout2.default.observable(false);
      // 用于支持键盘上下事件 当前选中内容的索引
      this.curIndex = _knockout2.default.observable(-1);
      // dropdown 滚动条的高度
      this.scrollTop = _knockout2.default.observable(0);
      // filter查询值 查询的时候有选中值
      this.key = _knockout2.default.observable(this.value() ? this.value()[this.labelkey] : '');
      // 当前选中值（单选）
      this.curValue = _knockout2.default.observable();
      // 是否已经设置过默认值防止重复调用（
      this.hasSetDefault = false;
      this.stopLockScroll = params.stopLockScroll || false;
      // 是否禁用下拉框，在级联和行可编辑场景均可用到
      this.disabled = params.disabled || _knockout2.default.observable(false);
      // 用于判断是否要重新查询
      this.oldSearchKey = undefined;
      this.isStopTransferDom = params.isStopTransferDom || false;
      this.topAdjust = params.topAdjust;
      this.hasMultiMore = _knockout2.default.observable(-1);
    }
  }, {
    key: 'computed',
    value: function computed(params) {
      var _this3 = this;

      // 显示暂无数据
      this.isNoData = _knockout2.default.computed(function () {
        // 没有数据且包含查询条件 且是可搜索的下拉
        return _this3.filterable() && _this3.key() && _this3.filterDataList().length === 0;
      });
      // 用于判断是否显示关闭按钮
      this.showCloseIcon = _knockout2.default.computed(function () {
        // 支持清空按钮 + 已有选中值
        return _this3.clearable && (_this3.selectedLabel() || _this3.multiValue().length > 0);
      });
      // 是否显示placeholder
      this.showPlaceholder = _knockout2.default.computed(function () {
        if (_this3.multiple) {
          return _this3.multiValue().length === 0;
        } else {
          return !_this3.selectedLabel();
        }
      });
      this.multititle = _knockout2.default.computed(function () {
        return _this3.multiValue().map(function (item) {
          return item[_this3.labelkey];
        }).toString();
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      var _this4 = this;

      // 监听单选值改变
      this.value.subscribe(function (item) {
        _this4.selectedLabel(item[_this4.labelkey]);
        _this4.selectedValue(item[_this4.valuekey]);
        _this4.curValue(item[_this4.valuekey]);
        _this4.key(item[_this4.labelkey]);
        // 另一种场景value 单选默认值设置 vm.value({label:'x',id:'x'})
        if (!_this4.hasSetDefault) {
          setDefaultValue.apply(_this4);
        }
      });
      // 如果只绑定了id则需要监听（没有绑定value属性）fix
      if (!params.value) {
        this.selectedValue.subscribe(function (selectedId) {
          setDefaultValue.apply(_this4);
        });
      }
      // 多选数据改变
      this.multiValue.subscribe(function (val) {
        // 另一种场景value 多选默认值设置 vm.value({label:'x',id:'x'})
        if (!_this4.hasSetDefault) {
          setDefaultValue.apply(_this4);
        }
        var ctnWidth = _this4.$el.querySelector('.y-select-tag-ctn').offsetWidth;
        var width = 0;
        var i;
        for (i = 0; i < val.length; i++) {
          if (width <= ctnWidth) {
            var length = (val[i][_this4.labelkey] || 0).length * 12 + 40;
            width += length > 200 ? 200 : length;
          } else {
            break;
          }
        }
        if (width > ctnWidth) {
          i--;
        }
        _this4.hasMultiMore(i === val.length ? -1 : i);
      });
      // 下拉展开的时候才接受键盘的上下事件
      this.isKeyDownEffect = false;
      // 是否显示下拉
      this.showDropdown.subscribe(function (val) {
        if (!_this4.stopLockScroll) {
          if (val) {
            _this4.isKeyDownEffect = true;
          } else {
            _this4.isKeyDownEffect = false;
          }
        }
      });
      // 数据改变时需要重新设置默认值
      this.filterDataList.subscribe(function (val) {
        setDefaultValue.apply(_this4);
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this5 = this;

      _mixin.gridRefMixin.call(this, params);
      this.setFocus = function () {
        _this5.$el.querySelector('.y-input').click();
        _this5.$el.querySelector('.y-input').focus();
      };
      // 点击更多事件
      this.handleMore = function () {
        _this5.showDropdown(false);
        params.onmore && params.onmore();
      };
      // 点击重置
      this.handlerReset = function () {
        params.onreset && params.onreset();
      };
      // 选中数据改变事件 单选多选都会触发给外部回调使用
      this.onChange = params.onChange || function () {};
      // filterable + 键盘上下键的时候需要重新设置滚动高度
      this.resetScrollTop = function (division) {
        _this5.scrollTop(_this5.scrollTop() + division);
      };
      this.handleKeyDown = function (data, event) {
        var e = event || window.event;
        if (_this5.isKeyDownEffect && e) {
          if (e.keyCode === _keycode2.default.ENTER) {
            // 按 enter
            var item = _this5.filterDataList()[_this5.curIndex()];
            if (item) {
              _this5.handleOptClick({
                value: item
              });
            } else {
              if (_this5.filterDataList().length > 0) {
                _this5.handleOptClick({
                  value: _this5.filterDataList()[0]
                });
              }
            }
            // 如果是filterable则需要重新设定curIndex
            if (params.filterable) {
              _this5.curIndex(-1);
            }
          } else if (e.keyCode === _keycode2.default.DOWN) {
            // 按 arrow down
            if (_this5.curIndex() < _this5.filterDataList().length - 1) {
              _this5.curIndex(_this5.curIndex() + 1);
            }
            // 每7个重新计算一次
            if (_this5.curIndex() > 0 && _this5.curIndex() % 6 === 0) {
              _this5.resetScrollTop(200);
            }
          } else if (e.keyCode === _keycode2.default.UP) {
            // 按 arrow up
            if (_this5.curIndex() > 0) {
              _this5.curIndex(_this5.curIndex() - 1);
            }
            // 每7个重新计算一次
            if (_this5.curIndex() > 0 && _this5.curIndex() % 6 === 0) {
              _this5.resetScrollTop(-200);
            }
          } else if (e.keyCode === _keycode2.default.BACKSPACE) {
            // 删除
            _this5.showDropdown(true);
            return true;
          } else {
            return true;
          }
          e.stopPropagation();
          return false;
        }
        return true;
      };
      // 点击显示下拉
      this.handleShowDrop = function () {
        if (_this5.disabled()) {
          return false;
        } else {
          _this5.showDropdown(true);
        }
      };
      // 鼠标移入的时候如果是从后端获取数据，则直接开始查询
      // 需要先判断key是否改变 改变了才重新查询否则每次进来都查询效率低
      this.handleFocus = function () {
        if (_this5.oldSearchKey !== _this5.key()) {
          _this5.oldSearchKey = _this5.key();
          params.loadData && params.loadData(_this5.key(), function (remoteData) {
            _this5.filterDataList(remoteData);
          });
          _this5.handleShowDrop(true);
        }
      };
      // 点击外部收起下拉
      this.clickoutside = function (e) {
        // 多选的时候 点击option不收起 下拉
        if ((0, _jquery2.default)(e.target).parents('.y-option-ctn').length > 0 && this.multiple) {
          return;
        }
        this.showDropdown(false);
        if (params.value) {
          if (this.value() && this.value()[this.labelkey]) {
            this.key(this.value()[this.labelkey]);
          } else {
            this.key('');
          }
        } else {
          if (this.selectedLabel()) {
            this.key(this.selectedLabel());
          } else {
            this.key('');
          }
        }
      }.bind(this);
      // 选中事件
      this.handleOptClick = function (item) {
        var _this6 = this;

        // enter事件无值情况
        if (item) {
          if (!this.multiple) {
            // 如果没有定义params.value 则要给selectedValue赋值
            if (params.value) {
              this.value(item.value);
            } else {
              this.selectedValue(item.value[this.valuekey]);
              this.selectedLabel(item.value[this.labelkey]);
            }
            this.key(item.value[this.labelkey]);
            this.showDropdown(false);
            this.onChange(item.value);
          } else {
            var sourceList = this.multiValue().map(function (v) {
              return v[_this6.valuekey];
            });
            var itemKey = item.value[this.valuekey];
            var index = sourceList.indexOf(itemKey);
            if (index >= 0) {
              this.multiValue.splice(index, 1);
            } else {
              this.multiValue.push(item.value);
            }
            this.onChange(this.multiValue());
          }
        } else {
          return false;
        }
      }.bind(this);
      // 在中文输入法期间不触发查询
      var isStartQuery = true;
      params.filterable && this.key.subscribe(function (val) {
        if (isStartQuery) {
          _this5.startFilter(val);
        }
      });
      // 键盘输入法事件开始 如果在用中文输入法，则输入法期间的文字不触发查询
      this.handleCompositionStart = function (data, event) {
        isStartQuery = false;
      };
      // 键盘输入法事件结束
      this.handleCompositionEnd = function (data, event) {
        isStartQuery = true;
        _this5.startFilter(_this5.key());
      };
      // 查询数据过滤客户端+远程
      this.startFilter = function (key) {
        var _this7 = this;

        if (params.loadData) {
          // 从远程查询
          params.loadData(key, function (remoteData) {
            _this7.filterDataList(remoteData);
          });
        } else {
          var result = [];
          if (key !== '') {
            if (params.dataList.subscribe) {
              result = params.dataList().filter(function (item) {
                return item[_this7.labelkey].indexOf(key) >= 0;
              });
            } else {
              result = params.dataList.filter(function (item) {
                return item[_this7.labelkey].indexOf(key) >= 0;
              });
            }
            this.filterDataList(result);
          } else {
            this.filterDataList(params.dataList.subscribe ? params.dataList() : params.dataList);
          }
        }
      };
      // 点击清空按钮
      this.handlerClear = function () {
        _this5.value({});
        _this5.multiValue([]);
        _this5.key('');
        if (_this5.multiple) {
          _this5.onChange([]);
        } else {
          _this5.onChange({});
        }
      };
      // 点击清空已选择的
      this.handleDeleteSelected = function (item) {
        var index = _this5.multiValue.indexOf(item.item);
        _this5.multiValue.splice(index, 1);
        _this5.onChange(_this5.multiValue());
      };
    }
  }, {
    key: 'created',
    value: function created(params) {
      var _this8 = this;

      // 初始化的时候把dataList值传入filterDataList中 并添加监听
      if (params.dataList && params.dataList.subscribe) {
        this.filterDataList(params.dataList());
        params.dataList.subscribe(function (val) {
          _this8.filterDataList(val);
        });
      } else {
        this.filterDataList(params.dataList || []);
      }
      // 两种场景 如果传入的value是ko.observable({label: '男',value: 1})这种，就要一开始就设置默认值
      // 另一种场景在value 监听改变事件里设置
      setDefaultValue.apply(this);
    }
  }]);

  return Select;
}(_base2.default);
// 思路 根据filterDataList里的值重写label 重新setValue里的值


function setDefaultValue() {
  var _this9 = this;

  // 设置默认值 通常用于修改页面 todo 需要重构 还要支持value值异步设置
  // 多选
  if (this.multiple) {
    // 有值才查询
    if (this.multiValue().length > 0 && this.filterDataList().length > 0) {
      // 如果存在old值（old值可能内容比查询出列表里的值少，比如除了value,label还有一些其他的字段）
      // 则需要进行过滤后重新赋值
      // 这里考虑到filterDataList可能是通过loadData服务端动态筛选查询出来的（有些值已选中但不在当前lodaData返回的列表里）
      // 所以需要进行过滤筛选，重新对multiValue赋值
      var _defaultItem = this.multiValue().map(function (item) {
        var _list = _this9.filterDataList().filter(function (data) {
          return item[_this9.valuekey] === data[_this9.valuekey];
        });
        // 如果filterDataList（下拉列表中存在）则用下拉的值代替，如果不存在则返回当前值
        if (_list.length > 0) {
          return _list[0];
        } else {
          return item;
        }
      });
      if (_defaultItem.length > 0) {
        this.hasSetDefault = true;
        this.multiValue(_defaultItem);
      }
    }
  } else {
    // 单选
    if (this.value() && this.value()[this.valuekey] && this.filterDataList().length > 0) {
      var defaultItem = this.filterDataList().filter(function (item) {
        if (_this9.value()) {
          return item[_this9.valuekey] === _this9.value()[_this9.valuekey];
        } else {
          return false;
        }
      });
      if (defaultItem.length > 0) {
        this.hasSetDefault = true;
        this.selectedLabel(defaultItem[0][this.labelkey]);
      }
    } else if (this.selectedValue() !== undefined && this.selectedValue() !== null) {
      // 单选时有可能是只绑定了id属性，同样需要 fix error #86
      var __defaultItem = this.filterDataList().filter(function (item) {
        if (_this9.selectedValue() !== undefined && _this9.selectedValue() !== null) {
          // 要支持值为0的情况
          return item[_this9.valuekey] === _this9.selectedValue();
        } else {
          return false;
        }
      });
      if (__defaultItem.length > 0) {
        this.selectedLabel(__defaultItem[0][this.labelkey]);
      }
    }
  }
}
exports.default = {
  name: 'select',
  init: _base2.default.createViewModel(Select),
  template: _index2.default
};

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-inline-block y-relative y-width-100\" data-bind=\"clickoutside:clickoutside,css:{selected:showDropdown, 'y-select-sm': size === 'sm'}\">\n  <div class=\"y-select-ctn y-input\" data-bind=\"event:{keydown: handleKeyDown},click:handleShowDrop, css:{'y-select-disabled':disabled}, attr:{disabled:disabled, tabindex: tabindex}\">\n    <div style=\"overflow: hidden;\" class=\"y-select-tag-ctn\" data-bind=\"attr:{title:multititle}\">\n      <span data-bind=\"foreach:{data: multiValue, as: 'tag'}\">\n        <!--ko if: $parent.hasMultiMore() === -1  || $index() < $parent.hasMultiMore() || $index() == 0-->\n        <y-tag params=\"item: tag,text: tag[$parent.labelkey],closeable:true,handleClose:$parent.handleDeleteSelected\"></y-tag>\n        <!--/ko-->\n      </span>\n      <!-- ko if: hasMultiMore() !== -1 && multiValue().length > 1-->\n      <div class=\"y-tag\" style=\"display: inline-block;\n      padding: 0 5px;\n      line-height: 18px;\n      font-weight: bold;\">...</div>\n      <!--/ko-->\n    </div>\n    <div class=\"y-select-single\" data-bind=\"visible:!multiple&&selectedLabel() && !filterable(), text:selectedLabel\"></div>\n    <div class=\"y-select-placeholder\" data-bind=\"text:placeholder,visible:showPlaceholder() && !filterable()\"></div>\n    <input class=\"y-select-filter\" type=\"text\" data-bind=\"event:{focus:handleFocus, compositionend: handleCompositionEnd,compositionstart:handleCompositionStart},textInput:key,visible:filterable,attr:{fieldid: fieldid + '|input',placeholder:placeholder}\">\n    <i class=\"y-select-arrow fa fa-close\" data-bind=\"visible:clearable,css:{'y-select-showclose':showCloseIcon(),'y-select-important':hasmore}, click:handlerClear, clickBubble: false\"></i>\n    <i class=\"y-select-arrow\" data-bind=\"text: resettext,visible:resetable,css:{'y-select-showclose': true,'y-select-important': true}, click: handlerReset, clickBubble: false\" style=\"color: #2db7f5;right: 44px;\"></i>\n    <i class=\"y-select-arrow fa fa-angle-down\" data-bind=\"css: {'y-select-showdrop':clearable && showCloseIcon()}, visible:!hasmore\"></i>\n    <i data-bind=\"visible: hasmore,click:function(data, event){handleMore(data, event);return false;}, clickBubble: false, attr:{fieldid: fieldid + '_icon',class: icon}\"></i>\n  </div>\n  <div data-bind=\"let: {fieldid: fieldid, isNoData:isNoData,curIndex:curIndex,curValue:curValue,valuekey:valuekey,labelkey:labelkey,handleOptClick:handleOptClick,multiValue:multiValue}\">\n    <y-dropdown params=\"topAdjust: topAdjust,width:dropWidth,targetEl:$el, isShow:showDropdown,scrollTop:scrollTop,isStopTransferDom:isStopTransferDom\">\n      <div class=\"y-option-ctn\" data-bind=\"foreach:{data: $parent.filterDataList, as: 'item'}\">\n        <y-option params=\"fieldid: fieldid, style: item.style, value: item,valuekey:valuekey, label:labelkey,itemClick:handleOptClick,index:$index, curIndex:curIndex, curValue:curValue, curMultiValue:multiValue\"></y-option>\n      </div>\n      <div class=\"y-select-nodata\" data-bind=\"visible: isNoData, text: $parent.i18nNoData\"></div>\n    </y-dropdown>\n  </div>\n</div>\n";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _option = __webpack_require__(478);

var _option2 = _interopRequireDefault(_option);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  this.value = params.value;
  this.label = params.label || 'label';
  this.curIndex = params.curIndex;
  this.index = params.index;
  this.fieldid = params.fieldid ? params.fieldid + '_option_' + this.index() : '';
  this.style = params.style || {};
  this.valuekey = params.valuekey || 'value';
  this.labelsecond = params.labelsecond || '';
  this.itemClick = function (item, evt) {
    params.itemClick(item, evt);
  };
  this.active = _knockout2.default.observable();
  this.multiActive = _knockout2.default.observable();
  this.curValue = params.curValue;
  this.curValue.subscribe(function (item) {
    _this.active(item === _this.value[_this.valuekey]);
  });
  // 用valuekey判断 不能用整个item判断
  this.multiActive = _knockout2.default.computed(function () {
    var keys = params.curMultiValue().map(function (item) {
      return item[_this.valuekey];
    });
    return keys.indexOf(_this.value[_this.valuekey]) >= 0;
  });
}
exports.default = {
  name: 'option',
  init: init,
  template: _option2.default
};

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "<div data-bind=\"click: itemClick, style: style, css:{'y-selected-item':active,'y-selected-multiItem':multiActive, 'y-select-hover':index() == curIndex()},\n  attr: {fieldid: fieldid}\n\" class=\"y-option\" >\n  <span data-bind=\"text:value[label],attr:{title:value[label]}\"></span>\n  <i data-bind=\"visible:multiActive\" class=\"fa fa-check pull-right\"></i>\n</div>\n";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index2 = __webpack_require__(480);

var _index3 = _interopRequireDefault(_index2);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var StateTab = function (_Base) {
  _inherits(StateTab, _Base);

  function StateTab() {
    _classCallCheck(this, StateTab);

    return _possibleConstructorReturn(this, (StateTab.__proto__ || (0, _getPrototypeOf2.default)(StateTab)).apply(this, arguments));
  }

  _createClass(StateTab, [{
    key: 'initialize',
    value: function initialize(params) {
      this.items = params.items;
      this.index = params.index;
      this.style = params.style || {};
      this.hideNum = params.hideNum || false;
      this.type = params.type;
      this.stateActiveStyle = _knockout2.default.observable();
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      var _this2 = this;

      // 索引改变需要重新计算active样式
      this.index.subscribe(function (val) {
        _this2.computedStyle();
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this3 = this;

      this.handler = function (msg, _index) {
        _this3.index(_index);
        params.handler(msg);
      };
      this.computedStyle = function () {
        var curIndex = _this3.index();
        var el = params.$el;
        var tabList = el.querySelectorAll('.y-state-tab');
        var style = {};
        var contentWidth = 0;
        var transformLeft = 0;
        if (curIndex >= 0 && curIndex < tabList.length) {
          var curNode = tabList[curIndex];
          transformLeft = curNode.offsetLeft;
          contentWidth = curNode.offsetWidth;
        }
        if (params.type === 'line') {
          transformLeft += 24;
          contentWidth = 9;
        }
        style.transform = 'translateX(' + transformLeft + 'px) translateZ(0px)';
        style.width = contentWidth + 'px';
        _this3.stateActiveStyle(style);
      };
    }
  }, {
    key: 'created',
    value: function created(params) {
      var _this4 = this;

      // 渲染完先重新计算一遍
      setTimeout(function () {
        _this4.computedStyle();
      });
    }
  }]);

  return StateTab;
}(_base2.default);

exports.default = {
  name: 'state-tabs',
  init: _base2.default.createViewModel(StateTab),
  template: _index3.default
};

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-relative\">\n  <!-- ko if: type -->\n  <!-- ko if: type == 'card' -->\n  <div class=\"y-state-tabs cards\" data-bind=\"foreach:{data: items, as:'item'}, style:style\">\n    <div class=\"y-state-tab card-margin\" data-bind=\"click:function(){$parent.handler($data,$index())},css:$parent.index()==$index()?'activeCard':''\">\n      <label data-bind=\"text: item.title\" style=\"margin: 5px 0;\"></label>\n      <span data-bind=\"visible: !$parent.hideNum, text: '('+item.num+')'\"></span>\n    </div>\n  </div>\n  <!-- /ko -->\n  <!-- ko if: type == 'line' -->\n  <div class=\"y-state-line-active\" data-bind=\"style: stateActiveStyle\"></div>\n  <div class=\"y-state-tabs line-bot\" data-bind=\"foreach:{data: items, as:'item'}, style:style\">\n    <div class=\"y-state-tab line-margin\" data-bind=\"click:function(){$parent.handler($data,$index())},css:$parent.index()==$index()?'activeLine':''\">\n      <label data-bind=\"text: item.title\"></label>\n      <span data-bind=\"visible: !$parent.hideNum, text: '('+item.num+')'\"></span>\n    </div>\n  </div>\n  <!-- /ko -->\n  <!-- /ko -->\n  <!-- ko ifnot: type -->\n  <div class=\"y-state-active\" data-bind=\"style: stateActiveStyle\"></div>\n  <div class=\"y-state-tabs\" data-bind=\"foreach:{data: items, as:'item'}, style:style\">\n    <div class=\"y-state-tab\" data-bind=\"click:function(){$parent.handler($data,$index())},css:$parent.index()==$index()?'active':''\">\n      <label data-bind=\"text: item.title\"></label>\n      <span data-bind=\"visible: !$parent.hideNum, text: '('+item.num+')'\"></span>\n    </div>\n  </div>\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(482);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(params) {
  var _this = this;

  this.item = params.item;
  this.text = params.text;
  this.closeable = params.closeable || false;
  this.type = params.type || 'default';
  this.fill = params.fill || false;
  var color = params.color || '';
  this.style = {
    color: color,
    borderColor: '',
    backgroundColor: ''
  };
  if (color) {
    if (this.fill) {
      // 场景的话 基本要么是填充 要么是border
      // 留着border 要不还设置其他样式
      this.style.color = '#FFF';
      this.style.borderColor = color;
      this.style.backgroundColor = color;
    } else {
      this.style.borderColor = color;
      this.style.backgroundColor = '#FFF';
    }
  }
  this.active = params.active || _knockout2.default.observable(false);
  this.typeClass = _knockout2.default.computed(function () {
    return 'y-tag-' + _this.type + ' ' + (_this.active() ? 'y-tag-active' : '');
  });
  this.handleClose = params.handleClose;
  this.handleClick = function () {
    if (_this.type === 'blank' && params.enableActive) {
      _this.active(!_this.active());
    }
    params.handleClick && params.handleClick(_this.item, _this.active());
  };
}
exports.default = {
  name: 'tag',
  init: init,
  template: _index2.default
};

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-tag\" data-bind=\"css:typeClass,style:style\">\n  <span class=\"y-tag-text\" data-bind=\"text:text,click:handleClick,style:{color: style.color}\"></span>\n  <i data-bind=\"visible:closeable,click:handleClose,style:{color: style.color}\" class=\"y-tag-close\">+</i>\n</div>\n";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(484);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _treenode = __webpack_require__(485);

var _treenode2 = _interopRequireDefault(_treenode);

var _mixin = __webpack_require__(23);

var _common = __webpack_require__(67);

var _common2 = _interopRequireDefault(_common);

var _lodash = __webpack_require__(53);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIX = 'y-';
_knockout2.default.components.register(PREFIX + _treenode2.default.name, {
  viewModel: _treenode2.default.init,
  template: _treenode2.default.template
});
function init(params) {
  var _this = this;

  _mixin.validatemixin.call(this, params);
  this.data = params.data;
  this.height = params.height || 'auto';
  this.hideNodeCheckStyle = params.hideNodeCheckStyle || false;
  debugger;
  this.minHeight = params.minHeight || '0';
  this.loadData = params.loadData;
  this.nameField = params.nameField;
  this.extraEdit = params.extraEdit;
  this.extraText = params.extraText;
  this.multiple = params.multiple || false;
  this.selectedItem = params.selectedItem || (this.multiple ? _knockout2.default.observableArray() : _knockout2.default.observable({}));
  this.keyWord = _knockout2.default.observable();
  this.searchAble = params.searchAble ? params.searchAble : _knockout2.default.observable(false);
  if (!this.multiple) {
    if (_knockout2.default.isObservableArray(this.selectedItem)) {
      throw new Error('y-tree: selectedItem should be ko.observableArray while multiple = true');
    }
  }
  this.nodeOption = params.nodeOption || {
    showCheck: '', // 用来判断是否显示check节点的函数
    nodeIcon: '' // 用来动态显示Icon的函数
  };
  this.selectedId = params.selectedId || (this.multiple ? _knockout2.default.observableArray() : _knockout2.default.observable());
  this.selectedItem.subscribe(function (val) {
    if (params.onChange) {
      params.onChange(val);
    }
    // validate校验 用于通知父容器校验信息
    _this.judgeValidate(val.id);
  });

  // 树 -> 数组
  this.treeConvertToArr = function (tree) {
    var a = _lodash2.default.cloneDeep(tree); // 深拷贝一下
    var arrs = [];
    var result = [];
    arrs = arrs.concat(a);
    while (arrs.length) {
      var first = arrs.shift(); // 弹出第一个
      if (first.children) {
        arrs = arrs.concat(first.children);
        delete first["children"];
      }
      result.push(first);
    }
    return result;
  };

  this.onEnterClick = function (data, event) {
    var e = event || window.event;
    var flatData = _this.treeConvertToArr(_this.data());
    if (e.keyCode === 13) {
      var key = _this.keyWord(); // 搜索框值
      if (!_this.keyWord()) {
        return _common2.default.toastr().error("请输入分类关键词"); // 有问题，暂时放着
      }
      var result = [];
      flatData.forEach(function (item) {
        if (item.name.indexOf(key.trim()) !== -1) {
          // 检索到，取其id
          result.push(item.id);
        }
      });
      _this.getSearchResult(result);
    }
  };

  this.getSearchResult = function (data) {
    var result = [];
    var flatData = _this.treeConvertToArr(_this.data());
    var newData = _lodash2.default.cloneDeep(flatData);
    var newTreeData = _lodash2.default.cloneDeep(_this.data()); // this.data() -> 初始的树
    for (var i = 0; i < data.length; i++) {
      result = result.concat(_this.getParentTreeNode(newTreeData, data[i]));
    }
    result = result.map(function (item) {
      return item.id;
    });
    newData.forEach(function (node) {
      if (result.indexOf(node.id) >= 0) {
        node._expand(true);
      } else {
        node._expand(false);
      }
    });
  };
  this.getParentTreeNode = function (data2, nodeId2) {
    var arrRes = [];
    if (data2.length === 0) {
      if (nodeId2) {
        // 检索的内容有值
        arrRes.unshift(data2);
      }
      return arrRes;
    }
    var recursion = function recursion(data, nodeId) {
      // 递归根据子节点反查父节点
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        if (node.id === nodeId) {
          arrRes.unshift(node);
          recursion(data2, node.parentId);
          break;
        } else {
          if (node.children) {
            recursion(node.children, nodeId);
          }
        }
      }
      return arrRes;
    };
    arrRes = recursion(data2, nodeId2);
    return arrRes;
  };
}
exports.default = {
  name: 'tree',
  init: init,
  template: _index2.default
};

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "<div data-bind=\"visible: searchAble\" style=\"height: 30px\">\n  <input class=\"pull-left\" style=\"height: 30px;width: 200px;\" data-bind=\"value:keyWord,event:{keyup:onEnterClick},attr:{placeholder:'请输入检索名称'}\">\n</div>\n<div class=\"y-tree\" data-bind=\"\n  style: {height: height, minHeight: minHeight},\n  let: {selectedId: selectedId, multiple: multiple}\">\n  <ul data-bind=\"foreach: {data: data, as: 'item'}\">\n    <y-treenode params=\"\n      extraText: $parent.extraText,\n      extraEdit: $parent.extraEdit,\n      selectedId: selectedId,\n      multiple: multiple,\n      data: item,\n      nameField: $parent.nameField,\n      loadData: $parent.loadData,\n      nodeOption: $parent.nodeOption,\n      hideNodeCheckStyle: $parent.hideNodeCheckStyle,\n      selectedItem: $parent.selectedItem\">\n    </y-treenode>\n  </ul>\n</div>\n";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _treenode = __webpack_require__(486);

var _treenode2 = _interopRequireDefault(_treenode);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _lodash = __webpack_require__(53);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init(params) {
  var _this = this;

  this.multiple = params.multiple;
  var data = params.data;
  data._checked = _knockout2.default.isObservable(data._checked) ? data._checked : _knockout2.default.observable(!!data._checked);
  data._expand = _knockout2.default.isObservable(data._expand) ? data._expand : _knockout2.default.observable(!!data._expand);
  data._disabled = _knockout2.default.isObservable(data._disabled) ? data._disabled : _knockout2.default.observable(!!data._disabled);
  this.data = _knockout2.default.observable(data);
  this.nameField = params.nameField && params.nameField !== '' ? params.nameField : 'name';
  this.extraEdit = params.extraEdit;
  this.extraText = params.extraText;
  this.loadData = params.loadData;
  this.selectedItem = params.selectedItem;
  this.loaded = _knockout2.default.observable(params.loadData === undefined || data._expand.peek());
  this.isLoading = _knockout2.default.observable(false);
  this.nodeOption = params.nodeOption || {};
  this.showCheck = function (vm) {
    if (this.nodeOption.showCheck) {
      return this.nodeOption.showCheck(vm);
    } else {
      return true;
    }
  }.bind(this);
  this.showIcon = this.nodeOption.nodeIcon;
  this.isShowExpanIcon = _knockout2.default.computed(function () {
    // 如果children有值休闲室
    if (_this.data().children && _this.data().children.length > 0) {
      return true;
    } else if (_this.isLoading()) {
      // 如果正在加载 那么也要隐藏
      return false;
    } else {
      // 需要异步加载切还没有点击过加载，也需要显示
      if (_this.loadData && !_this.loaded()) {
        return true;
      } else {
        return false;
      }
    }
  });
  this.findItemIndex = function (data) {
    return _lodash2.default.findIndex(_this.selectedItem.peek(), ['id', data.id]);
  };
  this.selectItem = function (data) {
    _lodash2.default.findIndex(_this.selectedItem(), ['id', data.id]) < 0 && _this.selectedItem.push(data);
  };
  this.hideNodeCheckStyle = params.hideNodeCheckStyle;
  if (this.hideNodeCheckStyle) {
    this.isNodeSelected = false;
  } else {
    this.isNodeSelected = _knockout2.default.computed(function () {
      if (_this.multiple) {
        return _this.selectedItem() && _this.findItemIndex(_this.data()) > -1;
      } else {
        return _this.selectedItem() && _this.selectedItem().id === _this.data().id;
      }
    });
  }
  this.expanded = data._expand || _knockout2.default.observable(false);
  this.selectedId = params.selectedId;

  // 列表+refer的场景，会动态改变所选择的selectedId的值，则需要改变对应的节点的勾选
  // 只有多选场景下才有
  if (this.multiple) {
    this.selectedId.subscribe(function (val) {
      var id = data.id;
      if (val.indexOf(id) >= 0) {
        data._checked(true);
        _this.selectItem(data);
      } else {
        data._checked(false);
      }
    });
  }
  // 多选场景下需要默认选中
  if (_knockout2.default.isObservableArray(this.selectedId)) {
    if (this.selectedId().indexOf(data.id) > -1) {
      data._checked(true);
      // 添加到已选中的项之中
      this.selectItem(data);
    }
  }
  data._checked.subscribe(function (val) {
    _this.handleClickNode(_this, null, true);
  });
};
// 展开子节点
init.prototype.handleExpand = function (data, event) {
  if (this.loaded()) {
    this.expanded(!this.expanded());
  } else {
    this.isLoading(true);
    this.loadData(data.data(), function (childrenData) {
      var _this2 = this;

      this.isLoading(false);
      var _data = this.data();
      // 设置默认勾选
      if (this.multiple) {
        childrenData && childrenData.forEach(function (child) {
          // 如果选中的id存在则勾选
          if (_this2.selectedId().indexOf(child.id) > -1) {
            child._checked = _knockout2.default.observable(true);
            _this2.selectItem(child);
            // this.selectedItem.indexOf(data) < 0 && this.selectedItem.push(child)
          }
        });
      }
      if (childrenData && childrenData.length > 0) {
        _data.children = childrenData;
      }
      this.data(_data);
      this.expanded(!this.expanded());
      this.loaded(true);
    }.bind(this));
  }
};
// 选中子节点 将选中值赋值给选中的
init.prototype.handleClickNode = function (data, event, checkFlag) {
  var item = this.data();
  // 直返会当前项不返回子节点
  item.children = [];
  var isShowCheck = this.showCheck(item);
  if (!isShowCheck) {
    return;
  }
  // 表示多选
  if (this.multiple) {
    if (!checkFlag) {
      item._checked(!item._checked());
    }
    var _index = this.findItemIndex(item);
    // 如果选中，加入已选中列表中，如果反宣，将其
    if (item._checked()) {
      if (_index < 0) {
        this.selectedItem.push(item);
      }
    } else {
      if (_index >= 0) {
        this.selectedItem.splice(_index, 1);
      }
    }
  } else {
    if (this.selectedItem() && this.selectedItem().id === item.id) {
      this.selectedItem({});
    } else {
      this.selectedItem(item);
    }
  }
};

exports.default = {
  name: 'treenode',
  init: init,
  template: _treenode2.default
};

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-treenode\">\n  <li>\n    <span class=\"y-tree-icon\" data-bind=\"\n        click: handleExpand,\n        css: {'y-tree-icon-expand': expanded}\">\n      <!-- ko if: isShowExpanIcon -->\n      <i class=\"fa fa-plus\" data-bind=\"visible: !expanded() || !loaded()\"></i>\n      <i class=\"fa fa-minus\" data-bind=\"visible: expanded\"></i>\n      <!-- /ko -->\n      <!-- ko if: isLoading -->\n      <i class=\"y-tree-isloading fa fa-spinner\"></i>\n      <!-- /ko -->\n    </span>\n    <!-- ko if: multiple && showCheck(data()) -->\n    <y-checkbox-item params=\"value: '', label: '', checked: data()._checked,disabled:data()._disabled\"></y-checkbox-item>\n    <!-- /ko -->\n    <!-- ko if: showIcon -->\n    <span data-bind=\"css: showIcon(data())\"></span>\n    <!-- /ko -->\n    <span class=\"y-tree-title\" data-bind=\"\n        click: handleClickNode,\n        text: data()[nameField],\n        attr: {title: data()[nameField]},\n        css: {'y-tree-node-selected': isNodeSelected}\"></span>\n    <!-- ko if: extraEdit -->\n    <span class=\"y-tree-extra pull-right\" data-bind=\"\n        text: extraText,\n        click: function() {extraEdit(data())}\"></span>\n    <!-- /ko -->\n  </li>\n  <li>\n    <!-- ko if: data().children && data().children.length > 0 -->\n    <ul data-bind=\"\n        foreach: {data: data().children, as:'item'},\n        css: {'y-tree-icon-expand': expanded}\">\n      <y-treenode params=\"\n          extraText: $parent.extraText,\n          extraEdit: $parent.extraEdit,\n          selectedId: $parent.selectedId,\n          nameField: $parent.nameField,\n          multiple: multiple,\n          data: item,\n          loadData: $parent.loadData,\n          expand: $parent.expand,\n          nodeOption: $parent.nodeOption,\n          hideNodeCheckStyle: $parent.hideNodeCheckStyle,\n          selectedItem: $parent.selectedItem\">\n      </y-treenode>\n    </ul>\n    <!-- /ko -->\n  </li>\n</div>\n";

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(119)))

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(489);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* author: ZJJ
* description: switch 组件
* 参数说明:
* @checkedInside: ko对象 Boolean 类型(组件内控制显示的值)
* @disabled: ko对象 Boolean 类型
* @size: String类型:large, small (大, 小)
* @checkedValue: 自定义选中状态的值
* @unCheckedValue: 自定义非选中状态的值
* @checked: 根据自定义选中值返回相应的值(组件输入和返回的值)
* */
function init(params) {
  var _this = this;

  var PREFIX = 'y-switch-'; // 通用前缀
  var FIELDIDSWITCH = '_switch';
  this.disabled = params.disabled ? params.disabled : _knockout2.default.observable(false);
  this.fieldid = (params.checked ? params.checked.fieldid || params.checked._fieldid || '' : '') + FIELDIDSWITCH;
  this.checkedValue = params.checkedValue ? params.checkedValue : true;
  if (params.unCheckedValue === 0) {
    this.unCheckedValue = 0;
  } else {
    this.unCheckedValue = params.unCheckedValue ? params.unCheckedValue : false;
  }
  this.checked = params.checked || _knockout2.default.observable(false); // 请传入ko对象 Boolean 值
  this.checkedInside = _knockout2.default.observable();
  this.checkedInside.subscribe(function (val) {
    if (val) {
      _this.checked(_this.checkedValue);
    } else {
      _this.checked(_this.unCheckedValue);
    }
  });
  this.checked.subscribe(function (val) {
    if (val === _this.checkedValue) {
      _this.checkedInside(true);
    }
    if (val === _this.unCheckedValue) {
      _this.checkedInside(false);
    }
  });
  this.size = params.size ? PREFIX + params.size : ''; // 尺寸  String 类型
  this.sizeClass = _knockout2.default.computed(function () {
    return _this.disabled() ? _this.checkedInside() ? _this.size + ' ' + PREFIX + 'checked ' + PREFIX + 'disabled' : _this.size + ' ' + PREFIX + 'disabled' : _this.checkedInside() ? _this.size + ' ' + PREFIX + 'checked' : _this.size + ' ' + PREFIX;
  }, this);
  // 初始化checked的返回值
  if (this.checked() === this.checkedValue) {
    this.checkedInside(true);
  } else {
    this.checkedInside(false);
  }
}
// 点击开关
init.prototype.checkSelect = function () {
  if (this.disabled()) {
    return false;
  } else {
    this.checkedInside(!this.checkedInside());
  }
};

exports.default = {
  name: 'switch',
  init: init,
  template: _index2.default
};

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inline-block\">\n  <span class=\"y-switch\" data-bind = \"css:sizeClass, click: checkSelect,attr:{fieldid: fieldid}\" >\n    <input type=\"hidden\" value=\"false\">\n    <span class=\"y-switch-inner\">\n          <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n    </span>\n  </span>\n</div>\n";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(491);

var _index2 = _interopRequireDefault(_index);

var _tooltipctn = __webpack_require__(492);

var _tooltipctn2 = _interopRequireDefault(_tooltipctn);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var PREFIX = 'y-';
_knockout2.default.components.register(PREFIX + _tooltipctn2.default.name, {
  viewModel: _tooltipctn2.default.init,
  template: _tooltipctn2.default.template
});

var Tooltip = function (_Base) {
  _inherits(Tooltip, _Base);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _possibleConstructorReturn(this, (Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).apply(this, arguments));
  }

  _createClass(Tooltip, [{
    key: 'initialize',
    value: function initialize(params) {
      this.title = params.title;
      this.class = params.class;
      this.isShow = _knockout2.default.observable(false);
      this.position = params.position || 'top';
      this.question = params.question || false;
      this.height = params.height;
      this.fixHeight = params.fixHeight;
    }
  }, {
    key: 'computed',
    value: function computed() {
      var _this2 = this;

      // 是否使用自己内部的tooltipctn
      this.isSelfCustom = _knockout2.default.computed(function () {
        return true;
      });
      this.hasMarkup = _knockout2.default.computed(function () {
        if (_this2.$templateNodes.length > 0) {
          var nodeList = _this2.$templateNodes.filter(function (node) {
            return node.nodeName !== '#text' && node.nodeName !== '#comment';
          });
          return nodeList.length > 0;
        } else {
          return false;
        }
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this3 = this;

      this.handleHover = function () {
        _this3.isShow(true);
      };
      this.handleLeave = function () {
        _this3.isShow(false);
      };
    }
  }]);

  return Tooltip;
}(_base2.default);

exports.default = {
  name: 'tooltip',
  init: _base2.default.createViewModel(Tooltip),
  template: _index2.default
};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "<span class=\"y-tooltip\" data-bind=\"event:{mouseenter:handleHover,mouseout: handleLeave}\">\n  <span class=\"fa fa-question-circle y-text-link\" data-bind=\"event:{mouseenter:handleHover},visible: question\"></span>\n  <span data-bind=\"text:title,event:{mouseenter:handleHover}\"></span>\n  <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n  <!-- ko if:!hasMarkup() -->\n  <y-tooltipctn params=\"fixHeight:fixHeight,targetEl:$el,title:title,show:isShow,position:position,height:height\"></y-tooltipctn>\n  <!-- /ko -->\n</span>\n";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(493);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipCtn = function (_Base) {
  _inherits(TooltipCtn, _Base);

  function TooltipCtn() {
    _classCallCheck(this, TooltipCtn);

    return _possibleConstructorReturn(this, (TooltipCtn.__proto__ || (0, _getPrototypeOf2.default)(TooltipCtn)).apply(this, arguments));
  }

  _createClass(TooltipCtn, [{
    key: "initialize",
    value: function initialize(params) {
      this.title = params.title;
      this.show = params.show || _knockout2.default.observable(false);
      this.targetEl = params.targetEl;
      this.left = _knockout2.default.observable(0);
      this.right = _knockout2.default.observable(0);
      this.top = _knockout2.default.observable(0);
      this.position = params.position;
      this.height = params.height || 0;
      this.fixHeight = params.fixHeight || false;
    }
  }, {
    key: "computed",
    value: function computed(params) {
      var _this2 = this;

      this.cssPosition = "y-tooltip-" + this.position;
      this.style = _knockout2.default.computed(function () {
        var style = {};
        if (_this2.left()) {
          style.left = _this2.left();
        }
        if (_this2.right()) {
          style.right = _this2.right();
        }
        style.top = _this2.top();
        style["transform-origin"] = "center bottom 0px";
        return style;
      });
    }
  }, {
    key: "methods",
    value: function methods(params) {
      var _this3 = this;

      this.innerRef = null;
      this.setRef = function (ref) {
        _this3.innerRef = ref;
      };
    }
  }, {
    key: "subscribe",
    value: function subscribe(params) {
      var _this4 = this;

      this.show.subscribe(function (val) {
        // 多选情况比较复杂，暂不支持穿越overflowhidden
        var el = _this4.targetEl.children[0];
        var position = el.getBoundingClientRect();
        var width = params.ctnWidth || el.offsetWidth;
        var height = 0;
        if (_this4.height) {
          height = _this4.height;
        }
        // top topleft topright
        if (_this4.position.indexOf("top") === 0) {
          if (_this4.fixHeight) {
            _this4.top(position.top - height + "px");
          } else {
            _this4.top(position.top - el.offsetHeight * 1.2 - height + "px");
          }
          // top right
          if (_this4.position.indexOf("right") > 0) {
            _this4.left(position.left - width * 3 / 4 + "px");
          } else {
            _this4.left(position.left - 10 + "px");
          }
        } else if (_this4.position.indexOf("bottom") === 0) {
          if (_this4.fixHeight) {
            _this4.top(position.top + height + "px");
          } else {
            _this4.top(position.top + el.offsetHeight * 1 + 5 + "px");
          }
          if (_this4.position.indexOf("right") > 0) {
            _this4.left(position.left - width * 3 / 4 + "px");
          } else {
            // 如果距离最右侧不足200，就多给200的距离
            if (document.body.clientWidth - position.left < 200) {
              _this4.left(position.left - (document.body.clientWidth - position.left) + "px");
            } else {
              _this4.left(position.left - 10 + "px");
            }
          }
        }
        if (!_this4.height) {
          _this4.height = position.height;
        }
      });
    }
  }]);

  return TooltipCtn;
}(_base2.default);

exports.default = {
  name: "tooltipctn",
  init: _base2.default.createViewModel(TooltipCtn),
  template: _index2.default
};

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-tooltip-ctn\" data-bind=\"style:style,visible:show,transferdom,css:cssPosition\">\n  <div class=\"y-tooltip-arrow\">\n  </div>\n  <div class=\"y-tooltip-cover\"></div>\n  <div class=\"y-tooltip-ctn-inner\" data-bind=\"ref:setRef\">\n    <span data-bind=\"text:title\"></span>\n    <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n  </div>\n</div>\n";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _index = __webpack_require__(495);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _scrollable = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

// const FORMAT = 'hh:mm'
// 获取元素距离窗口左侧距离
var getElementLeft = function getElementLeft(element) {
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
};

var DatePicker = function (_Base) {
  _inherits(DatePicker, _Base);

  function DatePicker() {
    _classCallCheck(this, DatePicker);

    return _possibleConstructorReturn(this, (DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).apply(this, arguments));
  }

  _createClass(DatePicker, [{
    key: 'initialize',
    value: function initialize(_ref) {
      var _this2 = this;

      var placeholder = _ref.placeholder,
          position = _ref.position,
          data = _ref.data,
          dropStyle = _ref.dropStyle,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === undefined ? false : _ref$disabled,
          _ref$gridRef = _ref.gridRef,
          gridRef = _ref$gridRef === undefined ? false : _ref$gridRef,
          _ref$hasSeconds = _ref.hasSeconds,
          hasSeconds = _ref$hasSeconds === undefined ? false : _ref$hasSeconds;

      this.dropStyle = dropStyle;
      this.placeholder = placeholder;
      if (position === 'top') {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
      // 默认不包含秒
      this.hasSeconds = hasSeconds;
      this.data = data;
      this.hour = _knockout2.default.observable();
      this.minutes = _knockout2.default.observable();
      this.seconds = _knockout2.default.observable();
      this.alignright = _knockout2.default.observable(false);
      if (!_knockout2.default.isObservable(disabled)) {
        disabled = _knockout2.default.observable(disabled);
      }
      this.disabled = disabled;
      this.isPopup = _knockout2.default.observable(false);
      this.setFocus = function () {
        _this2.$el.querySelector('.y-input').click();
        _this2.$el.querySelector('.y-input').focus();
      };
      this.setUnFoucs = function () {
        _this2.isPopup(false);
      };
    }
  }, {
    key: 'computed',
    value: function computed(params) {
      var _this3 = this;

      this.computedData = _knockout2.default.computed(function () {
        return _this3.data();
      });
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this4 = this;

      this.onMaskHover = function () {
        (0, _scrollable.resetScrollEffect)();
      };
      // 选中输入框
      this.focus = function (data, event) {
        var leftPosition = getElementLeft(event.target);
        // 获取viewport 宽度
        var screenWidth = document.documentElement.clientWidth;
        try {
          // 如果元素距离右侧的距离小于280 则将弹出浮动款左移，设置right：0
          if (screenWidth - leftPosition < 280) {
            _this4.alignright(true);
          } else {
            _this4.alignright(false);
          }
        } catch (e) {
          console.error(e);
        }
        _this4.isPopup(true);
        var getData = _this4.data();
        if (getData && getData.indexOf(':') > 0) {
          var dataArry = getData.split(':');
          _this4.hour(parseInt(dataArry[0]));
          _this4.minutes(parseInt(dataArry[1]));
          if (_this4.hasSeconds) {
            // 可能默认值有问题
            _this4.seconds(parseInt(dataArry[2] || 0));
          }
        } else {
          var d = new Date();
          _this4.hour(d.getHours());
          _this4.minutes(d.getMinutes());
          if (_this4.hasSeconds) {
            _this4.seconds(d.getSeconds());
          }
        }
      };
      this.nexthour = function () {
        var _hour = _this4.hour() + 1;
        if (_hour === 24) {
          _this4.hour(0);
        } else {
          _this4.hour(_hour);
        }
      };
      // 小时选择长按
      var timerTimeout;
      var innerInterval;
      this.nexthourholddown = function () {
        timerTimeout = setTimeout(function () {
          innerInterval = setInterval(function () {
            _this4.nexthour();
          }, 100);
        }, 200);
      };
      this.holdup = function () {
        clearInterval(innerInterval);
        clearTimeout(timerTimeout);
      };
      this.blur = function () {
        clearInterval(innerInterval);
        clearTimeout(timerTimeout);
      };
      // 小时手动输入
      this.blurHour = function (e) {
        var _hour = e.target.value.replace(/\D/g, '');
        if (_hour >= 24 || _hour <= 0) {
          _this4.hour(0);
          e.target.value = '00';
        } else {
          _this4.hour(_hour);
        }
      };
      this.lasthour = function () {
        var _hour = _this4.hour() - 1;
        if (_hour <= 0) {
          _this4.hour(23);
        } else {
          _this4.hour(_hour);
        }
      };
      this.lasthourholddown = function () {
        timerTimeout = setTimeout(function () {
          innerInterval = setInterval(function () {
            _this4.lasthour();
          }, 100);
        }, 200);
      };
      this.nextminutes = function () {
        var _minutes = _this4.minutes() + 1;
        if (_minutes >= 60) {
          _this4.minutes(0);
        } else {
          _this4.minutes(_minutes);
        }
      };
      // 分钟手动输入
      this.blurMinutes = function (e) {
        var _minutes = e.target.value.replace(/\D/g, '');
        if (_minutes >= 60 || _minutes <= 0) {
          _this4.minutes(0);
          e.target.value = '00';
        } else {
          _this4.minutes(_minutes);
        }
      };
      // 分钟选择长按
      this.nextminholddown = function () {
        timerTimeout = setTimeout(function () {
          innerInterval = setInterval(function () {
            _this4.nextminutes();
          }, 50);
        }, 200);
      };
      this.lastminutes = function () {
        var _minutes = _this4.minutes() - 1;
        if (_minutes <= 0) {
          _this4.minutes(59);
        } else {
          _this4.minutes(_minutes);
        }
      };
      // 分钟选择长按
      this.lastminholddown = function () {
        timerTimeout = setTimeout(function () {
          innerInterval = setInterval(function () {
            _this4.lastminutes();
          }, 50);
        }, 200);
      };
      this.nextseconds = function () {
        var _seconds = _this4.seconds() + 1;
        if (_seconds >= 60) {
          _this4.seconds(0);
        } else {
          _this4.seconds(_seconds);
        }
      };
      // 分钟手动输入
      this.blurSeconds = function (e) {
        var _seconds = e.target.value.replace(/\D/g, '');
        if (_seconds >= 60 || _seconds <= 0) {
          _this4.seconds(0);
          e.target.value = '00';
        } else {
          _this4.seconds(_seconds);
        }
      };
      // 秒选择长按
      this.nextsecholddown = function () {
        timerTimeout = setTimeout(function () {
          innerInterval = setInterval(function () {
            _this4.nextseconds();
          }, 50);
        }, 200);
      };
      this.lastseconds = function () {
        var _seconds = _this4.seconds() - 1;
        if (_seconds <= 0) {
          _this4.seconds(59);
        } else {
          _this4.seconds(_seconds);
        }
      };
      // 秒选择长按
      this.lastsecholddown = function () {
        timerTimeout = setTimeout(function () {
          innerInterval = setInterval(function () {
            _this4.lastseconds();
          }, 50);
        }, 200);
      };
      this.onInput = function (e) {
        var val = parseFloat(e.target.value);
        if (!/^[0-9]*[1-9][0-9]*$/.test(val)) {
          e.target.value = '00';
        }
      };
      // 遮罩点击
      this.maskClick = function () {
        _this4.isPopup(false);
      };
      //
      this.confirm = function () {
        _this4.bindModelValue();
        _this4.closeModal();
      };
      this.bindModelValue = function () {
        var hour = _this4.hour();
        var minutes = _this4.minutes();
        var seconds = _this4.seconds();
        if (hour < 10) {
          hour = '0' + Number(hour);
        }
        if (minutes < 10) {
          minutes = '0' + Number(minutes);
        }
        if (seconds < 10) {
          seconds = '0' + Number(seconds);
        }
        var time = hour + ':' + minutes;
        if (_this4.hasSeconds) {
          time += ':' + seconds;
        }
        _this4.data(time);
      };
      this.generateDate = function () {};
      // 关闭弹框
      this.closeModal = function () {
        _this4.isPopup(false);
      };
    }
  }, {
    key: 'created',
    value: function created(params) {
      // 初始化值
      this.generateDate(this.data());
    }
  }]);

  return DatePicker;
}(_base2.default);

exports.default = {
  name: 'timepicker',
  init: _base2.default.createViewModel(DatePicker),
  template: _index2.default
};

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position: relative\">\n  <div class=\"y-timepicker-input z-indexPicture\">\n    <input type=\"text\" class=\"y-input\"\n      data-bind=\"value:computedData,event:{focus:focus},attr:{disabled: disabled(), 'placeholder': placeholder}\">\n    <span class=\"fa fa-clock-o\"></span>\n  </div>\n  <y-dropdown\n    params=\"style: dropStyle,targetEl:$el,isShow:isPopup, width:'200', maxHeight: '150', overflow:'hidden',isTop: isTop\">\n    <div class=\"y-timepicker-ctn\" style=\"position: relative;\"\n      data-bind=\"if: $parent.isPopup, css:{'select-date': $parent.isPopup, 'isTimer': $parent.isTimer, 'alignright': $parent.alignright}\">\n      <div class=\"y-timepicker-mask\" data-bind=\"click: $parent.maskClick\"></div>\n      <div class=\"y-timepicker-ctn\">\n        <table class=\"y-timepicker-body\">\n          <tr>\n            <td>\n              <div>\n                <div class=\"fa fa-angle-up\"\n                  data-bind=\"click: $parent.nexthour, event:{mousedown:$parent.nexthourholddown,mouseup:$parent.holdup,blur:$parent.blur}\">\n                </div>\n                <input class=\"timer\" type=\"text\"\n                  data-bind=\"value:$parent.hour, event:{blur:function(){$parent.blurHour(event)},input:function(){$parent.onInput(event)}}\">\n                <div class=\"fa fa-angle-down\"\n                  data-bind=\"click: $parent.lasthour,event:{mousedown:$parent.lasthourholddown,mouseup:$parent.holdup,blur:$parent.blur}\">\n                </div>\n              </div>\n            </td>\n            <td>:</td>\n            <td>\n              <div>\n                <div class=\"fa fa-angle-up\"\n                  data-bind=\"click: $parent.nextminutes, event:{mousedown:$parent.nextminholddown,mouseup:$parent.holdup,blur:$parent.blur}\">\n                </div>\n                <input class=\"timer\" type=\"text\"\n                  data-bind=\"value:$parent.minutes, event:{blur:function(){$parent.blurMinutes(event)},input:function(){$parent.onInput(event)}}\">\n                <div class=\"fa fa-angle-down\"\n                  data-bind=\"click: $parent.lastminutes, event:{mousedown:$parent.lastminholddown,mouseup:$parent.holdup,blur:$parent.blur}\">\n                </div>\n              </div>\n            </td>\n            <!--ko if: $parent.hasSeconds-->\n            <td>:</td>\n            <td>\n              <div>\n                <div class=\"fa fa-angle-up\"\n                  data-bind=\"click: $parent.nextseconds, event:{mousedown:$parent.nextsecholddown,mouseup:$parent.holdup,blur:$parent.blur}\">\n                </div>\n                <input class=\"timer\" type=\"text\"\n                  data-bind=\"value:$parent.seconds, event:{blur:function(){$parent.blurSeconds(event)},input:function(){$parent.onInput(event)}}\">\n                <div class=\"fa fa-angle-down\"\n                  data-bind=\"click: $parent.lastseconds, event:{mousedown:$parent.lastsecholddown,mouseup:$parent.holdup,blur:$parent.blur}\">\n                </div>\n              </div>\n            </td>\n            <!--/ko-->\n          </tr>\n        </table>\n      </div>\n      <div class=\"y-timepicker-footer\">\n        <div class=\"y-timepicker-option\">\n          <div class=\"confirmbutton pull-right\" style=\"display: block!important;\"\n            data-bind=\"click:$parent.confirm, text: ko.observable('确定')\"></div>\n        </div>\n      </div>\n    </div>\n  </y-dropdown>\n</div>\n";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(497);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _tippy = __webpack_require__(161);

var _tippy2 = _interopRequireDefault(_tippy);

__webpack_require__(498);

__webpack_require__(499);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @author: liuxu7
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @date: 2018-03-14
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @description: 气泡组件
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @type: custom/default
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @position ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * */
// optional for styling


var Popper = function (_Base) {
  _inherits(Popper, _Base);

  function Popper() {
    _classCallCheck(this, Popper);

    return _possibleConstructorReturn(this, (Popper.__proto__ || (0, _getPrototypeOf2.default)(Popper)).apply(this, arguments));
  }

  _createClass(Popper, [{
    key: 'initialize',
    value: function initialize(params) {
      this.text = params.text || _knockout2.default.observable('');
      var innerTemplate = params.content || '';
      var tippyEl = params.$el.firstElementChild;
      var curTippy = null;
      if (_knockout2.default.isObservable(params.content)) {
        innerTemplate = params.content.peek();
        params.content.subscribe(function (val) {
          curTippy.setContent(val);
        });
      }
      if (!innerTemplate) {
        // 过滤掉html注释
        var templateNodes = params.$templateNodes.filter(function (item) {
          return item.nodeType !== 8;
        });
        templateNodes.forEach(function (node) {
          innerTemplate += node.outerHTML || node.textContent || '';
        });
        if (innerTemplate) {
          innerTemplate = innerTemplate.trim();
        }
      }
      if (!params.content && !innerTemplate) {
        innerTemplate = this.text;
        if (_knockout2.default.isObservable(innerTemplate)) {
          innerTemplate = innerTemplate.peek();
          this.text.subscribe(function (val) {
            curTippy.setContent(val);
          });
        }
      }
      curTippy = (0, _tippy2.default)(tippyEl, {
        content: innerTemplate,
        allowHTML: true,
        theme: 'light'
      });
    }
  }]);

  return Popper;
}(_base2.default);

exports.default = {
  name: 'popper',
  init: _base2.default.createViewModel(Popper),
  template: _index2.default
};

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "<span class=\"y-poper-text\" data-bind=\"html:text\"></span>";

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notice = __webpack_require__(501);

Object.defineProperty(exports, 'notice', {
  enumerable: true,
  get: function get() {
    return _notice.notice;
  }
});

var _loading = __webpack_require__(502);

Object.defineProperty(exports, 'loading', {
  enumerable: true,
  get: function get() {
    return _loading.loading;
  }
});

/* eslint-disable */
Date.prototype._format = function (fmt) {
  // author: songhlc
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }
  return fmt;
};

window.YCLOUD_REFS = {};
// 获取组件引用
var $refs = exports.$refs = window.YCLOUD_REFS;
/* eslint-disable */

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notice = undefined;

var _jquery = __webpack_require__(32);

var _jquery2 = _interopRequireDefault(_jquery);

var _stringHash = __webpack_require__(42);

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIELDIDNOTICE = '|notice';
var timeoutList = [];
var elCount = 0;
var $notice = {
  init: function init(msg, title, type, opt) {
    var _this = this;

    elCount++;
    var id = elCount;
    timeoutList.push(id);
    var fieldid = (0, _stringHash2.default)(msg) + FIELDIDNOTICE;
    var infoTemplate = '\n      <div id="y-notice-' + id + '" fieldid="' + fieldid + '" class="y-notice">\n        <div class="y-notice-ctn y-notice-info">\n          <i class="fa fa-check-circle"></i>' + msg + '\n          <span fieldid="info-' + fieldid + '" onclick="closenotice()">+</span>\n        </div>\n\n      </div>';
    var errorTemplate = '\n      <div id="y-notice-' + id + '" fieldid="' + fieldid + '" class="y-notice">\n        <div class="y-notice-ctn y-notice-error">\n          <i class="fa fa-info-circle"></i>' + msg + '\n          <span fieldid="error-' + fieldid + '" onclick="closenotice()">+</span>\n        </div>\n      </div>';
    var dialogTemplate = '\n      <div id="y-notice-' + id + '" fieldid="' + fieldid + '">\n        <div class="y-modal-mask"></div>\n        <div class="y-modal-wrap" data-bind="css:{animated: visible, fadeInUp: visible}">\n          <div class="y-modal" style="width:' + (opt.width || '600px') + '">\n            <div class="y-modal-ctn">\n              <div class="y-modal-head">\n                <span class="y-modal-head-title">' + title + '</span>\n              </div>\n              <div class="y-modal-body">\n                ' + msg + '\n              </div>\n              <div class="y-modal-foot">\n                <button class="y-button y-button-primary" id="ok-' + id + '">' + (opt.okValue || '确定') + '</button>\n                <button class="y-button y-button-secondary" id="cancel-' + id + '">' + (opt.cancelValue || '取消') + '</button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>';
    if (type === 'info') {
      (0, _jquery2.default)('body').append(infoTemplate);
    } else if (type === 'error') {
      (0, _jquery2.default)('body').append(errorTemplate);
    } else if (type === 'dialog') {
      (0, _jquery2.default)('body').append(dialogTemplate);
    }
    setTimeout(function () {
      (0, _jquery2.default)('#y-notice-' + id).addClass('y-notice-active');
      if (type === 'dialog') {
        (0, _jquery2.default)('#ok-' + id).click(function () {
          opt.ok();
          _this.close();
        });
        (0, _jquery2.default)('#cancel-' + id).click(function () {
          opt.cancel();
          _this.close();
        });
      }
    }, 100);
  },
  info: function info(msg) {
    var _this2 = this;

    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.init(msg, '', 'info', option);
    setTimeout(function () {
      _this2.close();
    }, option.timeout || 3000);
  },
  error: function error(msg) {
    var _this3 = this;

    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.init(msg, '', 'error', option);
    setTimeout(function () {
      _this3.close();
    }, option.timeout || 20000);
  },
  dialog: function dialog() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.init(option.content, option.title, 'dialog', option);
  },
  close: function close() {
    var curCount = timeoutList.shift();
    var id = '#y-notice-' + curCount;
    (0, _jquery2.default)(id).removeClass('y-notice-active');
    (0, _jquery2.default)(id).addClass('y-notice-hide');
    (0, _jquery2.default)(id).remove();
  }
};
window.closenotice = $notice.close;
var notice = exports.notice = $notice;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loading = undefined;

var _jquery = __webpack_require__(32);

var _jquery2 = _interopRequireDefault(_jquery);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $loading = {
  show: function show() {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _i18n2.default)('加载中...');

    var infoTemplate = '\n      <div id="y-loading" class="y-loading">\n        <div class="y-loading-ctn">\n          <div class="y-loading-spin">\n            <svg class="spinner" width="10px" height="10px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\n            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>\n            </svg>\n          </div>\n          ' + msg + '\n        </div>\n      </div>';
    (0, _jquery2.default)('#y-loading').remove();
    (0, _jquery2.default)('body').append(infoTemplate);
    setTimeout(function () {
      (0, _jquery2.default)('#y-loading').addClass('y-loading-active');
    }, 100);
  },
  hide: function hide() {
    (0, _jquery2.default)('#y-loading').remove();
  }
};
window.hideloading = $loading.hide;
var loading = exports.loading = $loading;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(504);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* @author: wangk2
* @date: 2018-02-01
* @description: 面包屑组件
*
* */
function init(params) {
  this.data = params.data;
  this.separator = params.separator || '>';
  var _data = _knockout2.default.utils.unwrapObservable(this.data);
  this.lastRow = _data[_data.length - 1];
  this.exceptLastRowArr = _data.slice(0, _data.length - 1);
}
exports.default = {
  name: 'breadcrumb',
  init: init,
  template: _index2.default
};

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-breadcrumb\">\n    <span data-bind=\"foreach: { data: exceptLastRowArr, as: 'row' }\">\n        <!-- ko if: row.link -->\n        <a data-bind=\"attr:{href:row.link},text:row.text\"></a>\n        <span class=\"y-breadcrumb-separate\" data-bind=\"text:$parent.separator\"></span>\n        <!-- /ko -->\n        <!-- ko if: !row.link -->\n        <span data-bind=\"text:row.text\"></span>\n        <span class=\"y-breadcrumb-separate\" data-bind=\"text:$parent.separator\"></span>\n        <!-- /ko -->\n    </span>\n    <span class=\"y-breadcrumb-last\">\n        <span data-bind=\"text:lastRow.text\"></span>\n    </span>\n</div>";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(506);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

__webpack_require__(65);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @author: songhlc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @date: 2018-03-05
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @description: 详情显示组件
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * */


var Showdetail = function (_Base) {
  _inherits(Showdetail, _Base);

  function Showdetail() {
    _classCallCheck(this, Showdetail);

    return _possibleConstructorReturn(this, (Showdetail.__proto__ || (0, _getPrototypeOf2.default)(Showdetail)).apply(this, arguments));
  }

  _createClass(Showdetail, [{
    key: 'initialize',
    value: function initialize(params) {
      this.text = params.text;
      // 在某些场景下，希望默认用于显示的字符和tooltip中显示的不一样，这里希望可以自定义
      // 添加textShow参数 以及适配原来的limitText
      this.textShow = params.textShow || params.limitText || params.text;
      this.visible = _knockout2.default.observable(false);
      this.multiple = !!params.multiple;
      this.title = (0, _i18n2.default)('详细');
    }
  }, {
    key: 'computed',
    value: function computed(params) {
      var _this2 = this;

      this.style = _knockout2.default.computed(function () {
        var style = {};
        if (_this2.visible()) {
          style.marginRight = '33px';
        }
        return style;
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      var _this3 = this;

      if (_knockout2.default.isObservable(this.text)) {
        this.text.subscribe(function (val) {
          _this3.computedVisible();
        });
      }
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this4 = this;

      this.computedVisible = function () {
        _knockout2.default.tasks.schedule(function () {
          var el = this.$el;
          if (!this.multiple) {
            var scrollWidth = el.children[0].children[0].scrollWidth;
            var offsetWidth = el.children[0].children[0].offsetWidth;
            // 有隐藏
            if (scrollWidth > offsetWidth) {
              this.visible(true);
            } else {
              this.visible(false);
            }
          } else {
            var scrollHeight = el.children[0].children[0].scrollHeight;
            var offsetHeight = el.children[0].children[0].offsetHeight;
            // 有一些机器srollHeight比offsetHeight高1px 加大判断的值
            if (scrollHeight - offsetHeight > 8) {
              this.visible(true);
            } else {
              this.visible(false);
            }
          }
        }.bind(_this4));
      };
    }
  }, {
    key: 'created',
    value: function created(params) {
      this.computedVisible();
    }
  }]);

  return Showdetail;
}(_base2.default);

exports.default = {
  name: 'showdetail',
  init: _base2.default.createViewModel(Showdetail),
  template: _index2.default
};

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-relative\">\n  <div data-bind=\"nullValueDisplay:textShow,style:style, css:{'y-showdetail-single':!multiple,\n  'y-showdetail-multiple': multiple}\">\n  </div>\n  <div class=\"y-text-link\" data-bind=\"visible:visible,css:{'y-showdetail-singlemore':!multiple,\n  'y-showdetail-multiplemore': multiple}\">\n    <y-tooltip params=\"title: title\">\n      <y-tooltipctn params=\"targetEl:$el,show:isShow,position:'bottomleft'\">\n        <div data-bind=\"html:$parentContext.$parent.text\"></div>\n      </y-tooltipctn>\n    </y-tooltip>\n    <span class=\"fa fa-angle-down\"></span>\n  </div>\n</div>\n";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(508);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _common = __webpack_require__(67);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @author: liuxu7
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @date: 2018-03-14
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @description: 气泡组件
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @type: custom/default
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @position ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * */


var Poptip = function (_Base) {
  _inherits(Poptip, _Base);

  function Poptip() {
    _classCallCheck(this, Poptip);

    return _possibleConstructorReturn(this, (Poptip.__proto__ || (0, _getPrototypeOf2.default)(Poptip)).apply(this, arguments));
  }

  _createClass(Poptip, [{
    key: 'initialize',
    value: function initialize(params) {
      this.title = params.title || '';
      this.question = params.question || false;
      this.trigger = params.trigger || 'hover';
      _common2.default.initialize.call(this, params);
    }
  }, {
    key: 'methods',
    value: function methods() {
      this.handleClick = function () {};
      this.handleHover = function () {};
      function handleVisible() {
        this.visible(Number(!this.visible()));
      }
      if (this.trigger === 'click') {
        this.handleClick = handleVisible;
      } else {
        this.handleHover = handleVisible;
      }
    }
  }, {
    key: 'computed',
    value: function computed() {
      var _this2 = this;

      this.hasMarkup = _knockout2.default.computed(function () {
        if (_this2.$templateNodes.length > 0) {
          var nodeList = _this2.$templateNodes.filter(function (node) {
            return node.nodeName !== '#text' && node.nodeName !== '#comment';
          });
          return nodeList.length > 0;
        } else {
          return false;
        }
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      _common2.default.subscribe.call(this, params);
    }
  }]);

  return Poptip;
}(_base2.default);

exports.default = {
  name: 'poptip',
  init: _base2.default.createViewModel(Poptip),
  template: _index2.default
};

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "<span class=\"y-poptip\" data-bind=\"css: trigger=='hover'?'trigger-hover':''\">\n  <span class=\"element\" data-bind=\"event:{click: handleClick, mouseenter:handleHover}\">\n    <!-- ko if: question -->\n    <span class=\"fa fa-question-circle y-text-link\"></span>\n    <!-- /ko -->\n    <!-- 其它元素 -->\n    <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n\n    <!-- title span -->\n    <!-- ko if: !hasMarkup() -->\n    <span data-bind=\"html: title\"></span>\n    <!-- /ko -->\n  </span>\n  <div class=\"y-poptip-ctn\" data-bind=\"css: thisClass, style: trigger=='hover'? {}:{opacity: visible, zIndex: (visible()?'1000':'-1')}\">\n    <div class=\"y-poptip-arrow\"></div>\n    <div class=\"y-poptip-cover\"></div>\n    <div class=\"y-poptip-ctn-inner\" data-bind=\"html: title\"></div>\n  </div>\n</span>\n";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

__webpack_require__(179);

var _index = __webpack_require__(510);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateItem(items) {
  items = items || [];
  return [].concat(items).map(function (item) {
    return {
      item: item,
      dragged: item.dragged || _knockout2.default.observable(true),
      dragging: _knockout2.default.observable(false)
    };
  });
}
function init(params) {
  var _this = this;

  this.items = _knockout2.default.observableArray(generateItem(params.items()));
  params.items.subscribe(function (items) {
    _this.items(generateItem(items));
  });
  this.style = params.style || {};
  this.name = params.name || 'sortable_' + Math.random();
  this.dragStart = function (item) {
    item.dragging(true);
  };
  this.dragEnd = function (item) {
    item.dragging(false);
    params.items(_this.items().map(function (item) {
      return item.item;
    }));
  };
  var that = this;
  this.drop = function () {
    that.items().forEach(function (item) {
      item.dragged && item.dragged(true);
      item.dragging && item.dragging(false);
    });
    params.items(that.items().map(function (item) {
      return item.item;
    }));
  };
  this.reorder = function (event, dragData, zoneData) {
    if (dragData !== zoneData.item) {
      var items = zoneData.items;
      var zoneDataIndex = items.indexOf(zoneData.item);
      var dragIndex = items.indexOf(dragData);
      dragData.dragging(true);
      if (dragIndex >= 0) {
        items.splice(dragIndex, 1);
      }
      items.splice(zoneDataIndex, 0, dragData);
    }
  };
}
exports.default = {
  name: 'sortablelist',
  init: init,
  template: _index2.default
};

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "<div data-bind=\"foreach:items\">\n  <div data-bind=\"style: $parent.style,\n  css: { 'y-dragging': dragging },\n  dragZone:{\n    name: $parent.name,\n    dragStart: $parent.dragStart,\n    dragEnd: $parent.dragEnd\n  },\n  dropZone: {\n    accepts: $parent.name,\n    drop: $parent.drop\n  },\n  dragEvents: {\n    accepts: $parent.name,\n    dragOver: $parent.reorder,\n    data: { items: $parent.items, item: $data }\n  }\">\n  <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n  </div>\n</div>\n";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

__webpack_require__(179);

var _index = __webpack_require__(512);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateItem(items) {
  items = items || [];
  return [].concat(items).map(function (item) {
    return {
      item: item,
      dragged: item.dragged || _knockout2.default.observable(true),
      dragging: _knockout2.default.observable(false)
    };
  });
}
function init(params) {
  var _this = this;

  this.items = _knockout2.default.observableArray(generateItem(params.items()));
  params.items.subscribe(function (items) {
    _this.items(generateItem(items));
  });
  this.style = params.style || {};
  this.name = params.name || 'dragable_' + Math.random();
}
exports.default = {
  name: 'dragablelist',
  init: init,
  template: _index2.default
};

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "<div data-bind=\"foreach:items\">\n  <div data-bind=\"style: $parent.style,\n  dragZone:{\n    name: $parent.name\n  }\">\n    <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n  </div>\n</div>\n";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(514);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _debounce = __webpack_require__(78);

var _debounce2 = _interopRequireDefault(_debounce);

var _mixin = __webpack_require__(23);

var _formatFunc = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var _INTERGER = 'integer';
var _POSITIVEINTEGER = 'positiveinteger';
var _POSITIVENUMBER = 'positivenumber';
var _CUSTOMTYPELIST = [_INTERGER, _POSITIVEINTEGER, _POSITIVENUMBER];

var Textarea = function (_Base) {
  _inherits(Textarea, _Base);

  function Textarea() {
    _classCallCheck(this, Textarea);

    return _possibleConstructorReturn(this, (Textarea.__proto__ || (0, _getPrototypeOf2.default)(Textarea)).apply(this, arguments));
  }

  _createClass(Textarea, [{
    key: 'initialize',
    value: function initialize(params) {
      var _this2 = this;

      this.value = params.value || _knockout2.default.observable();
      this.fieldid = params.fieldid || this.value._fieldid || '';
      // textarea的行，默认两行
      this.rows = params.rows || '2';
      this.resizeType = params.resizeType || '';
      this.placeholder = params.placeholder || '';
      this.maxlength = params.maxlength;
      if (_knockout2.default.isObservable(params.disabled)) {
        this.disabled = params.disabled;
      } else if (params.disabled) {
        this.disabled = _knockout2.default.observable(!!params.disabled);
      } else {
        this.disabled = _knockout2.default.observable(false);
      }
      // textarea是否可以自动变高，如果参数为‘true’则可以，默认不可以
      this.autoHeightChange = params.autoHeightChange || false;
      // textarea是否显示计数，
      this.showCount = !!params.showCount;
      if (this.showCount) {
        var that = this;
        this.remainWords = _knockout2.default.pureComputed({
          // 获取数据时通过value动态计算
          read: function read() {
            if (that.value()) {
              return that.maxlength - that.value().toString().length;
            } else {
              return that.maxlength;
            }
          },
          // 设置的时候动态改变value值
          write: function write(val) {
            that.value(val);
          }
        });
        this.countMsg = _knockout2.default.computed(function () {
          return (0, _i18n2.default)('限') + ' ' + _this2.maxlength + ' ' + (0, _i18n2.default)('字') + ',' + (0, _i18n2.default)('还可输入') + ' <span class="remain-words">' + _this2.remainWords() + '</span> ' + (0, _i18n2.default)('字');
        });
      }
      _mixin.changeStyleMixin.call(this, params);
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this3 = this;

      _mixin.gridRefMixin.call(this, params);
      this.setFocus = function () {
        _this3.$el.querySelector('textarea').focus();
        _this3.$el.querySelector('textarea').click();
      };
      // 默认校验
      this.defaultValidate = function (vm, e) {
        if (_CUSTOMTYPELIST.indexOf(params.type) > -1) {
          switch (params.type) {
            case _INTERGER:
              return _formatFunc.isInteger.call(_this3, 'textarea');
            case _POSITIVEINTEGER:
              return _formatFunc.isPositiveInteger.call(_this3, 'textarea');
            case _POSITIVENUMBER:
              return _formatFunc.isPositivenumber.call(_this3, 'textarea');
          }
        } else {
          return true;
        }
      };
      this.calcRemainWords = (0, _debounce2.default)(function (e) {
        _this3.remainWords(e.target.value);
      }, 200);
      this.onKeyup = function (a, e) {
        params.onKeyup && params.onKeyup();
        _this3.defaultValidate();
        if (_this3.showCount) {
          _this3.calcRemainWords(e);
        }
      };
      this.onInput = function (a, e) {
        _this3.defaultValidate();
        if (_this3.showCount) {
          _this3.calcRemainWords(e);
        }
        params.onInput && params.onInput(e);
        if (_this3.autoHeightChange) {
          var el = e.target;
          el.style.height = 'auto';
          el.style.height = el.scrollHeight + 'px';
          el.style.overflowY = 'hidden';
        }
        if (_this3.enableChangingStyle) {
          if (String(_this3.oldValue) !== String(e.target.value)) {
            _this3.textChanged(true);
          } else {
            _this3.textChanged(false);
          }
        }
      };
      this.onClick = function (a, b) {
        if (_this3.autoHeightChange) {
          var el = b.target;
          el.style.height = 'auto';
          el.style.height = el.scrollHeight + 'px';
          el.style.overflowY = 'hidden';
        }
      };
      this.onBlur = function (a, b) {
        params.onBlur && params.onBlur(b);
        if (_this3.autoHeightChange) {
          var el = b.target;
          el.style.height = 'auto';
          el.style.height = el.scrollHeight + 'px';
          el.style.overflowY = 'hidden';
        }
      };
    }
  }]);

  return Textarea;
}(_base2.default);

exports.default = {
  name: 'textarea',
  init: _base2.default.createViewModel(Textarea),
  template: _index2.default
};

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-textarea-ctn y-relative\">\n  <textarea autocomplete=\"off\" wrap=\"soft\" class=\"y-textarea\" data-bind=\"\n  css:{'y-textarea-changed': enableChangingStyle && textChanged()},\n  attr:{tabindex: tabindex,maxlength:maxlength,rows:rows,placeholder:placeholder,disabled:disabled, fieldid: fieldid},style:{resize:resizeType},value:value,\n    event:{input:onInput,keyup:onKeyup,click:onClick, blur:onBlur}\"></textarea>\n  <!-- ko if: showCount && !disabled() -->\n  <div class=\"y-textarea-msg\" data-bind=\"html: countMsg\"></div>\n  <!-- /ko -->\n</div>\n";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _iterator = __webpack_require__(154);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(157);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!_knockout2.default.when) {
  _knockout2.default.when = function (predicate, callback, context) {
    var observable = _knockout2.default.pureComputed(predicate).extend({ notify: 'always' });
    var subscription = observable.subscribe(function (value) {
      if (value) {
        subscription.dispose();
        callback.call(context);
      }
    });
    // In case the initial value is true, process it right away
    observable['notifySubscribers'](observable.peek());
    return subscription;
  };
}
// 用于判断是否是ObservableArray
if (!_knockout2.default.isObservableArray) {
  _knockout2.default.isObservableArray = function (instance) {
    return _knockout2.default.isObservable(instance) && typeof instance['remove'] === 'function' && typeof instance['push'] === 'function';
  };
}
// 文本显示空值显示成--
if (!_knockout2.default.bindingHandlers.nullValueDisplay) {
  _knockout2.default.bindingHandlers.nullValueDisplay = {
    init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
      return { 'controlsDescendantBindings': true };
    },
    update: function update(element, valueAccessor, allBindings, viewModel, bindingContext) {
      if (valueAccessor() === null || valueAccessor() === undefined || valueAccessor() === '') {
        _knockout2.default.utils.setTextContent(element, '--');
      } else {
        if (_knockout2.default.isObservable(valueAccessor())) {
          // valueAccessor()为监听对象
          if (valueAccessor()() === null || valueAccessor()() === undefined || valueAccessor()() === '') {
            _knockout2.default.utils.setTextContent(element, '--');
          } else {
            _knockout2.default.utils.setTextContent(element, valueAccessor());
          }
        } else {
          // valueAccessor()为一个值
          _knockout2.default.utils.setTextContent(element, valueAccessor());
        }
      }
    }
  };
}
if (!_knockout2.default.bindingHandlers.css) {
  var classesWrittenByBindingKey = '__ko__cssValue';
  _knockout2.default.bindingHandlers['class'] = {
    'update': function update(element, valueAccessor) {
      var value = _knockout2.default.utils.stringTrim(_knockout2.default.utils.unwrapObservable(valueAccessor()));
      _knockout2.default.utils.toggleDomNodeCssClass(element, element[classesWrittenByBindingKey], false);
      element[classesWrittenByBindingKey] = value;
      _knockout2.default.utils.toggleDomNodeCssClass(element, value, true);
    }
  };

  _knockout2.default.bindingHandlers['css'] = {
    'update': function update(element, valueAccessor) {
      var value = _knockout2.default.utils.unwrapObservable(valueAccessor());
      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        _knockout2.default.utils.objectForEach(value, function (className, shouldHaveClass) {
          shouldHaveClass = _knockout2.default.utils.unwrapObservable(shouldHaveClass);
          _knockout2.default.utils.toggleDomNodeCssClass(element, className, shouldHaveClass);
        });
      } else {
        _knockout2.default.bindingHandlers['class']['update'](element, valueAccessor);
      }
    }
  };
}
if (!_knockout2.default.bindingHandlers.ref) {
  _knockout2.default.bindingHandlers['ref'] = {
    'init': function init(element, valueAccessor) {
      if (valueAccessor && valueAccessor()) {
        valueAccessor()(element);
      }
    }
  };
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(517);

var _index2 = _interopRequireDefault(_index);

var _knockout = __webpack_require__(0);

var _knockout2 = _interopRequireDefault(_knockout);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

__webpack_require__(518);

var _stringHash = __webpack_require__(42);

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; } // click 参数是 主点击事件
// dropList 下拉按钮组的data  类似{value:1，label:'新增'}
// onDropList 下拉按钮组点击事件 根据参数判断执行事件
// 欢迎吐槽  by wjk


var FIELDIDAFFIX = '_sub-btn';

var DropButton = function (_Base) {
  _inherits(DropButton, _Base);

  function DropButton() {
    _classCallCheck(this, DropButton);

    return _possibleConstructorReturn(this, (DropButton.__proto__ || (0, _getPrototypeOf2.default)(DropButton)).apply(this, arguments));
  }

  _createClass(DropButton, [{
    key: 'initialize',
    value: function initialize(params) {
      this.fieldid = '';
      this.text = params.text || '新增';
      var innerTpl = params.text || params.$templateNodes.length > 0 ? params.$templateNodes[0].textContent : '';
      if (params.fieldid) {
        this.fieldid = params.fieldid + FIELDIDAFFIX;
      } else if (innerTpl) {
        this.fieldid = (0, _stringHash2.default)(innerTpl) + FIELDIDAFFIX;
      }
      this.mainClick = params.click || function () {};
      this.isShowDrop = _knockout2.default.observable(false).extend({
        rateLimit: 100
      });
      this.dropWidth = params.dropWidth;
      this.type = params.type || '';
      this.dropList = params.dropList || _knockout2.default.observableArray([]);
      this.isMouseoverGroupBtn = params.isMouseoverGroupBtn || _knockout2.default.observable(false);
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this2 = this;

      this.showdropdown = function () {
        _this2.isShowDrop(!_this2.isShowDrop());
      };
      this.handleOptClick = function (item) {
        params.onDropList(item);
      };
      this.handleHideDrop = function () {
        _this2.isShowDrop(false);
      };
      this.overBtnShow = function () {
        _this2.isShowDrop(true);
      };
      this.outBtnHide = function () {
        _this2.isShowDrop(false);
      };
    }
  }]);

  return DropButton;
}(_base2.default);

exports.default = {
  name: 'button-group',
  init: _base2.default.createViewModel(DropButton),
  template: _index2.default
};

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-group-button y-fontsize-0\" data-bind=\"clickoutside: handleHideDrop\">\n  <!-- ko if: !isMouseoverGroupBtn() -->\n    <button class=\"y-button y-group-default\" data-bind=\"click:mainClick, css: type === 'primary' ?'y-button-primary': '', attr: {fieldid: fieldid}\">\n      <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n    </button>\n    <button class=\"y-button y-dropdown-toggle\" data-bind=\"click:showdropdown,css: type === 'primary' ?'y-button-primary': '', attr: {fieldid: fieldid + '|toggle'}\">\n      <span class=\"fa fa-angle-down\"></span>\n    </button>\n    <div data-bind=\"let: {handleOptClick:handleOptClick, dropList:dropList}\">\n      <y-dropdown params=\"width:dropWidth, isShow:isShowDrop,targetEl:$el, style:{minWidth: '90px',marginLeft:'8px'}\">\n        <ul data-bind=\"foreach:{data: dropList, as: 'item'}\">\n          <li class=\"y-drop-item\" data-bind=\"text:label,click:handleOptClick, attr: {fieldid: $parentContext.$parent.fieldid + '|item-' + $index()}\"></li>\n        </ul>\n      </y-dropdown>\n    </div>\n  <!-- /ko -->\n  <!-- ko if: isMouseoverGroupBtn() -->\n    <button class=\"y-button\" data-bind=\"event:{mouseover:overBtnShow,mouseout:outBtnHide}, css: type === 'primary' ?'y-button-primary': '', attr: {fieldid: fieldid}\">\n      <span class=\"y-punish_Btn\">\n        <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n      </span>\n      <span data-bind=\"css:{'fa-angle-down':!isShowDrop(),'fa-angle-up':isShowDrop()}\" class=\"fa y-punish_Btnicon\" style=\"position: relative; left: 10px;\"></span>\n    </button>\n    <ul class=\"dist-conter\" data-bind=\"foreach:{data: dropList, as: 'item'},visible:isShowDrop,event:{mouseover:overBtnShow,mouseout:outBtnHide}\">\n      <li class=\"y-drop-item\" data-bind=\"text:label,click:$parent.handleOptClick,attr: {fieldid: $parent.fieldid + '|item-' + $index()}\"></li>\n    </ul>\n  <!-- /ko-->\n\n</div>\n";

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(520);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _common = __webpack_require__(67);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var MouseDialog = function (_Base) {
  _inherits(MouseDialog, _Base);

  function MouseDialog() {
    _classCallCheck(this, MouseDialog);

    return _possibleConstructorReturn(this, (MouseDialog.__proto__ || (0, _getPrototypeOf2.default)(MouseDialog)).apply(this, arguments));
  }

  _createClass(MouseDialog, [{
    key: 'initialize',
    value: function initialize(params) {
      this.rowData = params.rowData;
      // 支持tipText function引用
      if (typeof params.tipText === 'function') {
        this.tipText = params.tipText();
      } else {
        this.tipText = params.tipText;
      }
      this.operText = params.operText;
      this.hideOperation = params.hideOperation || false;
      this.css = params.css;
      this.okTitle = params.okTitle || (0, _i18n2.default)('确定');
      this.cancelTitle = params.cancelTitle || (0, _i18n2.default)('取消');
      this.data = params.data || {};
      _common2.default.initialize.call(this, params);
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this2 = this;

      this.handleClick = function () {
        _this2.visible(Number(!_this2.visible()));
      };
      this.handleOk = function () {
        params.onOk && params.onOk(_this2.data);
        setTimeout(function () {
          _this2.visible(0);
        }, 1000);
      };
      this.handleCancel = function () {
        _this2.visible(0);
      };
      this.clickoutside = function () {
        _this2.visible(0);
      };
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      _common2.default.subscribe.call(this, params);
    }
  }]);

  return MouseDialog;
}(_base2.default);

exports.default = {
  name: 'mousedialog',
  init: _base2.default.createViewModel(MouseDialog),
  template: _index2.default
};

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = "<span class=\"y-poptip\" data-bind=\"css: css,clickoutside:clickoutside\">\n  <span class=\"element\" data-bind=\"text: operText,event:{mouseover: handleClick}\"></span>\n  <div class=\"y-poptip-ctn\" data-bind=\"css: thisClass,style: {opacity: visible, zIndex: (visible()?'1000':'-1')}\">\n    <div class=\"y-poptip-arrow\"></div>\n    <div class=\"y-poptip-cover\"></div>\n    <div class=\"y-poptip-ctn-inner\">\n      <div data-bind=\"html: tipText\"></div>\n      <div style=\"text-align: right;margin-top: 10px;\" data-bind=\"visible: !hideOperation\">\n        <y-button params=\"size:'small',type:'error', click: handleOk\"><span data-bind=\"text:$parent.okTitle\">确定</span>\n        </y-button>\n        <y-button params=\"size:'small',type: 'secondary', click: handleCancel\"><span\n            data-bind=\"text:$parent.cancelTitle\">取消</span>\n        </y-button>\n      </div>\n\n    </div>\n\n  </div>\n</span>\n";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(2);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setPrototypeOf = __webpack_require__(3);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(4);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(522);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _i18n = __webpack_require__(7);

var _i18n2 = _interopRequireDefault(_i18n);

var _common = __webpack_require__(67);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var PopDialog = function (_Base) {
  _inherits(PopDialog, _Base);

  function PopDialog() {
    _classCallCheck(this, PopDialog);

    return _possibleConstructorReturn(this, (PopDialog.__proto__ || (0, _getPrototypeOf2.default)(PopDialog)).apply(this, arguments));
  }

  _createClass(PopDialog, [{
    key: 'initialize',
    value: function initialize(params) {
      // 仅当popdialog使用在grid之中
      this.rowData = params.rowData;
      // 支持tipText function引用
      if (typeof params.tipText === 'function') {
        this.tipText = params.tipText(this.rowData);
      } else {
        this.tipText = params.tipText;
      }
      this.action = params.action || '';
      this.operText = params.operText;
      this.hideOperation = params.hideOperation || false;
      this.css = params.css;
      this.okTitle = params.okTitle || (0, _i18n2.default)('确定');
      this.cancelTitle = params.cancelTitle || (0, _i18n2.default)('取消');
      this.data = params.data || {};
      _common2.default.initialize.call(this, params);
    }
  }, {
    key: 'methods',
    value: function methods(params) {
      var _this2 = this;

      this.handleClick = function () {
        _this2.visible(Number(!_this2.visible()));
      };
      this.handleOk = function () {
        params.onOk && params.onOk(_this2.data);
        setTimeout(function () {
          _this2.visible(0);
        }, 1000);
      };
      this.handleCancel = function () {
        _this2.visible(0);
      };
      this.clickoutside = function () {
        _this2.visible(0);
      };
    }
  }, {
    key: 'subscribe',
    value: function subscribe(params) {
      _common2.default.subscribe.call(this, params);
    }
  }]);

  return PopDialog;
}(_base2.default);

exports.default = {
  name: 'popdialog',
  init: _base2.default.createViewModel(PopDialog),
  template: _index2.default
};

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = "<span class=\"y-poptip\" data-bind=\"css: css,clickoutside:clickoutside\">\n  <span class=\"element\" data-bind=\"event:{click: handleClick}\">\n    <span data-bind=\"text: operText\"></span>\n  </span>\n  <div class=\"y-poptip-ctn\" data-bind=\"css: thisClass,style: {opacity: visible, zIndex: (visible()?'1000':'-1')}\">\n    <div class=\"y-poptip-arrow\"></div>\n    <div class=\"y-poptip-cover\"></div>\n    <div class=\"y-poptip-ctn-inner\">\n      <div data-bind=\"html: tipText\"></div>\n      <div style=\"text-align: right;margin-top: 10px;\" data-bind=\"visible: !hideOperation\">\n        <y-button params=\"size:'small',type:'error', click: handleOk\"><span data-bind=\"attr:{'data-action':$parent.action},text:$parent.okTitle\">确定</span></y-button>\n        <y-button params=\"size:'small',type:'secondary', click: handleCancel\"><span data-bind=\"text:$parent.cancelTitle\">取消</span></y-button>\n      </div>\n\n    </div>\n\n  </div>\n</span>\n";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(524);

var _index2 = _interopRequireDefault(_index);

var _base = __webpack_require__(1);

var _base2 = _interopRequireDefault(_base);

var _base3 = __webpack_require__(92);

var _base4 = _interopRequireDefault(_base3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'table',
  init: _base2.default.createViewModel(_base4.default),
  template: _index2.default
};

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = "<div class=\"y-table-content y-grid-wrapper\" data-bind=\"css: {'y-grid-noborder':noborder, 'y-grid-separate': isSeparate, 'y-hasCollapseToolbar': lockright},style:style\">\n  <div class=\"y-grid\" data-bind=\"css:{'y-grid-stripe':isStripe, 'y-grid-verticalScroll':verticalScroll,'y-grid-border': isTableBorder}\">\n    <div class=\"y-table-scroll\">\n      <y-grid-head data-bind=\"groupSort:groupSort,visible:!nohead\" params=\"el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:columns,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n      <y-grid-body-basic params=\"bodyrefs: bodyrefs,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,tdstyle: tdstyle,\n        lockhead:lockhead,tableWidth:tableWidth,handleBodyScroll: handleBodyScroll,rowspan:rowspan,domId:domId,\n        maxheight:maxheight,columns:columns,isDataTable:isDataTable,forbitRowSelect:forbitRowSelect,\n        rows:rows,onRowSelect:onRowSelect,isEnableCrossPage:isEnableCrossPage,crossPageRowPrimaryKey:crossPageRowPrimaryKey,crossPageSelectedRows:crossPageSelectedRows,isShowLoading:isShowLoading,isSeparate:isSeparate,isNoDataCustomTpl: hasMarkup,transform:vertiacalScrollTransform\">\n      </y-grid-body-basic>\n    </div>\n    <!-- ko if:lockcolumn-->\n    <div class=\"y-table-fixed-left\" data-bind=\"style:{width: fixedTableWidth}\">\n      <y-grid-head data-bind=\"visible:!nohead\" params=\"groupSort:groupSort,el:$el,columns1:columns1,columns2:columns2,lockhead:lockhead,columns:columns,allRowChecked:allRowChecked,tableWidth:tableWidth\"></y-grid-head>\n      <div class=\"y-grid-body-outter\">\n        <y-grid-body-basic params=\"handleBodyScroll:handleBodyScroll,lockcolumn:lockcolumn,bodyrefs: bodyrefs, isLockLeft: true,lockColumnHeight:lockColumnHeight,forbitRowSelectFn:forbitRowSelectFn,verticalAlign:verticalAlign,hasSummaryRow:hasSummaryRow,headHeight:headHeight,transform:fixColumnTransform,tdstyle: tdstyle, lockhead:true,tableWidth:tableWidth,rowspan:rowspan,domId:domId+'_fix',expand:expand,maxheight:computedMaxHeight, isDataTable:isDataTable, columns:lockleftColumns,forbitRowSelect:forbitRowSelect,rows:rows, onRowSelect:onRowSelect\">\n        </y-grid-body-basic>\n      </div>\n    </div>\n    <!-- /ko -->\n  </div>\n</div>\n";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var onExit = '';
function enable(element, callback) {
  // 判断各种浏览器，找到正确的方法
  var requestMethod = element.requestFullScreen || // W3C
  element.webkitRequestFullScreen || // FireFox
  element.mozRequestFullScreen || // Chrome等
  element.msRequestFullScreen; // IE11
  if (requestMethod) {
    requestMethod.call(element);
  } else if (typeof window.ActiveXObject !== 'undefined') {
    // for Internet Explorer
    var wscript = new window.ActiveXObject('WScript.Shell');
    if (wscript !== null) {
      wscript.SendKeys('{F11}');
    }
  }
  // 给exit方法重新赋值
  if (!onExit) {
    onExit = callback || function () {};
  }
}
// 退出全屏 判断浏览器种类
function exit(e) {
  if (!isFull()) {
    onExit();
    onExit = '';
  }
}
// 判断当前是否全屏
function isFull() {
  var isFull = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen;
  // to fix : false || undefined == undefined
  return !!isFull;
}
document.addEventListener('fullscreenchange', exit);
document.addEventListener('mozfullscreenchange', exit);
document.addEventListener('webkitfullscreenchange', exit);
document.addEventListener('msfullscreenchange', exit);

exports.default = {
  enable: enable,
  exit: exit
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (descriptor) {
  return new _asyncValidator2.default(descriptor);
};

var _asyncValidator = __webpack_require__(148);

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ycloud.min.js